import React, { useState, useRef, useCallback, useEffect } from 'react';
import { Accordion, Card, Button, Form, Modal, Table, Tabs, Tab, OverlayTrigger, Popover } from 'react-bootstrap'
import Select from 'react-select';
import axios from 'axios';
import { useLocation } from "react-router-dom";
import Moment from 'moment';
import SHA256 from "crypto-js/sha256";
//import { AES } from 'crypto-js';
import * as CryptoJS from 'crypto-js'
import DatePicker from 'react-datepicker';
import { isEmpty, set } from 'lodash';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import Sticky from 'react-sticky-el';
import InputMask from 'react-input-mask';
import validator from 'validator';
import ReCAPTCHA from 'react-google-recaptcha';
import { addDays} from 'date-fns'

const channel = 'Howden';
const insurer_msig = 'MSIG';
const insurer_rhbi = 'RHBI';
const insurer_tune = 'TUNEPROTECT';
const premierBenefits = ["PEA8", "MED4", "LPE4"];
const annualSelectedPlan= ["TDA6", "TDC6", "TDJ6"];
const insurerList = ["MSIG", "RHBI"];
const mal_code = 'MAL';

const dropOffPlan = 2;
const dropOffAddOns = 3;
const dropOffInsured = 4;
const dropOffPaymentSummary = 5;

const manualInsurerList = ["CHUBB", "AIG"];

export default (props) => {
    let query = new URLSearchParams(useLocation().search);
    const [activeId, setActiveId] = useState(query.get("paymentID") === null ? 'travel' : query.get("keyTab"));
    const [travelInfo, setTravelInfo] = useState({});
    const [selectedPlan, setSelectedPlan] = useState({});
    const [selectedAddOns, setSelectedAddOns] = useState([]);
    const [insuredInfo, setInsuredInfo] = useState([]);
    const [grossPremium, setGrossPremium] = useState(0);
    const [addOnsTotal, setAddOnsTotal] = useState(0);
    const [serviceTax, setServiceTax] = useState(0);
    const [totalPayable, setTotalPayable] = useState(0);
    const [stampDuty, setStampDuty] = useState(10);
    const [token, setToken] = useState("");
    const [tuneToken, setTuneToken] = useState("");
    const [allNationalities, setAllNationalities] = useState([]);
    const [malNationality, setMalNationality] = useState({});
	 const [dropOffDob, setDropOffDob] = useState("");
	 const [basicName, setBasicName] = useState("");
	const [basicContactNo, setBasicContactNo] = useState("");
	const [basicEmailAdd, setBasicEmailAdd] = useState("");
    const [transactionId, setTransactionId] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [loadPlan, setLoadPlan] = useState(false);
    
    const [apiToken, setApiToken] = useState("");
    
    const [showRenewalModal, setShowRenewalModal] = useState(false);
    const [renewalInfo, setRenewalInfo] = useState({});
    
     const [dropOffTrigger, setDropOffTrigger] = useState(0);    
    let closeCount = 0;

    const [travelInfoParams, setTravelInfoParams] = useState({});

    const [steps] = useState(['travel', 'plan', 'add-on', 'insured', 'payment']);

    const [transactionNo] = useState(Math.floor(new Date().getTime() / 1000)); //for log api key
    const [queryParam, setQueryParam] = useState("");
    
     const [loadMSIGToken, setLoadMSIGToken] = useState(false);
     const [loadTuneToken, setLoadTuneToken] = useState(false);
    
    let closingWindow = true;

      $(document).on("click", "#btn-paynow", function () {
        closingWindow = false;
    });

    $("#btn-paynow").on("click",function() {
        closingWindow = false;
    });

    $(document).on("click", ".btn-manual-plans", function () {
        closingWindow = false;
    });

    $(".btn-manual-plans").on("click",function() {
        closingWindow = false;
    });


    // $(document).on("click", "a", function () {
    //     closingWindow = false;
    // });

    // $(document).on("click", "button", function () {
    //     closingWindow = false;
    // });

    // $('html').on('mouseleave', function () {
    //     closingWindow = true; 
    // });

    // $(document).on('mouseleave', function () {
    //     closingWindow = true; 
    // });
    
     useEffect(() => {

        window.addEventListener('beforeunload', function (e) {
            if(closingWindow) {

                e.preventDefault();
                closeCount++;
                console.log('beforeunload closingWindow');
                setDropOffTrigger(closeCount);
                e.returnValue = '';
                
            }
            
        });

       // window.addEventListener('beforeunload', alertUser);
        // return () => {
        //   window.removeEventListener('beforeunload', alertUser);
        // }
    }, []);

    const alertUser = (event) => {
        closeCount++;
        setDropOffTrigger(closeCount);

        console.log(closingWindow);

        event.preventDefault();
        event.returnValue = '';

    //     if(closingWindow) { 
    //         event.preventDefault();
    //         if (event) {
    //             event.returnValue = ''; // Legacy method for cross browser support
    //         }
    //    }
    }


    const swalAlert = withReactContent(Swal);

    useEffect(() => {
        // Use the referral prop as needed in the component

        if(props.referral) {
            console.log('Referral in Travel component:', props.referral);
        }
        
    }, [props.referral]);

    useEffect(() => {

        if(!isEmpty(props.renewalParam) && !isEmpty(props.renewalTag)) {
            console.log('promp modal to key in ID');

            if(loadMSIGToken == true && loadTuneToken == true) {
                 setShowRenewalModal(true);
            }
           

        }
        
    }, [props.renewalParam, props.renewalTag, loadMSIGToken, loadTuneToken]);

    useEffect(() => {
       
        if(!isEmpty(props.travelDetails) && !isEmpty(token)) {
           
           const decryptedData = CryptoJS.AES.decrypt(props.travelDetails, process.env.MIX_URL_ENCRYPT_KEY).toString(CryptoJS.enc.Utf8);
           const travelJson =  JSON.parse(decryptedData);

           if(travelJson.fromApi && travelJson.fromApi == '1') {
                console.log(travelJson.travelInfo);
                setTravelInfo(travelJson.travelInfo);
                setTravelInfoParams(travelJson.travelInfo);
                //setQueryParam(travelJson);
                if(travelJson.referral && !isEmpty(travelJson.referral)) {
                    props.setReferral(travelJson.referral);
                } 

                if(travelJson.basicName && !isEmpty(travelJson.basicName)) {
                    setBasicName(travelJson.basicName);
                }

                if(travelJson.basicEmailAdd && !isEmpty(travelJson.basicEmailAdd)) {
                    setBasicEmailAdd(travelJson.basicEmailAdd);
                }

                if(travelJson.basicContactNo && !isEmpty(travelJson.basicContactNo)) {
                    setBasicContactNo(travelJson.basicContactNo);
                }
                
                setLoadPlan(true);
                setActiveId('plan');
               

           }
        }
       
    }, [props.travelDetails, token]);


    useEffect(() => {

       

        switch(selectedPlan.insurer) {
            case insurer_msig:
            case insurer_rhbi:
            case insurer_tune:
             setStampDuty(selectedPlan.stampDuty);
              break;
            default:
                if (grossPremium > 150) {
                    setStampDuty(10);
                } else {
                    setStampDuty(0);
                }

        }

       
    }, [grossPremium]);


    useEffect(() => {
        if(isEmpty(token)) {
          
            getMsigToken();

        }
       
    }, [token]);

    useEffect(() => {
        if(isEmpty(tuneToken)) {
          
            getTuneToken();

        }
       
    }, [tuneToken]);

    useEffect(() => {
        setTotalPayable(parseFloat(grossPremium) + parseFloat(addOnsTotal) + parseFloat(serviceTax) + parseFloat(stampDuty));
    }, [stampDuty]);

    function getMsigToken() {

       
        // swalAlert.fire({
        //     title: 'Please Wait ...',
        //     allowOutsideClick: false
        // });
        // swalAlert.showLoading();


        axios.post('/api/get-token', {
            insurer: insurer_msig,
            transactionNo: transactionNo
        }).then((response) => {

          
            setToken(response.data)
            setLoadMSIGToken(true);
          
            // if(isEmpty(props.travelDetails))
            // {
            //     swalAlert.close();
            // }   
           

        }).catch((error) => {
            console.log(error);
            setLoadMSIGToken(true);
            //swalAlert.close();
        });
        
    }

    function getTuneToken() {

    
        axios.post('/api/get-token', {
            insurer: insurer_tune,
            transactionNo: transactionNo
        }).then((response) => {

          
            setTuneToken(response.data);
            setLoadTuneToken(true);
          

        }).catch((error) => {
            console.log(error);
              setLoadTuneToken(true);
        });
        
    }

    return (
        <section id="body">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="row text-center steps bg-white shadow">
                            <div className="col-12 px-0 px-sm-auto">
                                <div className={(steps.indexOf(activeId) >= steps.indexOf('travel') ? "" : "opacity-25") + " d-inline-block position-relative pt-5 align-text-top step first"} onClick={() => { steps.indexOf(activeId) >= steps.indexOf('travel') ? setActiveId('travel') : null }}>
                                    <div className={(steps.indexOf(activeId) >= steps.indexOf('travel') ? 'bg-secondary clickable' : 'bg-primary') + " d-block text-white position-absolute border rounded-circle text-center px-1 order"}>
                                        <h4 className="fw-bold text-white mb-0">1</h4>
                                    </div>
                                    <div className={(activeId === 'travel' ? 'text-primary text-nowrap d-block' : 'd-none') + " text-center text-break description"}>Travel Info</div>
                                </div>
                                <div className={(steps.indexOf(activeId) >= steps.indexOf('plan') ? "" : "opacity-25") + " d-inline-block position-relative pt-5 align-text-top step"} onClick={() => { steps.indexOf(activeId) >= steps.indexOf('plan') ? setActiveId('plan') : null }}>
                                    <div className={(steps.indexOf(activeId) >= steps.indexOf('plan') ? 'bg-secondary clickable' : 'bg-primary') + " d-block text-white position-absolute border rounded-circle text-center px-1 order"}>
                                        <h4 className="fw-bold text-white mb-0">2</h4>
                                    </div>
                                    <div className={(activeId === 'plan' ? 'text-primary text-nowrap d-block' : 'd-none') + " text-center text-break description"}>Plan</div>
                                </div>
                                <div className={(steps.indexOf(activeId) >= steps.indexOf('add-on') ? "" : "opacity-25") + " d-inline-block position-relative pt-5 align-text-top step"} onClick={() => { steps.indexOf(activeId) >= steps.indexOf('add-on') ? setActiveId('add-on') : null }}>
                                    <div className={(steps.indexOf(activeId) >= steps.indexOf('add-on') ? 'bg-secondary clickable' : 'bg-primary') + " d-block text-white position-absolute border rounded-circle text-center px-1 order"}>
                                        <h4 className="fw-bold text-white mb-0">3</h4>
                                    </div>
                                    <div className={(activeId === 'add-on' ? 'text-primary text-nowrap d-block' : 'd-none') + " text-center text-break description"}>Add Ons</div>
                                </div>
                                <div className={(steps.indexOf(activeId) >= steps.indexOf('insured') ? "" : "opacity-25") + " d-inline-block position-relative pt-5 align-text-top step"} onClick={() => { steps.indexOf(activeId) >= steps.indexOf('insured') ? setActiveId('insured') : null }}>
                                    <div className={(steps.indexOf(activeId) >= steps.indexOf('insured') ? 'bg-secondary clickable' : 'bg-primary') + " d-block text-white position-absolute border rounded-circle text-center px-1 order"}>
                                        <h4 className="fw-bold text-white mb-0">4</h4>
                                    </div>
                                    <div className={(activeId === 'insured' ? 'text-primary text-nowrap d-block' : 'd-none') + " text-center text-break description"}>Insured Details</div>
                                </div>
                                <div className={(steps.indexOf(activeId) >= steps.indexOf('payment') ? "" : "opacity-25") + " d-inline-block position-relative pt-5 align-text-top step last"} onClick={() => { steps.indexOf(activeId) >= steps.indexOf('payment') ? setActiveId('payment') : null }}>
                                    <div className={(steps.indexOf(activeId) >= steps.indexOf('payment') ? 'bg-secondary clickable' : 'bg-primary') + " d-block text-white position-absolute border rounded-circle text-center px-1 order"}>
                                        <h4 className="fw-bold text-white mb-0">5</h4>
                                    </div>
                                    <div className={(activeId === 'payment' ? 'text-primary text-nowrap d-block' : 'd-none') + " text-center text-break description"}>Payment Summary</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mt-5">
                    <div className="col-12">
                        <div className="row content">
                            <div className="col-lg-1"></div>
                            <div className="col-12 col-lg-10 shadow bg-white rounded p-3 p-sm-5">
                                <Tabs activeKey={activeId} variant="tabs">
                                    <Tab eventKey="travel">
                                        <Travel dropOffTrigger={dropOffTrigger} activeId={activeId} setActiveId={setActiveId} setTravelInfo={setTravelInfo} travelInfo={travelInfo} setToken={setToken} token={token} travelInfoParams={travelInfoParams}
                                        getMsigToken={getMsigToken} setAllNationalities={setAllNationalities} allNationalities={allNationalities} referral={props.referral} tuneToken={tuneToken}
                                        setMalNationality={setMalNationality} malNationality={malNationality} transactionNo={transactionNo} 
                                        setShowModal={setShowModal} showModal={showModal} setLoadPlan={setLoadPlan} basicName={basicName}
                                        setBasicName={setBasicName} setBasicEmailAdd={setBasicEmailAdd} setBasicContactNo={setBasicContactNo} setTransactionId={setTransactionId}
                                        renewalInfo={renewalInfo} setRenewalInfo={setRenewalInfo} setShowRenewalModal={setShowRenewalModal} showRenewalModal={showRenewalModal} renewalParam={props.renewalParam} renewalTag={props.renewalTag}
                                        loadMSIGToken={loadMSIGToken} loadTuneToken={loadTuneToken}
                                        apiToken={apiToken} setApiToken={setApiToken}
                                        />
                                    </Tab>
                                    <Tab eventKey="plan">
                                        <Plan dropOffTrigger={dropOffTrigger} activeId={activeId} setActiveId={setActiveId} travelInfo={travelInfo} setSelectedPlan={setSelectedPlan} setToken={setToken} token={token} getMsigToken={getMsigToken} transactionNo={transactionNo} queryParam={queryParam}
                                        transactionId={transactionId} setTransactionId={setTransactionId} referral={props.referral} setReferral={props.setReferral} tuneToken={tuneToken}
                                        loadPlan={loadPlan} basicName={basicName} basicEmailAdd={basicEmailAdd} basicContactNo={basicContactNo} apiToken={apiToken}
                                        renewalInfo={renewalInfo} setRenewalInfo={setRenewalInfo}
                                        />
                                    </Tab>
                                    <Tab eventKey="add-on">
                                        <AddOn dropOffTrigger={dropOffTrigger} activeId={activeId}
                                            setActiveId={setActiveId} travelInfo={travelInfo} selectedPlan={selectedPlan} setSelectedAddOns={setSelectedAddOns} referral={props.referral}
                                            grossPremium={grossPremium} setGrossPremium={setGrossPremium} setServiceTax={setServiceTax} setStampDuty={setStampDuty} addOnsTotal={addOnsTotal} setAddOnsTotal={setAddOnsTotal}
                                            totalPayable={totalPayable} setTotalPayable={setTotalPayable} stampDuty={stampDuty} serviceTax={serviceTax} transactionNo={transactionNo}
                                            transactionId={transactionId} setTransactionId={setTransactionId} apiToken={apiToken}
                                            renewalInfo={renewalInfo} setRenewalInfo={setRenewalInfo}
                                        />
                                    </Tab>
                                    <Tab eventKey="insured">
                                        <Insured activeId={activeId} referral={props.referral}
                                            setActiveId={setActiveId} travelInfo={travelInfo} selectedPlan={selectedPlan} setSelectedPlan={setSelectedPlan}
                                            selectedAddOns={selectedAddOns} setSelectedAddOns={setSelectedAddOns} setInsuredInfo={setInsuredInfo} tuneToken={tuneToken}
                                            grossPremium={grossPremium} setGrossPremium={setGrossPremium} setServiceTax={setServiceTax} setStampDuty={setStampDuty} addOnsTotal={addOnsTotal} setAddOnsTotal={setAddOnsTotal}
                                            totalPayable={totalPayable} setTotalPayable={setTotalPayable} stampDuty={stampDuty} serviceTax={serviceTax} 
                                            setToken={setToken} token={token} getMsigToken={getMsigToken} setAllNationalities={setAllNationalities} allNationalities={allNationalities} 
                                            setMalNationality={setMalNationality} malNationality={malNationality} transactionNo={transactionNo} 
                                            dropOffTrigger={dropOffTrigger} basicName={basicName} basicEmailAdd={basicEmailAdd} basicContactNo={basicContactNo} 
                                            transactionId={transactionId} setTransactionId={setTransactionId} apiToken={apiToken}
                                            renewalInfo={renewalInfo} setRenewalInfo={setRenewalInfo}
                                        />
                                    </Tab>
                                    <Tab eventKey="payment">
                                        <Payment dropOffTrigger={dropOffTrigger}
                                            activeId={activeId} setActiveId={setActiveId}
                                            travelInfo={travelInfo} selectedPlan={selectedPlan} selectedAddOns={selectedAddOns} setSelectedAddOns={setSelectedAddOns} insuredInfo={insuredInfo}
                                            totalPayable={totalPayable} addOnsTotal={addOnsTotal} serviceTax={serviceTax} stampDuty={stampDuty} grossPremium={grossPremium} 
                                            setToken={setToken} token={token} getMsigToken={getMsigToken} transactionNo={transactionNo} referral={props.referral} tuneToken={tuneToken}
                                            transactionId={transactionId} setTransactionId={setTransactionId} apiToken={apiToken}
                                            renewalInfo={renewalInfo} setRenewalInfo={setRenewalInfo}
                                        />
                                    </Tab>
                                </Tabs>
                            </div>
                            <div className="col-lg-1"></div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

// Validation for input only
function Travel(props) {
    const [tripType, setTripType] = useState("");
    const [allDestinations, setAllDestinations] = useState([]);

    const [previuosTripType, setPreviuosTripType] = useState("");

    const [allAreasBk] = useState([
        { value: 'L', label: 'Area 1', axa_zone: 1, chubb_zone: 1, aig_zone: 1, msig_zone: 1, zurichTakaful_zone: 1, tune_zone: 1, countries: 'Australia, Brunei, Cambodia, China (excluding Mongolia & Tibet), Hong Kong, India, Indonesia, Japan, South Korea, Laos, Macau,  Maldives, Myanmar, New Zealand,  Pakistan, Philippines, Singapore, Sri Lanka, Taiwan, Thailand, and Vietnam.' },
        { value: 'M', label: 'Area 2', axa_zone: 2, chubb_zone: 2, aig_zone: 2, msig_zone: 2, zurichTakaful_zone: 2, tune_zone: 2, countries: 'Bhutan, Europe, Mongolia, Nepal, Tibet, United Kingdom and countries in Area 1 but excluding Belarus, Russia and Ukraine.' },
        { value: 'N', label: 'Area 3', axa_zone: 3, chubb_zone: 3, aig_zone: 3, msig_zone: 3, zurichTakaful_zone: 3, tune_zone: 3, countries: 'Worldwide and countries in Area 1 and 2 but excluding Afghanistan, Belarus, Cuba, Democratic   Republic of Congo, Iran, Iraq, North Korea, Russia, Sudan, Syria, Ukraine, and Venezuela.' },
       // { value: 4, label: 'Area 4', axa_zone: 4, chubb_zone: 4, aig_zone: 4, msig_zone: 4, zurichTakaful_zone: 4, tune_zone: 4, countries: 'Applicable to single trip between Peninsular and East Malaysia and vice versa. Area 4 is part of the cover of Annual Policy.' },
    ]);

    const [allAreas] = useState([
        { value: 'L', label: 'Asia Pacific (Exc. Mongolia and Tibet)', axa_zone: 1, chubb_zone: 1, aig_zone: 1, msig_zone: 1, zurichTakaful_zone: 1, tune_zone: 0, countries: 'Excluding Belarus, Cuba, Iran, North Korea, Russia inc Crimea, Syria, Ukraine (inc Crimea, Donestk, Luhansk, Kaporizhzhia, Kherson), Venezuela, and Yemen.' },
        { value: 'A', label: 'Asia Pacific (Inc. Mongolia and Tibet)', axa_zone: 1, chubb_zone: 1, aig_zone: 1, msig_zone: 0, zurichTakaful_zone: 1, tune_zone: 1, countries: 'Excluding Belarus, Cuba, Iran, North Korea, Russia inc Crimea, Syria, Ukraine (inc Crimea, Donestk, Luhansk, Kaporizhzhia, Kherson), Venezuela, and Yemen.'},
        { value: 'M', label: 'Worldwide (Exc. USA, Canada, Belarus, Russia and Ukraine)', axa_zone: 2, chubb_zone: 2, aig_zone: 2, msig_zone: 2, zurichTakaful_zone: 2, tune_zone: 2, countries: 'Excluding Belarus, Cuba, Iran, North Korea, Russia inc Crimea, Syria, Ukraine (inc Crimea, Donestk, Luhansk, Kaporizhzhia, Kherson), Venezuela, and Yemen.' },
        { value: 'N', label: 'Worldwide (Inc. USA and Canada)', axa_zone: 3, chubb_zone: 3, aig_zone: 3, msig_zone: 3, zurichTakaful_zone: 3, tune_zone: 3, countries: 'Excluding Belarus, Cuba, Iran, North Korea, Russia inc Crimea, Syria, Ukraine (inc Crimea, Donestk, Luhansk, Kaporizhzhia, Kherson), Venezuela, and Yemen.' },
        { value: 'B', label: 'Domestic (Within Malaysia)', axa_zone: 0, chubb_zone: 0, aig_zone: 0, msig_zone: 0, zurichTakaful_zone: 0, tune_zone: 4, countries: 'Within Malaysia' },
        // { value: 4, label: 'Area 4', axa_zone: 4, chubb_zone: 4, aig_zone: 4, msig_zone: 4, zurichTakaful_zone: 4, tune_zone: 4, countries: 'Applicable to single trip between Peninsular and East Malaysia and vice versa. Area 4 is part of the cover of Annual Policy.' },
    ]);

    const area1Options = [
        { value: 'L', label: 'Area 1 - Australia, Brunei, Cambodia, China (excluding Mongolia & Tibet), Hong Kong, India, Indonesia, Japan, South Korea, Laos, Macau,  Maldives, Myanmar, New Zealand,  Pakistan, Philippines, Singapore, Sri Lanka, Taiwan, Thailand, and Vietnam.', axa_zone: 1, chubb_zone: 1, aig_zone: 1, msig_zone: 1, zurichTakaful_zone: 1, tune_zone: 1, countries: 'Australia, Brunei, Cambodia, China (excluding Mongolia & Tibet), Hong Kong, India, Indonesia, Japan, South Korea, Laos, Macau,  Maldives, Myanmar, New Zealand,  Pakistan, Philippines, Singapore, Sri Lanka, Taiwan, Thailand, and Vietnam.' }
    ];

    const area2Options = [
        { value: 'M', label: 'Area 2 - Bhutan, Europe, Mongolia, Nepal, Tibet, United Kingdom and countries in Area 1 but excluding Belarus, Russia and Ukraine.', axa_zone: 2, chubb_zone: 2, aig_zone: 2, msig_zone: 2, zurichTakaful_zone: 2, tune_zone: 2, countries: 'Bhutan, Europe, Mongolia, Nepal, Tibet, United Kingdom and countries in Area 1 but excluding Belarus, Russia and Ukraine.' },
    ];

    const area3Options = [
        { value: 'N', label: 'Area 3 - Worldwide and countries in Area 1 and 2 but excluding Afghanistan, Belarus, Cuba, Democratic   Republic of Congo, Iran, Iraq, North Korea, Russia, Sudan, Syria, Ukraine, and Venezuela.', axa_zone: 3, chubb_zone: 3, aig_zone: 3, msig_zone: 3, zurichTakaful_zone: 3, tune_zone: 3, countries: 'Worldwide and countries in Area 1 and 2 but excluding Afghanistan, Belarus, Cuba, Democratic   Republic of Congo, Iran, Iraq, North Korea, Russia, Sudan, Syria, Ukraine, and Venezuela.' },
    ];

    const groupedOptions = [
        {
          label: "Area 1",
          options: area1Options
        },
        {
          label: "Area 2",
          options: area2Options
        },
        {
            label: "Area 3",
            options: area3Options
          }
    ];

    const [allBuyFor] = useState([
        { value: 'IO', label: 'Insured Only'},
        { value: 'IS', label: 'Insured & Spouse'},
        { value: 'FC', label: 'Family with Child(ren)'},
    ]);
  
    const [destination, setDestination] = useState({});
    const [area, setArea] = useState({});
    const [departureDate, setDepartureDate] = useState("");
    const [returnDate, setReturnDate] = useState("");
    const [planType, setPlanType] = useState("");
    const [dateOfBirth, setDateOfBirth] = useState("");
    const swalAlert = withReactContent(Swal);

    //MSIG
    const [buyFor, setBuyFor] = useState(""); //IO, IS, FC , IC - Child, GP - Group
    const [noOfAdults, setNoOfAdults] = useState("");
    const [noOfChildren, setNoOfChildren] = useState("");
    const [noOfPersons, setNoOfPersons] = useState("");
    
    const [msigCountryCode, setMsigCountryCode] = useState([]);
    const [msigPlanDetails, setMsigPlanDetails] = useState([]);
    const [msigMainPlan, setMsigMainPlan] = useState([]);
    const [productType, setProductType] = useState(""); //TAA, TDA
    const [tripCode, setTripCode] = useState(""); // S, A
    const [travelTo, setTravelTo] = useState(""); // I,J,K,L ,  L,M,N
    const [areaCountryList, setAreaCountryList] = useState("");
    const [region, setRegion] = useState("");

    const [allNationality, setAllNationality] = useState([]);
    const [nationality, setNationality] = useState("");
    const [nationalityCountry, setNationalityCountry] = useState("");
    const [nationalityCountryObj, setNationalityCountryObj] = useState({});
    
    const [availableAllType, setAvailableAllType] = useState(true);
    const [maxAdult, setMaxAdult] = useState(2);
    const [maxChild, setMaxChild] = useState("");
    const [isIsrael, setIsIsrael] = useState(false);
    const [destinationList, setDestinationList] = useState("");

    const [defaultDestinations, setDefaultDestinations] = useState([]); //single trip
    const [defaultAreas, setDefaultAreas] = useState([]); //Annual trip

    const [testMobile, setTestMobile] = useState([]); 

    const [agreedPlan, setAgreedPlan] = useState("");

    const [captchaResponse, setCaptchaResponse] = useState(true);
    const [validationResponse, setValidationResponse] = useState(true);
    const [verificationResponse, setVerificationResponse] = useState(false);
    const [capchaToken, setCapchaToken] = useState('');
    const recaptchaRef = useRef(null);
    const [validToken, setValidToken] = useState('');

     const handleRecaptcha = useCallback((token) => {
            setCapchaToken(token || '');
    
            if(token.length > 0) {
                var captchaWidget = document.getElementById('captchaV');
                captchaWidget.style.border = '';

                setCaptchaResponse(true);
                setValidationResponse(true);
                setVerificationResponse(false);

                verifyCaptcha(token);
            }
        }, []);
          
        // useEffect(() => {
        //     const refreshCaptcha = () => {
        //     if (recaptchaRef.current && capchaToken) {
        //         recaptchaRef.current.reset();
        //         setCapchaToken('');
        //     }
        //     };
        
        //     let tokenRefreshTimeout = null;
        
        //     if (capchaToken) {
        //     tokenRefreshTimeout = setTimeout(refreshCaptcha, 110000); // 110 seconds
        //     }
        
        //     return () => {
        //     if (tokenRefreshTimeout) {
        //         clearTimeout(tokenRefreshTimeout);
        //     }
        //     };
        // }, [capchaToken]);

    useEffect(() => {
        if(!isEmpty(props.travelInfoParams.destination))
        {
            
            if( props.travelInfoParams.tripType == 'Annual')
            {
               

                setDefaultAreas(props.travelInfoParams.destination);
                
            } else {


                props.travelInfoParams.destination.forEach((destObj) => {

                    setDefaultDestinations(destObj);
        
                });


            }

        }
      
    }, [allDestinations,props.travelInfoParams.destination]);

    

    useEffect(() => {
      
        if (!isEmpty(props.travelInfoParams)) {
            console.log('props.travelInfoParams');
            console.log(props.travelInfoParams);
           // setTripType(props.travelInfoParams.tripType),

            setTripType(props.travelInfoParams.tripType);
            setArea(props.travelInfoParams.area);

            
           setDestination(props.travelInfoParams.destination);
            setDestinationList(props.travelInfoParams.destinationList);

            
            setDepartureDate(new Date(Moment(props.travelInfoParams.departureDate, 'DD/MM/YYYY').format('YYYY/MM/DD')));
            setReturnDate(new Date(Moment(props.travelInfoParams.returnDate, 'DD/MM/YYYY').format('YYYY/MM/DD')));
            setDateOfBirth(new Date(Moment(props.travelInfoParams.dateOfBirth, 'DD/MM/YYYY').format('YYYY/MM/DD')));
            setPlanType(props.travelInfoParams.planType);
            setBuyFor(props.travelInfoParams.buyFor);
            setNoOfAdults(props.travelInfoParams.noOfAdults);
            setNoOfChildren(props.travelInfoParams.noOfChildren);
            setNoOfPersons(props.travelInfoParams.noOfPersons);
            setMsigPlanDetails(props.travelInfoParams.msigPlanDetails);
            setProductType(props.travelInfoParams.productType);
            setTripCode(props.travelInfoParams.tripCode);
            setTravelTo(props.travelInfoParams.travelTo);
            setAreaCountryList(props.travelInfoParams.areaCountryList);
            setNationality(props.travelInfoParams.nationality);
            //setProceedManual(props.travelInfoParams.allowManual);
            //destination: tripType == 'Annual' ? area :destination,
            //area: area,
            //destinationLst: destinationList,
            //departureDate: Moment(departureDate).format('DD/MM/YYYY'),
            //returnDate: Moment(returnDate).format('DD/MM/YYYY'),
            //dateOfBirth: Moment(dateOfBirth).format('DD/MM/YYYY'),
            //planType: planType,
            //buyFor: buyForCode,
            //noOfAdults: noOfAdults,
            //noOfChildren: noOfChildren,
            //noOfPersons: noOfPersons,
           // msigPlanDetails:msigPlanDetails,
            //productType: productType, //TAA, TDA
            //tripCode: tripCode, //S, A
            //travelTo: travelTo, //(S) I, J, K, L , (A) L,M,N 
            //areaCountryList: areaCountryList,
            //nationality: nationality,
            //allowManual: proceedManual ,

             props.setTravelInfo(props.travelInfoParams);
        }
    }, [props.travelInfoParams]);
    
    

    useEffect(() => {
      
        if(props.loadMSIGToken == true && props.loadTuneToken == true) {
                swalAlert.close();
        }

    }, [props.loadMSIGToken, props.loadTuneToken]);
    

    useEffect(() => {
      
    
       //setReturnDate(new Date(Moment(departureDate, 'DD/MM/YYYY').add(1, 'years').subtract(1, 'days').format('YYYY/MM/DD')))

        if (isEmpty(props.travelInfo) || isEmpty(allDestinations)) {
            swalAlert.fire({
                title: 'Please Wait...',
                allowOutsideClick: false
            });
            swalAlert.showLoading();

            axios.get('/api/countries')
                .then((response) => {
                   setAllDestinations(response.data.countries);
                   setAllNationality(response.data.nationality);

                   props.setAllNationalities(response.data.nationality);
                   props.setMalNationality(response.data.mal);

                   updateNationality(response.data.mal);


                    //swalAlert.close()
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    }, [props.travelInfo]);






    // useEffect(() => {

    //     if(!isEmpty(props.token)) {

    //         ChangeTripType('Single Return Trip');
    //     }

    // }, [props.token]);

    {/*useEffect(() => {
        setReturnDate("");

	var dayOfWeek = 0;
	 if (validator.isDate(departureDate)) {
    	  dayOfWeek = departureDate.getDay();
    	 }
	var isWeekend = (dayOfWeek === 6) || (dayOfWeek  === 0);

	if (isWeekend===true && departureDate !== ""){
   		 swalAlert.fire({
                title: 'Oops...',
                icon: 'error',
                text: 'Sorry, we\'re unable to process your request on time.',
            })
		if(tripType === 'Annual' && departureDate !== "") {
           	 setReturnDate(new Date(Moment(departureDate, 'DD/MM/YYYY').add(1, 'years').subtract(1, 'days').format('YYYY/MM/DD')))
        	}

        } else if(departureDate !== "" && ((Moment(departureDate).format('DD/MM/YYYY') == Moment().format('DD/MM/YYYY') && Moment().hour() >= 16) ||
        (Moment(departureDate).format('DD/MM/YYYY') === Moment().add(1, 'day').format('DD/MM/YYYY') && Moment().hour() >= 16 && Moment().day() === 5)
        || (Moment().day() === 5 && Moment().hour() >= 16 && 
        (Moment(departureDate).format('DD/MM/YYYY') == Moment(Moment().day(6)).format('DD/MM/YYYY') || Moment(departureDate).format('DD/MM/YYYY') == Moment(Moment().day(7)).format('DD/MM/YYYY') )))) {
         swalAlert.fire({
                title: 'Oops...',
                icon: 'error',
                text: 'Sorry, we\'re unable to process your request on time.',
            })
		if(tripType === 'Annual' && departureDate !== "") {
           	 setReturnDate(new Date(Moment(departureDate, 'DD/MM/YYYY').add(1, 'years').subtract(1, 'days').format('YYYY/MM/DD')))
        	}

	} else if(tripType === 'Annual' && departureDate !== "") {
            setReturnDate(new Date(Moment(departureDate, 'DD/MM/YYYY').add(1, 'years').subtract(1, 'days').format('YYYY/MM/DD')))
        }
    }, [departureDate]);
	*/}

    useEffect(() => {
       
        if(!isEmpty(props.renewalInfo)) {


            const renewalStartDate = addDays(new Date(props.renewalInfo.coverage_to), 1);
           
            setDepartureDate(new Date(renewalStartDate));
           
        }

    }, [props.renewalInfo]);


    useEffect(() => {
       
        if(isEmpty(props.travelInfoParams)) {
            setReturnDate("");

            if (tripType === 'Annual' && departureDate !== "") {
                setReturnDate(new Date(Moment(departureDate, 'DD/MM/YYYY').add(1, 'years').subtract(1, 'days').format('YYYY/MM/DD')))
            }

        }
      
    }, [departureDate]);

    

    useEffect(() => {

        if(tripType !== 'Annual')
        {  
            if(!isEmpty(destination))
            {

                let countryList = [];
                destination.forEach((destObj) => {

                    setIsIsrael(false);
                    if(destObj.label == 'Israel')
                    {
                        setIsIsrael(true);
                    }

                    countryList.push(destObj.label);
        
                });

                setDestinationList(countryList.join(', '));

            }
        }
       

    }, [destination]);


    // useEffect(() => {


      
    //     if (planType == 'Family' && age > 65) {
    //         swalAlert.fire({
    //             title: 'Oops...',
    //             icon: 'error',
    //             text: 'You have exceeded the eligible age for Famiy Plan. Kindly select individual plan instead.'
    //         }).then((result) => {
    //             if (result.isConfirmed) {
    //                 setDateOfBirth("");
    //             }
    //         });
    //     }
    // }, [dateOfBirth]);

    useEffect(() => {
       
        if(isEmpty(props.travelInfoParams)) {
            if (tripType === 'Annual' && departureDate !== "") {
                setReturnDate(new Date(Moment(departureDate, 'DD/MM/YYYY').add(1, 'years').subtract(1, 'days').format('YYYY/MM/DD')));
            } else {
                setReturnDate("");
            }
        }

    }, [tripType]);


    function ChangeTripType(e) {

      

        // if(!isEmpty(previuosTripType) && e != previuosTripType ) {
        //     setDestination({});
        //     $("#destination").find(".css-1rhbuit-multiValue").html("");
        //     $("#zone").find(".css-1uccc91-singleValue").html("");
           
        // }
     
        setTripType(e);  
        setPreviuosTripType(e);

        getMsigProductDetails(e);
       // getBenefitPremium(e)
       
    }

    function handleCardNumberChange(e) {

        if(e.charAt(0) == '0') {
            let result = '' + e.slice(1);
            setTestMobile(result);

        } else {
            setTestMobile(e);
        }

    }

    function  getBenefitPremium(trip) {

        var productType = productTypeMapping(trip);

        setProductType(productType);

        var tripCodeMap =  tripCodeMapping(productType);
        setTripCode(tripCodeMap);

        swalAlert.fire({
            title: 'Please Wait...',
            allowOutsideClick: false
        });
        swalAlert.showLoading();

        axios.post('/api/get-benefit-premium', {
            productType: productType,
            insurer: insurer_msig,
            token: props.token,
            tuneToken: props.tuneToken,
            transactionNo: props.transactionNo
            }).then((response) => {
              
               var responseData = JSON.parse(response.data.data);
            
                if(response.status == 200 && response.data.status == 200) {
    
                    var msigCountryCode = responseData.destinationDetails.destinationDetail;
    
                    //Set available countries
                    var msigContryValues = [];
    
                    $.each(msigCountryCode, function (i, obj) {
                           var travelCode = travelCodeToLabelMapping(obj.destinationCode);
                            msigContryValues.push({
                                value: obj.destinationCode,
                                label: 'Area '+travelCode,
                                area: travelCode,
                                countries: obj.destinationValue  
                            })
        
                    });
    
                  
                    setAllAreas(msigContryValues);
        
                    var msigPlanDetails = responseData.planDetails.planDetail;
                    var msigPlansValues = [];
    
                    $.each(msigPlanDetails, function (i, obj) {
                       
                        if(trip === 'Annual')
                        {
                           
                            if(annualSelectedPlan.includes(obj.planId)) {
                                msigPlansValues.push(obj);   
                            }
                            
                        } else {
                            msigPlansValues.push(obj);
                        }
                     
                    });   
                   
                    setMsigPlanDetails(msigPlansValues);
        
                }
    
                swalAlert.close();
    
             
    
            }).catch((error) => {
                swalAlert.close()
                console.log(error);
            });
    

    }
    
    function getMsigProductDetails(trip) {

        var productType = productTypeMapping(trip);

        setProductType(productType);

        var tripCodeMap =  tripCodeMapping(productType);
        setTripCode(tripCodeMap);

        // swalAlert.fire({
        //     title: 'Please Wait...',
        //     allowOutsideClick: false
        // });
        // swalAlert.showLoading();

        if(trip === 'Annual') {

            setAvailableAllType(false);

            // setPlanType('Individual');
            // setNoOfAdults(1);
            // setNoOfChildren('');


        } else {
            setAvailableAllType(true);
        }

    //    axios.post('/api/get-travel-product-details', {
    //     productType: productType,
    //     insurer: insurer_msig,
    //     token: props.token
    //     }).then((response) => {
          
    //        var responseData = JSON.parse(response.data.data);
        
    //         if(response.status == 200 && response.data.status == 200) {

    //             var msigCountryCode = responseData.destinationDetails.destinationDetail;

    //             //Set available countries
    //             var msigContryValues = [];

    //             $.each(msigCountryCode, function (i, obj) {
    //                    var travelCode = travelCodeToLabelMapping(obj.destinationCode);
    //                     msigContryValues.push({
    //                         value: obj.destinationCode,
    //                         label: 'Area '+travelCode,
    //                         area: travelCode,
    //                         countries: obj.destinationValue  
    //                     })
    
    //             });

              
    //             setAllAreas(msigContryValues);
    
    //             // var msigPlanDetails = responseData.planDetails.planDetail;
    //             // var msigPlansValues = [];

    //             // $.each(msigPlanDetails, function (i, obj) {
                   
    //             //     if(trip === 'Annual')
    //             //     {
                       
    //             //         if(annualSelectedPlan.includes(obj.planId)) {
    //             //             msigPlansValues.push(obj);   
    //             //         }
                        
    //             //     } else {
    //             //         msigPlansValues.push(obj);
    //             //     }
                 
    //             // });   
               
    //             // setMsigPlanDetails(msigPlansValues);
    
    //         }

    //         swalAlert.close();

    //         // if(trip == 'Annual') {
    //         //     swalAlert.close();
    //         // }

    //     }).catch((error) => {
    //         swalAlert.close()
    //         console.log(error);
    //     });

    }

    
    function productTypeMapping(trip) {

        var product = '';

        switch(trip) {
            case 'Single Return Trip':
                product = 'TAA';
              break;
            case 'Annual':
                product = 'TDA';
              break;
            case 'One-way':
                product = 'ONE';
              break;  
            default:
              
          }

         return product; 
    }

    //S, A
    function tripCodeMapping(product) {
        var code = '';
        switch(product) {
            case 'TAA':
                code = 'S';
              break;
            case 'TDA':
                code = 'A';
              break;
            case 'ONE':
                code = 'O';
              break;  
            default:   
          }
         return code; 
    }

    function buyForMapping(plan) {
        var buy = '';
        switch(plan) {
            case 'Individual':
                buy = 'IO';
              break;
            case 'InsuredSpouse':
                buy = 'IS';
              break;
            case 'Child':
               buy = 'IC'
              break;    
            case 'Family':
                buy = 'FC';
              break;  
            case 'Group':
                buy = 'GP';
              break;     
            default:
              
          }
         
         return buy; 
    }

    function updatePlanType(e) {
        setPlanType(e);
        
        switch(e) {
            case 'Individual':
                setNoOfAdults(1);
                setNoOfChildren('');
              break;
            case 'InsuredSpouse':
                setNoOfAdults(2);
                setNoOfChildren('');
              break;
            case 'Child': // individual Child
                setNoOfAdults('');
                setNoOfChildren(1);
              break;  
            case 'Family':
                setNoOfAdults(2);
                setNoOfChildren(1);
              break;
            case 'Group':
                setNoOfAdults('');
                setNoOfChildren('');
              break;   
            default:
          }
    }

    function updateNationalityCountry(e) {

        // setNationality(e.label); // inusered
        setNationalityCountry(e.countrycode); //insured
        setNationalityCountryObj(e);

    }

    function FamilyDeclaration(e) {

        setPlanType(e);
        updatePlanType(e);
        swalAlert.fire({
            title: "Are you sure?",
            //text: "If you select the Family plan, it is essential to include yourself, your spouse or child.",
            text: "If you select Family Plan, you must include yourself and/or your spouse and at least one child.",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Yes',
            cancelButtonText: "No",
            closeOnConfirm: false,
            closeOnCancel: false
         }).then((result) => {	
            if (result){
            setbuttondisabled(false);  
            } else {
               setbuttondisabled(true);  
    
                 e.preventDefault();
            }
         });           
    }

    function ChildDeclaration(e)  {
        setPlanType(e);
        updatePlanType(e);
        swalAlert.fire({
            title: "Are you sure?",
            //text: "If you select the Family plan, it is essential to include yourself, your spouse or child.",
            text: "If you select the Child plan, the Child must be from 30 days old to 19 years old (or up to 23 years old if they're still studying, unmarried and unemployed).",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Yes',
            cancelButtonText: "No",
            closeOnConfirm: false,
            closeOnCancel: false
         }).then((result) => {	
            if (result){
            setbuttondisabled(false);  
            } else {
               setbuttondisabled(true);  
    
                 e.preventDefault();
            }
         });           
    }

    function GroupDeclaration(e)  {
        setPlanType(e);
        updatePlanType(e);
        swalAlert.fire({
           // title: "Are you sure?",
            //text: "If you select the Family plan, it is essential to include yourself, your spouse or child.",
            text: " Number of travellers in Group plan is up to maximum 6.",
            type: "info",
            //showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Ok',
            cancelButtonText: "No",
            closeOnConfirm: false,
           // closeOnCancel: false
         }).then((result) => {	
            if (result){
            setbuttondisabled(false);  
            } else {
               setbuttondisabled(true);  
    
                 e.preventDefault();
            }
         });           
    }

    function updateTravelTo(e) {
        setDestination(e);
        
        setDefaultDestinations(e);
        //var travelToCode = travelToCodeMapping(e.msig_zone);
        //setTravelTo(travelToCode);
      
    }

    function updateNationality(e) {
        setNationality(e.countrycode);
      
    }

    function updateTravelCountryCode(e) {
        //setDestination(e);
        setArea(e);
        setDefaultAreas(e);
        //var travelToCode = travelToCodeMapping(e.msig_zone);
        setTravelTo(e.value);

        if(e.value == "B") {
            setPlanType("Individual");
            setNoOfAdults(1);
            setNoOfChildren('');
        }
        
    }

    function travelToCodeMapping(msig_zone) {
        var code = '';
        switch(msig_zone) {
            case  1 :
                code =  'I';
               if(productType == 'TDA') {
                    code =  'L';
               }
              break;
            case 2 :
                code =  'J';
                if(productType == 'TDA') {
                    code =  'M';
               }
              break;
            case 3 :
                code =  'K';
                if(productType == 'TDA') {
                    code =  'N';
               }
              break; 
            case 4 :
                code =  'L';
                if(productType == 'TDA') {
                    code =  '';
               }
              break;    
            default:
              
          }

         return code; 
    }


    function travelCodeToLabelMapping(msig_zone) {
        var label = '';
        switch(msig_zone) {
            case 'L':
            case 'I':    
                label =  '1';
              break;
            case 'M' :
            case 'J': 
                label =  '2';
              break;
            case 'N' :
            case 'K' :
                label =  '3';
              break; 
            default:
          }

         return label; 
    }

    function updateRegion(e) {
        setRegion(e.value);
    }

    function verifyCaptcha(token) {

        if(!isEmpty(token))
        {    

            setValidToken(token);

            var captchaWidget = document.getElementById('captchaV');

            captchaWidget.style.border = '';

            axios.post('/api/get-captcha', {
                response: token
            }).then(function (response) {
                    
                    let cresponse = response.data;
                    if(cresponse.success == true) {
                        setValidationResponse(true);
                        setVerificationResponse(true);
                       // grecaptcha.reset();
                    } else {
                        setValidationResponse(false);
                        setVerificationResponse(false);

                        swalAlert.fire({
                            title: 'Oops...',
                            icon: 'error',
                            text: 'Captcha verification Failed. Please try again.'
                        });

                        return false;
                    }
            }).catch(function (error) {
                    console.log(error);
            });
        }

    }


    function onClickNext(e) {
        e.preventDefault();

        let currYear =Moment(departureDate).format('YYYY');
        let dobYear = Moment(dateOfBirth).format('YYYY');
        let diffYear = (parseInt(currYear) - parseInt(dobYear));

        let age = Moment(departureDate, 'DD/MM/YYYY').diff(Moment(dateOfBirth), 'years',false);

       
        let proceedManual = true;

        // if(!isEmpty(dateOfBirth)) {
    
        //     if(age < 18) {
               
        //         proceedManual = false;
        //     }
        // }
        

        //if ((planType != 'Child') &&  (diffYear > 80 || diffYear < 18)) {
        if ((planType != 'Child') &&  age < 18) {
            swalAlert.fire({
                title: 'Oops...',
                icon: 'error',
                text: 'Age of Insured must between 18 and above.'
            }).then((result) => {
                if (result.isConfirmed) {
                    setDateOfBirth("");
                }
            });

            return false;
        } 


        if (planType == 'Child' && 
        ((parseInt(Moment(departureDate, 'DD/MM/YYYY').diff(Moment(dateOfBirth), 'days')) < 15 ) || age > 23)) 
        {

                swalAlert.fire({
                    title: 'Oops...',
                    icon: 'error',
                    text: "Sorry, Age of Child must between 15 days to 23 years old."
                }).then((result) => {
                    if (result.isConfirmed) {
                        setDateOfBirth("");
                    }
                });

                return false;

        }

        if (planType == 'Group' && noOfPersons > 6) {
            swalAlert.fire({
                title: 'Oops...',
                icon: 'error',
                text: 'Total number of people in Group Plan is up to maximum 6.',
            }).then((result) => {
                if (result.isConfirmed) {
                    setNoOfPersons("");
                }
            });

            return false;
        } 

        if (planType == 'Family') {
            // swalAlert.fire({
            //     title: 'Oops...',
            //     icon: 'error',
            //     text: 'You have exceeded the eligible age for Famiy Plan. Kindly select individual plan instead.'
            // }).then((result) => {
            //     if (result.isConfirmed) {
            //         setDateOfBirth("");
            //     }
            // });

            // return false;
           
            if(tripType == 'Annual' && age > 70) {
            proceedManual = false;
        }

        }

        if(planType != 'Individual' && planType != 'Family' && planType != 'Group' && planType != 'Child') {
           
            proceedManual = false;
        }

       
        if(tripType != 'Annual' && Object.keys(destination).length > 1) 
        {
            proceedManual = false;
        }

        //One-way || Single Return Trip block for age 56
        /* if(tripType === "One-way" || tripType === "Single Return Trip" && planType == 'Family' && (Moment(departureDate).diff(Moment(dateOfBirth), 'days') / 365) > 56) {
            swalAlert.fire({
                title: 'Oops...',
                icon: 'error',
                text: 'You have exceeded the eligible age for Famiy Plan. Kindly select individual plan instead.'
            }).then((result) => {
                if(result.isConfirmed) {
                    setDateOfBirth("");
                }
            });

            return false;
        } */

        let requiredChilden = false;
        if(planType == 'Family' && noOfChildren < 1)
        {
            requiredChilden = true;
        }

        let requiredAdult = false;
        if(planType != 'Child' && planType != 'Group' && noOfAdults < 1)
        {
            requiredAdult = true;
        }

        let requiredNoOfPersons = false;
        if(planType == 'Group' && noOfPersons < 1)
        {
            requiredNoOfPersons = true;
        }

        let requiredDestination = false;
        if(tripType == 'Annual') {
            if(isEmpty(area)) {
                requiredDestination = true;
            }
        } else {
            if(isEmpty(destination)) {
                requiredDestination = true;
            }
        }

        let requiredNationalityCountry = false;
        if(nationality == 'ALL' && isEmpty(nationalityCountry))
        {
            requiredNationalityCountry = true;
        }

        let requiredReturnDate = false;
        if(tripType == 'One-way') {
            requiredReturnDate = false;
        } else {
            if(returnDate === "" ) {
                requiredReturnDate = true;
            } else {
                requiredReturnDate = false;
            }
        }

        if (tripType === "" || requiredDestination == true || departureDate === "" || requiredReturnDate == true || planType === "" || dateOfBirth === "" || requiredAdult == true || requiredChilden == true || requiredNoOfPersons == true) {
            swalAlert.fire({
                title: 'Oops...',
                icon: 'error',
                text: 'Please complete all the required fields.'
            });

            return false;
        }

        if(requiredNationalityCountry == true) {

            swalAlert.fire({
                title: 'Oops...',
                icon: 'error',
                text: 'We are unable to proceed with your quotation. Please select Country (as per passport).'
            });

            return false;

        }

        if (tripType !== "Annual" && (isEmpty(destination))) {
            swalAlert.fire({
                title: 'Oops...',
                icon: 'error',
                text: 'Please put in the destination.'
            });

            return false;
        }

        //START Google Captcha

        // setCaptchaResponse(true);
        // setValidationResponse(true);
        
        var captchaWidget = document.getElementById('captchaV');
        if (validToken.length == 0) {
            // reCAPTCHA not verified, add red border and prevent form submission

            captchaWidget.style.border = '2px solid #e3342f';
            setCaptchaResponse(false);
           

            swalAlert.fire({
                title: 'Oops...',
                icon: 'error',
                text: 'Please verify Captcha.'
            });

            return false;
        } 

        if(verificationResponse == false)
        {

            return false;

        }

        //END Google Captcha

        var dayOfWeek1 = 0; //day of current date
        var dayOfWeek2 = 0; //day of departure date
        var daydifference = 0; //difference of current and departure date

        var date1 = new Date();

        var date2 = new Date(departureDate);

        if (validator.isDate(date1)) {
            dayOfWeek1 = date1.getDay();
        }

        if (validator.isDate(date2)) {
            dayOfWeek2 = date2.getDay();
        }

        // To calculate the time difference of two dates
        var Difference_In_Time = date2.getTime() - date1.getTime();

        // // To calculate the no. of days between two dates
        var Difference_In_Days = Math.ceil(Difference_In_Time / (1000 * 3600 * 24));

        //for weekday logic
        var currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0);

        //console.log('currentDate');
        //console.log(currentDate);

        var weekdayDifferenceInTime = date2.getTime() - currentDate.getTime();
        var weekdayDifferenceInDays = weekdayDifferenceInTime / (1000 * 60 * 60 * 24);

        //console.log('weekdayDifferenceInTime');
        //console.log(weekdayDifferenceInDays);
      

        var isWeekend1 = (dayOfWeek1 === 6) || (dayOfWeek1 === 0);
        var isWeekend2 = (dayOfWeek2 === 6) || (dayOfWeek2 === 0);

        if (isWeekend1 == true && isWeekend2 == true && Difference_In_Days <= 2 && departureDate !== "") {
            // swalAlert.fire({
            //     title: 'Oops...',
            //     icon: 'error',
            //     text: 'Sorry, your departure date is less than 1 working day.\n We are unable to process your request on time',
            // })
            // if (tripType === 'Annual' && departureDate !== "") {
            //     setReturnDate(new Date(Moment(departureDate, 'DD/MM/YYYY').add(1, 'years').subtract(1, 'days').format('YYYY/MM/DD')))
            // }
            // setDepartureDate("");
            
            proceedManual = false;
        }
        //book and fly on the same day
        else if (Difference_In_Days < 1 && departureDate !== "") {
            // swalAlert.fire({
            //     title: 'Oops...',
            //     icon: 'error',
            //     text: 'Sorry, your departure date is less than 1 working day.\n We are unable to process your request on time',
            // })

            // if (tripType === 'Annual' && departureDate !== "") {
            //     setReturnDate(new Date(Moment(departureDate, 'DD/MM/YYYY').add(1, 'years').subtract(1, 'days').format('YYYY/MM/DD')))
            // }
            // setDepartureDate("");
           
            proceedManual = false;
        }//Book on Fri and fly on weekend
        else if (isWeekend1 !== true && Difference_In_Days <= 2 && departureDate !== "" && dayOfWeek1 === 5) {
            // swalAlert.fire({
            //     title: 'Oops...',
            //     icon: 'error',
            //     text: 'Sorry, your departure date is less than 2 working days.\n We are unable to process your request on time.',
            // })
            // if (tripType === 'Annual' && departureDate !== "") {
            //     setReturnDate(new Date(Moment(departureDate, 'DD/MM/YYYY').add(1, 'years').subtract(1, 'days').format('YYYY/MM/DD')))
            // }
            // setDepartureDate("");
          
            proceedManual = false;
        }//Book on Fri and fly on monday
        else if (isWeekend1 !== true && Difference_In_Days <= 3 && departureDate !== "" && dayOfWeek1 === 5 && dayOfWeek2 === 1) {
            // swalAlert.fire({
            //     title: 'Oops...',
            //     icon: 'error',
            //     text: 'Sorry, your departure date is less than 2 working days.\n We are unable to process your request on time.',
            // })
            // if (tripType === 'Annual' && departureDate !== "") {
            //     setReturnDate(new Date(Moment(departureDate, 'DD/MM/YYYY').add(1, 'years').subtract(1, 'days').format('YYYY/MM/DD')))
            // }
            // setDepartureDate("");
           
            proceedManual = false;

        }//Book on sat/sun and fly on Monday
        else if (isWeekend1 === true && Difference_In_Days <= 2 && dayOfWeek2 === 1 && departureDate !== "") {
            // swalAlert.fire({
            //     title: 'Oops...',
            //     icon: 'error',
            //     text: 'Sorry, your departure date is less than 2 working days.\n We are unable to process your request on time',
            // })
            // setDepartureDate("");
           
            proceedManual = false;
        } else if(weekdayDifferenceInDays < 2 && departureDate !== "") {
             proceedManual = false;
        }

        if (tripType === 'Annual' && departureDate !== "") {
                setReturnDate(new Date(Moment(departureDate, 'DD/MM/YYYY').add(1, 'years').subtract(1, 'days').format('YYYY/MM/DD')))
            }

        let buyForCode = buyForMapping(planType);
        setBuyFor(buyForCode);

        let tuneCheckAge = false;
        let isDomestic = false;

        if(Object.keys(destination).length == 1 && destination[0].countrycode == mal_code) {
            tuneCheckAge = true;
            isDomestic = true;


        } else {

            tuneCheckAge = (age <= 60) ? false: true;

        }

        if(tripType == 'Annual' && travelTo == 'B') 
        {
            tuneCheckAge = true;
            isDomestic = true;
        }

        props.setTravelInfo({
            tripType: tripType,
            destination: tripType == 'Annual' ? area :destination,
            area: area,
            destinationList: destinationList,
            departureDate: Moment(departureDate).format('DD/MM/YYYY'),
            returnDate: tripType == 'One-way' ?  Moment(departureDate).format('DD/MM/YYYY') : Moment(returnDate).format('DD/MM/YYYY'),
            dateOfBirth: Moment(dateOfBirth).format('DD/MM/YYYY'),
            planType: planType,
            buyFor: buyForCode,
            noOfAdults: noOfAdults,
            noOfChildren: noOfChildren,
            noOfPersons: noOfPersons,
            msigPlanDetails:msigPlanDetails,
            productType: productType, //TAA, TDA
            tripCode: tripCode, //S, A
            travelTo: travelTo, //(S) I, J, K, L , (A) L,M,N , A,B
            areaCountryList: areaCountryList,
            nationality: nationality,
            nationalityCountry: nationalityCountry,
            nationalityCountryObj: nationalityCountryObj,
            allowManual: proceedManual,
            tuneCheckAge: tuneCheckAge,
            isDomestic: isDomestic,
            contact_time: ''
           // region: region
        });

        //For Travel Just Validation only
        //props.setActiveId('plan');

        if(isEmpty(props.basicName)) {
            props.setShowModal(true);
       } else {

            props.setLoadPlan(true);
            props.setActiveId('plan');

       }
    }

    function ShowBasicInfoPopup(props) {
        const [name, setName] = useState('');
        const [email, setEmail] = useState('');
        const [contact, setContact] = useState('');
    
        function onClickNextPlan(e) {
            e.preventDefault();
            e.stopPropagation();

            props.setShowModal(false);
    
            props.setBasicName(name);
            props.setBasicEmailAdd(email);
            props.setBasicContactNo(contact);
            //props.setShowModal(false);
    
    
            axios.post('/api/basic-info', {
                name: name,
                email: email,
                contact: contact
            }).then(function (response) {
                
                console.log('api basic-info');
                console.log(response.data.apiToken);
                 props.setApiToken(response.data.apiToken);
                props.setTransactionId(response.data.transactionId);
                props.setShowModal(false);
                props.setLoadPlan(true);
                props.setActiveId('plan');
              
               
                // let link = props.referral ? `/travel?r=${props.referral}` : '/travel'
                // props.history.push(link);
                    
            })
    
        }
    
        return (
            <Modal show={props.showModal} onHide={() => props.setShowModal(false)} size="lg" centered>
                <Modal.Header closeButton>
                    <div className="col-11 text-center">
                        <img src="../images/new-logo-02.png" className="img ml-5" width={120} />
                    </div>
                </Modal.Header>
                <Form onSubmit={(e) => { onClickNextPlan(e); }}>
                    <Modal.Body>
                        <div className="mb-3 row">
                            <label className="col-5 col-form-label">Name</label>
                            <div className="col-7">
                                <input type="text" className="form-control" placeholder='Full name as per NRIC' required maxLength={50} value={name} onChange={(e) => setName(e.target.value)} />
                            </div>
                        </div>
                        <div className="mb-3 row">
                            <label className="col-5 col-form-label">Mobile</label>
                            <div className="col-7">
                                <input type="text" className="form-control" required value={contact} onChange={(e) => setContact(e.target.value)} pattern="\d*" maxLength="11" placeholder="012xxxxxxxx" />
                            </div>
                        </div>
                        <div className="mb-3 row">
                            <label className="col-5 col-form-label">Email</label>
                            <div className="col-7">
                                <input type="email" className="form-control" required placeholder='abc@gmail.com'  maxLength={50} value={email} onChange={(e) => setEmail(e.target.value)} />
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="mb-3 row text-end">
                            <div className="col-12">
                                <Button type="submit" variant="success" block>Continue</Button>
                            </div>
                        </div>
                    </Modal.Footer>
                </Form>
            </Modal>
        );
    }

     function ShowRenewalPopup(props) {

        //  showRenewalModal={props.showRenewalModal} setShowRenewalModal={props.setShowRenewalModal}
        // renewalParam={props.renewalParam}
        // renewalTag={props.renewalTag}
        
        const [icNumber, setIcNumber] = useState('');
    
        function onClickNextValidate(e) {
            e.preventDefault();
            e.stopPropagation();

         

            console.log("api validate IC")
    
            axios.post('/api/validate-renewal-id', {
                icNumber: icNumber,
                renewalParam: props.renewalParam,
                renewalTag: props.renewalTag,
            }).then(function (response) {
                
                console.log("response validate IC");
                console.log(response.data);


// {
//     "transaction_data": {
//         "name": "chan sl",
//         "mobileNo": "0196974282",
//         "email": "siowlee.chan@howdengroup.com",
//         "idNumber": "821201099822",
//         "dateOfBirth": "1982-12-01",
//         "insured_address": "27, Jln test",
//         "insured_postcode": null,
//         "insured_address1": null,
//         "insured_address2": null,
//         "insured_address3": null,
//         "insured_address4": null,
//         "insured": [
//             {
//                 "name": "chan sl",
//                 "idNumber": "821201099822",
//                 "dateOfBirth": "1982-12-01",
//                 "gender": "Female",
//                 "nationality": "Malaysian",
//                 "mobileNo": "0196974282",
//                 "email": "siowlee.chan@howdengroup.com",
//                 "address": "27, Jln test",
//                 "nominee": {
//                     "name": null,
//                     "idNumber": null,
//                     "relationship": "-- Select a relationship --"
//                 }
//             }
//         ],
//         "insuredInfo": null,
//         "travelInfo": null,
//         "planInfo": null,
//         "product": "AIG TravelGuard Enhanced - Premier",
//         "insurer": "AIG",
//         "trip_type": "Annual",
//         "plan_type": "Individual",
//         "plan": "Individual",
//         "coverage_from": "2025-01-14",
//         "coverage_to": "2025-05-27",
//         "destination": "Area 1",
//         "destination_zone": 1,
//         "gross_premium": "633.00",
//         "add_ons_total": "0.00",
//         "service_tax": "0.00",
//         "stamp_duty": "10.00",
//         "total_payable": "643.00",
//         "transaction_number": 1733451027,
//         "payment_date": "2024-12-06T02:18:37.000000Z",
//         "payment_status": "Payment Accepted",
//         "txn_message": "Transaction Successful",
//         "referral": "",
//         "token": "",
//         "tuneToken": ""
//     },
//     "status": "success",
//     "add_ons": []
// }

                if(response.data.status == 'success') {

                    console.log('renewal validation sucess');

                    let transactionInfo = response.data.transaction_data;

                    ChangeTripType(transactionInfo.trip_type);
                    setDepartureDate(new Date(Moment().format('YYYY/MM/DD')));
                    setDateOfBirth(new Date(Moment(transactionInfo.dateOfBirth, 'YYYY-MM-DD').format('YYYY/MM/DD')));
                    updatePlanType(transactionInfo.plan_type);

                    props.setBasicName(transactionInfo.name);
                    props.setBasicEmailAdd(transactionInfo.email);
                    props.setBasicContactNo(transactionInfo.mobileNo);

                    props.setRenewalInfo(transactionInfo);


                    props.setShowRenewalModal(false);
               

                } else {

                     swalAlert.fire({
                        text: "The number you entered does not match the last 4 digits of the Owner's NRIC Number. Do you want to try again?",
                        type: "info",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: '#DD6B55',
                        confirmButtonText: 'Yes',
                        cancelButtonText: "No",
                        closeOnConfirm: false,
                        closeOnCancel: false
                    }).then((result) => {	
                        if (result.value){
                           props.setShowRenewalModal(true);
                        } else {
                            props.setShowRenewalModal(false);
                        }
                    });           

                    // swalAlert.fire({
                    //     title: 'Oops...',
                    //     icon: 'error',
                    //     text: "The number you entered does not match the last 4 digits of the Owner's NRIC Number. Please enter travel details to proceed."
                    // }).then((result) => {
                    //     if (result.isConfirmed) {
                    //          props.setShowRenewalModal(false);
                    //     }
                    // });


                }

                
                    
            })
    
        }
    
        return (
            <Modal show={props.showRenewalModal} onHide={() => props.setShowRenewalModal(false)} size="lg" centered>
                <Modal.Header closeButton>
                    <div className="col-11 text-center">
                        <img src="../images/new-logo-02.png" className="img ml-5" width={120} />
                    </div>
                </Modal.Header>
                <Form onSubmit={(e) => { onClickNextValidate(e); }}>
                    <Modal.Body>
                        <div className="mb-3 row">
                            <label className="col col-form-label">Please key in the last <b>4 digit</b> of owner's NRIC number to continue.</label>
                            <div className="col-12">
                                <input type="text" className="form-control" placeholder="Last 4 Digit NRIC Number" required maxLength={4} value={icNumber} onChange={(e) => setIcNumber(e.target.value)} />
                                <small>Without spaces / dashes [-]</small>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="mb-3 row text-end">
                            <div className="col-12">
                                <Button type="submit" variant="success" block>Next</Button>
                            </div>
                        </div>
                    </Modal.Footer>
                </Form>
            </Modal>
        );
    }

    return (
        <Form onSubmit={(e) => onClickNext(e)}>

            <div className="mb-3 row">
                <label className="col-12 col-sm-12 col-form-label">
                <small>Fields marked with an asterisk(*) are required.</small>
                </label>
            </div>

            <input type="text" name="contact_time"  style={{display: 'none'}} tabindex="-1" autocomplete="off"></input>

           
            <div className="mb-3 row justify-content-end">
            <label htmlFor="destination" className="col-12 col-sm-4 col-form-label">Trip Type <span className="text-danger">*</span></label>
                <div className="col-12 col-sm-8 btn-group" role="group" aria-label="Basic radio toggle button group">
                   
                    <input type="radio" class="btn-check" name="trip_type" id="btnradio1" autocomplete="off" checked={tripType === "Single Return Trip" ? 'checked' : ''} value="Single Return Trip" onClick={(e) => ChangeTripType(e.target.value)} />
                    <label className={tripType === "Single Return Trip" ? 'btn btn-primary active' : 'btn btn-outline-primary'} for="btnradio1">Single Return Trip</label>

                    <input type="radio" class="btn-check" name="trip_type" id="btnradio2" autocomplete="off" checked={tripType === "Annual" ? 'checked' : ''} value="Annual" onClick={(e) => ChangeTripType(e.target.value)} />
                    <label className={tripType === "Annual" ? 'btn btn-primary active' : 'btn btn-outline-primary'} for="btnradio2">Annual</label>   
                   
                    <input type="radio" class="btn-check" name="trip_type" id="btnradio3" autocomplete="off" checked={tripType === "One-way" ? 'checked' : ''} value="One-way" onClick={(e) => ChangeTripType(e.target.value)} />   
                    <label className={tripType === "One-way" ? 'btn btn-primary active' : 'btn btn-outline-primary'} for="btnradio3">One Way </label>
                </div>
            </div>

            <div className={(tripType === 'Annual' ? "d-none" : "") + " mb-3 row"}>
                <label htmlFor="destination" className="col-12 col-sm-4 col-form-label">Destination(s) <span className="text-danger">*</span></label>
                <div className="col-12 col-sm-8">
                    {!isEmpty(defaultDestinations) ?
                    
                        <Select
                            isMulti
                            id="destination"
                            styles={{
                                control: provided => ({ ...provided, borderRadius: "2rem" }),
                                menu: provided => ({ ...provided, zIndex: 2 })
                            }}
                            placeholder="Select a Destination or Type to Search"
                            //onChange={setDefaultDestinations}
                            onChange={(e) => { updateTravelTo(e) }}
                            value={defaultDestinations}
                            options={allDestinations}
                            
                        />
                       
                    :

                        <Select
                            id="destination"
                            styles={{
                                control: provided => ({ ...provided, borderRadius: "2rem" }),
                                menu: provided => ({ ...provided, zIndex: 2 })
                            }}
                            placeholder="Select a Destination or Type to Search"
                            
                            isMulti
                            options={allDestinations}
                            value={allDestinations.find(dest => dest.label === destination)}
                        onChange={(e) => { updateTravelTo(e) }}
                            required
                        />

                    }

                    <div className={isIsrael ? "alert alert-warning mt-2" : "d-none"} role="alert">
                            <small>
                                <strong>PLEASE NOTE THAT</strong> travel prohibition to Israel is imposed by the Government of Malaysia on all Malaysia citizens. As a Malaysia citizen, if you choose “Israel” as your travel destination in our system, you must obtain all the necessary approvals/permits from the Malaysia authorities before purchasing the insurance. Your claim(s) under the insurance policy (if any) may still be subject to the applicable sanction restrictions and the Sanctions Exclusion clause applicable to the insurance policy. If you fail to obtain the necessary approvals/permits, your claim(s) may be fully or partially rejected and/or be subject to the applicable sanctions restrictions and our rights are reserved.
                            </small>
                    </div>
                </div>
            </div>
            <div className={(tripType === 'Annual' ? "" : "d-none") + " mb-3 row"}>
                <label htmlFor="destination" className="col-12 col-sm-4 col-form-label">Destination <span className="text-danger">*</span></label>
                <div className="col-12 col-sm-8">
                    {!isEmpty(defaultAreas) ?

                        <Select
                        id="zone"
                        styles={{
                            control: provided => ({ ...provided, borderRadius: "2rem" }),
                            menu: provided => ({ ...provided, zIndex: 2 })
                        }}
                        placeholder="Select a Destination Area or Type to Search"
                        //onChange={setDefaultDestinations}
                        onChange={(e) => { updateTravelCountryCode(e) }}
                        value={defaultAreas}
                        options={allAreas}
                        />

                    :
                        <Select
                            id="zone"
                            styles={{
                                control: provided => ({ ...provided, borderRadius: "2rem" }),
                                menu: provided => ({ ...provided, zIndex: 2 })
                            }}
                            placeholder="Select a Destination Area or Type to Search"
                            options={allAreas}
                            value={allAreas.find(dest => dest.label === destination)}
                            onChange={(e) => { updateTravelCountryCode(e) }}
                            required={tripType === "Annual"}
                        />

                    }

                    <div className={(!isEmpty(area) && area.label !== '' && area.value != 'B') ? "zone-desc col-12 mt-3" : "zone-desc d-none"}> 
                        <h6>{ (!isEmpty(area) && area.label !== '') ? area.label : ""}</h6>
                        <p>
                           { (!isEmpty(area) && area.label !== '') ? area.countries : ""}
                        </p>
                    </div>

                    {/* <div className={destination.label === 'Area 1' ? "col-12 mt-3" : "d-none"}> 
                        <h6>Area 1</h6>
                        <p>
                            Australia, Brunei, Cambodia, China (excluding Mongolia, Nepal &amp; Tibet), Hong Kong, Macau, India,
                            Indonesia, Japan, South Korea, Laos, Myanmar (Burma), New Zealand, Pakistan, Philippines, Singapore,
                            Sri Lanka, Taiwan, Thailand and Vietnam only.
                        </p>
                    </div>
                    <div className={destination.label === 'Area 2' ? "col-12 mt-3" : "d-none"}>
                        <h6>Area 2</h6>
                        <p>
                            Worldwide <span className="fw-bold">EXCLUDING</span> USA, Canada, Iran, Syria, Belarus, Cuba,
                            Democratic Republic of Congo, North Korea, Somalia, Sudan, South Sudan, Crimea (including Sevastopol),
                            Russia, Ukraine and Zimbabwe.
                        </p>
                    </div>
                    <div className={destination.label === 'Area 3' ? "col-12 mt-3" : "d-none"}>
                        <h6>Area 3</h6>
                        <p>
                            Worldwide <span className="fw-bold">EXCLUDING</span> Iran, Syria, Belarus, Cuba,
                            Democratic Republic of Congo, North Korea, Somalia, Sudan, South Sudan,
                            Crimea (including Sevastopol), Russia, Ukraine and Zimbabwe.
                        </p>
                    </div>
                    <div className={destination.label === 'Area 4' ? "col-12 mt-3" : "d-none"}>
                        <h6>Area 4</h6>
                        <p>
                            Applicable to single trip between Peninsular and East Malaysia and vice versa. Area 4 is
                            part of the cover of Annual Policy.
                        </p>
                    </div> */}
                </div>
            </div>

            <div className="mb-3 row">
                <label htmlFor="departure-date" className="col-12 col-sm-4 col-form-label">Departure Date <span className="text-danger">*</span></label>
                <div className="col-12 col-sm-8">
                    <DatePicker
                        id="departure-date"
                        className="form-control"
                        dateFormat="dd/MM/yyyy"
                        minDate={new Date()}
                        selected={departureDate}
                        onChange={(date) => { setDepartureDate(date) }}
                        autoComplete="off"
                        placeholderText="DD/MM/YYYY"
                        required
                    />

                </div>
            </div>

            {tripType != 'One-way' ?
                <div className="mb-3 row">
                    <label htmlFor="return-date" className="col-12 col-sm-4 col-form-label">{tripType === 'One-way' ? 'Arrival Date' : 'Return Date'} <span className="text-danger">*</span></label>
                    <div className="col-12 col-sm-8">
                        <DatePicker
                            id="return-date"
                            className="form-control"
                            dateFormat="dd/MM/yyyy"
                            minDate={new Date(departureDate)}
                            maxDate={new Date(Moment().add(365, 'days'))}
                            selected={returnDate}
                            onChange={(date) => { setReturnDate(date) }}
                            autoComplete="off"
                            disabled={departureDate === "" || tripType === "Annual"}
                            placeholderText="DD/MM/YYYY"
                            required={tripType !== "Annual"}
                        />
                    </div>
                </div>
                :
                null
            }

            {/* MSIG - Buy For           */}
            {/* <div className="mb-3 row">
                <label htmlFor="buy-for" className="col-12 col-sm-4 col-form-label">Buy For</label>
                <div className="col-12 col-sm-8">
                    <Select
                        id="buy-for"
                        styles={{
                            control: provided => ({ ...provided, borderRadius: "2rem" }),
                            menu: provided => ({ ...provided, zIndex: 2 })
                        }}
                        placeholder="Select Buy For Insured Only, Insured & Spouse or Family with Child(ren)"
                        options={allBuyFor}
                        value={allBuyFor.find(dest => dest.value === buyFor)}
                        onChange={(e) => { setBuyFor(e) }}
                    />
                </div>
            </div>
            */ }


            <div className="mb-3 row">
                <label htmlFor="dob" className="col-12 col-sm-4 col-form-label">Date of Birth of Principal Traveller <span className="text-danger">*</span>
                { <OverlayTrigger data-html="true"
                                            trigger={['hover', 'click']}
                                            key={"o1"}
                                            placement="right"
                                            overlay={
                                                <Popover id={`popover-positioned-left`}>
                                                    <Popover.Content>
                                                        * Adult must be 18 years old and above.<br/>
                                                        * Child must be between 30 days old to 19 years old.
                                                    </Popover.Content>
                                                </Popover>
                                            }
                                        >
                                            <i className="fa fa-question-circle text-primary ml-2" aria-hidden="true"></i>
                                        </OverlayTrigger> }
                </label>
                <div className="col-12 col-sm-8">
                    <DatePicker
                        id="dob"
                        className="form-control"
                        dateFormat="dd/MM/yyyy"
                        selected={dateOfBirth}
                        maxDate={new Date(Moment().subtract(0, 'years'))}
                        onChange={(date) => { setDateOfBirth(date) }}
                        autoComplete="off"
                        disabled={departureDate === ""}
                        showYearDropdown
                        showMonthDropdown
                        scrollableYearDropdown
                        dropdownMode="select"
                        placeholderText="DD/MM/YYYY"
                        required
                    />
                </div>
            </div>

            {/* <div className="mb-3 row">
                <label htmlFor="region" className="col-12 col-sm-4 col-form-label">Religion</label>
                <div className="col-12 col-sm-8">
                    <Select
                        id="region"
                        styles={{
                            control: provided => ({ ...provided, borderRadius: "2rem" }),
                            menu: provided => ({ ...provided, zIndex: 2 })
                        }}
                        placeholder="Select Religion"
                        options={allRegions}
                        value={allRegions.find(dest => dest.label === region)}
                        onChange={(e) => updateRegion(e)} 
                        required
                    />
                </div>
            </div> */}
            
            {/* className={(tripType === 'Annual' ? "d-none" : "") + " mb-3 row"} */}

            <div className="d-none d-lg-block mb-3 row my-4">
                <label htmlFor="no-of-adults" className="col-12 col-sm-4">Buy For <span className="text-danger">*</span></label>
                { availableAllType == true ?
                    
                        <div className="col-12 col-sm-8 btn-group" role="group" aria-label="Basic radio toggle button group">

                          
                           <input type="radio" className="btn-check" name="plan_type" id="plan_type1" autocomplete="off" checked={planType === "Individual" ? 'checked' : ''} value="Individual" onClick={(e) => updatePlanType(e.target.value)} />
                            <label for="plan_type1" className={planType === "Individual" ? 'btn btn-primary active' : 'btn btn-outline-primary'}>
                               Self
                            </label>

                            {tripType != 'One-way' ?  
                                <>
                            
                                <input type="radio" className="btn-check" name="plan_type" id="plan_type2" autocomplete="off" checked={planType === "InsuredSpouse" ? 'checked' : ''} value="InsuredSpouse" onClick={(e) => updatePlanType(e.target.value)} />
                                <label  for="plan_type2" className={planType === "InsuredSpouse" ? 'btn btn-primary active' : 'btn btn-outline-primary'}>
                                    Self & Spouse
                                </label>
                                 </>
                                : 
                                null
                           

                            }

                           {tripType != 'One-way' ?  
                                <>
                                    <input type="radio" className="btn-check" name="plan_type" id="plan_type3" autocomplete="off" checked={planType === "Child" ? 'checked' : ''} value="Child" onClick={(e) => ChildDeclaration(e.target.value)} />
                                    <label for="plan_type3" className={planType === "Child" ? 'btn btn-primary active' : 'btn btn-outline-primary'}>
                                        Child
                                </label>
                                </>
                                :
                                null
                            }

                            <input type="radio" className="btn-check" name="plan_type" id="plan_type4" autocomplete="off" checked={planType === "Family" ? 'checked' : ''} value="Family" onClick={(e) => FamilyDeclaration(e.target.value)} />
                            <label for="plan_type4" className={planType === "Family" ? 'btn btn-primary active' : 'btn btn-outline-primary'}>
                                Family
                            </label>

                            <input type="radio" className="btn-check" name="plan_type" id="plan_type5"  autocomplete="off" checked={planType === "Group" ? 'checked' : ''} value="Group" onClick={(e) => updatePlanType(e.target.value)} />
                            <label for="plan_type5" className={planType === "Group" ? 'btn btn-primary active' : 'btn btn-outline-primary'}>
                               Group
                            </label>
                        </div>
                    
                       
                : 

                <>
                
                
                {(!isEmpty(area) && area.label !== '' && area.value == 'B') ?

                // <div className="col-12 col-sm-8 btn-group" role="group" aria-label="Basic radio toggle button group">
                   
                //     <input type="radio" class="btn-check" name="trip_type" id="btnradio1" autocomplete="off" checked={tripType === "Single Return Trip" ? 'checked' : ''} value="Single Return Trip" onClick={(e) => ChangeTripType(e.target.value)} />
                //     <label className='btn btn-outline-primary' for="btnradio1">Single Return Trip</label>

                //     <input type="radio" class="btn-check" name="trip_type" id="btnradio2" autocomplete="off" checked={tripType === "Annual" ? 'checked' : ''} value="Annual" onClick={(e) => ChangeTripType(e.target.value)} />
                //     <label className='btn btn-outline-primary' for="btnradio2">Annual</label>   

                //     <input type="radio" class="btn-check" name="trip_type" id="btnradio3" autocomplete="off" checked={tripType === "One-way" ? 'checked' : ''} value="One-way" onClick={(e) => ChangeTripType(e.target.value)} />   
                //     <label className='btn btn-outline-primary' for="btnradio3">One Way </label>
                // </div>

                    <div className="col-4 col-sm-4 btn-group" role="group" aria-label="Basic radio toggle button group">

                        <input type="radio" className="btn-check" name="plan_type" id="plan_type6" checked={planType === "Individual" ? 'checked' : ''} value="Individual" onClick={(e) => updatePlanType(e.target.value)} /> 
                        <label for="plan_type6" className={planType === "Individual" ? 'btn btn-primary active' : 'btn btn-outline-primary'}>
                            Individual
                        </label>


                    </div>

                    :
                    <div className="col-4 col-sm-4 btn-group" role="group" aria-label="Basic radio toggle button group">

                        <input type="radio" className="btn-check" name="plan_type" id="plan_type7" checked={planType === "Individual" ? 'checked' : ''} value="Individual" onClick={(e) => updatePlanType(e.target.value)} />
                        <label for="plan_type7" className={planType === "Individual" ? 'btn btn-primary active' : 'btn btn-outline-primary'}>
                            Individual
                        </label>

                        <input type="radio" className="btn-check" name="plan_type" id="plan_type8" checked={planType === "Group" ? 'checked' : ''} value="Group" onClick={(e) => updatePlanType(e.target.value)} />
                        <label for="plan_type8"  className={planType === "Group" ? 'btn btn-primary active' : 'btn btn-outline-primary'}>
                            Group
                        </label>
                    </div>

                }

                </>
                    

                }
            </div>

            <div className="d-block d-lg-none mb-3 row my-4">
                <label htmlFor="no-of-adults" className="col-12 col-sm-4">Buy For <span className="text-danger">*</span></label>
                { availableAllType == true ?
                    
                       
                        <div className="col-12 col-sm-8 btn-group-vertical" role="group" aria-label="Basic radio toggle button group">

                            <input type="radio" className="btn-check" autocomplete="off" checked={planType === "Individual" ? 'checked' : ''} id="plan_type9" name="plan_type" value="Individual" onClick={(e) => updatePlanType(e.target.value)} />
                            <label for="plan_type9" className={planType === "Individual" ? 'btn btn-primary active' : 'btn btn-outline-primary'}>
                                Self
                            </label>

                            <input type="radio" className="btn-check" autocomplete="off" checked={planType === "InsuredSpouse" ? 'checked' : ''}  id="plan_type10" name="plan_type" value="InsuredSpouse" onClick={(e) => updatePlanType(e.target.value)} />
                            <label for="plan_type10" className={planType === "InsuredSpouse" ? 'btn btn-primary active' : 'btn btn-outline-primary'}>
                                Self & Spouse
                            </label>

                            <input type="radio" className="btn-check" autocomplete="off" id="plan_type11" checked={planType === "Child" ? 'checked' : ''}  name="plan_type" value="Child" onClick={(e) => ChildDeclaration(e.target.value)} />
                            <label for="plan_type11" className={planType === "Child" ? 'btn btn-primary active' : 'btn btn-outline-primary'}>
                                Child
                            </label>

                             <input type="radio" name="plan_type" autocomplete="off" className="btn-check" checked={planType === "Family" ? 'checked' : ''} id="plan_type12" value="Family" onClick={(e) => FamilyDeclaration(e.target.value)} />
                            <label for="plan_type12" className={planType === "Family" ? 'btn btn-primary active' : 'btn btn-outline-primary'}>
                               Family
                            </label>

                            <input type="radio" name="plan_type" autocomplete="off" className="btn-check" checked={planType === "Group" ? 'checked' : ''}  id="plan_type13" value="Group" onClick={(e) => updatePlanType(e.target.value)} />
                            <label for="plan_type13" className={planType === "Group" ? 'btn btn-primary active' : 'btn btn-outline-primary'}>
                                Group
                            </label>

                        </div>
                    
                       
                : 

                <>
                
                
                {(!isEmpty(area) && area.label !== '' && area.value == 'B') ?

                    <div className="col-4 col-sm-4 btn-group" role="group" aria-label="Basic radio toggle button group">

                         <input type="radio" className="btn-check" id="plan_type14" name="plan_type" value="Individual" checked={planType === "Individual" ? 'checked' : ''} onClick={(e) => updatePlanType(e.target.value)} />
                        <label for="plan_type14" className={planType === "Individual" ? 'btn btn-primary active' : 'btn btn-outline-primary'}>
                           Individual
                        </label>
                   
                    </div>


                    :
                    <div className="col-4 col-sm-4 btn-group" role="group" aria-label="Basic radio toggle button group">

                        <input type="radio" className="btn-check" id="plan_type15" name="plan_type"  checked={planType === "Individual" ? 'checked' : ''} value="Individual" onClick={(e) => updatePlanType(e.target.value)} />
                        <label for="plan_type15" className={planType === "Individual" ? 'btn btn-primary active' : 'btn btn-outline-primary'}>
                            Individual
                        </label>

                        <input type="radio" className="btn-check" id="plan_type16" name="plan_type" checked={planType === "Group" ? 'checked' : ''} value="Group" onClick={(e) => updatePlanType(e.target.value)} />
                        <label for="plan_type16" className={planType === "Group" ? 'btn btn-primary active' : 'btn btn-outline-primary'}>
                                Group
                        </label>
                    </div>

                }


                </>

                }
            </div>

             {/* MSIG - No of Adult */}
             <div className={(planType === 'Family' ? "" : "d-none") + " mb-3 row"}>
                <label htmlFor="no-of-adults" className="col-12 col-sm-4">Number of Adults <span className="text-danger">*</span>
                { <OverlayTrigger data-html="true"
                                            trigger={['hover', 'click']}
                                            key={"o1"}
                                            placement="right"
                                            overlay={
                                                <Popover id={`popover-positioned-left`}>
                                                    <Popover.Content>
                                                        *Insured must be between 18 and 80 years old.
                                                    </Popover.Content>
                                                </Popover>
                                            }
                                        >
                        <i className="fa fa-question-circle text-primary ml-2" aria-hidden="true"></i>
                    </OverlayTrigger> }
                </label>
                <div className="col-12 col-sm-4">
                    <input type="number" min="1" max={(planType === 'Family') ? "2" : ""} name="no_of_adults" className="form-control" value={noOfAdults} onChange={(e) => setNoOfAdults(e.target.value)} />
                   
                </div>
            </div>

              {/* MSIG - No of Children */}
            <div className={(planType === 'Family'? "" : "d-none") + " mb-3 row"}>
                <label htmlFor="no-of-adults" className="col-12 col-sm-4">Number of Children <span className="text-danger">*</span>
                { <OverlayTrigger data-html="true"
                                            trigger={['hover', 'click']}
                                            key={"o1"}
                                            placement="right"
                                            overlay={
                                                <Popover id={`popover-positioned-left`}>
                                                    <Popover.Content>
                                                        *Insured must be from 30 days old to 19 years old (or up to 23 years old if they're still studying, unmarried and unemployed).

                                                    </Popover.Content>
                                                </Popover>
                                            }
                                        >
                        <i className="fa fa-question-circle text-primary ml-2" aria-hidden="true"></i>
                    </OverlayTrigger> }
                </label>
                <div className="col-12 col-sm-4">
                    <input type="number"  name="no_of_children" className="form-control" value={noOfChildren} onChange={(e) => setNoOfChildren(e.target.value)} />
                </div>
            </div>      

             {/* MISG - GROUP                                */}
            <div className={(planType === 'Group' && tripType !== 'Annual)' ? "" : "d-none") + " mb-3 row"}>
                <label htmlFor="no-of-adults" className="col-12 col-sm-4">Number of Person<span className="text-danger">*</span>
                { <OverlayTrigger data-html="true"
                                            trigger={['hover', 'click']}
                                            key={"o1"}
                                            placement="right"
                                            overlay={
                                                <Popover id={`popover-positioned-left`}>
                                                    <Popover.Content>
                                                        *Number of travellers in Group plan is up to maximum 6.
                                                    </Popover.Content>
                                                </Popover>
                                            }
                                        >
                        <i className="fa fa-question-circle text-primary ml-2" aria-hidden="true"></i>
                    </OverlayTrigger> }
                </label>
                <div className="col-12 col-sm-4">
                    <input type="number" min="2" max="6" name="no_of_person" className="form-control" value={noOfPersons} onChange={(e) => setNoOfPersons(e.target.value)} />
                   
                </div>
            </div>

            <div className="mb-3 row mt-4">
                <label htmlFor="nationality" className="col-12 col-sm-4">Nationality <span className="text-danger">*</span></label>
                
                    <div className="col-12 col-sm-4 btn-group" role="group" aria-label="Basic radio toggle button group">

                        <input type="radio" className="btn-check" id="nationality1" checked={nationality === "MAL" ? 'checked' : ''} name="nationality" value="MAL" onClick={(e) => setNationality(e.target.value)}/>
                        <label for="nationality1" className={nationality === "MAL" ? 'btn btn-primary active' : 'btn btn-outline-primary'}>
                            Malaysian
                        </label>

                         <input type="radio" className="btn-check" id="nationality2" checked={nationality === "ALL" ? 'checked' : ''}  name="nationality" value="ALL" onClick={(e) => setNationality(e.target.value)}/>
                        <label for="nationality2" className={nationality === "ALL" ? 'btn btn-primary active' : 'btn btn-outline-primary'}>
                           Non-Malaysian
                        </label>
                    </div>                
            </div>  

            <div className={(nationality === 'MAL' ? "d-none" : "") + " mb-3 row"}>
                <label htmlFor="nationality_country" className="col-12 col-sm-4 col-form-label">Country (as per passport) <span className="text-danger">*</span></label>
                <div className="col-12 col-sm-8">
                
                     <Select
                        id="nationality_country"
                        styles={{
                            control: provided => ({ ...provided, borderRadius: "2rem" }),
                            menu: provided => ({ ...provided, zIndex: 2 })
                        }}
                        placeholder="Select country as per passport"
                        options={props.allNationalities}
                        value={props.allNationalities.find(dest => dest.countrycode === nationalityCountry)}
                        onChange={(e) => { updateNationalityCountry(e) }}
                     />

                </div>                
            </div>

            

            <div className={(nationality === 'ALL' ? "" : "d-none") + " mb-3 row"}>
                <label htmlFor="nationality" className="col-12 col-sm-4">&nbsp;</label>
                
                    <div className="col-12 col-sm-8">
                        <div className={nationality == 'ALL' ? "alert alert-primary" : "d-none"} role="alert">
                            <small>
                            I am a Malaysian permanent resident / holder of a valid working permit, dependant pass, long-term social visit pass or student visa in Malaysia.

                            </small>

                            <div className="col-sm-12 text-end mt-3">
                                <button type="button" id="btn-agree-plan" className={agreedPlan == 'Yes' ? "btn btn-primary active px-2 px-sm-5 mr-3" : "btn btn-outline-primary px-2 px-sm-5 mr-3"} onClick={() => { setAgreedPlan('Yes') }}>YES</button>
                                <button type="button" id="btn-disagree-plan" className={agreedPlan == 'No' ? "btn btn-primary active px-2 px-sm-5" : "btn btn-outline-primary px-2 px-sm-5"} onClick={() => { setAgreedPlan('No') }}>NO</button> 

                            </div>

                            <div className={(agreedPlan === 'No' ? "" : "d-none") + " col-sm-12 text-end mt-3 fw-bold"}>
                                We are unable to proceed with your quotation.
                            </div>
                        </div>
                      
                    </div>                
                        </div>
                      

            {/* START Google Captcha Verification */}
            <div className="mb-3 row">
                <label htmlFor="nationality" className="col-12 col-sm-4">&nbsp;</label>
                
                <div className="col-12 col-sm-8">
                    <ReCAPTCHA id="captchaV" ref={recaptchaRef} sitekey={process.env.MIX_GOOGLE_CAPTCHA_SITE_KEY} onChange={handleRecaptcha}/>

                    <small id="verify-alert" className={(captchaResponse == true) ? 'd-none': 'text-danger'}>Please verify Captcha. </small>
                    <small id="response-alert" className={(validationResponse == true) ? 'd-none': 'text-danger'}>Captcha verification Failed. Please try again. </small>
                    <small id="gcresponse-success" className={(verificationResponse == true) ? 'text-success fw-bold': 'd-none'}>Verification Success.</small>
                    </div>                
            </div>  



            <div className="mb-3 row">
                <div className="col-sm-12 text-end">
                    <Button type="submit" variant="success" className={nationality == 'ALL' && (agreedPlan == 'No' || isEmpty(agreedPlan) )? "d-none" : ""}>Choose Your Plan</Button>

                   
                    {/* <Button type="button" id="" className={nationality == 'ALL' ? "" : "d-none"}>YES</Button>
                    <Button type="button" className={nationality == 'ALL' ? "" : "d-none"}>NO</Button> */}
                    {/* <button type="button" id="btn-agree-plan" className={nationality == 'ALL' ? "btn btn-primary px-2 px-sm-5 mr-3" : "d-none"} onClick={() => { agreeChoosePlan() }}>YES</button>
                    <button type="button" id="btn-disagree-plan" className={nationality == 'ALL' ? "btn btn-outline-primary px-2 px-sm-5" : "d-none"} onClick={() => { disagreeChoosePlan() }}>NO</button> */}

                    <ShowBasicInfoPopup
                        showModal={props.showModal} setShowModal={props.setShowModal}
                        setLoadPlan={props.setLoadPlan}
                        setBasicName={props.setBasicName}
                        setBasicEmailAdd={props.setBasicEmailAdd}
                        setBasicContactNo={props.setBasicContactNo}
                        setTransactionId={props.setTransactionId}
                        setActiveId={props.setActiveId}
                        history={history}
                        setApiToken={props.setApiToken}
                    />


                     <ShowRenewalPopup
                        showRenewalModal={props.showRenewalModal} setShowRenewalModal={props.setShowRenewalModal}
                        setBasicName={props.setBasicName}
                        setBasicEmailAdd={props.setBasicEmailAdd}
                        setBasicContactNo={props.setBasicContactNo}
                        renewalParam={props.renewalParam}
                        renewalTag={props.renewalTag} 
                        renewalInfo={props.renewalInfo} setRenewalInfo={props.setRenewalInfo}
                    />
                    
                </div>
            </div>

            {/*<div className="mb-3 row mb-0">
                <label className="col-12 col-sm-12 col-form-label">
                    <small>
                        * Coverage will be terminated at the earliest happening of 24 hours upon your arrival in Malaysia, upon reaching your home or workplace in Malaysia (whichever is earlier), or upon expiry date of your policy.
                    </small>
                </label>
            </div>
            <div className="mb-3 row">
                <label className="col-12 col-sm-12 col-form-label">
                    <small>
                        * Coverage for “Travel Cancellation” and “Loss of Travel Deposit” will not be applicable for travel insurance purchased less than 7 days before travel start date.
                    </small>
                </label>
            </div>*/}
        </Form>
    );
}

function Plan(props) {
    const [allPlans, setAllPlans] = useState([]);
    const [selectedPlan, setSelectedPlan] = useState({});
    const [planId, setPlanId] = useState("");
    const [renewalInsurer, setRenewalInsurer] = useState("");
    const [renewalManualInsurer, setRenewalManualInsurer] = useState(false);
    const [renewalProduct, setRenewalProduct] = useState("");
    const [renewalPlan, setRenewalPlan] = useState("");
    const [renewalTransactionNumber, setRenewalTransactionNumber] = useState("");
    const [activeEventKey, setActiveEventKey] = useState("");
    const [shouldUpdateBenfits, setShouldUpdateBenfits] = useState(true);
    const swalAlert = withReactContent(Swal);
    const [showAllPlans, setShowAllPlans] = useState(false);
    const [manualPlan, setManualPlan] = useState("");
    const [allowManualFromParam, setAllowManualFromParam] = useState(false);

    const [showManualPlans, setShowManualPlans] = useState(false);

   // const manualInsurers = ["chubb", "aig", "tuneprotect"];
   const [manualInsurers, setManualInsurers] = useState([]);

    const renewalPlanStyle = {
        backgroundColor: "#9a5cd024"
      };
    
    const renewalPlanDefaultStyle = {
        backgroundColor: "#ffffff"
      };
      

   useEffect(() => {
    if(props.activeId == 'plan') {
        
        axios.post('/api/update-travel-info', {
            drop_off_point: dropOffPlan,
            transaction_id: props.transactionId,
            tripType: props.travelInfo.tripType,
            destination: (props.travelInfo.productType == 'TAA' || props.travelInfo.productType == 'ONE') ? props.travelInfo.destinationList:  props.travelInfo.destination.label,
            departureDate: props.travelInfo.departureDate,
            returnDate: props.travelInfo.returnDate,
            dateOfBirth: props.travelInfo.dateOfBirth,
            planType: props.travelInfo.planType,
            referral: props.referral,   
            name: props.basicName,
            email: props.basicEmailAdd,
            contact: props.basicContactNo
        }).then(function (response) {
            if(response.data.transactionId) {
                props.setTransactionId(response.data.transactionId);
            }
        }).catch(function (error) {
                console.log(error);
        })
    }
}, [props.dropOffTrigger]);

    useEffect(() => {

        if (!isEmpty(props.travelInfo) && props.loadPlan == true) {
            setAllPlans([]);

            console.log('Plan props.travelInfo');
            console.log(props.travelInfo);

           //getMsigPlanBenefits();
           getInsurerPlanBenefits();
           getManualInsurers();


        }
    }, [props.travelInfo, props.loadPlan]);

    useEffect(() => {

        if (!isEmpty(props.queryParam)) {
            setAllPlans([]);

            console.log('Plan props.queryParams');
            console.log(props.queryParam);

            setAllowManualFromParam(props.queryParam.travelInfo.allowManual);

           // props.setTravelInfo.allowManual = props.queryParam.travelInfo.allowManual;
            getInsurerPlanBenefitsFromParam();

        }
    }, [props.queryParam]);

  
    useEffect(() => {

        if(!isEmpty(props.renewalInfo) && !isEmpty(props.travelInfo)) {

            console.log('Plan useEffect renewalInfo');

            console.log(props.renewalInfo);
            console.log(props.renewalInfo.insurer);

            setRenewalInsurer(props.renewalInfo.insurer);
            setRenewalProduct(props.renewalInfo.product);
            setRenewalPlan(props.renewalInfo.plan);
            setRenewalTransactionNumber(props.renewalInfo.transaction_number);
            
            if(manualInsurerList.includes(props.renewalInfo.insurer)) {
                setRenewalManualInsurer(true);
                 console.log('is renewal Manual insurer');

            } else {
                 setRenewalManualInsurer(false);
                  console.log('NOT renewal Manual insurer');
            }
            
        }
       
       
    }, [props.renewalInfo, props.travelInfo]);

  


    function getManualInsurers() {

        setManualInsurers([]);
        axios.post('/api/get-manual-insurer',{
            dateOfBirth: props.travelInfo.dateOfBirth,
            buyFor: props.travelInfo.buyFor,
            departureDate :props.travelInfo.departureDate,
            returnDate: props.travelInfo.returnDate,
            tripCode: props.travelInfo.tripCode,
            travelDestination: (props.travelInfo.productType == 'TAA' || props.travelInfo.productType == 'ONE') ? props.travelInfo.destination:  props.travelInfo.area,
            contact_time: props.travelInfo.contact_time
        }).then((response) => {
            console.log('response get-manual-insurer');
            console.log(response.data);
            setManualInsurers(response.data);
            
            if(props.travelInfo.allowManual == true || allowManualFromParam == true) {
            if(!isEmpty(response.data)) {
              setShowManualPlans(true);
            }
          
            }
           
          
            
            //checkShowManual();

        })
        .catch((error) => {
            console.log(error);
        });

    }

    function checkShowManual() {

        setShowManualPlans(false);

        if(props.travelInfo.allowManual == true || allowManualFromParam == true)
        {
            if(!isEmpty(manualInsurers)) {
                setShowManualPlans(true);
            }
        }

    }

    


    function getInsurerPlanBenefits() {


        // tripType: tripType,
        // destination: destination,
        // departureDate: Moment(departureDate).format('DD/MM/YYYY'),
        // returnDate: Moment(returnDate).format('DD/MM/YYYY'),
        // dateOfBirth: Moment(dateOfBirth).format('DD/MM/YYYY'),
        // planType: planType,
        // buyFor: buyForCode,
        // noOfAdults: noOfAdults,
        // noOfChildren: noOfChildren,
        // msigPlanDetails:msigPlanDetails,
        // productType: productType, //TAA, TDA
        // tripCode: tripCode, //S, A
        // travelTo: travelTo, //(S) I, J, K, L , (A) L,M,N 
        // areaCountryList: areaCountryList,

        swalAlert.fire({
            title: 'Please Wait ...',
            allowOutsideClick: false
        });
        swalAlert.showLoading();

        setShowAllPlans(false);


        //  axios.get('/api/countries',{
        //         headers: {
        //         Authorization : 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ' ,    
        //         customeToken: 'akjiiiiiiiusas'  //the token is a variable which holds the token
        //         }
        //     })

          console.log("apiToken");
         console.log(props.apiToken);

        const headers = {
        'Authorization': 'Bearer '+props.apiToken
        };
        
        axios.post('/api/get-benefit-premium',
        {
            insurer: insurer_msig,
            token: props.token,
            tuneToken: props.tuneToken,
            productType: props.travelInfo.productType,
            channel: channel,
            travelTo:  props.travelInfo.travelTo,
           // travelCountryCode: (props.travelInfo.productType == 'TDA') ? props.travelInfo.areaCountryList  : props.travelInfo.destination.msig_countrycode,
            travelCountryCode: (props.travelInfo.productType == 'TDA') ? '' : props.travelInfo.destination.msig_countrycode,
            travelDestination: (props.travelInfo.productType == 'TAA' || props.travelInfo.productType == 'ONE') ? props.travelInfo.destination:  props.travelInfo.area,
            buyFor: props.travelInfo.buyFor,
            noOfAdults: props.travelInfo.noOfAdults,
            noOfChildren: props.travelInfo.noOfChildren,
            noOfPersons:  props.travelInfo.noOfPersons,
            tripType:  props.travelInfo.tripCode,
            travelStartDate: props.travelInfo.departureDate,
            travelEndDate: props.travelInfo.returnDate,
            promoCode: "",
            declCompanyCode: "",
            declClaimType: "",
            declOtherClaim: "",
            tripCode: props.travelInfo.tripCode,
            //dateOfBirth: Moment(props.travelInfo.dateOfBirth).format('DD/MM/YYYY'),
            dateOfBirth: props.travelInfo.dateOfBirth,
            nationality:  props.travelInfo.nationality,
            transactionNo: props.transactionNo,
            isDomestic: props.travelInfo.isDomestic,
            tuneCheckAge:  props.travelInfo.tuneCheckAge,
            email: props.basicEmailAdd,
            contact: props.basicContactNo,
            contact_time : props.travelInfo.contact_time
        },{
            headers: headers
        }
        )
        .then((response) => {
          
          

            setAllPlans(response.data);
            setShowAllPlans(true);
            swalAlert.close();
        })
        .catch((error) => {
            swalAlert.close();
            setShowAllPlans(false);
            console.log(error);
        });
    }

    function getInsurerPlanBenefitsFromParam() {

        swalAlert.fire({
            title: 'Please Wait ...',
            allowOutsideClick: false
        });
        swalAlert.showLoading();

        setShowAllPlans(false);


        axios.post('/api/get-benefit-premium',
        {
            insurer: insurer_msig,
            token: props.token,
            tuneToken: props.tuneToken,
            productType: props.queryParam.travelInfo.productType,
            channel: channel,
            travelTo:  props.queryParam.travelInfo.travelInfotravelTo,
           // travelCountryCode: (props.travelInfo.productType == 'TDA') ? props.travelInfo.areaCountryList  : props.travelInfo.destination.msig_countrycode,
            travelCountryCode: (props.queryParam.travelInfo.productType == 'TDA') ? '' : props.queryParam.travelInfo.destination.msig_countrycode,
            travelDestination: (props.queryParam.travelInfo.productType == 'TAA' || props.travelInfo.productType == 'ONE') ? props.queryParam.travelInfo.destination:  props.queryParam.travelInfo.area,
            buyFor: props.queryParam.travelInfo.buyFor,
            noOfAdults: props.queryParam.travelInfo.noOfAdults,
            noOfChildren: props.queryParam.travelInfo.noOfChildren,
            noOfPersons:  props.queryParam.travelInfo.noOfPersons,
            tripType:  props.queryParam.travelInfo.tripCode,
            travelStartDate: props.queryParam.travelInfo.departureDate,
            travelEndDate: props.queryParam.travelInfo.returnDate,
            promoCode: "",
            declCompanyCode: "",
            declClaimType: "",
            declOtherClaim: "",
            tripCode: props.queryParam.travelInfo.tripCode,
            //dateOfBirth: Moment(props.travelInfo.dateOfBirth).format('DD/MM/YYYY'),
            dateOfBirth: props.queryParam.travelInfo.dateOfBirth,
            nationality:  props.queryParam.travelInfo.nationality,
            transactionNo: props.transactionNo
        }
        )
        .then((response) => {
          
            setAllPlans(response.data);
            setShowAllPlans(true);
            swalAlert.close();
        })
        .catch((error) => {
            swalAlert.close();
            console.log(error);
        });
    }


    function getMsigPlanBenefits() {
        //For MSIG plan
       
        swalAlert.fire({
            title: 'Please Wait ...',
            allowOutsideClick: false
        });
        swalAlert.showLoading();

        axios.post('/api/get-quote', {
            insurer: insurer_msig,
            token: props.token,
            tuneToken: props.tuneToken,
            productType: props.travelInfo.productType,
            channel: channel,
            travelTo:  props.travelInfo.travelTo,
           // travelCountryCode: (props.travelInfo.productType == 'TDA') ? props.travelInfo.areaCountryList  : props.travelInfo.destination.msig_countrycode,
            travelCountryCode: (props.travelInfo.productType == 'TDA') ? '' : props.travelInfo.destination.msig_countrycode,
            buyFor: props.travelInfo.buyFor,
            noOfAdults: props.travelInfo.noOfAdults,
            noOfChildren: props.travelInfo.noOfChildren,
            tripType:  props.travelInfo.tripCode,
            travelStartDate: props.travelInfo.departureDate,
            travelEndDate: props.travelInfo.returnDate,
            promoCode: "",
            declCompanyCode: "",
            declClaimType: "",
            declOtherClaim: "",
            }).then((response) => {

              

                var responseData = JSON.parse(response.data.data);

                if(response.status == 200 && response.data.status == 200) {
                   
                    getMsigQuotation(responseData.quoteDetails);
                }
          }).catch((error) => {
            swalAlert.close();
            console.log(error);
        });

         

    }

    function getMsigQuotation(travelQuotations) {

        let result = [];

        if(!isEmpty(props.travelInfo.msigPlanDetails)) {

         
            $.each(props.travelInfo.msigPlanDetails, function (i, objPlan) {
                $.each(travelQuotations.quoteDetail, function (i, objQuotation) {
                    if(objPlan.planId == objQuotation.planId) {

                        var coverageCode = [];
                        var msigBenefits = [];

                        $.each(objPlan.benefitDetails.benefitDetail, function (j, obj) {
                                if(!coverageCode.includes(obj.coverageCode)) {
                                    coverageCode.push(obj.coverageCode);   
                                    msigBenefits.push(obj);  
                                }
                        });    

                      

                        var msigMainbenefits = [];
                        
                        if(msigBenefits) {

                            $.each(msigBenefits, function (j, obj) {
                                if(premierBenefits.includes(obj.coverageCode)) {
                                    msigMainbenefits.push(obj);   
                                }
                            });

                        }

                        result.push({
                            "insurer": insurer_msig,
                            "product": objPlan.productName,
                            "plan": objPlan.planName,
                            "planId": objPlan.planId,
                            "premium": objQuotation.grossPremium,
                            "serviceTax": objQuotation.serviceTax,
                            "stampDuty": objQuotation.stampDuty,
                            "discount": objQuotation.discount,
                            "totalAmount": objQuotation.totalAmount,
                            "planType": props.travelInfo.planType,
                            "zone": props.travelInfo.destination.msig_zone,
                            "benefits" : msigBenefits,
                            "mainBenefits" : msigMainbenefits,
                            "hideOverviewFaq" : false,
                            "quotationID": travelQuotations.quotationID
                        });
                    }

                });
            });
        }

        swalAlert.close();

      

       setAllPlans(result);
       setShowAllPlans(true);
    }


    function ChangeSelectedPlan(e) {

        //Start Validation
       
        let valid = validationRules(e.insurer)

       
     
        if(valid) {
            props.setSelectedPlan(e);
            setSelectedPlan(e);
            setPlanId(e.planId);
            props.setActiveId('add-on');
            
        }

    }

    function changeManualPlan(e) {

        swalAlert.fire({
           // title: "Oops...",
            //text: "Upon selecting this insurer, your policy will be emailed to you within 3 business days. Proceed with "+e.toUpperCase()+"?",
             html: "Upon selecting this insurer, your policy will be emailed to you within 3 business days. <br/> Proceed with "+e.toUpperCase()+"?",
            type: "warning",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Yes',
            cancelButtonText: "No",
            closeOnConfirm: false,
            closeOnCancel: false
         }).then((result) => {	
            if (result.value) {
                
                setManualPlan(e);
                let travelObj = {};

                travelObj = {
                    travelInfo: props.travelInfo,
                    fromApi: 1,
                    insurer: e,
                    referral: props.referral,
                    basicName: props.basicName,
                    basicEmailAdd: props.basicEmailAdd,
                    basicContactNo: props.basicContactNo,
                    renewalTransactionNumber: renewalTransactionNumber
                }
                const travelDetails =  JSON.stringify(travelObj);
       
     
                const encryptedData = CryptoJS.AES.encrypt(travelDetails, process.env.MIX_URL_ENCRYPT_KEY).toString();
                const manualUrl = process.env.MIX_DOMAIN_TRAVEL_MANUAL+"/travel?m="+encryptedData;
        
                console.log(travelDetails);
                console.log(encryptedData);
                // console.log(manualUrl);
        
                const decryptedData = CryptoJS.AES.decrypt(encryptedData, process.env.MIX_URL_ENCRYPT_KEY).toString(CryptoJS.enc.Utf8);
        
                console.log('decryptedData');
                console.log(decryptedData);
        
                const travelJson =  JSON.parse(decryptedData);
        
                console.log(travelJson.fromApi);
        
                console.log(travelJson.travelInfo.tripType);
                
                
               location.href = manualUrl;
                
            } 
         });     


       
    }

    function validationRules(insurer) {

        let valid = true;

        switch(insurer) {
            case insurer_msig:
                valid = msigValidation();
                break;
            default:
        }

        return valid;

    }

    function msigValidation() {

     

        let date1 = new Date();
        let departure_date = Moment(props.travelInfo.departureDate, 'DD/MM/YYYY');
        let return_date =  Moment(props.travelInfo.returnDate, 'DD/MM/YYYY');

    
        let date2 = new Date(departure_date);

        let date3 = new Date(return_date);

        // To calculate the time difference of two dates
        let Difference_In_Time_Departure = date2.getTime() - date1.getTime();
        let Difference_In_Time_Return = date3.getTime() - date1.getTime();
        let Difference_In_Time_Departure_Return = date3.getTime() - date2.getTime();

        // To calculate the no. of days between two dates
        let Difference_In_Days_Departure = Math.ceil(Difference_In_Time_Departure / (1000 * 3600 * 24));
        let Difference_In_Days_Return = Math.ceil(Difference_In_Time_Return / (1000 * 3600 * 24));
        let Difference_In_Days_Departure_Return = Math.ceil(Difference_In_Time_Departure_Return / (1000 * 3600 * 24));

        //let dateCurr = new Date();
        let currYear =Moment(props.travelInfo.departureDate).format('YYYY');
        let dobYear = Moment(props.travelInfo.dateOfBirth).format('YYYY');

        let diffYear = (parseInt(currYear) - parseInt(dobYear));

        if(props.travelInfo.tripCode == 'S' && Difference_In_Days_Return > 365) {
            swalAlert.fire({
                title: 'Oops...',
                icon: 'error',
                text: 'Sorry, Return Date cannot exceed more than 1 year from date of purchase.',
            }).then((result) => {
                if (result.isConfirmed) {
                    props.setActiveId('travel');
                    
                }
            });

            return false;

        }

        if(props.travelInfo.tripCode == 'S' && Difference_In_Days_Departure > 364) {

            swalAlert.fire({
                title: 'Oops...',
                icon: 'error',
                text: 'Sorry, Departure Date cannot exceed more than 1 year from date of purchase.',
            }).then((result) => {
                if (result.isConfirmed) {
                    props.setActiveId('travel');
                    
                }
            });

            return false;
        }

        if(props.travelInfo.tripCode == 'A' && props.travelInfo.buyFor != 'IO') {

            swalAlert.fire({
                title: 'Oops...',
                icon: 'error',
                text: 'Sorry, anuual plan only applicable for the Insured only (IO).',
            }).then((result) => {
                if (result.isConfirmed) {
                    props.setActiveId('travel');
                   
                }
            });

            return false;

        }

        
        if(props.travelInfo.tripCode == 'A' && props.travelInfo.travelTo == 'O') {

            swalAlert.fire({
                title: 'Oops...',
                icon: 'error',
                text: 'Sorry, anuual plan only applicable for the Insured only (IO).',
            }).then((result) => {
                if (result.isConfirmed) {
                    props.setActiveId('travel');
                   
                }
            });

            return false;
        }

        if(props.travelInfo.tripCode == 'S' && Difference_In_Days_Departure_Return > 185) {

            swalAlert.fire({
                title: 'Oops...',
                icon: 'error',
                text: 'Sorry, Travel coverage period is only up to a maximum of 185 days.',
            }).then((result) => {
                if (result.isConfirmed) {
                    props.setActiveId('travel');
                    return false;
                }
            });

            return false;
        }

        if(props.travelInfo.buyFor == 'FC' &&  props.travelInfo.noOfAdults < 0) {
            swalAlert.fire({
                title: 'Oops...',
                icon: 'error',
                text: 'Sorry, Minimum number of adults in Family Plan is 1.',
            }).then((result) => {
                if (result.isConfirmed) {
                    props.setActiveId('travel');
                  
                }
            });

            return false;
        }

        if(props.travelInfo.buyFor == 'FC' &&  props.travelInfo.noOfAdults > 2) {
            swalAlert.fire({
                title: 'Oops...',
                icon: 'error',
                text: 'Sorry, Number of adults in Family Plan is up to maximum 2.',
            }).then((result) => {
                if (result.isConfirmed) {
                    props.setActiveId('travel');
                  
                }
            });

            return false;
        }

        if(props.travelInfo.buyFor == 'FC' &&  (parseInt(props.travelInfo.noOfAdults) + parseInt(props.travelInfo.noOfChildren)) > 6) {
            swalAlert.fire({
                title: 'Oops...',
                icon: 'error',
                text: 'Sorry, Total number of people in Family Plan is up to maximum 6.',
            }).then((result) => {
                if (result.isConfirmed) {
                    props.setActiveId('travel');
                  
                }
            });

             return false;

        }

    
        if ( diffYear > 69 || diffYear < 18) {
            swalAlert.fire({
                title: 'Oops...',
                icon: 'error',
                text: 'Sorry, Age of Insured must between 18 to 69 years old.'
            }).then((result) => {
                if (result.isConfirmed) {
                    props.setActiveId('travel');
                }
            });

            return false;
        } 

        

        return true;


    }

    function onClickNext(e) {
        e.preventDefault();

        props.setSelectedPlan(selectedPlan);
        props.setActiveId('add-on');
    }

    function onClickBack() {
        props.setActiveId('travel');
    }

    function MoreBenefits(props) {

        if (isEmpty(props.plan.benefits)) {
            return null;
        }

        return (
            <>

                <ul>
                    {props.plan.benefits.map((obj) => {

                        if (props.plan.insurer == insurer_msig) {
                            return (
                            
                                <>
                                    
                                        {/* {props.plan.insurer == 'MSIG' || props.plan.insurer == 'TUNEPROTECT'? */}
                                        
                                    
                                        
                                        {/* <> */}

                                        {obj.coverageCode == 'MED7' ?
                                            <label class="fw-bold">Add-on benefits in relation to Covid-19 (subject to T&C)</label>
                                        :
                                        null  
                                        }

                                        

                                        <li>
                                            {obj.coverageDescription} 

                                            {(isNaN(obj.sumInsured.replace(',', '')) || isEmpty(obj.sumInsured.replace(',', '')) || obj.sumInsured.replace(',', '') <= 0) ?
                                                <span className="text-primary ml-3">Covered</span>

                                            :
                                                <span className="text-primary ml-3">
                                                
                                                    RM {parseFloat(obj.sumInsured.replace(',', '')).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                                                    
                                                </span>
                                            }

                                        </li>

                                        {/* </> */}

                                    {/* : */}

                                    

                            
                                    {/* } */}

                                </>

                            );
                        } else if (props.plan.insurer == insurer_rhbi) {
                            return (
                                <>
                                    <li>
                                        {obj.coverageDescription} 

                                        <ul>
                                            {obj.items.map((objSum) => {
                                            return (
                                                <>
                                                    <li>
                                                        {objSum.benefit} 
                                                        <span className="text-primary ml-3">
                                                        {props.plan.planId == 'ADVANCE'?   
                                                            <>
                                                                {objSum.sumInsured.ADVANCE == 'AVAILABLE' || objSum.sumInsured.ADVANCE == 'COVERED' ?
                                                                    <>
                                                                        {objSum.sumInsured.ADVANCE}
                                                                    </>

                                                                :
                                                                    <>
                                                                    RM {objSum.sumInsured.ADVANCE}
                                                                    </>

                                                                }
                                                                {/* {(isNaN(objSum.sumInsured.ADVANCE.replace(',', '')) || isEmpty(objSum.sumInsured.ADVANCE.replace(',', '')) || objSum.sumInsured.ADVANCE.replace(',', '') <= 0) ?
                                                                    <>
                                                                    Covered
                                                                    </>
                                                                : 
                                                                    <>
                                                                    RM {parseFloat(objSum.sumInsured.ADVANCE.replace(',', '')).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                                                                    
                                                                    </>
                                                                
                                                                } */}
                                                            </>
                                                    
                                                        :

                                                        <>
                                                            {objSum.sumInsured.SUPREME == 'AVAILABLE' || objSum.sumInsured.SUPREME == 'COVERED' ?
                                                                <>
                                                                    {objSum.sumInsured.SUPREME}
                                                                </>
                                                                :
                                                                <>
                                                                RM {objSum.sumInsured.SUPREME}
                                                                </>
                                                            }
                                                        </>
                                                    

                                                            // <>
                                                            //     {(isNaN(objSum.sumInsured.SUPREME.replace(',', '')) || isEmpty(objSum.sumInsured.SUPREME.replace(',', '')) || objSum.sumInsured.SUPREME.replace(',', '') <= 0) ?
                                                            //         <>
                                                            //         Covered
                                                            //         </>
                                                            //     :
                                                            //         <>
                                                            //         RM {parseFloat(objSum.sumInsured.SUPREME.replace(',', '')).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                                                            //         </>
                                                            //     }
                                                            // </> 

                                                        }
                                                        </span>    

                                                    </li>
                                                    
                                                </>
                                            );
                                        })}

                                        </ul>
                                        

                                    </li>

                                </>
                            );   


                        } else if (props.plan.insurer == insurer_tune) {
                            return (
                               
                                <>
                                  <li>
                                        {obj.coverageDescription} 

                                      
                                        <div className="text-primary ml-3" dangerouslySetInnerHTML={{__html: obj.sumInsuredDescription}} />
                                           
                                            
                                       

                                    </li>

                                </>
                            );


                        }

                       
                    })
                    }
                </ul>
                <label class="fw-bold">
                    Note: The above benefits list are non-exhaustive. Please refer to the <a href={"../storage/pdf/POLICY_WORDING_" + props.plan.insurer.toLowerCase()+".pdf"} className="text-decoration-primary" target="_blank">Policy Wording</a> for full list of benefits under the policy.
                </label>
            
               
                <p>
                    {getInsurerFullName(props.plan.insurer)} is a member of PIDM. The benefit(s) payable under eligible product is protected by PIDM up to limits. Please refer to <a href={"../storage/pdf/PIDM_Brochure.pdf"} className="text-decoration-primary" target="_blank">PIDM's TIPS Brochure</a> or contact {getInsurerFullName(props.plan.insurer)} or PIDM (visit <a href="https://www.pidm.gov.my/" className="text-decoration-primary" target="_blank">www.pidm.gov.my</a>).

                </p>
             
               
            </>
        );


    }

    function Overview(props) {
        if (props.insurer === 'AXA') {
            return (
                <>
                    <h5 className="text-primary">Key Benefits</h5>
                    <ul>
                        <li>
                            <h6 className="text-primary">High Medical Coverage When Overseas</h6>
                            <p>
                                We pay for your medical and hospital expenses incurred overseas due to accident or
                                illness during your travels up to RM 350,000.
                            </p>
                        </li>
                        <li>
                            <h6 className="text-primary">Get Compensated for Damage to Personal Belongings &amp; Travel Inconveniences</h6>
                            <p>
                                We pay for loss or damage to your baggage and personal effects up to RM 7,500, as
                                well as travel and baggage delays.
                            </p>
                        </li>
                        <li>
                            <h6 className="text-primary">Online Claim Submission</h6>
                            <p>
                                For your ease and convenience, you can submit your travel claims online. You will be
                                notified of the claim status once approved, the claim payment will be credited to your
                                bank account.
                            </p>
                        </li>
                        <li>
                            <h6 className="text-primary">Trip Cancellation</h6>
                            <p>
                                But travel insurance at least 14 days before your trip, and we will compensate you for
                                irrecoverable travel and accomodation expenses as a result of trip cancellation due to
                                serious injury or illness to you or your immediate family or a natural disaster at your
                                destination.
                            </p>
                            <p>
                                For trip cancellation cover due to flight cancellation or reschedulling, purchase the
                                Add-on for `Flight Cancellation or Reschedulling`.
                            </p>
                        </li>
                        <li>
                            <h6 className="text-primary">Emergency Medical Evacuation</h6>
                            <p>
                                Unlimited coverage for emergency transportation and medical care to the nearest
                                hospitals.
                            </p>
                        </li>
                    </ul>
                </>
            );
        } else if (props.insurer === 'CHUBB') {
            return (
                <>
                    <h5 className="text-primary">Key Benefits</h5>
                    <ul>
                        <li>
                            <h6 className="text-primary">24 hours Worldwide Chubb Assistance Emergency</h6>
                            <p>
                                Helpline: <a href="tel:+60376283703">+603 7628 3703</a>
                            </p>
                        </li>
                        <li>
                            <h6 className="text-primary">No Maximum Age Limit</h6>
                        </li>
                        <li>
                            <h6 className="text-primary">High Sum Insured for Overseas Medical Expenses</h6>
                        </li>
                        <li>
                            <h6 className="text-primary">High Sum Insured for Travel Cancellation &amp; Curtailment</h6>
                        </li>
                        <li>
                            <h6 className="text-primary">Cruise Pack Add-On Available</h6>
                        </li>
                        <li>
                            <h6 className="text-primary">Covers Both Leisure &amp; Business Trips</h6>
                        </li>
                        <li>
                            <h6 className="text-primary">Golf Benefits Available for Golfers</h6>
                        </li>
                    </ul>
                </>
            );
        } else if (props.insurer === 'AIG') {
            return (
                <>
                    <h5 className="text-primary">Key Benefits</h5>
                    <ul>
                        <li> <h6 className="text-primary"> Overseas COVID-19 coverage (applicable to Superior or Premier plan only).</h6> </li>
                        <li> <h6 className="text-primary"> Comprehensive coverage including medical benefits, personal accident, trip cancellation, travel inconvenience, lost/damaged or delayed baggage, car rental excess charges and more.</h6> </li>
                        <li> <h6 className="text-primary"> Medical expenses coverage of up to RM10 million (including cashless hospital admission).</h6> </li>
                        <li> <h6 className="text-primary">Lump sum pay out of up to RM500,000 if you suffer from an accidental death or permanent disablement during your trip.</h6> </li>
                        <li> <h6 className="text-primary"> 24/7 Worldwide Travel Assistance available <a href="tel:1800 88 8811">1800 88 8811</a>  to assist you in the event of injury following an accident or if you are ill and require hospital attention abroad.</h6> </li>
                        <li> <h6 className="text-primary"> Optional add on Travel Delay Upgrade covers you if your flight is delayed for at least 3 hours.</h6> </li>
                    </ul>
                </>
            );
        } else if (props.insurer === 'MSIG') {
            return (
                <>
                    <h5 className="text-primary">Key Benefits</h5>
                    <ul>
                        <li>
                            <h6 className="text-primary">Higher Coverage – Plan 3</h6>
                            <p>
                                <ul>
                                    <li>Sum Insured up to RM500,000</li>
                                </ul>
                            </p>
                        </li>
                        <li>
                            <h6 className="text-primary">Additional Coverage</h6>
                            <p>
                                <ul>
                                    <li>Emergency Telephone Charges</li>
                                    <li>Alternative Transport Arrangement</li>
                                </ul>
                            </p>
                        </li>
                        <li>
                            <h6 className="text-primary">Extra Covers for Travel Inconvenience</h6>
                            <p>
                                <ul>
                                    <li>Unauthorised use of credit or debit card following robbery or theft</li>
                                    <li>Missed events due to Travel Delay</li>
                                    <li>Rental car excess if the car is damaged or stolen</li>
                                </ul>
                            </p>
                        </li>
                        <li>
                            <h6 className="text-primary">Revised Cover for Travel Delay</h6>
                            <p>
                                <ul>
                                    <li>First four consecutive hours of delay at RM200 and
                                        every subsequent six consecutive hours of delay at
                                        RM200 subject to a maximum amount of RM3,600
                                        (Plan 1), RM4,000 (Plan 2) & RM4,500 (Plan 3)
                                    </li>
                                </ul>
                            </p>
                        </li>
                        <li>
                            <h6 className="text-primary">Extensive Personal Accident Cover</h6>
                            <p>
                                <ul>
                                    <li>Covers accidental Death & Permanent Total Disablement</li>
                                </ul>
                            </p>
                        </li>
                        <li>
                            <h6 className="text-primary">Attractive Medical and Related Benefits</h6>
                            <p>
                                <ul>
                                    <li>Covers illness and injury whilst travelling overseas. Covers include alternative medicine, hospital income and follow-up medical treatment in Malaysia</li>
                                    <li>Emergency Medical Evacuation, repatriation, burial and cremation expenses are covered</li>
                                </ul>
                            </p>
                        </li>
                        <li>
                            <h6 className="text-primary">24-hour Worldwide Travel Assistance Hotline: +603 2166 3080</h6>
                        </li>
                        <li>
                            <h6 className="text-primary">No UPPER age limit for Single Trip Cover</h6>
                        </li>
                        <li>
                            <h6 className="text-primary">Flexible plans for overseas travel</h6>
                        </li>
                        <li>
                            <h6 className="text-primary">Covers both business and leisure trips</h6>
                        </li>
                        <li>
                            <h6 className="text-primary">Covers hijacking and terrorism</h6>
                        </li>
                        <li>
                            <h6 className="text-primary">Chartered flights (scheduled) are covered</h6>
                        </li>
                        <li>
                            <h6 className="text-primary">Member of MATTA (Malaysian Association of Tour and Travel Agents)</h6>
                        </li>
                        <li>
                            <h6 className="text-primary">Add-on Key Covid-19 Coverage:</h6>
                            <p>
                                <ul>
                                    <li>COVID-19 coverage is only applicable for COVID Plus Plan and COVID Lite Plan</li>
                                    <li>Both COVID Plus and COVID Lite Plans automatically include the benefits under the Basic Plan</li>
                                </ul>
                            </p>
                        </li>


                    </ul>
                </>
            );

        } else if (props.insurer === 'ZurichTakaful') {
            return (
                <>
                    <h5 className="text-primary">Key Benefits</h5>
                    <ul>
                        <li>
                            <h6 className="text-primary">General Takaful is an Islamic insurance whereby
                                members contribute money into a pool to protect and
                                reimburse each other</h6>
                        </li>
                        <li>
                            <h6 className="text-primary">Covers up to the age of 85 years old</h6>
                        </li>
                        <li>
                            <h6 className="text-primary">24-Hour Emergency Medical Assistance Benefits</h6>
                        </li>
                        <li>
                            <h6 className="text-primary">24/7 Worldwide Zurich Travel Assistance</h6>
                        </li>
                        <li>
                            <h6 className="text-primary">High Medical Coverage</h6>
                        </li>
                        <li>
                            <h6 className="text-primary">Travel Inconvenience Coverage</h6>
                        </li>
                        <li>
                            <h6 className="text-primary">Personal Accident Coverage</h6>
                        </li>
                        <li>
                            <h6 className="text-primary">Protection for Amateur Sports Including Scuba Diving,
                                Winter Sports, Bungee Jumping & More</h6>
                        </li>
                        <li>
                            <h6 className="text-primary">Home Care Benefits</h6>
                        </li>
                        <li>
                            <h6 className="text-primary">Car Rental Excess</h6>
                        </li>
                        <li>
                            <h6 className="text-primary">Optional Covid-19 Add-On</h6>
                        </li>
                    </ul>
                </>
            );

        }
        else if (props.insurer === 'TuneProtect') {
            return (
                <>
                    <h5 className="text-primary">Travel Comprehensive - Platinum / Gold / Silver</h5>
                    <h5 className="text-primary">Key Benefits</h5>
                    <ul>
                        <li>
                            <h6 className="text-primary">Covid-19 Coverage (Applicable to Travel Comprehensive - Platinum Plan Cover)</h6>

                        </li>
                        <li>
                            <h6 className="text-primary">Personal Accident</h6>

                        </li>
                        <li>
                            <h6 className="text-primary">Travel Inconveniences</h6>

                        </li>
                        <li>
                            <h6 className="text-primary">Medical Benefits (Accidental & Sickness)</h6>

                        </li>
                        <li>
                            <h6 className="text-primary">Personal Liability</h6>

                        </li>
                        <li>
                            <h6 className="text-primary">Home Care Benefit</h6>

                        </li>
                        <li>
                            <h6 className="text-primary">Travel Assistance Services</h6>

                        </li>
                    </ul>


                </>
            );

        }


        return null;
    }

    function PolicyDetails(props) {
        if (props.insurer === 'AXA') {
            return (
                <>
                    <Accordion className="mb-3">
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                Personal Accident
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={props.insurer}>
                                <Card.Body>
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <h6 className="text-primary">Accidental Death and Permanent Disablement</h6>
                                            <p>
                                                We pay up to RM 350,000 for Accidental Death and Permanent Disablement
                                                of Insured Person.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <h6 className="text-primary">Child Education</h6>
                                            <p>We cover the education fees of the children of the Insured Person who suffer from Accidental Death.</p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                Medical Benefits
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={props.insurer}>
                                <Card.Body>
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <h6 className="text-primary">Medical, Hospital and Treatment Expenses</h6>
                                            <p>
                                                Reimburse expenses (including cost of emergency dental treatment)
                                                incurred during accident or sickness.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <h6 className="text-primary">Compassionate Visitation (due to Hospitalisation of Insured Person)</h6>
                                            <p>
                                                Pay for additional expenses of one relative or friend required on
                                                medical advice to travel or remain behind you.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <h6 className="text-primary">Alternative Medicine</h6>
                                            <p>
                                                Reimburse medical expenses for traditional medicine, osteopath,
                                                physiotherapy, and chiroproactor.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <h6 className="text-primary">Compassionate Visitation (due to Insured Person's Death)</h6>
                                            <p>
                                                In the event of the Insured Person's death, we reimburse for travel
                                                and accommodation expenses for one relative or friend to assist in
                                                the burial or cremation arrangements in the locality where death occurs.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <h6 className="text-primary">Child Care</h6>
                                            <p>
                                                Pay for additional expenses of one relative or friend to take care of your
                                                children whilst you are hospitalised and the cost of a return trip economy
                                                class ticket.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <h6 className="text-primary">Medical Treatment in Malaysia</h6>
                                            <p>
                                                Reimburse for follow up treatment within 90 days of initial treatment upon
                                                return to Malaysia.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <h6 className="text-primary">Hospital Allowance</h6>
                                            <p>
                                                Pay for each complete day you are confined in a hospital on top of medical
                                                costs incurred (RM 350 per day for overseas travel).
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                Emergency Medical Evacuation &amp; Repatriation
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={props.insurer}>
                                <Card.Body>
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <h6 className="text-primary">Emergency Medical Evauation</h6>
                                            <p>
                                                Emergency transportation and medical care en route to move you
                                                (in a medical critial condition) to the nearest hospital.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <h6 className="text-primary">Emergency Medical Repatriation</h6>
                                            <p>
                                                In an event that the Insured Person is hospitalised abroad and
                                                it is medically necessaery for the Insured Person to be repatriated
                                                back to Malaysia to continue the treatment, we will pay in respect of
                                                reasonable and necessary repatriation costs including reasonable transportation
                                                costs of one qualified medical attendant accompanying the Insured Person.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <h6 className="text-primary">Repatriation of Mortal Remains</h6>
                                            <p>
                                                Pay for the cost of burial or cremation in the locality where death
                                                occurs or the expenses of transporting the mortal remains back to Malaysia.
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                Personal Belongings
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={props.insurer}>
                                <Card.Body>
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <h6 className="text-primary">Baggage and Personal effects</h6>
                                            <p>
                                                Pay a loss of or damage to your baggage and personal effects due to theft
                                                or negligence of the common carrier. Maximum limit for any one item or pair
                                                or set of articles is up to RM 500. Maximum limit per baggage is up to RM 300.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <h6 className="text-primary">Money and Travel Documents</h6>
                                            <p>
                                                Pay for travel and accomodation expenses including cost of obtaining replacement
                                                passports, travel tickets and other relavant travel documents. Loss of money due
                                                to theft is covered up to RM 1,500.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <h6 className="text-primary">Baggage Delay</h6>
                                            <p>
                                                Pay if your checked-in baggage is delayed for each full 6 consecutive hours
                                                (RM 200 for every 6 hours) upon arrival at your destination abroad.
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                Travel Inconveniences Benefits
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={props.insurer}>
                                <Card.Body>
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <h6 className="text-primary">Travel Delay / Overbooked / Misconnection or Reroute</h6>
                                            <p>
                                                Pay :
                                                <ul>
                                                    <li>if the conveyance is delayed from the scheduled departure time</li>
                                                    <li>
                                                        due to overbooked or misconnection by common air carrier and no
                                                        alternative transportation is
                                                    </li>
                                                    <li>
                                                        provided if the arrival of the scheduled public conveyance is
                                                        delayed due to rerouting for each full 6 consecutive hours delay
                                                        (RM200 for every 6 hours).
                                                    </li>
                                                </ul>
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <h6 className="text-primary">Cancellation and Postponement</h6>
                                            <p>
                                                Reimburse for irrecoverable travel and accommodation expenses paid in advance
                                                due to death, serious injury or illness to you or your immediate family or a
                                                natural disaster at your destination, provided that the insurance is purchased
                                                not less than 14 days prior to the commencement of the scheduled trip.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <h6 className="text-primary">Travel Curtailment</h6>
                                            <p>
                                                Reimburse for proportional return of irrecoverable prepaid costs incurred,
                                                if it is necessary and unavoidable to curtail your trip.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <h6 className="text-primary">Hijacking</h6>
                                            <p>
                                                Pay for each full 24 consecutive hours of hijack (RM1,000/24 hours).
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <h6 className="text-primary">Missed Departure</h6>
                                            <p>
                                                Reimburse for additional accommodation and travel expenses necessarily and
                                                reasonably incurred, as a result of strike, industrial action, natural disaster,
                                                inclement weather condition, mechanical breakdown of the public transport which
                                                prevented you from arriving at your outbound port, airport or station in time.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <h6 className="text-primary">Loss of Use of Entertainment Tickets</h6>
                                            <p>
                                                Reimburse for unused and irrecoverable deposits or payment made for entertainment
                                                (tourist attraction centres / concerts) ticket charges due to death, hospitalisation
                                                or due to adverse weather condition or Natural Disaster at planned destination.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <h6 className="text-primary">Loss of Credit Card</h6>
                                            <p>
                                                Pay you for fraudulent usage of your credit card.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <h6 className="text-primary">Personal Liability</h6>
                                            <p>
                                                Indemnify you for legal liability towards third parties or damage to their property
                                                due to your negligence.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <h6 className="text-primary">Rental Car Excess</h6>
                                            <p>
                                                Pay for any excess/deductible which you become legally liable to pay in respect of
                                                loss or damage to rental vehicle during the rental period.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <h6 className="text-primary">Ransom Payment as a Result of Kidnapping &amp; Hostage</h6>
                                            <p>
                                                Pay for the ransom payment as a result of kidnapping and hostage outside Malaysia.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <h6 className="text-primary">Home Care</h6>
                                            <p>
                                                Pay for damages to your home contents as a result of burglary or fire when your house
                                                is left vacant while travelling.
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                Add-ons
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={props.insurer}>
                                <Card.Body>
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <h6 className="text-primary">Golf Equipment</h6>
                                            <p>
                                                Pay for replacement or repair cost of the lost or damaged golf equipment and the
                                                cost for hiring replacement golf equipment.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <h6 className="text-primary">Sports Equipment / Musical Instruments</h6>
                                            <p>
                                                Pay for replacement or repair cost of the lost or damaged sports equipment / musical
                                                instruments and the cost for hiring replacement sports equipment / musical instruments.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <h6 className="text-primary">Flight Cancellation or Reschedulling</h6>
                                            <p>
                                                Pay for the non refundable prepaid expenses or deposits paid if you cancel the trip or
                                                pay for an alternative flight ticket as a result of flight cancellation or rescheduling.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <h6 className="text-primary">Cruise Cover</h6>
                                            <p>
                                                Reimburse the additional expenses to join the cruise due to missed connection as a
                                                result of flight delay or rejoin due to hospitalisation on land. Also reimburse for
                                                additional expenses to secure return flight home due to delay in the cruise arriving
                                                at disembarkation port.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <h6 className="text-primary">Medical Expenses Top Up *</h6>
                                            <p>
                                                Option to increase your medical, hospital and treatment expense limit.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <h6 className="text-primary">Accidental Death &amp; Permanent Disablement Top Up *</h6>
                                            <p>
                                                Option to increase Accidental Death and Permanent Disablement benefit by RM100,000.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <h6 className="text-primary">Pandemic Cover</h6>
                                            <p>
                                                Option to extend cover for Pandemic events. This covers for Trip Cancellation, Trip
                                                Curtailment, Medical, Hospital and Treatment Expenses, Hospital Allowances, Emergency
                                                Medical Evacuation, Emergency Medical Repatriation and Repatriation of Mortal Remains
                                                if you are diagnosed with a pandemic illness.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <h6 className="text-primary">Domestic Travel Extension</h6>
                                            <p>
                                                Option to extend cover for domestic travels.
                                            </p>
                                        </div>
                                    </div>
                                    <p className="mt-4">* not applicable to Senior Plan for persons aged 65 and above</p>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                Key Exclusions
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={props.insurer}>
                                <Card.Body>
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <ul>
                                                <li>Pre-existing medical conditions</li>
                                                <li>Travelling against medical advice</li>
                                                <li>Flight cancellations or rescheduling unless Add-on is purchased</li>
                                                <li>Pandemic (unless Add-on is purchased)</li>
                                                <li>Engaging in offshore activities, explosive handling</li>
                                                <li>Loss or expenses that causes us to be in breach of any trade or economic sanctions</li>
                                                <li>War, act of foreign enemy, radiation or contamination by radioactivity</li>
                                                <li>Acquired Immune Deficiency Syndrome (AIDS), Human Immune Deficiency Virus (HIV)</li>
                                                <li>Suicide or self-inflicted injury, pregnancy</li>
                                                <li>Professional or hazardous sports, racing</li>
                                                <li>If you are a member of the aircraft crew</li>
                                                <li>Under the influence of alcohol or drug, mental insanity</li>
                                                <li>The consequential loss or damage of any kind</li>
                                            </ul>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                </>
            );
        }
        else if (props.insurer === 'CHUBB') {
            return (
                <>
                    <Accordion className="mb-3">
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                Personal Accident
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={props.insurer}>
                                <Card.Body>
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <h6 className="text-primary">Accidental Death and Permanent Disablement</h6>
                                            <p>
                                                We cover Accidental Death and Permanent Disablement up to RM 325,000 within 180 days from the date
                                                of the Accident from date of Accident.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <h6 className="text-primary">Child Education Fund</h6>
                                            <p>We cover the education fees of the children of the Insured Person who suffer from Accidental Death.</p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                Medical Benefits
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={props.insurer}>
                                <Card.Body>
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <h6 className="text-primary">Medical, Hospital and Treatment Expenses</h6>
                                            <p>
                                                Reimburse expenses (including cost of emergency dental treatment)
                                                incurred during accident or sickness.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <h6 className="text-primary">Alternative Treatment</h6>
                                            <p>
                                                We reimburse medical expenses for traditional medicine whilst you are on an
                                                Overseas Return Journey, and you may continue to seek treatment from a Traditional
                                                Physician in Malaysia within 30 days from the date of your return to Malaysia for
                                                the same Bodily Injury or Sickness.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <h6 className="text-primary">Daily Hospital Income</h6>
                                            <p>
                                                We pay for each complete day you are confined in a hospital on top of the medical
                                                cost within 30 days of the Accident causing Bodily Injury or Sickness.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <h6 className="text-primary">Compassionate Visit</h6>
                                            <p>
                                                In the event of the Insured Person's death, we reimburse for economy return
                                                travel tickets and ordinary room accommodation expenses for one relative or
                                                friend to assist with the burial or cremation arrangement in the locality
                                                where death occurs.
                                            </p>
                                            <p>
                                                In the event of Serious Bodily Injury, we reimburse for economy return travel
                                                tickets and ordinary room accommodation expenses for one relative or friend
                                                to take care of you until you are discharged.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <h6 className="text-primary">Child Guard</h6>
                                            <p>
                                                We pay for the travel expenses (economy return travel ticket) and ordinary
                                                room accommodation expenses in any reasonable hotel outside Malaysia necessarily
                                                incurred for one relative or friend to accompany your child back to Malaysia.
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                Emergency Medical Evacuation &amp; Repatriation
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={props.insurer}>
                                <Card.Body>
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <h6 className="text-primary">Emergency Medical Evacuation</h6>
                                            <p>
                                                Emergency transportation and medical care en route to move you
                                                (in a medical critial condition) to the nearest hospital.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <h6 className="text-primary">Emergency Medical Repatriation</h6>
                                            <p>
                                                In an event that the Insured Person is hospitalised abroad and
                                                it is medically necessary for the Insured Person to be repatriated
                                                back to Malaysia to continue the treatment, we will pay in respect
                                                of reasonable and necessary repatriation costs including reasonable
                                                transportation costs of one qualified medical attendant accompanying
                                                the Insured Person.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <h6 className="text-primary">Repatriation of Mortal Remains</h6>
                                            <p>
                                                Pay for the cost of burial or cremation in the locality where death
                                                occurs or the expense of transporting the mortal remains back to
                                                Malaysia.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <h6 className="text-primary">Emergency Mobile Phone Charges</h6>
                                            <p>
                                                We reimburse charges of personal mobile phone used for the sole purpose
                                                of engaging the services of Chubb Assistance during medical emergency
                                                of which Overseas Medical Expenses claim has been submitted.
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                Travel Inconveniences Benefits
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={props.insurer}>
                                <Card.Body>
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <h6 className="text-primary">Travel Cancellation / Postponement</h6>
                                            <p>
                                                Reimburse for irrecoverable travel and accommodation expenses paid in
                                                advance due to death, serious injury or illness to you or your immediate
                                                family or a natural disaster at your destination, provided that the
                                                insurance is purchased not less than 14 days prior to the commencement
                                                of the scheduled trip.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <h6 className="text-primary">Travel Curtailment / Disruption</h6>
                                            <p>
                                                Reimburse for proportional return of irrecoverable prepaid costs incurred,
                                                if it is necessary and unavoidable to curtail your trip.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <h6 className="text-primary">Travel Re-route / Overbooked / Misconnection or Delayed</h6>
                                            <p>Pay :</p>
                                            <ul>
                                                <li>if the conveyance is delayed from the scheduled departure time</li>
                                                <li>
                                                    due to overbooked or misconnection by common air carrier and no alternative
                                                    transportation is
                                                </li>
                                                <li>
                                                    provided if the arrival of the scheduled public conveyance is delayed for
                                                    every full 6 consecutive hours
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <h6 className="text-primary">Hijacking Inconvenience</h6>
                                            <p>
                                                Pay for each full 24 consecutive hours of hijack (RM800 / 24 hours).
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <h6 className="text-primary">Missed Departure</h6>
                                            <p>
                                                Reimburse for additional accommodation and travel expenses necessarily and
                                                reasonably incurred, as a result of strike, industrial action, natural disaster,
                                                inclement weather condition, mechanical breakdown of the public transport which
                                                prevented you from arriving at your outbound port, airport or station in time.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <h6 className="text-primary">Personal Liability</h6>
                                            <p>
                                                Indemnify you for legal liability towards third parties as a result of Accidental
                                                Death or Bodily Injury or Accidental Property Damage due to your negligence.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <h6 className="text-primary">Home Inconvenience Allowance</h6>
                                            <p>
                                                Pay for damages to your home contents as a result of burglary or fire when your
                                                house is left vacant while travelling.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <h6 className="text-primary">Golf Benefits : Hole-in-one</h6>
                                            <p>
                                                We reimburse Hole-in-One as defined in St. Andrew's Golf Rules. All claims must
                                                be accompanied by a copy of the certificate for Hole-in-One issued by the club
                                                and receipts supporting the Hospitality Expenses.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <h6 className="text-primary">Loss of Golf Equipment (due to theft)</h6>
                                            <p>
                                                We will reimburse after taking into account wear and tear and depreciation to
                                                replace or repair such item. Police report is required within 24 hours of the
                                                incident.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <h6 className="text-primary">Unused Golf Green Fees</h6>
                                            <p>
                                                We pay for the Golf Green Fees should you are prevented from playing golf as
                                                a result of bodily injury or sickness. All claims must be accompanied by a
                                                copy of a medical report from the Physician substantiating the bodily injury
                                                or sickness.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <h6 className="text-primary">Pet Care</h6>
                                            <p>
                                                We reimburse the additional cost of boarding of your pet's boarding home whilst
                                                you are prevented from completing the return leg of the Overseas Return
                                                Journey, as a result of a travel delay.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <h6 className="text-primary">Terrorism Expenses</h6>
                                            <p>The policy is extended to cover you whilst you are on your Journey arising from Act of Terrorism.</p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                Personal Belongings
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={props.insurer}>
                                <Card.Body>
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <h6 className="text-primary">Baggage and Personal effects</h6>
                                            <p>
                                                Pay a loss of or damage to your baggage and personal effects due to theft,
                                                robbery, burglary. Police report is required within 24 hours of the incident.
                                                Any claim due to negligence of the common carrier should be made to the
                                                common carrier first.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <h6 className="text-primary">Money and Travel Documents</h6>
                                            <p>
                                                Pay for travel and accommodation expenses including cost of obtaining
                                                replacement passports, travel tickets and other relevant travel documents.
                                                Police report is required within 24 hours of the incident.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <h6 className="text-primary">Baggage Delay</h6>
                                            <p>
                                                Pay if your checked-in baggage is delayed for each full 6 consecutive hours
                                                (RM 200 for every 6 hours) upon arrival at your destination abroad.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <h6 className="text-primary">Loss of Credit Card</h6>
                                            <p>Pay you for fraudulent usage of your credit card.</p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                Add-ons
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={props.insurer}>
                                <Card.Body>
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <h6 className="text-primary">Cruise Pack</h6>
                                            <p>Excursion Tour Cancellation / Curtailment / Cruise Re-route.</p>
                                            <p>
                                                We pay if your excursion tour is cancelled, curtailed or re-routed due to
                                                Strike, Riot or Civil Commotion, adverse weather, Natural Disasters,
                                                epidemic or when you or your travel companion is confined in a hospital
                                                or Sickness which prevents you from boarding the scheduled Cruise Tour.
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                </>
            );
        }
        else if (props.insurer === 'AIG') {
            return (
                <>
                    <Accordion className="mb-3">
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                COVID-19 Benefits
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={props.insurer}>
                                <Card.Body>
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <p>In the event you are diagnosed with COVID-19, we will cover you for COVID-19 coverages including medical and emergency evacuation & repatriation expenses, travel cancellation, travel curtailment and quarantine benefits (applicable to superior or premier plan only).
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                Trip Cancellation
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={props.insurer}>
                                <Card.Body>
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <p>If you have to cancel your trip as a result of the covered events, we will reimburse your forfeited travel and accommodation expenses.
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                Medical Expenses
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={props.insurer}>
                                <Card.Body>
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <p>We will cover you for the necessary and reasonable medical expenses you incurred and paid following an injury or illness you suffered during your trip.
                                            </p>
                                        </div>
                                    </div>
                                    <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                        Emergency Medical Evacuation & Emergency Medical Repatriation
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey={props.insurer}>
                                        <Card.Body>
                                            <div className="row mb-3">
                                                <div className="col-12">
                                                    <p>In the event of a medical emergency, we will send you to an appropriate medical facility for treatments, or we will bring you home to Malaysia.
                                                    </p>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                    <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                        Compassionate Visit
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey={props.insurer}>
                                        <Card.Body>
                                            <div className="row mb-3">
                                                <div className="col-12">
                                                    <p>If you are hospitalised overseas for more than 3 days and no adult immediate family member is with you on your trip, we will cover the transport, hotel, communication, and meal expenses of 1 person to accompany you while hospitalised, or if upon your death overseas, we will cover the above costs of 1 person to attend your repatriation, burial, or cremation at the place of your death.
                                                    </p>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                    <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                        Child Guard
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey={props.insurer}>
                                        <Card.Body>
                                            <div className="row mb-3">
                                                <div className="col-12">
                                                    <p>If you are hospitalised overseas and accompanied by your children, and if no other adult is travelling with you, we will cover transport, hotel, communication, and meals expenses for an immediate family member to take care of the children.
                                                    </p>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                    <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                        Daily Hospitalisation Income
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey={props.insurer}>
                                        <Card.Body>
                                            <div className="row mb-3">
                                                <div className="col-12">
                                                    <p>If you are hospitalised overseas due to injury or illness, we will pay you for each continuous 24 hours period of hospital confinement.
                                                    </p>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                    <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                        Emergency Telephone Charges and Internet Use
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey={props.insurer}>
                                        <Card.Body>
                                            <div className="row mb-3">
                                                <div className="col-12">
                                                    <p>We will cover for telephone charges incurred and paid by you for the sole purpose of engaging the services of our Travel Assistance during an in-patient medical emergency.
                                                    </p>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                    <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                        Overseas Dental Expenses
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey={props.insurer}>
                                        <Card.Body>
                                            <div className="row mb-3">
                                                <div className="col-12">
                                                    <p>We will cover the overseas dental expenses incurred following an injury to sound and natural teeth sustained from an accident occurring during your trip.
                                                    </p>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                    <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                        Follow up Medical Treatment in Home Country &mdash; Malaysia
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey={props.insurer}>
                                        <Card.Body>
                                            <div className="row mb-3">
                                                <div className="col-12">
                                                    <p>We cover follow-up medical treatment in Malaysia for an injury or illness that you sustained whilst travelling overseas. The cover will be for the treatments received within 1 month of your return date to Malaysia.
                                                    </p>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                    <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                        Repatriation of Mortal Remains or Funeral Expenses Overseas
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey={props.insurer}>
                                        <Card.Body>
                                            <div className="row mb-3">
                                                <div className="col-12">
                                                    <p>In the event of your death overseas, we cover the expense incurred to transport the remains back to Malaysia or for a funeral/cremation at the location of your death overseas.
                                                    </p>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Accordion.Collapse>

                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                Travel Inconveniences
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={props.insurer}>
                                <Card.Body>

                                    <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                        Trip Curtailment
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey={props.insurer}>
                                        <Card.Body>
                                            <div className="row mb-3">
                                                <div className="col-12">
                                                    <p>We cover you if, after your trip has commenced, it becomes necessary for you to cut short your trip and return home as a result of one or more of the covered events of the policy.
                                                    </p>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                    <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                        Trip Interruption
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey={props.insurer}>
                                        <Card.Body>
                                            <div className="row mb-3">
                                                <div className="col-12">
                                                    <p>We cover trip interruption if, whilst traveling overseas, your trip is unexpectedly interrupted for more than 24 consecutive hours due to the covered events of the policy.
                                                    </p>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                    <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                        Travel Missed Connection
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey={props.insurer}>
                                        <Card.Body>
                                            <div className="row mb-3">
                                                <div className="col-12">
                                                    <p>If you miss a connecting flight at the transit point due to the delay of an incoming flight and no alternative transport is made available, we will pay this benefit every 6 consecutive hours of delay.
                                                    </p>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                    <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                        Travel Delay
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey={props.insurer}>
                                        <Card.Body>
                                            <div className="row mb-3">
                                                <div className="col-12">
                                                    <p>If your flight is delayed due to covered events, we will pay this benefit every 6 consecutive hours of delay.
                                                    </p>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                    <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                        Travel Re-Route
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey={props.insurer}>
                                        <Card.Body>
                                            <div className="row mb-3">
                                                <div className="col-12">
                                                    <p>If your flight while on an overseas trip is rerouted due to covered events, we will pay this benefit every 6 consecutive hours.
                                                    </p>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                Baggage
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={props.insurer}>
                                <Card.Body>

                                    <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                        Loss of Personal Baggage Items
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey={props.insurer}>
                                        <Card.Body>
                                            <div className="row mb-3">
                                                <div className="col-12">
                                                    <p>We will cover if your personal baggage items are lost, stolen or accidentally damaged during your trip.
                                                    </p>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                    <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                        Baggage Delay
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey={props.insurer}>
                                        <Card.Body>
                                            <div className="row mb-3">
                                                <div className="col-12">
                                                    <p>If during the trip your baggage is delayed for more than 6 continuous hours by the provider, we will pay this benefit every 6 consecutive hours of delayed.
                                                    </p>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                    <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                        Fraudulent Use of Credit Card
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey={props.insurer}>
                                        <Card.Body>
                                            <div className="row mb-3">
                                                <div className="col-12">
                                                    <p>If your credit cards are stolen during trip, we will pay for the non-recoverable legal liability and the cost of replacing credit cards.
                                                    </p>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                    <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                        Loss of Travel Document
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey={props.insurer}>
                                        <Card.Body>
                                            <div className="row mb-3">
                                                <div className="col-12">
                                                    <p>If during the trip your passport, visa, identity card or entry permit is stolen or lost/damaged due to natural disaster/extreme weather/accident, we will pay for the replacement of the documents and transport, hotel, meals and communication expenses incurred by you in overseas for the sole purpose of securing your emergency passport, visa, identity card or entry permit.
                                                    </p>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                    <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                        Loss of Personal Money
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey={props.insurer}>
                                        <Card.Body>
                                            <div className="row mb-3">
                                                <div className="col-12">
                                                    <p>If your personal money got stolen during trip, we will reimburse you under this benefit.
                                                    </p>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                Personal Accident
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={props.insurer}>
                                <Card.Body>
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <p>If you suffer death or permanent disablement due accident during the trip within 12 months of the date of the accident, we will pay the compensation for the specific event as set out in the benefits table.
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                Personal Liability
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={props.insurer}>
                                <Card.Body>
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <p>If you become legally liable to pay compensatory damages because during your trip you injured someone, caused someone to die, or lost or damaged someone&#39;s property, we will reimburse you the compensatory damages cost and legal expenses incurred.
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                Loss of Home Contents
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={props.insurer}>
                                <Card.Body>
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <p>We will cover you for the loss of or damage to household contents contained within your home as a direct result of burglary while you are travelling on a trip.
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                Car Rental Excess Charges
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={props.insurer}>
                                <Card.Body>
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <p>We will cover for:
                                                <ol>
                                                    <li>Car rental excess charges due to loss or damage caused by an accident to the rental vehicle during your trip; or </li>
                                                    <li>Car rental vehicle return costs due to your hospital confinement. </li>
                                                </ol>
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            Optional Add-on
                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                Travel Delay Upgrade
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={props.insurer}>
                                <Card.Body>
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <p>If your flight is delayed for at least 3 consecutive hours, we will pay this benefit every 3 consecutive hours of delay.
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                </>
            );
        }
        else if (props.insurer === 'MSIG') {
            return (
                <>
                    <Accordion className="mb-3">
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary"  style={{ cursor: "pointer" }}>
                                Personal Accident
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={props.insurer}>
                                <Card.Body>
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <p>
                                                We will pay up to the limit in the Schedule of Benefits for injury sustained by you during the journey.
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary" style={{ cursor: "pointer" }}>
                                Medical and Other Expenses
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={props.insurer}>
                                <Card.Body>
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <p>
                                                We will pay the necessarily incurred expenses within the Period of Insurance that gives rise to the claim resulting from your death, injury or illness during the journey overseas except follow-up treatment.
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                    {/* <Accordion className="mb-3">
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                Baggage
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={props.insurer}>
                                <Card.Body>

                                    <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                        Loss of Personal Baggage Items
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey={props.insurer}>
                                        <Card.Body>
                                            <div className="row mb-3">
                                                <div className="col-12">
                                                    <p>We will cover if your personal baggage items are lost, stolen or accidentally damaged during your trip.
                                                    </p>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                    <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                        Baggage Delay
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey={props.insurer}>
                                        <Card.Body>
                                            <div className="row mb-3">
                                                <div className="col-12">
                                                    <p>If during the trip your baggage is delayed for more than 6 continuous hours by the provider, we will pay this benefit every 6 consecutive hours of delayed.
                                                    </p>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                    <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                        Fraudulent Use of Credit Card
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey={props.insurer}>
                                        <Card.Body>
                                            <div className="row mb-3">
                                                <div className="col-12">
                                                    <p>If your credit cards are stolen during trip, we will pay for the non-recoverable legal liability and the cost of replacing credit cards.
                                                    </p>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                    <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                        Loss of Travel Document
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey={props.insurer}>
                                        <Card.Body>
                                            <div className="row mb-3">
                                                <div className="col-12">
                                                    <p>If during the trip your passport, visa, identity card or entry permit is stolen or lost/damaged due to natural disaster/extreme weather/accident, we will pay for the replacement of the documents and transport, hotel, meals and communication expenses incurred by you in overseas for the sole purpose of securing your emergency passport, visa, identity card or entry permit.
                                                    </p>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                    <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                        Loss of Personal Money
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey={props.insurer}>
                                        <Card.Body>
                                            <div className="row mb-3">
                                                <div className="col-12">
                                                    <p>If your personal money got stolen during trip, we will reimburse you under this benefit.
                                                    </p>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion> */}
                    <Accordion className="mb-3">
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary" style={{ cursor: "pointer" }}>
                                Luggage and Personal Effect
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={props.insurer}>
                                <Card.Body>
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <p>
                                                We will pay: up to the limit as specified in the Schedule of Benefits in respect of your personal luggage and personal effects due to theft or damage to or loss of your personal luggage and personal e!ects during your journey overseas less a deduction for any wear, tear or depreciation or any compensation paid either by the carrier or others. The luggage and personal e!ects must be owned by you and in your possession and/or accompany you and include suitcase, trunks, hand luggage and the like receptacles as well as their contents.
                                            </p>
                                            <p>
                                                All valuables are only covered against theft and only if carried by you or while deposited with and under the care of a hotel.
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary" style={{ cursor: "pointer" }}>
                                Luggage Delay
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={props.insurer}>
                                <Card.Body>
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <p>
                                                We will pay up to the limit as specified in the Schedule of Benefits for every six (6) consecutive hours subject to the maximum limit if your accompanying checked-in luggage is delayed from the time of arrival at the destination overseas. In the event your accompanying check-in luggage is delayed upon returning to Malaysia, for each insured person we will pay up to the limit as specified in the Schedule of Benefits after six (6) consecutive hours.
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary" style={{ cursor: "pointer" }}>
                                Personal Money & Unauthorised Use of Card
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={props.insurer}>
                                <Card.Body>
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <p>
                                                We will pay up to the limit as specified in the Schedule of Benefits in respect of :
                                                <ol>
                                                    <li>
                                                        Robbery or theft of your personal money during your journey overseas,
                                                        provided that such loss is reported to the police within 24 hours from 
                                                        the incident.
                                                    </li>
                                                    <li>
                                                        Fraudulent use of credit or debit card following robbery or theft during
                                                        your journey overseas, provided that such loss is reported to the card
                                                        issuer within 24 hours from the incident.
                                                    </li>
                                                </ol>
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary" style={{ cursor: "pointer" }}>
                                Travel Documents
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={props.insurer}>
                                <Card.Body>
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <p>
                                                We will pay up to the limit as specified in the Schedule of Benefits for the reasonable additional accommodation, travel expenses and communication expenses necessarily incurred in obtaining new passport or visa and/or travel documents due to loss by robbery or theft whilst overseas during your journey provided always that you shall exercise reasonable precaution to prevent theft, loss of or damage and that it must be reported to the police within 24 hours of discovery.
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary" style={{ cursor: "pointer" }}>
                                Travel Cancellation
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={props.insurer}>
                                <Card.Body>
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <p>
                                                We will pay up to the limit as specified in the Schedule of Benefits for loss of personal accommodation or transport charges and additional travel expenses paid or contracted to be paid by or for you and loss of excursion charges pre-booked and prepaid in Malaysia by or for you which are not recoverable from any other source if your journey is unavoidably cancelled at the time of departure.
                                            </p>
                                            <p>
                                                Provided you have purchased this insurance no later than seven (7) days before the commencement date of your journey, the above benefits are payable in the event of the conditions specified in the policy.
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary" style={{ cursor: "pointer" }}>
                                Travel Curtailment
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={props.insurer}>
                                <Card.Body>
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <p>
                                                We will pay up to the limit as specified in the Schedule of Benefits for the refund of the unused and non-refundable part of your trip in proportion to the unused days paid or contracted to be paid by you or for you in Malaysia in the event of necessary and unavoidable cancellation by you arising from causes beyond your control occurring during your journey. The refund for accommodation will be based on each day of the journey you have lost. A proportion of travel expenses will be refunded only if you cannot use your return ticket and you are not claiming return travel expenses under other Sections of this policy.
                                            </p>
                                           
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary" style={{ cursor: "pointer" }}>
                                Travel Delay
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={props.insurer}>
                                <Card.Body>
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <p>
                                                We will pay up to the limit as specified in the Schedule of Benefits for the first four (4) consecutive hours of delay and every subsequent six (6) hours of delay subject to the maximum limit if the scheduled aircraft, train, or sea vessel on which you are booked is delayed in departure at any single place or stopover (including transit) from the time specified in the scheduled carrier or tour operator travel itinerary during your journey.
                                            </p>
                                            <p>
                                                The coverage under this Section only applies to scheduled carriers, which you had duly confirmed and provided you have performed your check-in by the check-in time and receive your boarding pass including self service channels in accordance with the original itinerary as advised by your carrier.
                                            </p>
                                            <p>
                                                The number of hours delayed must be verified and confirmed in writing by the operator(s) of the carrier.
                                            </p>
                                           
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary" style={{ cursor: "pointer" }}>
                                Missed Travel Connection
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={props.insurer}>
                                <Card.Body>
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <p>
                                                We will pay up to the limit as specified in the Schedule of Benefits if your confirmed onward connecting scheduled aircraft, train or sea vessel is missed at any single transfer point due to the late arrival of the incoming scheduled aircraft, train or sea vessel and no alternative onward transportation is made available to you for more than six (6) hours from the actual arrival time of your incoming scheduled aircraft, train or sea vessel.
                                            </p>
                                            <p>
                                                Any missed travel connection of charter carrier is not covered.
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary" style={{ cursor: "pointer" }}>
                                Travel Overbooked
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={props.insurer}>
                                <Card.Body>
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <p>
                                                We will pay up to the limit as specified in the Schedule of Benefits for every six (6) consecutive hours subject to the maximum limit if your confirmed onward scheduled aircraft, train or sea vessel is overbooked by the scheduled carrier company and no alternative onward transportation is made available to you within six (6) hours from the actual departure time.
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary" style={{ cursor: "pointer" }}>
                                Missed Departure
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={props.insurer}>
                                <Card.Body>
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <p>
                                                We will pay up to the limit as specified in the Schedule of Benefits for additional accommodation and travel expenses necessarily and reasonably incurred if you miss a scheduled carrier while travelling to the departure port, airport or train station stated in your schedule ticket as a result of mechanical breakdown of public transport services. If you are a non-resident, benefit under this Section is only applicable whilst you are out of Malaysia.   
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary" style={{ cursor: "pointer" }}>
                                Travel Reroute
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={props.insurer}>
                                <Card.Body>
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <p>
                                                We will pay up to the limit as specified in the Schedule of Benefits if your covered scheduled carrier is delayed for six (6) consecutive hours from the original schedule arrival time as specified in your printed itinerary due to rerouting of the scheduled carrier.    
                                            </p>
                                            <p>
                                                The number of hours delayed must be verified and confirmed in writing by the operator(s) of the carrier.
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary" style={{ cursor: "pointer" }}>
                                Additional Costs of Rental Car Return & Rental Car Excess
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={props.insurer}>
                                <Card.Body>
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <p>
                                                We will reimburse up to the limit as specified in the Schedule of Benefits for the:
                                                <ol>
                                                    <li>
                                                        additional costs of rental car if you are unable to return the rental car to
                                                        the nearest hire depot due to your injury or serious illness which requires
                                                        hospitalisation.
                                                    </li>
                                                    <li>
                                                        excess of your rental car motor insurance policy that you are liable to
                                                        pay if it is damaged or stolen whilst under your control during the
                                                        journey. This will apply if you:
                                                        <ol type="a">
                                                            <li>
                                                                hire a rental car from a licensed rental car agency;
                                                            </li>
                                                            <li>
                                                                are the nominated driver on the rental car agreement; duly licensed to drive and comply with all requirements of the rental agreement
                                                            </li>
                                                            <li>
                                                                have comprehensive motor vehicle insurance (cover for theft and damage and third party liability) for the rental car for the hired period.
                                                            </li>
                                                        </ol>

                                                    </li>
                                                </ol>
                                            </p>

                                            <p>
                                                The coverage under this Section only applies if you are liable for the cost under the car rental agreement.
                                            </p>
                                           
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary" style={{ cursor: "pointer" }}>
                                Personal Liability
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={props.insurer}>
                                <Card.Body>
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <p>
                                                We will indemnify up to the limit as specified in the Schedule of Benefits plus costs agreed between us in writing which you are legally liable to pay as a result of:
                                                <ol type="a">
                                                    <li>
                                                        injury, illness or disease of any person.
                                                    </li>
                                                    <li>
                                                        loss of or damage to property that does not belong to and is neither in the charge or under the control of you or <br/>
                                                        any member of your family which occurs during the Period of Insurance.
                                                    </li>
                                                </ol>
                                            </p>
                                            
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary" style={{ cursor: "pointer" }}>
                                Loss of Use of Hotel Facilities
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={props.insurer}>
                                <Card.Body>
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <p>
                                            We will pay up to the limit as specified in the Schedule of Benefits for each day of unavailability of prepaid hotel accommodation subject to the maximum limit in respect of the additional expenses incurred for 
alternative accommodation in the event that you suffer loss of booked hotel accommodation as a result of fire, flood, riot, strike or industrial action during your journey overseas.
                                            </p>
                                            <p>
                                            To qualify for this benefit, you must have checked-in in accordance to the original itinerary and obtained written confirmation from the hotel or their handling agents stating the duration and reason for finding alternative
accommodation. In the event that you are prevented from checking-in to the pre-booked hotel accommodation due to the contingencies mentioned above, you must obtain a written confirmation from the hotel or their handling agents stating the duration and reason for finding alternative accommodation.
                                            </p>
                                            
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary" style={{ cursor: "pointer" }}>
                                Home Protection
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={props.insurer}>
                                <Card.Body>
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <p>
                                                We will pay up to the limit as specified in the Schedule of Benefits if you suffer loss or damage to your home contents that was caused by burglary or fire to your home while it is left vacant during your journey.
                                            </p>        
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary" style={{ cursor: "pointer" }}>
                                Adventurous Acitivity Cover
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={props.insurer}>
                                <Card.Body>
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <p>
                                            Notwithstanding General Exception 3(k), this Policy is extended to cover the insured person in respect of Section 1 – Personal Accident and Section 2 – Medical and Other Expenses which may be sustained resulting from
engaging in or practicing for bungee jumping, sky diving, hang-gliding, helicopter rides rides for sightseeing, hot air ballooning, jet skiing, Mountaineering necessitating the use of ropes and other climbing equipment or trekking at mountains below the height of three thousand (3,000) metres above sea level, Skiing or snowboarding all within official approved areas of a ski resort, Canoeing or white water rafting with a qualified guide and up to Grade 3 of International Scale of River Diffulty,
Underwater activities involving artificial breathing apparatus for diving up to a maximum depth of thirty (30) metres with a qualified diving instructor and with recognised diving certification.
Provided always that the above activities are done on an amateur basis and for leisure purpose with a licensed operator during your journey.  All other terms, conditions and exclusions of this policy continue to apply.
                                            </p>      
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary" style={{ cursor: "pointer" }}>
                                Emergency Telephone Charges
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={props.insurer}>
                                <Card.Body>
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <p>
                                                Reimbursement up to the limit as specified in the Schedule of Benefits for telephone charges incurred and paid by you for the use of:
                                                <ol type="a">
                                                    <li>
                                                        Your mobile phone;
                                                    </li>
                                                    <li>
                                                        a standard land line phone; or
                                                    </li>
                                                    <li>
                                                        internet for the sole purpose of engaging the services of MSIG Assist during a medical emergency which is covered under Section 2 of the policy. The call charges must be supported by an itemised statement of charges.
                                                    </li>
                                                </ol>
                                            </p>        
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary" style={{ cursor: "pointer" }}>
                            Alternative Transport Arrangement
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={props.insurer}>
                                <Card.Body>
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <p>
                                            Reimbursement up to the limit as specified in the Schedule of Benefits for reasonable additional cost incurred foralternative transport or alternative routes to your next destination in the event that the scheduled carrier is cancelled or delayed for more than 24 hours at overseas directly caused by following reasons :
                                                <ol type="a">
                                                    <li>
                                                        Strike, riot and civil commotion or industrial action
                                                    </li>
                                                    <li>
                                                        Adverse weather conditions
                                                    </li>
                                                    <li>
                                                        Natural disaster or
                                                    </li>
                                                    <li>
                                                        Mechanical breakdown or structural defect of your scheduled public conveyance
                                                    </li>
                                                </ol>
                                            </p>     
                                            <p>
                                                You can only claim either under Section 9 – Travel Delay or Section 21 - Alternative Transport Arrangement for the same incident but not both.
                                            </p>   
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary" style={{ cursor: "pointer" }}>
                                Worldwide Travel Assistance Services
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={props.insurer}>
                                <Card.Body>
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <p>
                                            We have arranged for services to be provided through MSIG Assist so as to assist you in an emergency overseas.  To activate the services, contact MSIG Assist 24-hour emergency telephone number by reverse charge call and give them the necessary information.
                                            </p>        
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                    {/* <Accordion className="mb-3">
                        <Card>
                            Optional Add-on
                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                Travel Delay Upgrade
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={props.insurer}>
                                <Card.Body>
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <p>If your flight is delayed for at least 3 consecutive hours, we will pay this benefit every 3 consecutive hours of delay.
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion> */}
                </>
            );
        }
        else if (props.insurer === 'ZurichTakaful') {
            return (
                <>

                    <Accordion className="mb-3">
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                Medical Expenses
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={props.insurer}>
                                <Card.Body>
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <p>If You suffer a Disability during Your Overseas Journey, We will reimburse the Medically Necessary medical, surgical, nursing or hospital charges incurred by You, provided the treatment must be treated by a Physician.
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                            </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                Overseas Hospital Income
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={props.insurer}>
                                <Card.Body>
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <p>If You suffer a Disability during Your Overseas Journey and as a result of this, confined in a Hospital as a registered in-patient, We will pay the daily amount stated in the Schedule of Benefits for each day of Your confinement in the Hospital.
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                            </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                Compassionate Visit
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={props.insurer}>
                                <Card.Body>
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <p>If you are hospitalised overseas for more than 3 days and no adult immediate family member is with you on your trip, we will cover the transport, hotel, communication, and meal expenses of 1 person to accompany you while hospitalised, or if upon your death overseas, we will cover the above costs of 1 person to attend your repatriation, burial, or cremation at the place of your death.
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                            </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                Child Care Benefit
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={props.insurer}>
                                <Card.Body>
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <p>If You suffer a Disability during Your Overseas Journey and as a result of this, confined in a Hospital as a registered in-patient and no other Adult is travelling with You to accompany the Child who is covered with Us on the same Journey, We will reimburse the reasonable and necessary Common Carrier (economy class return fare) and Hotel accommodation expenses including any mandatory taxes and charges incurred by one (1) Family Member residing in Malaysia to accompany the Child back to Your Home.
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                            </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                Compassionate Visit
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={props.insurer}>
                                <Card.Body>
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <p>If You suffer a Serious Injury or Serious Illness during Your Overseas Journey and as a result of this, confined in a Hospital as a registered in-patient for more than three (3) consecutive days and no other Adult Family Member is with You, We will reimburse the reasonable and necessary Common Carrier (economy class return fare) expenses and Hotel accommodation including any mandatory taxes and charges incurred by one (1) person to travel from Malaysia to be with You until You are discharged from the Hospital:
                                            </p>
                                            <p>	If You suffer a Disability during Your Journey which results in death and no other Adult Family Member is with You, We will reimburse the reasonable and necessary Common Carrier (economy class return fare) expenses and Hotel accommodation including any mandatory taxes and charges incurred by one (1) person to travel from Malaysia to attend Your repatriation burial or cremation at the place of Your death.
                                            </p>
                                            <p>	Specific Conditions :
                                                <oi>
                                                    <li>You can only make a claim on either Disability or death, but not both; and
                                                    </li>
                                                    <li>the Common Carrier and Hotel accommodation expenses must be arranged and pre-approved by the Service Provider.
                                                    </li>
                                                </oi>
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                            </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                Emergency Medical Evacuation
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={props.insurer}>
                                <Card.Body>
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <p>If You suffer a Serious Injury or Serious Illness during Your Journey, and in Our or the Service Provider�s opinion, it is judged medically appropriate to move You to another location for medical treatment, the Service Provider will arrange the evacuation utilizing the means We or the Service Provider believe to be the most appropriate based on the medical severity of Your condition.
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                            </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                Medical Repatriation
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={props.insurer}>
                                <Card.Body>
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <p>If You suffer a Serious Injury or Serious Illness during Your Journey, and in Our or the Service Provider�s opinion, it is judged medically appropriate to return You to Malaysia, the Service Provider will arrange the repatriation utilizing the means We or the Service Provider believe to be the most appropriate based on the medical severity of Your condition.
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                            </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                Repatriation of Mortal Remains
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={props.insurer}>
                                <Card.Body>
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <p>If You suffer a Disability during Your Overseas Journey and result in death, Our Service Provider will make:
                                            </p>
                                            <p>
                                                <oi>
                                                    <li>all the necessary transportation arrangements (including any procedures or arrangements necessary to meet local formalities) for the return of Your mortal remains to Your Home; and
                                                    </li>
                                                    <li>all the necessary arrangements for funeral, cremation, casket or embalming (if so selected) at the place of death in Overseas, but excluding any expenses related to religious rights, ceremonies or burial posts.
                                                    </li>
                                                </oi>
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                            </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                                    <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                        Travel Cancellation
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey={props.insurer}>
                                        <Card.Body>
                                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                                Travel Cancellation
                                            </Accordion.Toggle>
                                            <Accordion.Collapse eventKey={props.insurer}>
                                                <Card.Body>
                                                    <div className="row mb-3">
                                                        <div className="col-12">
                                                            <p>If the Journey is necessary and unavoidably for You to cancel / alter due to any of the covered events for Benefit 8, prior to the commencement of Your Journey, We will reimburse the transportation expenses, accommodation expenses, Ground Tour Expenses and cost of visas paid or legally required to be paid by You for the Journey.
                                                            </p>
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Accordion.Collapse>
                                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                                Travel Alteration
                                            </Accordion.Toggle>
                                            <Accordion.Collapse eventKey={props.insurer}>
                                                <Card.Body>
                                                    <div className="row mb-3">
                                                        <div className="col-12">
                                                            <p>If the Journey is necessary and unavoidably for You to alter due to any of the covered events for Benefit 8, prior to the commencement of Your Journey, We will reimburse the additional reasonable and necessary transportation expenses, accommodation expenses, Ground Tour Expenses and cost of visas incurred by You to re-schedule Your Journey.
                                                            </p>
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Accordion.Collapse>
                                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                                Travel Curtailment
                                            </Accordion.Toggle>
                                            <Accordion.Collapse eventKey={props.insurer}>
                                                <Card.Body>
                                                    <div className="row mb-3">
                                                        <div className="col-12">
                                                            <p>If the Journey is necessary and unavoidably for You to curtail and return Home after its commencement due to any of the covered events for Benefit 9, We will reimburse the additional cost of a Common Carrier to return You Home and the unused transportation expenses, accommodation expenses and Ground Tour Expenses paid or legally required to be paid by You for the Journey:
                                                            </p>
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Accordion.Collapse>
                                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                                Travel Interruption
                                            </Accordion.Toggle>
                                            <Accordion.Collapse eventKey={props.insurer}>
                                                <Card.Body>
                                                    <div className="row mb-3">
                                                        <div className="col-12">
                                                            <p>If the Journey is interrupted for more than twenty-four (24) hours, after its commencement due to any of the covered events for Benefit 10, We will reimburse the additional cost of Common Carrier (economy class fare) incurred by You to re-arrange You to the Destination You would have been if You are not interrupted, Overseas accommodation expenses while You are stranded in an international transit or Your return Journey at Home and additional car park costs in Malaysia�s airport (up to maximum of ten (10) days period) due to Your late arrival at Home:
                                                            </p>
                                                            <p>Covered Events for Benefit 10 - Travel Interruption
                                                            </p>
                                                            <p>
                                                                <oi>
                                                                    <li>You or Travel Companion suffer a Serious Injury or Serious Illness and agreed by Service Provider that You should stay at where You are until You or Travel Companion is medically fit to continue the Journey;
                                                                        Z-Travel Takaful (International)/CW/20220322 Page 8 of 18
                                                                    </li>
                                                                    <li>Natural Disaster, major industrial or Covered Transport accident at Your Destination;
                                                                    </li>
                                                                    <li>Strike, riot, civil commotion, civil unrest or Act of Terrorism at Your Destination;
                                                                    </li>
                                                                    <li>Unexpected outbreak of epidemic or pandemic at Your Destination; or
                                                                    </li>
                                                                    <li>Any events leading to airport closures at Your Destination.
                                                                    </li>
                                                                </oi>
                                                            </p>
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Accordion.Collapse>
                                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                                Travel Delay - more than 6 consecutive hours (RM150 for every 6 consecutive hours)

                                            </Accordion.Toggle>
                                            <Accordion.Collapse eventKey={props.insurer}>
                                                <Card.Body>
                                                    <div className="row mb-3">
                                                        <div className="col-12">
                                                            <p>If the paid Covered Transport You have arranged for Your Journey is delayed for more than the number of hours stated in the Schedule of Benefits due to any of the covered events for Benefit 11 after Your Journey has commenced, We will pay the amount stated in the Schedule of Benefits.
                                                            </p>
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Accordion.Collapse>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                    </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                                    <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                        Travel Misconnection
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey={props.insurer}>
                                        <Card.Body>
                                            <div className="row mb-3">
                                                <div className="col-12">
                                                    <p>If You miss Your scheduled onward travel connection during Your Journey due to the late arrival of the incoming scheduled Common Carrier and no alternative onward transportation is made available to You for more than the number of hours stated in the Schedule of Benefits from the actual arrival time, We will pay the amount stated in the Schedule of Benefits.
                                                    </p>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                    </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                                    <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                        Travel Reroute - more than 6 consecutive hour (RM200 for every 6 consecutive hours)
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey={props.insurer}>
                                        <Card.Body>
                                            <div className="row mb-3">
                                                <div className="col-12">
                                                    <p>If the Common Carrier You have boarded during Your Overseas Journey is rerouted and delayed for more than the number of hours stated in the Schedule of Benefits due to any of the covered events for Benefit 13, We will pay the amount stated in the Schedule of Benefits.
                                                    </p>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                    </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                                    <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                        Baggage Delay - more than 6 consecutive hour (RM200 for every 6 consecutive hours)
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey={props.insurer}>
                                        <Card.Body>
                                            <div className="row mb-3">
                                                <div className="col-12">
                                                    <p>If Your checked-in baggage is delayed by the Common Carrier during Your Journey from Your arrival time at the Destination, We will pay the amount stated in the Schedule of Benefits.
                                                    </p>
                                                    <p>If Your checked-in baggage is lost, stolen or accidentally damaged during the delay, and You made a claim under Benefit 15, We will deduct any payment We make under Benefit 14 from Your overall claim under Benefit 15.
                                                    </p>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                    </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                                    <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                        Baggage & Personal Effects
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey={props.insurer}>
                                        <Card.Body>
                                            <div className="row mb-3">
                                                <div className="col-12">
                                                    <p>If Your baggage and Personal Effects are lost, stolen or accidentally damaged during Your Journey, We will, at Our sole discretion, reimburse, repair or replace the lost or damaged item subject to the market value of the item at the time of lost, stolen or accidentally damaged and deduction for loss of value due to usage and age of the item based on Our depreciation rates.
                                                    </p>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                    </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                                    <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                        Personal Money
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey={props.insurer}>
                                        <Card.Body>
                                            <div className="row mb-3">
                                                <div className="col-12">
                                                    <p>If Your Personal Money is stolen during Your Journey, We will reimburse the loss of Personal Money.
                                                    </p>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                    </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                                    <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                        Travel Documents
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey={props.insurer}>
                                        <Card.Body>
                                            <div className="row mb-3">
                                                <div className="col-12">
                                                    <p>If Your Travel Documents are stolen during Your Journey, We will reimburse:
                                                    </p>
                                                    <p>
                                                        <oi>
                                                            <li>the replacement cost of Travel Documents, including the actual expenses charged by the issuing authority for the replacement; and
                                                            </li>
                                                            <li>the additional reasonable and necessary Covered Transport, accommodation, meals and communication expenses incurred at the place of loss at Overseas and for the sole purpose of obtaining Your emergency Travel Documents to continue the Journey or return Home.
                                                            </li>
                                                        </oi>
                                                    </p>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                    </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                                    <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                        Personal Credit Card Theft
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey={props.insurer}>
                                        <Card.Body>
                                            <div className="row mb-3">
                                                <div className="col-12">
                                                    <p>If Your credit card is stolen during Your Journey, and as a result of this, You suffer financial loss as a direct result of the fraudulent use of Your stolen credit card, We will reimburse for losses arise from such unauthorised transactions and cost of replacing the stolen credit card.
                                                    </p>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                    </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                                    <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                        Accidental Death and Permanent Disablement
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey={props.insurer}>
                                        <Card.Body>
                                            <div className="row mb-3">
                                                <div className="col-12">
                                                    <p>If You suffer an Injury during Your Journey, shall within twelve (12) consecutive months result in any of the covered events for Benefit 19, We will pay the amount stated in the Schedule of Benefits:
                                                    </p>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                    </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                                    <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                        Personal Liability
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey={props.insurer}>
                                        <Card.Body>
                                            <div className="row mb-3">
                                                <div className="col-12">
                                                    <p>If You become legally liable to third party as a result of accidental death or accidental bodily injury to third party or accidental damage property of third party during Your Journey, We will reimburse the damages You are legally liable to pay and the reasonable legal cost and expenses for settling and defending the claim made against You provided You have paid or incurred with Our approval.
                                                    </p>
                                                    <p>If any claim is proven to be fraudulent after payment is made, We will retrieve all payments made in respect of that fraudulent claim. We further reserve the right to take any further actions, including legal action against the claimant in such case.
                                                    </p>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                    </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                                    <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                        Home Care Benefits
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey={props.insurer}>
                                        <Card.Body>
                                            <div className="row mb-3">
                                                <div className="col-12">
                                                    <p>If You suffer loss of or damage to Your Home Contents within Your Home in Malaysia that was left vacant during Your Journey due to burglary, We will, at Our sole discretion, reimburse, repair or replace the lost or damaged Home Contents subject to the market value of the Home Contents at the time of lost or damaged and deduction for loss of value due to usage and age of the item based on Our depreciation rates.
                                                    </p>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                    </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                                    <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                        Pet Care Benefits
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey={props.insurer}>
                                        <Card.Body>
                                            <div className="row mb-3">
                                                <div className="col-12">
                                                    <p>If You suffer a Disability during Your Overseas Journey or Your scheduled Common Carrier is delayed and as a result of this, You are unable to return Home on the scheduled return date, We will reimburse for Your pet�s (dog and/or cat only) continued stay at the pet hotel, kennel or cattery where the pet is deposited with during Your Overseas Journey following Your inability to collect the pet on the scheduled collection date.
                                                    </p>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                    </Card>
                    </Accordion>
                                    <Accordion className="mb-3">
                                        <Card>
                                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                                Car Excess
                                            </Accordion.Toggle>
                                            <Accordion.Collapse eventKey={props.insurer}>
                                                <Card.Body>
                                                    <div className="row mb-3">
                                                        <div className="col-12">
                                                            <p>If You accidentally lose or damage the Rented Vehicle during Your Overseas Journey, We will reimburse the excess or deductibles imposed by the motor insurance policy/takaful certificate of Your Rented Vehicle which You are legally liable to pay.
                                                            </p>
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Accordion.Collapse>
                                            </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                                        <Card>
                                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                                Car Return
                                            </Accordion.Toggle>
                                            <Accordion.Collapse eventKey={props.insurer}>
                                                <Card.Body>
                                                    <div className="row mb-3">
                                                        <div className="col-12">
                                                            <p>If You suffer a Disability during Your Overseas Journey and as a result of this, confined in a Hospital as a registered in-patient and unable to return the Rented Car during Your Journey, We will reimburse the charges You have paid or incurred to return the Rented Vehicle to the nearest car depot.
                                                            </p>
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Accordion.Collapse>
                                        </Card>
                                    </Accordion>

                </>
            );
        }
        else if (props.insurer === 'TuneProtect') {
            return (
                <>
                    <Accordion className="mb-3">
                        <Card>
                                    <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                    Covid-19 Coverage (Applicable to Travel Comprehensive - Platinum Plan Cover)
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey={props.insurer}>
                                        <Card.Body>
                                            <div className="row mb-3">
                                                <div className="col-12">
                                                    <p>
                                                        <ol list-style-type="lower-alpha;">
                                                            <li>Medical Expenses (incurred Overseas due to Stage 3 to Stage 5 treatment)</li>
                                                            <li>Emergency Overseas Evacuation & Repatriation</li>
                                                            <li>Hospital Income</li>
                                                            <li>Quarantine Allowance</li>
                                                            <li>Bereavement Allowance</li>
                                                            <li>Compassionate Visit</li>
                                                            <li>Trip Cancellation</li>
                                                            <li>Trip Curtailment</li>
                                                        </ol>
                                                    </p>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                    </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                                    <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                    Personal Accident Benefit
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey={props.insurer}>
                                        <Card.Body>
                                            <div className="row mb-3">
                                                <div className="col-12">
                                                    <p>
                                                    In the event of an Accident happening during the Trip, if You suffer Bodily Injury which results in Your death or disablement, We will, subject to the exclusions, limitations, provisions and terms of this Policy, pay compensation as provided in the Table of Compensation.
                                                    </p>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                    </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                                    <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                    Travel Inconveniences
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey={props.insurer}>
                                        <Card.Body>
                                            <div className="row mb-3">
                                                <div className="col-12">
                                                    <p>
                                                        You will be covered for the Travel Inconvenience Benefit for the following events as specified below:
                                                        <ol>
                                                            <li> Trip Cancellation</li>
                                                            <li> Trip Curtailment</li>
                                                        </ol>
                                                    </p>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                    </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                                    <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                    Medical Expenses
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey={props.insurer}>
                                        <Card.Body>
                                            <div className="row mb-3">
                                                <div className="col-12">
                                                    <p>
                                                        We will reimburse You subject to an excess up to the maximum limit as specified in the Schedule of Benefit.
                                                    </p>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                    </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                                    <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                    Personal Liability
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey={props.insurer}>
                                        <Card.Body>
                                            <div className="row mb-3">
                                                <div className="col-12">
                                                    <p>
                                                        We agree to indemnify You against Your personal liability at law for damages and any claimant's cost and expenses up to the maximum limit as specified for Personal Liability in the Schedule of Benefit.
                                                    </p>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                    </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                                    <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                    Home Care Benefit
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey={props.insurer}>
                                        <Card.Body>
                                            <div className="row mb-3">
                                                <div className="col-12">
                                                    <p>
                                                        We will, by payment or at Our option by reinstatement or repair, indemnify You up to the amount as specified in the Schedule of Benefits against physical loss or damage to Your Home Contents at permanent residence in
                                                        Malaysia that was left vacant because of Your Trip, caused by Theft during the Period of Insurance, but only after commencement of Your Trip.
                                                    </p>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                    </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                                    <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                    Worldwide
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey={props.insurer}>
                                        <Card.Body>
                                            <div className="row mb-3">
                                                <div className="col-12">
                                                    <p>
                                                        Please contact Our appointed third-party administrator Hotline at any time for assistance. Please provide Us all relevant information and Our appointed third-party administrator will assist You accordingly. Please make sure You have details of Your Policy before You contact Us to ensure that We can assist You effectively.
                                                    </p>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                    </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                                    <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                    Optional Rider - Adventure Benefits
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey={props.insurer}>
                                        <Card.Body>
                                            <div className="row mb-3">
                                                <div className="col-12">
                                                    <p>
                                                        The following Rider Benefits are optional and are available only if they have been expressly selected by You and added to the Policy coverage during purchase of Your Worldwide Travel Policy; the required additional premium must also have been duly paid. All Optional Rider - Adventure Benefits are independent of each other and subject to the General Conditions and Exclusions of this Policy.
                                                        <ol>
                                                            <li>Accidental Death Benefit</li>
                                                            <li>Accidental & Sickness Medical Expenses Reimbursement</li>
                                                            <li>Follow-up Treatment in Home Country</li>
                                                            <li>Hospital Allowance (up to max of 30 full days)</li>
                                                            <li>Emergency Medical Evacuation</li>
                                                            <li>Mortal Remains Repatriation</li>
                                                            <li>Loss, theft or damage to equipment)</li>
                                                        </ol>
                                                    </p>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                    </Card>
                    </Accordion>
                </>
            );
        }

        return null;
    }

    function KeyBenefits(props) {
        if (isEmpty(props.plan.mainBenefits)) {
            return null;
        }

        return (
            <>
                {props.plan.mainBenefits.map((obj) => {
                    if(props.plan.insurer == insurer_msig) {
                        return (
                            <>
                                <li class="list-group-item">
                                    <div class="col-12"><span dangerouslySetInnerHTML={{__html: obj.coverageDescription}} /></div>
                                    <span class="fw-bold text-primary">RM {parseFloat(obj.sumInsured).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}</span>
                                </li>
                              
                            </>

                        );

                    } else if(props.plan.insurer == insurer_rhbi) {
                        return (
                            <>
                            <li class="list-group-item"> 
                                <div class="col-12">{obj.items[0].benefit}</div>

                                 <span class="fw-bold text-primary">       
                                {obj.items.map((objSum) => {
                                            return (
                                                <>
                                                   
                                                    {props.plan.planId == 'ADVANCE'?
                                                        <>
                                                            {(isNaN(objSum.sumInsured.ADVANCE.replace(',', '')) || isEmpty(objSum.sumInsured.ADVANCE.replace(',', '')) || objSum.sumInsured.ADVANCE.replace(',', '') <= 0) ?
                                                                <>
                                                                Covered
                                                                </>
                                                            : 
                                                                <>
                                                                RM {parseFloat(objSum.sumInsured.ADVANCE.replace(',', '')).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                                                                
                                                                </>
                                                            
                                                            }
                                                        </>
                                                
                                                    :
                                                        <>
                                                            {(isNaN(objSum.sumInsured.SUPREME.replace(',', '')) || isEmpty(objSum.sumInsured.SUPREME.replace(',', '')) || objSum.sumInsured.SUPREME.replace(',', '') <= 0) ?
                                                                <>
                                                                Covered
                                                                </>
                                                            :
                                                                <>
                                                                RM {parseFloat(objSum.sumInsured.SUPREME.replace(',', '')).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                                                                </>
                                                            }
                                                        </> 

                                                    }
                                                       
                                                </>
                                            );
                                        })}
                                    
                                </span>
                            </li>

                              

                            </>
                        )

                    } else if(props.plan.insurer == insurer_tune) {
                        return (
                            <>
                                <li class="list-group-item"> 
                                    <div class="col-12"><span dangerouslySetInnerHTML={{__html: obj.coverageDescription}} /></div>
                                    <span class="fw-bold text-primary">
                                            {obj.sumInsuredDescription}
                                    </span>
                                </li>
                            </>
                        )
                    }

                })
            }

            </>          
            
        );


    }

    function SumInsured(props) {
        if (isEmpty(props.plan.mainBenefits)) {
            return null;
        }

       
        return (
            <>
                {props.plan.mainBenefits.map((obj) => {
                    if(props.plan.insurer == insurer_msig) {
                        return (
                            <>
                                {/* {props.plan.insurer == 'MSIG' || props.plan.insurer == 'TUNEPROTECT' ? */}
                                    <div className="col-4 border-end">
                                        <p className="mb-0" dangerouslySetInnerHTML={{__html: obj.coverageDescription}} />


                                        <label className="text-primary fw-bold">
                                            RM {parseFloat(obj.sumInsured).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                                        </label>   

                                    
                                        {/* {(isNaN(obj.sumInsured.replace(',', '')) || isEmpty(obj.sumInsured.replace(',', '')) || obj.sumInsured.replace(',', '') <= 0) ?
                                            <label className="text-primary fw-bold">
                                                Covered
                                            </label> 

                                        :
                                            <label className="text-primary fw-bold">
                                                RM {parseFloat(obj.sumInsured.replace(',', '')).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                                            </label>       
                                        }                */}
                                    </div>

                                {/* : */}

                                    

                                {/* } */}

                            </>

                        );

                    } else if(props.plan.insurer == insurer_rhbi) {
                        return (
                            <>
                                <div className="col-6 border-end">
                                    <p className="mb-0">
                                        {obj.items[0].benefit}
                                    </p>

                                    
                                        {obj.items.map((objSum) => {
                                            return (
                                                <>
                                                    <label className="text-primary fw-bold">
                                                    {props.plan.planId == 'ADVANCE'?
                                                        <>
                                                            {(isNaN(objSum.sumInsured.ADVANCE.replace(',', '')) || isEmpty(objSum.sumInsured.ADVANCE.replace(',', '')) || objSum.sumInsured.ADVANCE.replace(',', '') <= 0) ?
                                                                <>
                                                                Covered
                                                                </>
                                                            : 
                                                                <>
                                                                RM {parseFloat(objSum.sumInsured.ADVANCE.replace(',', '')).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                                                                
                                                                </>
                                                            
                                                            }
                                                        </>
                                                
                                                    :
                                                        <>
                                                            {(isNaN(objSum.sumInsured.SUPREME.replace(',', '')) || isEmpty(objSum.sumInsured.SUPREME.replace(',', '')) || objSum.sumInsured.SUPREME.replace(',', '') <= 0) ?
                                                                <>
                                                                Covered
                                                                </>
                                                            :
                                                                <>
                                                                RM {parseFloat(objSum.sumInsured.SUPREME.replace(',', '')).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                                                                </>
                                                            }
                                                        </> 

                                                    }
                                                    </label>    
                                                </>
                                            );
                                        })}
                                    
                                </div>

                            </>
                        )

                    } else if(props.plan.insurer == insurer_tune) {
                        return (
                            <>
                                <div className="col-4 border-end">
                                    <p className="mb-0" dangerouslySetInnerHTML={{__html: obj.coverageDescription}} />


                                    <label className="text-primary fw-bold">
                                        {obj.sumInsuredDescription}
                                    </label>   
                                </div>

                            </>
                        )
                    }

                })
            }

            </>          
            
        );
            
        

        //return null;
    }

    function ScheduleOfBenefits(props) {
        if (!isEmpty(props.plan.benefits)) {
            if (props.plan.insurer === 'AXA') {
                return (
                    <>
                        {Object.keys(props.plan.benefits).map((benefit) => {
                            return (
                                Object.keys(props.plan.benefits[benefit]).map((per, index) => {
                                    return (
                                        <tr key={index}>
                                            {index === 0 ?
                                                <td rowSpan={Object.keys(props.plan.benefits[benefit]).length} className="align-middle">
                                                    <div className="row">
                                                        <div className="col-12">
                                                            {getBenefitName(benefit)}
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-12">
                                                            {getBenefitName(benefit).includes('Medical Treatment') ? <small className="text-danger">* Subject to Medical, Hospital and Treatment Expenses limit</small> : null}
                                                        </div>
                                                    </div>
                                                </td>
                                                : null
                                            }
                                            <td className="align-middle">
                                                {per !== 'condition' && per !== 'max' ? 'Per ' + per.split('_').map((text) => {
                                                    return text.charAt(0).toUpperCase() + text.slice(1);
                                                }).join(' / ')
                                                    : null}
                                            </td>
                                            {per !== 'condition' && per !== 'max' ?
                                                <td className="text-center">
                                                    <div className="row">
                                                        <div className="col-12">
                                                            {props.plan.benefits[benefit][per]['value']}
                                                        </div>
                                                    </div>

                                                    {props.plan.benefits[benefit][per]['condition'] ?
                                                        Object.values(props.plan.benefits[benefit][per]['condition']).map((condition) => {
                                                            return (
                                                                <div className="row">
                                                                    <div className="col-12">
                                                                        <small>({condition})</small>
                                                                    </div>
                                                                </div>
                                                            );
                                                        }) :
                                                        null
                                                    }
                                                </td>
                                                : null
                                            }
                                        </tr>
                                    );
                                })
                            );
                        })}
                    </>
                );
            }
            else if (props.plan.insurer === 'CHUBB') {
                return (
                    <>
                        {Object.keys(props.plan.benefits).map((benefit) => {
                            return (
                                Object.keys(props.plan.benefits[benefit]).map((per, index) => {
                                    return (
                                        <tr key={index}>
                                            {index === 0 ?
                                                <td rowSpan={Object.keys(props.plan.benefits[benefit]).length} className="align-middle">
                                                    <div className="row">
                                                        <div className="col-12">
                                                            {getBenefitName(benefit)}
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-12">
                                                            {getBenefitName(benefit).includes('Medical Treatment') ? <small className="text-danger">* Subject to Medical, Hospital and Treatment Expenses limit</small> : null}
                                                        </div>
                                                    </div>
                                                </td>
                                                : null
                                            }
                                            <td className="align-middle">
                                                {per !== 'condition' && per !== 'max' ? 'Per ' + per.split('_').map((text) => {
                                                    return text.charAt(0).toUpperCase() + text.slice(1);
                                                }).join(' / ')
                                                    : null}
                                            </td>
                                            {per !== 'condition' && per !== 'max' ?
                                                <td className="text-center">
                                                    <div className="row">
                                                        <div className="col-12">
                                                            {props.plan.benefits[benefit][per]['value']}
                                                        </div>
                                                    </div>

                                                    {props.plan.benefits[benefit][per]['condition'] ?
                                                        Object.values(props.plan.benefits[benefit][per]['condition']).map((condition) => {
                                                            return (
                                                                <div className="row">
                                                                    <div className="col-12">
                                                                        <small>({condition})</small>
                                                                    </div>
                                                                </div>
                                                            );
                                                        }) :
                                                        null
                                                    }
                                                </td>
                                                : null
                                            }
                                        </tr>
                                    );
                                })
                            );
                        })}
                        <tr>
                            <th colSpan={3}>Benefits Extended to Cover COVID-19</th>
                        </tr>
                        <tr>
                            <td>Medical Expenses due to Sickness</td>
                            <td>RM {parseFloat(450000).toLocaleString()}</td>
                        </tr>
                        <tr>
                            <td>Emergency Medical Evacuation</td>
                            <td>Unlimited</td>
                        </tr>
                        <tr>
                            <td>Repatriation of Mortal Remains</td>
                            <td>Unlimited</td>
                        </tr>
                        <tr>
                            <td>Daily Hospital Income</td>
                            <td>RM {parseFloat(props.plan.product.indexOf('First') > -1 ? 21000 : 15000).toLocaleString()}
                            </td>
                        </tr>
                        <tr>
                            <td>Travel Cancellation</td>
                            <td>RM {parseFloat(50000).toLocaleString()}</td>
                        </tr>
                        <tr>
                            <td>Travel Curtailment</td>
                            <td>RM {parseFloat(50000).toLocaleString()}</td>
                        </tr>
                    </>
                );
            } else if (props.plan.insurer === 'AIG') {
                return (
                    <>
                        {Object.keys(props.plan.benefits).map((benefit) => {
                            return (
                                Object.keys(props.plan.benefits[benefit]).map((per, index) => {
                                    return (
                                        <tr key={index}>
                                            {index === 0 ?
                                                <td rowSpan={Object.keys(props.plan.benefits[benefit]).length} className="align-middle">
                                                    <div className="row">
                                                        <div className="col-12">
                                                            {getBenefitName(benefit)}
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-12">
                                                            {getBenefitName(benefit).includes('Medical Treatment') ? <small className="text-danger">* Subject to Medical, Hospital and Treatment Expenses limit</small> : null}
                                                        </div>
                                                    </div>
                                                </td>
                                                : null
                                            }
                                            <td className="align-middle">
                                                {per !== 'condition' && per !== 'max' ? 'Per ' + per.split('_').map((text) => {
                                                    return text.charAt(0).toUpperCase() + text.slice(1);
                                                }).join(' / ')
                                                    : null}
                                            </td>
                                            {per !== 'condition' && per !== 'max' ?
                                                <td className="text-center">
                                                    <div className="row">
                                                        <div className="col-12">
                                                            {props.plan.benefits[benefit][per]['value']}
                                                        </div>
                                                    </div>

                                                    {props.plan.benefits[benefit][per]['condition'] ?
                                                        Object.values(props.plan.benefits[benefit][per]['condition']).map((condition) => {
                                                            return (
                                                                <div className="row">
                                                                    <div className="col-12">
                                                                        <small>({condition})</small>
                                                                    </div>
                                                                </div>
                                                            );
                                                        }) :
                                                        null
                                                    }
                                                </td>
                                                : null
                                            }
                                        </tr>
                                    );
                                })
                            );
                        })}
                    </>
                );
            } else if (props.plan.insurer === 'TuneProtect') {
                return (
                    <>
                        {Object.keys(props.plan.benefits).map((benefit) => {
                            return (
                                Object.keys(props.plan.benefits[benefit]).map((per, index) => {
                                    return (
                                        <tr key={index}>
                                            {index === 0 ?
                                                <td rowSpan={Object.keys(props.plan.benefits[benefit]).length} className="align-middle">
                                                    <div className="row">
                                                        <div className="col-12">
                                                            {getBenefitName(benefit)}
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-12">
                                                            {getBenefitName(benefit).includes('Medical Treatment') ? <small className="text-danger">* Subject to Medical, Hospital and Treatment Expenses limit</small> : null}
                                                        </div>
                                                    </div>
                                                </td>
                                                : null
                                            }
                                            <td className="align-middle">
                                                {per !== 'condition' && per !== 'max' ? 'Per ' + per.split('_').map((text) => {
                                                    return text.charAt(0).toUpperCase() + text.slice(1);
                                                }).join(' / ')
                                                    : null}
                                            </td>
                                            {per !== 'condition' && per !== 'max' ?
                                                <td className="text-center">
                                                    <div className="row">
                                                        <div className="col-12">
                                                            {props.plan.benefits[benefit][per]['value']}
                                                        </div>
                                                    </div>

                                                    {props.plan.benefits[benefit][per]['condition'] ?
                                                        Object.values(props.plan.benefits[benefit][per]['condition']).map((condition) => {
                                                            return (
                                                                <div className="row">
                                                                    <div className="col-12">
                                                                        <small>({condition})</small>
                                                                    </div>
                                                                </div>
                                                            );
                                                        }) :
                                                        null
                                                    }
                                                </td>
                                                : null
                                            }
                                        </tr>
                                    );
                                })
                            );
                        })}
                        <tr>
                            <th colSpan={3}>Benefits Extended to Cover COVID-19</th>
                        </tr>
                        <tr>
                            <td>Medical Expenses due to Sickness</td>
                            <td>RM {parseFloat(450000).toLocaleString()}</td>
                        </tr>
                        <tr>
                            <td>Emergency Medical Evacuation</td>
                            <td>Unlimited</td>
                        </tr>
                        <tr>
                            <td>Repatriation of Mortal Remains</td>
                            <td>Unlimited</td>
                        </tr>
                        <tr>
                            <td>Daily Hospital Income</td>
                            <td>RM {parseFloat(props.plan.product.indexOf('First') > -1 ? 21000 : 15000).toLocaleString()}
                            </td>
                        </tr>
                        <tr>
                            <td>Travel Cancellation</td>
                            <td>RM {parseFloat(50000).toLocaleString()}</td>
                        </tr>
                        <tr>
                            <td>Travel Curtailment</td>
                            <td>RM {parseFloat(50000).toLocaleString()}</td>
                        </tr>
                    </>
                );
            } else if (props.plan.insurer === 'ZurichTakaful') {
                return (
                    <>
                        {Object.keys(props.plan.benefits).map((benefit) => {
                            return (
                                Object.keys(props.plan.benefits[benefit]).map((per, index) => {
                                    return (
                                        <tr key={index}>
                                            {index === 0 ?
                                                <td rowSpan={Object.keys(props.plan.benefits[benefit]).length} className="align-middle">
                                                    <div className="row">
                                                        <div className="col-12">
                                                            {getBenefitName(benefit)}
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-12">
                                                            {getBenefitName(benefit).includes('Medical Treatment') ? <small className="text-danger">* Subject to Medical, Hospital and Treatment Expenses limit</small> : null}
                                                        </div>
                                                    </div>
                                                </td>
                                                : null
                                            }
                                            <td className="align-middle">
                                                {per !== 'condition' && per !== 'max' ? 'Per ' + per.split('_').map((text) => {
                                                    return text.charAt(0).toUpperCase() + text.slice(1);
                                                }).join(' / ')
                                                    : null}
                                            </td>
                                            {per !== 'condition' && per !== 'max' ?
                                                <td className="text-center">
                                                    <div className="row">
                                                        <div className="col-12">
                                                            {props.plan.benefits[benefit][per]['value']}
                                                        </div>
                                                    </div>

                                                    {props.plan.benefits[benefit][per]['condition'] ?
                                                        Object.values(props.plan.benefits[benefit][per]['condition']).map((condition) => {
                                                            return (
                                                                <div className="row">
                                                                    <div className="col-12">
                                                                        <small>({condition})</small>
                                                                    </div>
                                                                </div>
                                                            );
                                                        }) :
                                                        null
                                                    }
                                                </td>
                                                : null
                                            }
                                        </tr>
                                    );
                                })
                            );
                        })}
                    </>
                );
            } else if (props.plan.insurer === 'MSIG') {
                return (
                    <>
                        {Object.keys(props.plan.benefits).map((benefit) => {
                            return (
                                Object.keys(props.plan.benefits[benefit]).map((per, index) => {
                                    return (
                                        <tr key={index}>
                                            {index === 0 ?
                                                <td rowSpan={Object.keys(props.plan.benefits[benefit]).length} className="align-middle">
                                                    <div className="row">
                                                        <div className="col-12">
                                                            {getBenefitName(benefit)}
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-12">
                                                            {getBenefitName(benefit).includes('Medical Treatment') ? <small className="text-danger">* Subject to Medical, Hospital and Treatment Expenses limit</small> : null}
                                                        </div>
                                                    </div>
                                                </td>
                                                : null
                                            }
                                            <td className="align-middle">
                                                {per !== 'condition' && per !== 'max' ? 'Per ' + per.split('_').map((text) => {
                                                    return text.charAt(0).toUpperCase() + text.slice(1);
                                                }).join(' / ')
                                                    : null}
                                            </td>
                                            {per !== 'condition' && per !== 'max' ?
                                                <td className="text-center">
                                                    <div className="row">
                                                        <div className="col-12">
                                                            {props.plan.benefits[benefit][per]['value']}
                                                        </div>
                                                    </div>

                                                    {props.plan.benefits[benefit][per]['condition'] ?
                                                        Object.values(props.plan.benefits[benefit][per]['condition']).map((condition) => {
                                                            return (
                                                                <div className="row">
                                                                    <div className="col-12">
                                                                        <small>({condition})</small>
                                                                    </div>
                                                                </div>
                                                            );
                                                        }) :
                                                        null
                                                    }
                                                </td>
                                                : null
                                            }
                                        </tr>
                                    );
                                })
                            );
                        })}
                    </>
                );
            }
        }

        return null;
    }

    function FAQ(props) {
        if (props.insurer === 'AXA') {
            return (
                <>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">1.</label>
                            <label className="col-10 col-form-label text-primary">
                                Who is eligible to apply?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>All Malaysians, Permanent Residents, Employment Pass / Work Permit Holders and Dependant(s) of Pass Holders.</p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">2.</label>
                            <label className="col-10 col-form-label text-primary">
                                Is there a maximum period of cover?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>For Single Trip Coverage - The maximum period of cover is 190 days.</p>
                                <p>
                                    For Annual Trip Coverage - The maximum period of cover is 95 days per trip, unlimited number of trips
                                    within the period of insurance stated in the Certificate of Insurance.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">3.</label>
                            <label className="col-10 col-form-label text-primary">
                                Who is eligible to be covered under the Family Plan?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>
                                    The Family Plan includes you, your spouse and unlimited number of accompanying children. Not applicable for
                                    persons aged 65 and above.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">4.</label>
                            <label className="col-10 col-form-label text-primary">
                                What if I am over the aged of 65, can I still buy a travel insurance?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>
                                    Yes, if you are aged between 65 to 80 (both ages inclusive), you can buy for Senior Plan as an individual
                                    plan. Kindly refer to the product brochure for the sum insured details on medical benefits.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">5.</label>
                            <label className="col-10 col-form-label text-primary">
                                Can I buy a policy for my child?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>Yes, you may buy the policy in your name and the Insured Person can be your child.</p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">6.</label>
                            <label className="col-10 col-form-label text-primary">
                                Under what circumstances is an applicant allowed to take up a 'One Way' trip cover?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>
                                    It is only applicable to those who are emigrating or students going overseas for education. For
                                    'One Way' trip cover, arrival at final destination must be completed within 31 days [including any stopover(s)].
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">7.</label>
                            <label className="col-10 col-form-label text-primary">
                                When will my insurance terminate on a 'One Way' trip?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>
                                    Overseas 'One Way' trip will terminate either twenty four (24) hours after the Insured Person's arrival at the
                                    Common Carrier station or terminal of the final destination of the trip.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">8.</label>
                            <label className="col-10 col-form-label text-primary">
                                What if I want to include cover for domestic travel?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>If you wish to cover your domestic travels, you should take up the Domestic Travel Extension as an Add-On.</p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">9.</label>
                            <label className="col-10 col-form-label text-primary">
                                How do I purchase the Add-ons?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>
                                    You must purchase the Add ons at the point of inception of your travel policy. Take note that some benefits
                                    are only applicable if your policy is effective at least 14 days prior to your trip. It is advisable to get
                                    your travel insurance sorted out as soon as possible during your trip planning.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">10.</label>
                            <label className="col-10 col-form-label text-primary">
                                Where must the trip commence from?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>Your trip is only covered when it commences from Malaysia.</p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">11.</label>
                            <label className="col-10 col-form-label text-primary">
                                What is covered under Travel Curtailment benefit?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>
                                    We will pay on a Reimbursement Basis for the Loss of non-refundable, non-utilized and / or non-transferrable
                                    deposits or charges the Insured Person agreed to pay or has paid in advance for the Insured Person's Trip
                                    including but not limited to the Trip package, Entertainment Ticket, accommodation and the like based on a
                                    proportional calculation from the date of the Insured Person's arrival back in Malaysia (for Overseas Trips)
                                    to the expiry of the Insured Person's Trip.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">13.</label>
                            <label className="col-10 col-form-label text-primary">
                                What is covered under Cruise Cover benefit?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <ul>
                                    <li>
                                        Cruise Interruption - We will pay on a Reimbursement Basis for the additional accommodation and transportation
                                        expenses incurred for the Insured Person to rejoin the Insured Person's cruise voyage due to the Insured Person
                                        having to be hospitalised onshore.
                                    </li>
                                    <li>
                                        Missed Port - We will pay on a Reimbursement Basis for the additional accommodation and transportation expenses
                                        incurred for the Insured Person to rejoin the Insured Person's cruise voyage due to the Insured Person having
                                        missed the cruise when it started its initial voyage as a result of flight delay.
                                    </li>
                                    <li>
                                        Cruise Delay - We will pay on a Reimbursement Basis for the additional accommodation and transportation expenses
                                        incurred for the Insured Person to return to Malaysia if the Insured Person misses the Insured Person's return
                                        flight because of a delay in the cruise arriving at its final disembarkation port Overseas.
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">14.</label>
                            <label className="col-10 col-form-label text-primary">
                                What are the required documents to submit a claim?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>Notify us at instaPol@my.howdengroup.com immediately.</p>

                                <ol type="1">
                                    <li>Proof of Travel for your entire trip (Itinerary / Boarding Pass / Air Ticket / Land Transport)</li>
                                    <li>Medical Report (for illness / injury of insured)</li>
                                    <li>A written confirmation from the attending doctor abroad that it is necessary to return home</li>
                                    <li>New airlines ticket and / or boarding pass to confirm the actual date of arrival back to Malaysia</li>
                                    <li>Receipts / any proof of payment of the tour or pre-paid costs (if non refundable from tour / operator)</li>
                                    <li>Cancellation / refund credit note for the portion refunded by the tour / operator (if refundable from tour / operator)</li>
                                    <li>Proof of relationship of insured person or immediate family members.</li>
                                    <li>Postmortem report or Death Certificate (If due to Death)</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">15.</label>
                            <label className="col-10 col-form-label text-primary">
                                What is cover for Pandemic Cover Option?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>
                                    In the event of Pandemic, AXA will cover you for Trip Cancellation, Trip Curtailment, Medical, Hospital and Treatment Expenses,
                                    Hospital Allowances, Emergency Medical Evacuation, Emergency Medical Repatriation and Repatriation of Mortal Remains if you are
                                    diagnosed with a pandemic illness.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">16.</label>
                            <label className="col-10 col-form-label text-primary">
                                What is covered under Medical, Hospital and Treatment Expenses benefit?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>
                                    AXA will pay on a Reimbursement Basis the Reasonable and Customary Charges incurred at the place of Accident, or where the Illness
                                    first surfaced, as a direct result of Injury or Illness sustained Overseas during the Insured Person's Overseas Trip, subject to
                                    such charges being incurred pursuant to a consultation with, and in accordance with prescriptions by, a Physician or Specialist
                                    in respect of such Injury or Illness.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">17.</label>
                            <label className="col-10 col-form-label text-primary">
                                Can I extend my policy coverage if I decide to stay longer?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>All changes to the period of coverage will need to be requested before the commence of a Trip.</p>

                                <p>Trip extension is not allowed once the trip has commenced based on the policy conditions as follows:</p>

                                <p>Period of Insurance</p>
                                <ul>
                                    <li>
                                        The Period of Insurance must include the date of arrival back in Malaysia for a round Trip made under a Single Trip Policy.
                                    </li>
                                    <li>Extension of the Period of Insurance is not allowed after the Commencement of a Trip under a Single Trip Policy.</li>
                                </ul>

                                <p className="mt-3">Automatic Extension of Cover</p>
                                <p>
                                    If, during a Trip, the Insured Person cannot complete the return journey within the Period of Insurance as stated in the Policy
                                    Schedule because:
                                </p>

                                <ul>
                                    <li>
                                        The Insured Person is being Hospitalised as a result of sustaining Serious Illness or Accidental Bodily Injury or being
                                        quarantined overseas during a Trip, the Period of Insurance will automatically be extended for a period of up to thirty
                                        (30) consecutive days from the expiry of your Period of Insurance without You having to pay any additional premium for
                                        such period as is reasonably necessary for the completion of the Trip, but only if any of the benefits under this Policy
                                        is payable in the first place and You have documented proof of the reasons for the delay, unless You have AXA approval in
                                        writing; or
                                    </li>
                                    <li>
                                        The scheduled Common Carrier the Insured Person has arranged to travel on as a ticket-holding passenger is unavoidably delayed
                                        due to strikes or industrial actions, inclement weather conditions, Natural Disaster or mechanical breakdown/ derangement of
                                        the Common Carrier or due to grounding of an aircraft as a result of mechanical or structural defect, the Period of Insurance
                                        will automatically be extended for a period of up to ten (10) consecutive days without You having to pay any additional
                                        premium for such period as is reasonably necessary for the completion of the Trip.
                                    </li>
                                </ul>

                                <p>
                                    It is a condition of this automatic extension of cover that the Insured Person must make every endeavour to return home at the first
                                    available opportunity
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">18.</label>
                            <label className="col-10 col-form-label text-primary">
                                Where can I get further information?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>You may refer to the product disclosure sheet or policy wording available on the product webpage.</p>

                                <p>For any further enquiries, kindly contact us at:</p>
                                <Table>
                                    <tr>
                                        <td>Customer Service:</td>
                                        <td><a href="tel:+603-79890386" className="text-decoration-none">03-7989 0386</a></td>
                                    </tr>
                                    <tr>
                                        <td>WhatsApp:</td>
                                        <td><a target="_blank" href={"https://wa.me/60122606183?text=" + process.env.MIX_APP_NAME} className="text-decoration-none">6012-2606183</a></td>
                                    </tr>
                                    <tr>
                                        <td>Email:</td>
                                        <td><a href="mailto:instaPol@howdengroup.com" className="text-decoration-none">instaPol@my.howdengroup.com</a></td>
                                    </tr>
                                </Table>
                            </div>
                        </div>
                    </div>
                </>
            );
        }
        else if (props.insurer === 'CHUBB') {
            return (
                <>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">1.</label>
                            <label className="col-10 col-form-label text-primary">
                                Does the product cover professional sports?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>Professional sports falls under exclusion, therefore it is not covered.</p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">2.</label>
                            <label className="col-10 col-form-label text-primary">
                                What is your definition on Family Member?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>
                                    Insured Person's Spouse, parents, parents-in-law, grandparents,
                                    grandparents-in-law, great grandparents, great grandparents-in-law,
                                    Child(ren), daughter-in-law, son-in-law, brothers or sisters, brother-in-law,
                                    sister-in-law, grandchild(ren), step-brother, step-sister, step-parents, Guardian.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">3.</label>
                            <label className="col-10 col-form-label text-primary">
                                What countries are covered under this product?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>
                                    Professional sports falls under exclusion, therefore it is not
                                    covered. Please refer to policy wording Part 4: General Exclusion
                                    no. 26 for specified definition. (pg.17)
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">4.</label>
                            <label className="col-10 col-form-label text-primary">
                                Can foreigner purchase this product?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>Yes provided they have the valid documentation as below:</p>
                                <ol type="1">
                                    <li>Valid working permit / employment pass.</li>
                                    <li>Married and permanently resides in Malaysia.</li>
                                    <li>
                                        Dependent pass / long term social visit pass / student pass
                                        / MM2H etc..
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">5.</label>
                            <label className="col-10 col-form-label text-primary">
                                Can foreigners departing from their country to malaysia and return to their
                                country purchase this insurance?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>No. This policy will require departure from Malaysia.</p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">6.</label>
                            <label className="col-10 col-form-label text-primary">
                                What is the age limit?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <ul>
                                    <li>Single Trip - 30 days and no maximum age limit.</li>
                                    <li>Annual Trip - 18 to 70 years old, renewal to 80 years old.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">7.</label>
                            <label className="col-10 col-form-label text-primary">
                                How does Covid-19 travel cancellation work?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <ol type="1">
                                    <li>Policy to be purchased before You are aware of the sickness.</li>
                                    <li>
                                        Covid-19 cancellation will be triggered if the Specified
                                        Cause happen within 15 days prior departure.
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">8.</label>
                            <label className="col-10 col-form-label text-primary">
                                My family member whom I live together with but not travelling with me, has
                                tested positive. Can I file for Travel Cancellation?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>
                                    Based on the given example, the scenario is not claimable as
                                    close contact with infected family member are not within Specified
                                    Cause.
                                </p>
                                <p>
                                    Claim assessment will be ruled out firstly by referring to latest
                                    government SOP. Then refer back to the Specified Cause mentioned
                                    in pg.60.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">9.</label>
                            <label className="col-10 col-form-label text-primary">
                                What do you mean by Travel Companion?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>
                                    Travel Companion means someone whom you are travelling with, and
                                    will affect your journey in their absence.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">10.</label>
                            <label className="col-10 col-form-label text-primary">
                                I have booked a trip but am unable to travel due to official travel
                                warnings or restrictions due to COVID-19. Will my trip cancellation
                                be covered?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>
                                    The policy does not response as annoucement of border closure by regulations /
                                    government are under exclusion.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">11.</label>
                            <label className="col-10 col-form-label text-primary">
                                Close contact with travel companion who is positive, travel journey
                                affected. Can I claim?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>
                                    The scenario falls under the Specified Cause and it is claimable. We will reimburse
                                    You for the unused portion of the paid expenses as well the additional fee incurred
                                    to amend the flight ticket.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">12.</label>
                            <label className="col-10 col-form-label text-primary">
                                The country advise me to <span className="fw-bold">quarantine</span>
                                at the hotel as there is no available bed in the hospital OR it is the country
                                regulation for tourist to quarantine at hotel.
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>This scenario is claimable.</p>
                                <p>
                                    Claim assessment will be ruled out firstly by referring to latest government SOP.
                                    Then refer back to the Specified Cause mentioned in pg.60.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">13.</label>
                            <label className="col-10 col-form-label text-primary">
                                I was <span className="fw-bold">quarantine</span> at the hotel in the advise
                                of the local doctor. However I did not overstayed.
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>We will reimburse the expenses that you paid in advance, on loss of deposit.</p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">14.</label>
                            <label className="col-10 col-form-label text-primary">
                                What happen if I tested positive on the last day or 48/72 hours before returning
                                and resulted in <span className="fw-bold">quarantine</span> and
                                <span className="fw-bold">overstayed</span>?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>
                                    The policy will pay the benefit under Travel Curtailment. We will also absorb
                                    the fee to amend the flight ticket as well the additional hotel expenses.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">15.</label>
                            <label className="col-10 col-form-label text-primary">
                                Do I need to amend the return date of the policy due to the above situation?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>No need as the policy will auto extend until you are allowed to return to Malaysia.</p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">16.</label>
                            <label className="col-10 col-form-label text-primary">
                                The country I'm travelling to suddenly announced
                                <span className="fw-bold">border closure</span>.
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>
                                    The policy does not response as annoucement of border closure by regulations
                                    / government are under exclusion.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">17.</label>
                            <label className="col-10 col-form-label text-primary">
                                Is there any requirement on whether we can only admit to hospital at Stage 3 or above?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>
                                    The policy does not have such requirement, however, please monitor your own
                                    health and follow the country's SOP &amp; guideline on admission requirement.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">18.</label>
                            <label className="col-10 col-form-label text-primary">
                                Am admitted to hospital on day 3 as the condition deteriorated.
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>
                                    We will provide assistance with the admission as well as cashless facilities.
                                    You will have to notify Chubb Assistance for such request.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">19.</label>
                            <label className="col-10 col-form-label text-primary">
                                When &amp; how much Daily Hospital Income am I entitled for?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>
                                    Payout on 3rd day onwards. 3rd day will count as Day 1. Please refer to
                                    Benefit Schedule for benefit payout.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">20.</label>
                            <label className="col-10 col-form-label text-primary">
                                There is no admission but am required to quarantine at the hotel. Am I
                                eligible for Daily Hospital Income?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>
                                    The Daily Hospital Income is limited to hospital admission or checked into
                                    the Temporary Medical &amp; Quarantine Center.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">21.</label>
                            <label className="col-10 col-form-label text-primary">
                                Do I need to do any test before purchasing the policy or departure?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>
                                    You do not need to perform any test before purchasing the policy however,
                                    you are required to follow the regulation prior to the departure.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">22.</label>
                            <label className="col-10 col-form-label text-primary">
                                Can I claim for the test kit- RTK or PCR?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>
                                    This is not claimable however, if the test is required by respective
                                    hospital due to an admission, then the expenses will be absorb.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">23.</label>
                            <label className="col-10 col-form-label text-primary">
                                I am staying back to take care of my family member who admited due to
                                Covid-19. Can I claim for the additional expenses?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>
                                    Compasionate visit benefit are not extended to Covid-19 coverage therefore
                                    the scenario is not claimable.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">24.</label>
                            <label className="col-10 col-form-label text-primary">
                                I was free of COVID-19 infection while leaving for my final destination
                                at the airport check-in point but I was diagnosed with COVID-19 infection
                                upon arrival at an airport in Malaysia. Can I claim for medical expenses
                                incurred in Malaysia?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>Unfortunately no. The medical expenses are limit to travelling Overseas.</p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">25.</label>
                            <label className="col-10 col-form-label text-primary">
                                My life insurance already has coverage on Covid-19 medical. Can I use that
                                policy to travel and show to the immigration.
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>
                                    Yes you can. However, please always check on the full T&amp;C of the
                                    policy on cover while Overseas.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">26.</label>
                            <label className="col-10 col-form-label text-primary">
                                Will I be covered under Covid-19 benefits if I'm not fully vaccinated?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>The policy exclude anyone who has not taken Covid-19 vaccination.</p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">27.</label>
                            <label className="col-10 col-form-label text-primary">
                                Do I need to do any test before purchase the policy?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>
                                    You do not need to do test before purchase policy however if you purchase
                                    the policy only after detected Covid-19 positive, then Travel Cancellation
                                    will not be covered.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">28.</label>
                            <label className="col-10 col-form-label text-primary">
                                How do I prove I'm fully vacinated?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>
                                    You will need to screenshot from MYSejahtera to show the fully vaccinated
                                    profile if there is a claim incurred.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">29.</label>
                            <label className="col-10 col-form-label text-primary">
                                I am travelling on cruise, do I eligible for the Covid-19 benefits?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>
                                    You will have to take up the Cruise Pack add-on in order to be eligible
                                    for the Covid-19 benefits. Else, it will be excluded.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">30.</label>
                            <label className="col-10 col-form-label text-primary">
                                If I were denied entry / boarding due to fever or other medical condition?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>
                                    Unfortunately, there will be no compensation under any Covid-19 benefits
                                    until there is a final report / test result to confirm diagnosed with Covid-19.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">31.</label>
                            <label className="col-10 col-form-label text-primary">
                                Will Chubb issue an official letter to customer for application of travel
                                pass as proof of Covid-19 coverage?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>
                                    Customer will be receiving the Certificate of Insurance, Schedule of Benefits
                                    &amp; Policy Wording as a proof of policy coverage.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">32.</label>
                            <label className="col-10 col-form-label text-primary">
                                The itinerary include cruise activity. Will I entitled for Covid-19 coverage?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>
                                    You will need to add-on the Cruise Pack in order to extend coverage in
                                    relates to Cruise and Covid-19.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">33.</label>
                            <label className="col-10 col-form-label text-primary">
                                If Covid-19 become an endemic, no longer a pandemic, will it be covered
                                under the plan?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>
                                    Our definition of Covid-19 means, Coronavirus Disease 2019 as classified
                                    by WHO on Feb 2020 and refers as any mutation and variation of it. In
                                    short, yes the policy will still take effect if declared as endemic.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">34.</label>
                            <label className="col-10 col-form-label text-primary">
                                I am stranded Overseas as the country declared border closure /
                                lockdown. Can I request for policy extension?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>
                                    We may at Our discretion, either approve or reject the Insured Person's
                                    request. Any such approval must be in writing.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">35.</label>
                            <label className="col-10 col-form-label text-primary">
                                For those who previously insured with Chubb Travel Insurance
                                ANNUAL plan last year, upon RENEWAL this year, will the renewal
                                plan include these new Covid-19 features?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>
                                    Yes for annual plan that renewed on the 24 March onwards are subject to
                                    this enhancement product and they will have to pay the new premium.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">36.</label>
                            <label className="col-10 col-form-label text-primary">
                                I am currently holding the annual plan that will expire later in
                                Oct 2022. Can I cancel and purchase this enhance product?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>
                                    Yes you may. Premium refund on the old plan will be based on the
                                    pro-rate table refund.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">37.</label>
                            <label className="col-10 col-form-label text-primary">
                                I m going overseas on 21 Mar and currently already have annual plan.
                                The product launch on 24 Mar. So can I request to cancel on 24 Mar
                                and issue new plan on 24 Mar while I m overseas?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>
                                    Unfortunately not. However you may cancel it upon returning to
                                    Malaysia and re-purchase the enhanced CTI policy.
                                </p>
                            </div>
                        </div>
                    </div>
                </>
            );
        }
        else if (props.insurer === 'AIG') {
            return (
                <>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">1.</label>
                            <label className="col-10 col-form-label text-primary">
                                What is this product about?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>This product provides compensation in the event of injury, disability or death caused by a sudden and unforeseen accident, medical expenses incurred as a result of an accident or illness, travel inconvenience and travel assistance for domestic and overseas trips. For domestic trips, coverage for Personal Accident and Medical and Associated Expenses benefit is confined to accidental causes only. This cover can be purchased by an individual person for themselves, their accompanying spouse and dependent children. You will have immediate access to 24/7 worldwide travel assistance in case of an emergency situation when you are abroad. You have an option of Single Trip or Annual Multi-Trip coverage depending on the plan type selected.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">2.</label>
                            <label className="col-10 col-form-label text-primary">
                                Who is eligible to purchase this product?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>(a) You must be either a Malaysian citizen, Malaysian permanent resident, or a holder of a valid work permit or employment pass (of which your place of employment must be in Malaysia during the policy period), dependent pass, student pass or long-term social visit pass not including travelling visa (that is issued by the relevant governmental authority in Malaysia) with full rights to enter into and return to Malaysia regardless of medical status;  </p>
                                <p>(b) You must be returning to your home (primary residence within Malaysia) at the end of your travel, or be intending to return home on completion of your travel (for return trip);  </p>
                                <p>(c) Your travel pre-arrangements must be made and paid for in Malaysia prior to your trip and your trip must commence in Malaysia; and  </p>
                                <p>(d) You need to be a resident in Malaysia. </p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">3.</label>
                            <label className="col-10 col-form-label text-primary">
                                What is Travel Guard policy coverage period?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p text-primary> Single Trip Plan </p>
                                <p>Duration of cover ranges from 1 to 5 days to a maximum of 180 consecutive days for overseas trip and a maximum of 30 consecutive days for domestic trip. </p>
                                <p text-primary>Annual-Multi Trip Plan </p>
                                <p>Duration of cover is for one year with unlimited number of trips made during the policy period. The maximum duration for each overseas trip is 90 consecutive days and each domestic trip is 30 consecutive days.</p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">4.</label>
                            <label className="col-10 col-form-label text-primary">
                                Can I buy more than one Travel Guard policy for the same trip?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>If you are covered by more than one policy, we will cover you based on the policy which provides the highest benefit level.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">5.</label>
                            <label className="col-10 col-form-label text-primary">
                                I am holding a one-way ticket. Can I purchase Travel Guard insurance?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>Yes, you can. </p>
                                <p>Travel Guard covers a one-way trip provided you have purchased the policy in Malaysia, and the original point of departure is Malaysia. Transits at other countries are allowed provided you are confined to the transit area of the airports in these countries. Cover provided under a one-way trip policy is only limited to Sections A &mdash; Trip Cancellation, E2 &mdash; Travel Missed Connection, F1 &mdash; Travel Delay, F2 &mdash; Travel Re-Route, G &mdash; Baggage, H &mdash; Personal Accident and I &mdash; Personal Liability of this policy.

                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">6.</label>
                            <label className="col-10 col-form-label text-primary">
                                Who do I contact for an emergency assistance or if I need to be admitted to a hospital while overseas?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>Please call our 24 hours, 7 days Worldwide Travel Assistance at +603-2772 5600.
                                    If you are unable to do so during an emergency, seek treatment first, and contact our Travel Assistance as soon as possible.

                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">7.</label>
                            <label className="col-10 col-form-label text-primary">
                                What is the definition of Immediate Family Members?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>Immediate Family Member means your spouse, parent, parent-in-law, grandparent, son or daughter, son-in-law, daughter-in-law, brother or sister, step-parent, stepdaughter, stepson, grandchild, legal guardian.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">8.</label>
                            <label className="col-10 col-form-label text-primary">
                                What should  I do if the airlines loses my baggage?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>Lodge a report and seek compensation from the airline. You may file in your claim for the loss not compensated by the airline.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">9.</label>
                            <label className="col-10 col-form-label text-primary">
                                Will I be covered for an illness that I am already suffering from or have suffered in the past?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>No. We do not cover any pre-existing condition occurring within 1 year prior to the policy effective date.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">10.</label>
                            <label className="col-10 col-form-label text-primary">
                                What should I do if I lose money whilst abroad?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>You must make a report to the local police within 24 hours after the incident. Please refer to our 3 easy steps to make a claim at <a href='https://www.aig.my/claims/personal-claims/travel-claims' target="_blank" >https://www.aig.my/claims/personal-claims/travel-claims.</a>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-1 col-form-label text-center">11.</label>
                            <label className="col-10 col-form-label text-primary">
                                Can I purchase travel insurance after I depart and still be covered?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p>No. You must purchase the travel insurance prior to your scheduled departure.
                                </p>
                            </div>
                        </div>
                    </div>
                </>
            );
        }
        else if (props.insurer === 'ZurichTakaful') {
            return (
                <>
                    <Accordion className="mb-3">
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                Section A: Product Related Questions
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={props.insurer}>
                                <Card.Body>
                                    <div className="row mb-3">
                                        <div className="question">
                                            <div className="row text-primary fw-bold">
                                                <label className="col-1 col-form-label text-center">1.</label>
                                                <label className="col-10 col-form-label text-primary">
                                                    What is this product about?
                                                </label>
                                            </div>
                                            <div className="row">
                                                <div className="col-1"></div>
                                                <div className="col-10 col-form-label">
                                                    <p>This is an international travel product that covers you while you are travelling outside of Malaysia, and it is available in both Insurance & Takaful.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="question">
                                            <div className="row text-primary fw-bold">
                                                <label className="col-1 col-form-label text-center">2.</label>
                                                <label className="col-10 col-form-label text-primary">
                                                    Who is eligible to purchase this product?
                                                </label>
                                            </div>
                                            <div className="row">
                                                <div className="col-1"></div>
                                                <div className="col-10 col-form-label">
                                                    <p>(a) You must be a Malaysian, or non-Malaysian who has a permanent resident status, valid work permit, valid student permit or Malaysia My Second Home (MM2H) status. </p>
                                                    <p>(b) For One-Way Trip, the journey must commence from Malaysia. For Single Trip, the journey must commence from Malaysia & you must return to Malaysia at the end of your journey.  </p>
                                                    <p>(c) age limits (all ages refer to the age of your next birthday):
                                                        <ul>
                                                            <li><b>Individual Cover, Individual and Spouse Cover, Family Cover </b> - 30 days old until 70 years old. For children insured/covered under individual or family cover, the policy/certificate must be purchased/participated in by the parents/legal guardian. </li>
                                                            <li><b>Child Cover</b> - 30 days old to 17 years old, or 23 years old if studying as a full-time student </li>
                                                            <li><b>Senior Cover</b>, available for Single Trip and One-Way Trip - 71 until 85 years old. For Annual Trip, senior cover is only applicable for renewal policy/certificate.</li>
                                                        </ul>
                                                    </p>
                                                    <p>(d) You need to be a resident in Malaysia. </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="question">
                                            <div className="row text-primary fw-bold">
                                                <label className="col-1 col-form-label text-center">3.</label>
                                                <label className="col-10 col-form-label text-primary">
                                                    What is Travel Guard policy coverage period?
                                                </label>
                                            </div>
                                            <div className="row">
                                                <div className="col-1"></div>
                                                <div className="col-10 col-form-label">
                                                    <p><ul>
                                                        <li><b>Single Trip:</b> Covers you for a specific returning journey which commence from and return to Malaysia.</li>
                                                        <li><b>One-Way Trip: </b>Covers you for a specific one-way trip which commence from Malaysia but may or may not return to Malaysia (or the return date to Malaysia is uncertain). For one-way trip, coverage will cease upon arrival at the airport of the first destination country (excluding transit countries). Premium/Contribution shall be determined based on travel duration of 1-5 days.</li>
                                                        <li><b>Annual Trip: </b>Covers you for multiple journeys within a one-year period.</li>
                                                    </ul>
                                                    </p>

                                                </div>
                                            </div>
                                            <div className="question">
                                                <div className="row text-primary fw-bold">
                                                    <label className="col-1 col-form-label text-center">4.</label>
                                                    <label className="col-10 col-form-label text-primary">
                                                        Is there a maximum travel duration?
                                                    </label>
                                                </div>
                                                <div className="row">
                                                    <div className="col-1"></div>
                                                    <div className="col-10 col-form-label">
                                                        <p><ul>
                                                            <li><b>Single Trip:</b>the journey shall not exceed 200 days.</li>
                                                            <li><b>Annual Trip: </b>each journey within the year shall not exceed 100 days.</li>
                                                        </ul>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="question">
                                                <div className="row text-primary fw-bold">
                                                    <label className="col-1 col-form-label text-center">5.</label>
                                                    <label className="col-10 col-form-label text-primary">
                                                        Is this product subject to ST ({process.env.MIX_SERVICE_CHARGE_RATE}%)?
                                                    </label>
                                                </div>
                                                <div className="row">
                                                    <div className="col-1"></div>
                                                    <div className="col-10 col-form-label">
                                                        <p>This product is not subject to {process.env.MIX_SERVICE_CHARGE_RATE}% ST.This product is not subject to {process.env.MIX_SERVICE_CHARGE_RATE}% ST.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="question">
                                                <div className="row text-primary fw-bold">
                                                    <label className="col-1 col-form-label text-center">6.</label>
                                                    <label className="col-10 col-form-label text-primary">
                                                        Are there any countries that are not covered under this product?
                                                    </label>
                                                </div>
                                                <div className="row">
                                                    <div className="col-1"></div>
                                                    <div className="col-10 col-form-label">
                                                        <p>There are no excluded countries. You must select the Area of Travel based on the countries you are travelling to. However, do take note that Malaysia's passport is valid for all countries, except Israel. If you intend to go to Israel, you must ensure proper, legal and official entry permit is obtained.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="question">
                                                <div className="row text-primary fw-bold">
                                                    <label className="col-1 col-form-label text-center">7.</label>
                                                    <label className="col-10 col-form-label text-primary">
                                                        Can my company purchase/participate in a group travel policy/certificate?
                                                    </label>
                                                </div>
                                                <div className="row">
                                                    <div className="col-1"></div>
                                                    <div className="col-10 col-form-label">
                                                        Yes. This product is available for both individual and group.
                                                        <ul>
                                                            <li><b>Individual</b> - individual can purchase/participate in the policy/certificate for himself/herself or extend the cover for his/her spouse and children.  </li>
                                                            <li><b>Group</b> - company/association can purchase/participate in the policy/certificate for their employees/members. However, it is important to take note that the person/entity purchasing/participating in the policy/certificate is the policy holder/certificate holder. Therefore, in the event of claims, claims will be payable to the policy holder/ certificate holder.</li>
                                                        </ul>

                                                    </div>
                                                </div>
                                            </div>
                                            <div className="question">
                                                <div className="row text-primary fw-bold">
                                                    <label className="col-1 col-form-label text-center">8.</label>
                                                    <label className="col-10 col-form-label text-primary">
                                                        Can I form a group of friends to purchase/participate in a group travel policy/certificate?
                                                    </label>
                                                </div>
                                                <div className="row">
                                                    <div className="col-1"></div>
                                                    <div className="col-10 col-form-label">
                                                        <p>No. You cannot purchase/participate in a group policy/certificate with your friends if there is no insurable interest/permissible takaful interest between you and the other insured persons/persons covered.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="question">
                                                <div className="row text-primary fw-bold">
                                                    <label className="col-1 col-form-label text-center">9.</label>
                                                    <label className="col-10 col-form-label text-primary">
                                                        What are the criteria to purchase/participate in a family plan policy/ certificate?
                                                    </label>
                                                </div>
                                                <div className="row">
                                                    <div className="col-1"></div>
                                                    <div className="col-10 col-form-label">
                                                        <p>Family plan can be purchased/participated in to cover you, one of your legal spouses and your accompanying child(ren) who must be between 30 days old to 17 years old, or 23 years old if studying as a full-time student at the commencement of the journey.
                                                        </p>
                                                        <p>If your child(ren) has exceeded the child's maximum age as mentioned above, he/she must purchase/ participate in an individual policy/certificate. If your spouse is not travelling together, you can still purchase/ participate in a family plan to cover yourself and your child(ren).
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="question">
                                                <div className="row text-primary fw-bold">
                                                    <label className="col-1 col-form-label text-center">10.</label>
                                                    <label className="col-10 col-form-label text-primary">
                                                        Is there a maximum number of family member that can apply for the family plan?
                                                    </label>
                                                </div>
                                                <div className="row">
                                                    <div className="col-1"></div>
                                                    <div className="col-10 col-form-label">
                                                        <p>There is no limit on the number of family members that can apply on family plan.
                                                        </p>
                                                        <p>However, the maximum limits payable under the family plan is 300% of the limit and sub-limit stated in the Schedule of Benefits, except for the following benefits in which the limits remain as per the insured person/person covered. </p>
                                                        <p>BENEFIT 2 - Overseas Hospital Income </p>
                                                        <p>BENEFIT 19 - Accidental Death and Permanent Disablement </p>
                                                        <p>BENEFIT 25 to 29 - Special Coverage, Badal Haji, Wakaf, Qurban & Emergency Cash </p>
                                                        <p>BENEFIT 33 & 35 - Hospital Allowance & Death due to Covid-19 (if you have selected this ad- on benefits)</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="question">
                                                <div className="row text-primary fw-bold">
                                                    <label className="col-1 col-form-label text-center">11.</label>
                                                    <label className="col-10 col-form-label text-primary">
                                                        I am travelling to Hong Kong for one year, should I purchase/participate in a One-Way Trip?
                                                    </label>
                                                </div>
                                                <div className="row">
                                                    <div className="col-1"></div>
                                                    <div className="col-10 col-form-label">
                                                        <p>With reference to #4, each journey within an annual cover must not exceed 100 days. Since you are travelling more than 100 days, you are advised to purchase/participate in a One-Way Trip, under Area 1 (Hong Kong) with 1-5 days travel duration and coverage.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="question">
                                                <div className="row text-primary fw-bold">
                                                    <label className="col-1 col-form-label text-center">12.</label>
                                                    <label className="col-10 col-form-label text-primary">
                                                        I'm travelling for 5 days (i.e. from 1st July to 5th July) and will arrive Malaysia upon my return at midnight. As it is possible for me to return home after 12am on 5th July, should I purchase/participate in the policy/ certificate until 6th July?
                                                    </label>
                                                </div>
                                                <div className="row">
                                                    <div className="col-1"></div>
                                                    <div className="col-10 col-form-label">
                                                        <p>Yes, as the policy/certificate covers you until you return your home or place of business in Malaysia, it is advisable for you to purchase/participate in the policy/certificate until the date when you expect to return home or place of business.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="question">
                                                <div className="row text-primary fw-bold">
                                                    <label className="col-1 col-form-label text-center">13.</label>
                                                    <label className="col-10 col-form-label text-primary">
                                                        Can I extend my policy/certificate if I have decided to extend my stay during my trip?
                                                    </label>
                                                </div>
                                                <div className="row">
                                                    <div className="col-1"></div>
                                                    <div className="col-10 col-form-label">
                                                        <p>Once you have departed for your overseas trip, the policy/certificate cannot be amended/extended.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="question">
                                                <div className="row text-primary fw-bold">
                                                    <label className="col-1 col-form-label text-center">14.</label>
                                                    <label className="col-10 col-form-label text-primary">
                                                        I have purchased/participated in a family plan. Can my wife and I make our nominations separately?
                                                    </label>
                                                </div>
                                                <div className="row">
                                                    <div className="col-1"></div>
                                                    <div className="col-10 col-form-label">
                                                        <p>If the policy/certificate is purchased/participated in by you, you will be the policy holder/certificate holder of the policy/ certificate and only the policy holder/certificate holder have the sole right to nominate. However, if your wife wishes to nominate, it is advisable to purchase/participate in an individual policy/certificate, instead of family plan.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="question">
                                                <div className="row text-primary fw-bold">
                                                    <label className="col-1 col-form-label text-center">15.</label>
                                                    <label className="col-10 col-form-label text-primary">
                                                        Can I cancel my policy/certificate?
                                                    </label>
                                                </div>
                                                <div className="row">
                                                    <div className="col-1"></div>
                                                    <div className="col-10 col-form-label">
                                                        <p>
                                                            <ol>
                                                                <li><b>Single Trip and One-Way Trip </b> - no cancellation is allowed once the policy/ certificate has been issued.</li>
                                                                <li><b>Annual Trip </b> - you may at any time cancel this policy/certificate, in which case we will retain the customary short period rates for the time the policy/certificate has been in force, provided no claim has been or will be submitted by you.</li>
                                                            </ol></p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="question">
                                                <div className="row text-primary fw-bold">
                                                    <label className="col-1 col-form-label text-center">16.</label>
                                                    <label className="col-10 col-form-label text-primary">
                                                        I am going for Umrah/Haji at Makkah, can I purchase/participate in this product?
                                                    </label>
                                                </div>
                                                <div className="row">
                                                    <div className="col-1"></div>
                                                    <div className="col-10 col-form-label">
                                                        <p>Yes. This product provides coverage when you are travelling overseas, including for the purpose of performing Umrah or Hajj.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="question">
                                                <div className="row text-primary fw-bold">
                                                    <label className="col-1 col-form-label text-center">17.</label>
                                                    <label className="col-10 col-form-label text-primary">
                                                        Does it cover domestic (within Malaysia) journey? (i.e Kuala Lumpur to Sarawak)
                                                    </label>
                                                </div>
                                                <div className="row">
                                                    <div className="col-1"></div>
                                                    <div className="col-10 col-form-label">
                                                        <p>As this is an international travel product that covers you while you are travelling outside of Malaysia, it does not cover any domestic/inbound travel. However, the coverage begins at the time you leave your home or place of business in Malaysia for the purpose of commencing the travel abroad and ends at the time you return to your home or place of business in Malaysia.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="question">
                                                <div className="row text-primary fw-bold">
                                                    <label className="col-1 col-form-label text-center">18.</label>
                                                    <label className="col-10 col-form-label text-primary">
                                                        I have pre-booked a cruise trip during my holiday to Singapore. The cruise itinerary includes a ground tour activity stop in Penang (Home Country). Will I be covered during this Ground Tour arranged by the cruise in my own home country?
                                                    </label>
                                                </div>
                                                <div className="row">
                                                    <div className="col-1"></div>
                                                    <div className="col-10 col-form-label">
                                                        <p>As this is an international travel product that covers you while you are travelling outside of Malaysia, it does not cover any domestic/inbound travel including the ground tour activity in Malaysia. However, we do cover you when you are in your cruise journey outside of Malaysia. Nevertheless, as this is not solely a cruise cover, we do not cover Travel Interruption, Travel Delay, Travel Reroute, Baggage Delay during your cruise journey.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="question">
                                                <div className="row text-primary fw-bold">
                                                    <label className="col-1 col-form-label text-center">19.</label>
                                                    <label className="col-10 col-form-label text-primary">
                                                        Does this product cover activities such as bungee jump, hot air balloon, scuba diving, winter sports, hiking/ trekking?
                                                    </label>
                                                </div>
                                                <div className="row">
                                                    <div className="col-1"></div>
                                                    <div className="col-10 col-form-label">
                                                        <p>Yes, we do cover injuries caused by activities mentioned above. Reference can be made to policy/certificate wording in: Benefit 25 - Special Coverage. Please note that mountaineering or any activity above three thousand (3,000) meters height is excluded from this policy/certificate. However, the policy/certificate does cover you against accidental death and permanent disablement while engaging in this activity.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                Section B: Covid-19 Benefit Related Questions
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={props.insurer}>
                                <Card.Body>
                                    <div className="row mb-3">

                                        <div className="question">
                                            <div className="row text-primary fw-bold">
                                                <label className="col-1 col-form-label text-center">1.</label>
                                                <label className="col-10 col-form-label text-primary">
                                                    What is this product about?
                                                </label>
                                            </div>
                                            <div className="row">
                                                <div className="col-1"></div>
                                                <div className="col-10 col-form-label">
                                                    <p>This is an optional add-on benefit, it provides coverage for Covid-19 related incidents i.e., travel cancellation/alteration, overseas medical expenses, hospital allowance, childcare benefit and death due to Covid-19.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="question">
                                            <div className="row text-primary fw-bold">
                                                <label className="col-1 col-form-label text-center">2.</label>
                                                <label className="col-10 col-form-label text-primary">
                                                    Do I have to pay/make any additional premium/contribution?
                                                </label>
                                            </div>
                                            <div className="row">
                                                <div className="col-1"></div>
                                                <div className="col-10 col-form-label">
                                                    <p>Yes, the cover is subject to additional premium/contribution. Please refer to the premium/contribution table in the Brochure.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="question">
                                            <div className="row text-primary fw-bold">
                                                <label className="col-1 col-form-label text-center">3.</label>
                                                <label className="col-10 col-form-label text-primary">
                                                    Is this a standalone product or must it be purchased/participated in together with the base policy/certificate?
                                                </label>
                                            </div>
                                            <div className="row">
                                                <div className="col-1"></div>
                                                <div className="col-10 col-form-label">
                                                    This is not a standalone product. The Covid-19 add-on must be purchased/participated in together with the base policy/ certificate.
                                                </div>
                                            </div>
                                        </div>
                                        <div className="question">
                                            <div className="row text-primary fw-bold">
                                                <label className="col-1 col-form-label text-center">4.</label>
                                                <label className="col-10 col-form-label text-primary">
                                                    Will claims under Covid-19 benefits reduce any of the base policy/certificate benefit limit?
                                                </label>
                                            </div>
                                            <div className="row">
                                                <div className="col-1"></div>
                                                <div className="col-10 col-form-label">   Yes. There is a maximum travel duration.
                                                    No, any claim from Covid-19 benefit will not reduce any of the base policy/certificate benefit limit.
                                                </div>
                                            </div>
                                        </div>
                                        <div className="question">
                                            <div className="row text-primary fw-bold">
                                                <label className="col-1 col-form-label text-center">5.</label>
                                                <label className="col-10 col-form-label text-primary">
                                                    If I have not received any Covid-19 vaccination(s), will I be covered?
                                                </label>
                                            </div>
                                            <div className="row">
                                                <div className="col-1"></div>
                                                <div className="col-10 col-form-label">
                                                    <p>No, you will not be covered if you have not had the approved Covid-19 vaccination(s), except if you are unable to receive the vaccine due to medical conditions, or you are a child below the age of eighteen (18) years old in Malaysia.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="question">
                                            <div className="row text-primary fw-bold">
                                                <label className="col-1 col-form-label text-center">6.</label>
                                                <label className="col-10 col-form-label text-primary">
                                                    Can I claim both Travel Cancellation and Travel Alteration benefits due to Covid-19?
                                                </label>
                                            </div>
                                            <div className="row">
                                                <div className="col-1"></div>
                                                <div className="col-10 col-form-label">
                                                    <p>No, you can only claim from either travel cancellation or travel alteration due to Covid-19, but not both. The entire policy/certificate will be terminated once a claim has been paid for either travel cancellation/ alteration due to Covid-19.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="question">
                                            <div className="row text-primary fw-bold">
                                                <label className="col-1 col-form-label text-center">7.</label>
                                                <label className="col-10 col-form-label text-primary">
                                                    Is there a cut-off date I need to purchase/participate in the Covid-19 add-on?
                                                </label>
                                            </div>
                                            <div className="row">
                                                <div className="col-1"></div>
                                                <div className="col-10 col-form-label">
                                                    <p>Yes, to be eligible for Travel Cancellation due to Covid-19 and(or) Travel Alteration due to Covid-19 benefits, you must purchase/participate in the add-on for at least seven (7) days prior to the commencement of your journey.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="question">
                                            <div className="row text-primary fw-bold">
                                                <label className="col-1 col-form-label text-center">8.</label>
                                                <label className="col-10 col-form-label text-primary">
                                                    What happens if I am unable to return to Malaysia due to Covid-19 and require self-quarantine overseas?
                                                </label>
                                            </div>
                                            <div className="row">
                                                <div className="col-1"></div>
                                                <div className="col-10 col-form-label">
                                                    <p>We do not cover any costs related to quarantine.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="question">
                                            <div className="row text-primary fw-bold">
                                                <label className="col-1 col-form-label text-center">9.</label>
                                                <label className="col-10 col-form-label text-primary">
                                                    What are the special exclusions under this add-on?
                                                </label>
                                            </div>
                                            <div className="row">
                                                <div className="col-1"></div>
                                                <div className="col-10 col-form-label">
                                                    <p>Special exclusions applicable to Covid-19 benefits
                                                    </p>
                                                    <p>
                                                        <ul>
                                                            <li>Covid-19 infection that you have reasonable knowledge of prior to the Period of Insurance/Takaful, but this is not applicable if you have been fully recovered from Covid-19 and no longer receive treatment prior to the Period of Insurance/Takaful of the policy/certificate. </li>
                                                            <li>If you're travelling against physician's advice. </li>
                                                            <li>Any loss resulting from border closures, travel ban or other government orders. </li>
                                                            <li>You have not had the approved Covid-19 vaccination(s).</li>
                                                        </ul>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey={props.insurer} className="text-primary">
                                Section C: Claims Related Questions
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={props.insurer}>
                                <Card.Body>
                                    <div className="row mb-3">
                                        <div className="question">
                                            <div className="row text-primary fw-bold">
                                                <label className="col-1 col-form-label text-center">1.</label>
                                                <label className="col-10 col-form-label text-primary">
                                                    How do I make a claim?
                                                </label>
                                            </div>
                                            <div className="row">
                                                <div className="col-1"></div>
                                                <div className="col-10 col-form-label">
                                                    <p>You must notify all claims to us within 24 hours, but no later than 30 days after the loss or damage. You can submit your claims online as below and/or submit the original claims documents to:-
                                                    </p>
                                                    <p>Z-Travel Takaful (International) :- https://egms.zurich.com.my/claims
                                                    </p>
                                                    <p>Zurich General Takaful Malaysia Berhad</p>
                                                    <p>Attention to: General Claims Department - AHWC</p>
                                                    <p>Level 23A, Mercu 3, No.3, Jalan Bangsar, KL Eco City 59200 Kuala Lumpur, Malaysia</p>

                                                </div>
                                            </div>
                                        </div>
                                        <div className="question">
                                            <div className="row text-primary fw-bold">
                                                <label className="col-1 col-form-label text-center">2.</label>
                                                <label className="col-10 col-form-label text-primary">
                                                    Who do I contact for an emergency assistance or if I need to be admitted to a hospital while overseas?
                                                </label>
                                            </div>
                                            <div className="row">
                                                <div className="col-1"></div>
                                                <div className="col-10 col-form-label">
                                                    <p>Please call our 24-Hour, 7-Day Travel Assistance Helpline at +603 7841 5630.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="question">
                                            <div className="row text-primary fw-bold">
                                                <label className="col-1 col-form-label text-center">3.</label>
                                                <label className="col-10 col-form-label text-primary">
                                                    If I�m involved in an accident while on the way to airport, will I be covered?
                                                </label>
                                            </div>
                                            <div className="row">
                                                <div className="col-1"></div>
                                                <div className="col-10 col-form-label">
                                                    Yes, the policy/certificate covers the journey from your home or place of business to airport for the purpose of the overseas trip covered by the policy/certificate.
                                                </div>
                                            </div>
                                        </div>
                                        <div className="question">
                                            <div className="row text-primary fw-bold">
                                                <label className="col-1 col-form-label text-center">4.</label>
                                                <label className="col-10 col-form-label text-primary">
                                If I have departed for my overseas trip but would like to extend to include a short domestic trip (e.g. stay 1 night in Genting before flying to UK), will I be covered during my stay in Genting? For example: Johor Bahru &gt; KL &gt; Genting &gt; UK &gt; KL &gt; Johor Bahru
                                                </label>
                                            </div>
                                            <div className="row">
                                                <div className="col-1"></div>
                                                <div className="col-10 col-form-label">
                                                    <p>If you extend the trip for domestic travel (i.e. Genting or anywhere in Malaysia), it will not be covered if proven in the event of claims, is not part of the journey for the overseas trip.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="question">
                                            <div className="row text-primary fw-bold">
                                                <label className="col-1 col-form-label text-center">5.</label>
                                                <label className="col-10 col-form-label text-primary">
                                                    If multiple individuals (e.g. family members) are sharing the same baggage which is checked-in with the common carrier, and the baggage is delayed for more than 6 hours, can all of them make a claim under Baggage Delay?
                                                </label>
                                            </div>
                                            <div className="row">
                                                <div className="col-1"></div>
                                                <div className="col-10 col-form-label">
                                                    <p>If multiple insured persons/persons covered, regardless friends or family members, share the same baggage which is checked-in with the Common Carrier, we will only accept claim request from 1 insured person/person covered. This applies to delayed, lost, stolen or damaged baggage. Reference can be made to policy/certificate wording - <b>Special Conditions applicable to Benefits 14 and 15</b>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="question">
                                            <div className="row text-primary fw-bold">
                                                <label className="col-1 col-form-label text-center">6.</label>
                                                <label className="col-10 col-form-label text-primary">
                                                    If I am in Kaohsiung and experienced an earthquake and its aftershock, am I eligible to claim Travel Interruption as I feel it is unsafe to continue my journey in the country?
                                                </label>
                                            </div>
                                            <div className="row">
                                                <div className="col-1"></div>
                                                <div className="col-10 col-form-label">
                                                    <p>You are eligible to claim only if there is a notice issued by the government of Malaysia or relevant authorities formally advising against non-essential travel to the affected areas at your Destination. Reference can be made to policy/certificate wording - <b>Special Conditions applicable to Benefits 8 � 10</b>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="question">
                                            <div className="row text-primary fw-bold">
                                                <label className="col-1 col-form-label text-center">7.</label>
                                                <label className="col-10 col-form-label text-primary">
                                                    I am going to hike/trek in Nepal, will I be covered during my hiking/trekking activities?
                                                </label>
                                            </div>
                                            <div className="row">
                                                <div className="col-1"></div>
                                                <div className="col-10 col-form-label">
                                                    <p>Mountaineering or any activities above three thousand (3,000) meters height is excluded from this policy/ certificate. However, the policy/certificate does cover you against accidental death and permanent disablement while engaging in this activity. Reference can be made to policy/certificate wording: <b>Benefit 25 � Special Coverage</b>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="question">
                                            <div className="row text-primary fw-bold">
                                                <label className="col-1 col-form-label text-center">8.</label>
                                                <label className="col-10 col-form-label text-primary">
                                                    If my checked-in baggage is damaged by the common carrier and they have compensated me on the damages, can I make a claim on my policy/ certificate?
                                                </label>
                                            </div>
                                            <div className="row">
                                                <div className="col-1"></div>
                                                <div className="col-10 col-form-label">
                                                    <p>We do not cover any loss that is payable by any other sources. However, we will pay the difference between the amount payable from any other source and the actual loss you have incurred.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="question">
                                            <div className="row text-primary fw-bold">
                                                <label className="col-1 col-form-label text-center">9.</label>
                                                <label className="col-10 col-form-label text-primary">
                                                    In order to reach my destination in Europe, I need to transit in Middle East. Due to a delay of more than 6 hours of the common carrier to Middle East, I have missed my onward connecting flight to Europe. Can I claim from Travel Delay and Travel Misconnection?
                                                </label>
                                            </div>
                                            <div className="row">
                                                <div className="col-1"></div>
                                                <div className="col-10 col-form-label">
                                                    <p>In respect to the same incident, you can only make a claim under Travel Delay or Travel Misconnection but not both. Reference can be made to policy/certificate wording - <b>Special Conditions applicable to Benefits 8 to 13</b>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="question">
                                            <div className="row text-primary fw-bold">
                                                <label className="col-1 col-form-label text-center">10.</label>
                                                <label className="col-10 col-form-label text-primary">
                                                    During my overseas journey, my travel companion is suffering from a critical illness which in the opinion of the attending doctor, requires urgent treatment. Due to this, I have incurred additional flight ticket cost to curtail my trip and return home. I have also lost my initial unused flight ticket and hotel stays. Can I claim from Travel Curtailment benefit?
                                                </label>
                                            </div>
                                            <div className="row">
                                                <div className="col-1"></div>
                                                <div className="col-10 col-form-label">
                                                    <p>Yes. As it is necessary and unavoidable for you to curtail your trip, you can submit your claim for the additional costs of common carrier to return home and the unused transportation and accommodation expenses that are paid by you for the journey, subject to other terms and conditions of the policy/certificate. Reference can be made to policy /certificate wording - <b>Benefit 9 - Travel Curtailment</b>
                                                    </p>
                                                    <p>
                                                        *All due care has been taken in preparing these FAQs. However, in the event of any inconsistences between the information provided in these FAQs and the terms of the policy/certificate, the provisions set out in the policy/certificate will prevail.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>


                </>
            );
        }
        else if (props.insurer === 'TUNEPROTECT') {
            return (
                <>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-2 col-lg-1 col-form-label text-center">1.</label>
                            <label className="col-10 col-lg-11 col-form-label text-primary">
                                What is Tune Protect Travel Easy insurance?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-2 col-lg-1"></div>
                            <div className="col-10 col-lg-11 col-form-label">
                                <p>
                                Tune Protect Travel Easy is a comprehensive travel insurance plan for individuals and families travelling within Malaysia or internationally for business or leisure purpose. Please refer Product Disclosure Sheet and Policy Wording for the full list of benefits.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-2 col-lg-1 col-form-label text-center">2.</label>
                            <label className="col-10 col-lg-11 col-form-label text-primary">
                            Who is eligible to purchase?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-2 col-lg-1"></div>
                            <div className="col-10 col-lg-11 col-form-label">
                                <p>
                                Malaysian citizen or Permanent Resident of Malaysia or holder of a work permit, employment pass, dependent pass, long-term social visit pass, or student pass issued by the relevant authorities in Malaysia which is valid at the time of issuance of this Policy and who is legally residing in Malaysia.
                               </p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-2 col-lg-1 col-form-label text-center">3.</label>
                            <label className="col-10 col-lg-11 col-form-label text-primary">
                            What is the age limit to purchase travel insurance?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-2 col-lg-1"></div>
                            <div className="col-10 col-lg-11 col-form-label">
                                <p text-primary>Adults: 18 - 80 years old</p>
                                <p text-primary>Child: 30 days - 21 years old (unemployed and unmarried)</p>
                                <ul>
                                    <li>Between ages 18 - 21, individuals who are employed and/or married are considered adults</li>
                                    <li>A child must always be part of a Family plan and cannot be covered in an Individual or Group policy.</li>
                                    <li>Senior travellers (61 - 80 years old) cannot be part of a family plan and can instead purchase an Individual or Group policy.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-2 col-lg-1 col-form-label text-center">4.</label>
                            <label className="col-10 col-lg-11 col-form-label text-primary">
                            Does Travel Easy cover COVID-19 related benefits?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-2 col-lg-1"></div>
                            <div className="col-10 col-lg-11 col-form-label">
                                <p text-primary>Yes, both COVID Plus and COVID Lite plans have COVID-19 related benefits plus basic plan benefits e.g. personal accident, luggage delay and etc.</p>
                                <p text-primary>Please refer to the Schedule of Benefits for further details.</p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-2 col-lg-1 col-form-label text-center">5.</label>
                            <label className="col-10 col-lg-11 col-form-label text-primary">
                                What is a family plan and how does it work?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-2 col-lg-1"></div>
                            <div className="col-10 col-lg-11 col-form-label">
                                <p text-primary>A family plan is suitable for married adults and their legal children.</p>
                                <p text-primary>Conditions to qualify for a family plan:</p>
                                <ul>
                                    <li>Maximum 2 adults married to each other</li>
                                    <li>Maximum 10 children of the adults</li>
                                    <li>Minimum 1 parent and 1 child in a family plan</li>
                                    <li>A family plan cannot consist of adults only or children only</li>
                                    <li>Senior travellers (61 - 80 years old) cannot be part of a family plan</li>
                                    <li>Age limit for family plan:
                                        <ul>
                                            <li>Adult: 18 - 60 years old</li>
                                            <li>Child: 30 days - 21 years old (unemployed and unmarried)</li>
                                        </ul>
                                    </li>
                                    <li>A family will share one insurance policy</li>
                                       
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-2 col-lg-1 col-form-label text-center">6.</label>
                            <label className="col-10 col-lg-11 col-form-label text-primary">
                                What is a Group plan and how does it work?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-2 col-lg-1"></div>
                            <div className="col-10 col-lg-11 col-form-label">
                                <p text-primary>If you're travelling in a group, select the Group plan to purchase insurance for everyone in the group at one go. It's fast and easy! Here's how it works:</p>
                                <ul>
                                    <li>
                                        Maximum of 30 adults in a Group plan
                                    </li>
                                    <li>
                                        Qualifying age: 18 - 80 years old
                                    </li>
                                    <li>
                                        Children cannot be part of a group plan
                                    </li>
                                    <li>
                                        Senior travellers (61 - 80 years old) must purchase a separate individual or group plan
                                    </li>
                                    <li>
                                        Each traveller in the group will have their own individual travel policy
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-2 col-lg-1 col-form-label text-center">7.</label>
                            <label className="col-10 col-lg-11 col-form-label text-primary">
                                What is Annual Cover?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-2 col-lg-1"></div>
                            <div className="col-10 col-lg-11 col-form-label">
                                <p text-primary>Will you be travelling regularly in the coming year? You can purchase an Annual Cover that covers all your trips for a period of 12 months. Save time and money, and travel worry-free!</p>
                                <p text-primary>Things to note:</p>
                                <ul>
                                    <li>
                                        Coverage duration per leisure trip: 30 days (worldwide travel)
                                    </li>
                                    <li>
                                        Coverage duration per business trip: 90 days (worldwide travel)
                                    </li>
                                    <li>
                                        For Domestic travel, the duration of cover is 30 days for each leisure or business trip
                                    </li>
                                    <li>
                                        Annual Trip insurance does not include COVID-19 coverage
                                    </li>
                                    <li>
                                        One Way Trip is not covered under Annual Cover
                                    </li>
                                </ul>
                                <p text-primary>Note: This list is non-exhaustive. Please refer to the Policy Contract for the full list of exclusions under this Policy.</p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-2 col-lg-1 col-form-label text-center">8.</label>
                            <label className="col-10 col-lg-11 col-form-label text-primary">
                                What is the maximum period of coverage?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-2 col-lg-1"></div>
                            <div className="col-10 col-lg-11 col-form-label">
                               <ul>
                                    <li>
                                        One Way Trip: 72 hours from the first arrival date at the Country of Arrival, OR, upon checking in at point of immigration for travel outside of Country of Area, whichever comes first.
                                    </li>
                                    <li>
                                        Return Trip: 180 consecutive days for an overseas trip, 45 days for domestic travel
                                    </li>
                                    <li>
                                        Annual Trip: 30 consecutive days for an overseas leisure travel trip and 90 consecutive days for an overseas business travel trip; 30 days for domestic travel
                                    </li>
                               </ul>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-2 col-lg-1 col-form-label text-center">9.</label>
                            <label className="col-10 col-lg-11 col-form-label text-primary">
                            What if I'm travelling to multiple countries?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                                <p text-primary>
                                If you are travelling to multiple countries within the same trip, you can be covered under one policy. Simply enter the furthest country that you will be visiting to get your plan quotation.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-2 col-lg-1 col-form-label text-center">10.</label>
                            <label className="col-10 col-lg-11 col-form-label text-primary">
                                What do I need to do if there are changes to my contact details or trip information?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-2 col-lg-1"></div>
                            <div className="col-10 col-lg-11 col-form-label">
                                <p>You may email to <a href="mailto:insta.admin@howdengroup.com">insta.admin@howdengroup.com</a> to inform on the changes immediately.</p>
                            </div>
                        </div>
                    </div>

                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-2 col-lg-1 col-form-label text-center">11.</label>
                            <label className="col-10 col-lg-11 col-form-label text-primary">
                                How do I make a claim?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-2 col-lg-1"></div>
                            <div className="col-10 col-lg-11 col-form-label">
                                <p>Please submit your claim within 30 days of you becoming aware of an incident or loss leading to a claim.</p>
                                <p>Please contact us at +60122606183 [Monday to Friday, 8:45am to 5:45pm] or email us at <a href="mailto:insta.admin@howdengroup.com">insta.admin@howdengroup.com</a></p>
                            </div>
                        </div>
                    </div>

                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-2 col-lg-1 col-form-label text-center">12.</label>
                            <label className="col-10 col-lg-11 col-form-label text-primary">
                                Can I claim for stolen baggage?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-2 col-lg-1"></div>
                            <div className="col-10 col-lg-11 col-form-label">
                                <p>For loss or damage caused by theft during the trip, a report must be made at the nearest police station or relevant authorities within the jurisdiction where the incident took place within 24 hours of the incident. You must also notify the relevant airline authorities of missing luggage at the scheduled destination point and to obtain a property irregularity report.</p>
                            </div>
                        </div>
                    </div>

                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-2 col-lg-1 col-form-label text-center">13.</label>
                            <label className="col-10 col-lg-11 col-form-label text-primary">
                                Can I claim for baggage delay benefit if it is delay when returning to Home?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-2 col-lg-1"></div>
                            <div className="col-10 col-lg-11 col-form-label">
                                <p>
                                Unfortunately, the claim is not payable in respect of baggage delay on your return trip back to Your Home. The benefit pays for every 6 complete hours whereby your checked-in baggage is delayed, misdirected or temporarily misplaced by the airline operator from the time of your arrival at your scheduled destination till the time you received your baggage.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-2 col-lg-1 col-form-label text-center">14.</label>
                            <label className="col-10 col-lg-11 col-form-label text-primary">
                                Can the policy be cancelled?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-2 col-lg-1"></div>
                            <div className="col-10 col-lg-11 col-form-label">
                                <p>
                                Single Trip Cover:
                                </p>
                                <ol type="a">
                                    <li>
                                        We will refund in full the premium paid if you cancel the trip due to unforeseen circumstances prior to the date of departure and you will not make any claim for travel and cancellation charges.
                                    </li>
                                    <li>
                                        We will not refund any premium paid if you cancel the trip due to unforeseen circumstances prior to the date of departure and we have agreed to pay claims for travel and cancellation charges.
                                    </li>
                                    <li>
                                        We will not refund any premium paid if you cancel the policy due to reasons other than unforeseen circumstances prior to the date of departure.
                                    </li>
                                    <li>
                                        No refund is allowed for cancellation of policy after commencement of insurance.
                                    </li>
                                </ol>

                                <p>
                                Unforeseen Circumstances refers to:
                                </p>
                                <ul>
                                    <li>
                                        Your death or the death of an immediate family member; or
                                    </li>
                                    <li>
                                        Bodily Injury or sickness that requires treatment by a medical practitioner which results in that medical practitioner certifying in writing that you or an immediate family member is unfit to begin or continue the trip; or
                                    </li>
                                    <li>
                                        Unexpected outbreak or strike, riot or civil commotion arising out of circumstances beyond your control.
                                    </li>
                                </ul>

                                <p>
                                Annual Cover
                                </p>
                                <ul>
                                    <li>
                                        We will charge you the premium in accordance with the scale of refund if You cancel your Annual Cover Policy after commencement of insurance.
                                    </li>
                                    <li>
                                        We will not refund any premium paid if you cancel your Annual Cover Policy and We have agreed to pay any claim under the Policy or there has been an occurrence of any event for which a claim may be payable under the Policy. 
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-2 col-lg-1 col-form-label text-center">15.</label>
                            <label className="col-10 col-lg-11 col-form-label text-primary">
                                Can I purchase travel insurance after departure?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-2 col-lg-1"></div>
                            <div className="col-10 col-lg-11 col-form-label">
                                <p>
                                No, you must purchase travel insurance before your scheduled departure. Please purchase your insurance as early as possible to enjoy the Trip Cancellation benefit. Trip cancellation benefit will only be reimbursed if you purchase the insurance at a minimum of 7 days prior to commencement of your trip.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-2 col-lg-1 col-form-label text-center">16.</label>
                            <label className="col-10 col-lg-11 col-form-label text-primary">
                                I had extended my stay for my overseas trip, can I change my policy duration?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-2 col-lg-1"></div>
                            <div className="col-10 col-lg-11 col-form-label">
                                <p>
                                    Unfortunately, any amendments or changes must be made prior to your departure from Malaysia. Your insurance will be effective the moment you depart from Malaysia. No amendment/extension can be made after that.
                                </p>

                                <p>
                                    However, if you are hospitalized and/or quarantined overseas as recommended by a Physician which prohibits your return to Malaysia prior to the expiry of the Period of Insurance, the cover shall be automatically extended for up to 30 days from the expiry of the Period of Insurance for a trip without payment of any additional premium. This extension of cover shall be applicable if any of the benefits under the policy is payable in the first place and you have documented proof of the reasons for the delay unless you have our approval in writing. This extension of cover is applicable if you purchase worldwide travel for single trip return plan only.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-2 col-lg-1 col-form-label text-center">17.</label>
                            <label className="col-10 col-lg-11 col-form-label text-primary">
                                Do I need to do any test prior to my Trip for Covid-19 Coverage?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-2 col-lg-1"></div>
                            <div className="col-10 col-lg-11 col-form-label">
                                <p>
                                    Yes, Negative RTK/PCR test results taken within 72 hours prior to Scheduled Flight is a requirement for benefits under COVID-19 Coverage unless this is not part of the testing & quarantine procedure imposed by the government of the destination country at the time You travel into the Country of Arrival.
                                </p>

                            </div>
                        </div>
                    </div>

                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-2 col-lg-1 col-form-label text-center">18.</label>
                            <label className="col-10 col-lg-11 col-form-label text-primary">
                                Does this plan meet international government regulations and VTL (Vaccinated Travel Lane) requirements?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-2 col-lg-1"></div>
                            <div className="col-10 col-lg-11 col-form-label">
                                <p>
                                Requirements to enter other countries may change from time to time. Please ensure that the benefits provided for in your Travel Easy insurance (especially related to COVID-19) meets the entry regulations for the countries you are travelling to.
                                </p>

                            </div>
                        </div>
                    </div>

                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-2 col-lg-1 col-form-label text-center">19.</label>
                            <label className="col-10 col-lg-11 col-form-label text-primary">
                                Is there any after sales & claims services offered to customer after insurance purchase?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-2 col-lg-1"></div>
                            <div className="col-10 col-lg-11 col-form-label">
                                <p>
                                Yes, instaPol from Howden provides (1) Product Advisory, offering ongoing support to clients regarding insurance-related queries post-purchase (2) Assistance in changing / updating policy details (3) Claims assistance. Alternatively, you may also contact your chosen insurance company or takaful operator.
                                </p>

                            </div>
                        </div>
                    </div>

                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-2 col-lg-1 col-form-label text-center">20.</label>
                            <label className="col-10 col-lg-11 col-form-label text-primary">
                                Where can I get further information?
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-2 col-lg-1"></div>
                            <div className="col-10 col-lg-11 col-form-label">
                                <p>
                                Please contact us at +60122606183 [Monday to Friday, 8:45am to 5:45pm] or email us at <a href="mailto:insta.admin@howdengroup.com">insta.admin@howdengroup.com</a> 
                                </p>

                            </div>
                        </div>
                    </div>

                    <div className="question">
                        <div className="row text-primary fw-bold">
                            <label className="col-2 col-lg-1 col-form-label text-center">21.</label>
                            <label className="col-10 col-lg-11 col-form-label text-primary">
                                IMPORTANT NOTE:
                            </label>
                        </div>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-10 col-form-label">
                               <p>
                                You are advised to note the scale of benefits for death and disablement in your insurance Policy. You are advised to nominate a nominee and ensure that your nominee is aware of the personal accident policy that you have purchased. You should read and understand the insurance Policy and discuss with the agent or contact our company directly for more information. The information provided in this disclosure sheet is a summary for quick and easy reference. The full terms and conditions that apply are stated in the Policy Contract.
                               </p>
                            </div>
                        </div>
                    </div>
                </>
            );
        }

        else if (props.insurer === 'MSIG') {
            return (
                <>
                   
                    <div className="row mb-3">
                        <div className="question">
                            <div className="row text-primary fw-bold">
                                <label className="col-2 col-lg-1 col-form-label text-center">1.</label>
                                <label className="col-10 col-lg-11 col-form-label text-primary">
                                    Who is eligible to apply?
                                </label>
                            </div>
                            <div className="row">
                                <div className="col-2 col-lg-1"></div>
                                <div className="col-10 col-lg-11 col-form-label">
                                    <p>
                                        All Malaysians, Permanent Residents, Non Residents, Work Permit/Employment Pass Holders 
                                        or otherwise legally employed persons in Malaysia and their Dependents are eligible to apply.
                                        Family Plan is permitted for Single Trip only and the age limit of child is between 31 days and 17 years.
                                    </p>
                                    <p>
                                        For Annual Cover, all applicants must be between 18 to 69 years old at first enrolment.  Cover may be granted beyond age 70 provided you are enrolled in the Plan before that age and have remained continuously covered thereafter, up to maximum age of 80.
                                    </p>
                                    <p>
                                        For applicant age 70 years and above, please fill up the Proposal Form and contact us here <a href="https://takeiteasy.msig.com.my/msigonline/home/contact-us.html" target="_blank">contact us</a>  for acceptance consideration.
                                        
                                       
                                    </p>
                                    
                                </div>
                            </div>
                        </div>
                        <div className="question">
                            <div className="row text-primary fw-bold">
                                <label className="col-2 col-lg-1 col-form-label text-center">2.</label>
                                <label className="col-10 col-lg-11 col-form-label text-primary">
                                Can I buy a separate cover for my child?
                                </label>
                            </div>
                            <div className="row">
                                <div className="col-2 col-lg-1"></div>
                                <div className="col-10 col-lg-11 col-form-label">
                                    <p>
                                        Yes, the rate charged is based on the individual plan and for Single Trip only and 
                                        all the benefits are the same except for Death Benefit. A parent must sign the proposal 
                                        form on the life of the Insured Person.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="question">
                            <div className="row text-primary fw-bold">
                                <label className="col-2 col-lg-1 col-form-label text-center">3.</label>
                                <label className="col-10 col-lg-11 col-form-label text-primary">
                                How do I purchase the COVID-19 Benefit Add-On?
                                </label>
                            </div>
                            <div className="row">
                                <div className="col-2 col-lg-1"></div>
                                <div className="col-10 col-lg-11 col-form-label">
                                    <p>
                                    The COVID-19 Benefit Add-On plan is only applicable to Areas 1, 2 and 3 of 
                                    TravelRight Plus (Single trip). You have to correspond with the selected plan of the basic cover 
                                    when you apply for MSIG TravelRight Plus policy.
                                    </p>
                                    <p>
                                        See our detailed FAQ to learn more about the coverage of this add-on.  <br/>
                                        <a href="https://takeiteasy.msig.com.my/msigonline/resource/FAQ%20-%20COVID-19%20Add-On.pdf" target='_blank'>FAQ COVID-19 Add-on</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="question">
                            <div className="row text-primary fw-bold">
                                <label className="col-2 col-lg-1 col-form-label text-center">4.</label>
                                <label className="col-10 col-lg-11 col-form-label text-primary">
                                How do I purchase the Alternative Transport Top Up?
                                </label>
                            </div>
                            <div className="row">
                                <div className="col-2 col-lg-1"></div>
                                <div className="col-10 col-lg-11 col-form-label">
                                    <p>The Alternative Transport Top Up is available with our single trip and annual cover. 
                                        You'll have the option to choose the Alternative Transport Top Up plan which meet your needs when you 
                                        apply for MSIG TravelRight Plus policy.</p>
                                    <p>
                                        See our detailed FAQ to learn more about the coverage of this add-on. <br/>
                                        <a href="https://takeiteasy.msig.com.my/msigonline/resource/Alternative%20Transport%20Top%20Up%20-%20FAQ@02.11.22.pdf" target='_blank'>Alternative Transport Top Up FAQ</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="question">
                            <div className="row text-primary fw-bold">
                                <label className="col-2 col-lg-1 col-form-label text-center">5.</label>
                                <label className="col-10 col-lg-11 col-form-label text-primary">
                                I suffer from medical and physical conditions. Can I claim for medical/hospital and other related expenses 
                                if I require treatment while on my trip?
                                </label>
                            </div>
                            <div className="row">
                                <div className="col-2 col-lg-1"></div>
                                <div className="col-10 col-lg-11 col-form-label">
                                    <p>
                                    No, the policy excludes pre-existing conditions, i.e., any illness or injury that the Insured had 
                                    contracted, was diagnosed or treated for during the 12 months prior to the journey and whether or 
                                    not treatment, medication or advice was sought or received prior to the commencement of the journey.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="question">
                            <div className="row text-primary fw-bold">
                                <label className="col-2 col-lg-1 col-form-label text-center">6.</label>
                                <label className="col-10 col-lg-11 col-form-label text-primary">
                                Can I continue my medical treatment for any injury sustained during my overseas trip, after my return home?
                                </label>
                            </div>
                            <div className="row">
                                <div className="col-2 col-lg-1"></div>
                                <div className="col-10 col-lg-11 col-form-label">
                                    <p>
                                        Yes, you have a maximum of 45 days to undergo follow-up treatment subject to your plan’s benefit limits.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="question">
                            <div className="row text-primary fw-bold">
                                <label className="col-2 col-lg-1 col-form-label text-center">7.</label>
                                <label className="col-10 col-lg-11 col-form-label text-primary">
                                Can I claim for travel delay in the event of a terrorist attack at the Airport?
                                </label>
                            </div>
                            <div className="row">
                                <div className="col-2 col-lg-1"></div>
                                <div className="col-10 col-lg-11 col-form-label">
                                    <p>
                                        No. Terrorism Extension only covers the Insured Person in respect of death or bodily 
                                        injury caused by third party acts of terrorism provided that such acts of terrorism do not 
                                        involve the use of biological, chemical agents or nuclear devices.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="question">
                            <div className="row text-primary fw-bold">
                                <label className="col-2 col-lg-1 col-form-label text-center">8.</label>
                                <label className="col-10 col-lg-11 col-form-label text-primary">
                                Can I seek reimbursement for non-refundable expenses that I had paid if I have to cancel my 
                                trip due to a serious illness?
                                </label>
                            </div>
                            <div className="row">
                                <div className="col-2 col-lg-1"></div>
                                <div className="col-10 col-lg-11 col-form-label">
                                    <p>
                                        A claim under Section 7 will be payable if your trip is cancelled due to serious injury or 
                                        illness which requires hospitalisation or compulsory quarantine, and if you are unfit to 
                                        travel as certified by a Medical Practitioner.
                                    </p>
                                    <p>
                                        For this section to be payable, the insurance must be purchased no later than 7 days 
                                        before the commencement date of your journey.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="question">
                            <div className="row text-primary fw-bold">
                                <label className="col-2 col-lg-1 col-form-label text-center">9.</label>
                                <label className="col-10 col-lg-11 col-form-label text-primary">
                                How do I cancel my policy and get a refund of the premiums paid?
                                </label>
                            </div>
                            <div className="row">
                                <div className="col-2 col-lg-1"></div>
                                <div className="col-10 col-lg-11 col-form-label">
                                    <p>
                                        <ol type="a">
                                            <li>
                                            For Single Trip policy, you may cancel this policy before the commencement of 
                                            your journey by giving us 7 days' written notice. You are entitled to a refund of the premium paid 
                                            for this policy.
                                            </li>

                                            <li>
                                                For Annual Policy, you may cancel this policy by giving us 7 days' written notice. 
                                                You are entitled to a short rate refund as per policy wording.
                                            </li>
                                        </ol>
                                       
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="question">
                            <div className="row text-primary fw-bold">
                                <label className="col-2 col-lg-1 col-form-label text-center">10.</label>
                                <label className="col-10 col-lg-11 col-form-label text-primary">
                                    How do I make a claim?
                                </label>
                            </div>
                            <div className="row">
                                <div className="col-2 col-lg-1"></div>
                                <div className="col-10 col-lg-11 col-form-label">
                                    <p>
                                        You can submit your claim notification online at : <br/>
                                        <a href="https://takeiteasy.msig.com.my/msigonline/make-a-claim/claim.html" target="_blank">claim notification online</a>
                                        <br/>
                                        or <br/>
                                        by providing us with written notice together with the completed claim form and all relevant documents as per the Documents Checklist either by mail, email or walk in to our office as soon as you have returned from your trip in respect of any event that may give rise to a claim. <br/>
                                        You may download a copy of the claim form or contact any MSIG Branch to obtain the claim form. <br/>
                                        <a href="https://www.msig.com.my/PDF/TravelRightPlusInsuranceClaimForm.pdf" target="_blank">TravelRight Plus Insurance Claim Form</a>
                                    </p>
                                       
                                    <p>
                                        Documents Checklist
                                        <ol type="1">
                                            <li>
                                                Tour Operator's Confirmation of Booking Invoice
                                            </li>
                                            <li>
                                                Copies of Airline tickets, electronic tickets or boarding passes
                                            </li>
                                            <li>
                                                Original receipts for all medical bills and reports and confirmation of admittance and discharge from hospital of medical claims
                                            </li>
                                            <li>
                                                Original receipts for all items claimed
                                            </li>
                                            <li>
                                                Irregularity report from airline if baggage is lost or damaged by the airline
                                            </li>
                                            <li>
                                                Written confirmation from airline/shipping lines regarding the period of delay
                                                and the reasons if you are claiming for Luggage Delay/Travel Delay/Missed
                                                Travel Connection/Travel Overbooked/ Missed Departure/
                                                Travel Reroute/Alternative Transport Arrangement
                                            </li>
                                            <li>
                                                Police Report & Currency Exchange Slip for Money and Theft Claims
                                            </li>
                                            <li>
                                                Written confirmation from hotels or handling agents in respect of claim for loss of use of hotel facilities
                                            </li>
                                            <li>
                                                Police Report or Bomba Report for claim on Home Protection
                                            </li>
                                        </ol>
                                        
                                    </p>   

                                    <p>
                                    If you have any clarification or need assistance, please contact MSIG Customer Service Hotline or any MSIG Branch.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="question">
                            <div className="row text-primary fw-bold">
                                <label className="col-2 col-lg-1 col-form-label text-center">11.</label>
                                <label className="col-10 col-lg-11 col-form-label text-primary">
                                How do I lodge a complaint if I am unhappy with the product or services?
                                </label>
                            </div>
                            <div className="row">
                                <div className="col-2 col-lg-1"></div>
                                <div className="col-10 col-lg-11 col-form-label">
                                    <p>
                                        If you have a complaint about our products or services, or you are not satisfied with the rejection 
                                        or offer for any settlement of a claim, you should first try to resolve the complaint with our
                                         Customer Service Centre.
                                    </p>

                                    <p>
                                        MSIG Customer Service <br/>
                                        Customer Service Department <br/>
                                        MSIG Insurance (Malaysia) Bhd <br/>
                                        Level 15, Menara Hap Seng 2 <br/>
                                        Plaza Hap Seng <br/>
                                        No. 1, Jalan P. Ramlee <br/>
                                        50250 Kuala Lumpur <br/>
                                    </p>

                                    <p>
                                    Telephone : 1-800-88-6744 <br/>
                                    Facsimile : 03-2026 8086 <br/>
                                    Email : msig_online@my.msig-asia.com <br/>
                                    Website	: www.msig.com.my <br/>

                                    </p>
                                    <p>
                                        If you are still not satisfied with the decision, you can refer either to the Customer Services 
                                        Bureau of Bank Negara Malaysia or Ombudsman for Financial Services (OFS), free of charge. <br/>
                                        Bank Negara Malaysia (BNM) <br/>
                                        Pengarah <br/>
                                        Jabatan LINK & Pejabat Wilayah <br/>
                                        Bank Negara Malaysia <br/>
                                        P.O. Box 10922 <br/>
                                        50929 Kuala Lumpur <br/>
                                        Telephone : 1-300-88-5465 <br/>
                                        Facsimile : 03-2174 1515 <br/>
                                        Email : bnmtelelink@bnm.gov.my <br/>
                                    </p>

                                    <p>
                                        Ombudsman for Financial Services (OFS) <br/>
                                        Level 14, Main Block <br/>
                                        Menara Takaful Malaysia <br/>
                                        No.4, Jalan Sultan Sulaiman <br/>
                                        50000 Kuala Lumpur <br/>
                                        Telephone : 03-2272 2811 <br/>
                                        Facsimile : 03-2272 1577 <br/>
                                        Email : enquiry@ofs.org.my <br/>
                                    </p>

                                    <p>
                                        Disclaimer for FAQ <br/>
                                        The FAQs compiled herein are merely informational and not intended to be construed as a 
                                        contract of insurance. While every effort has been made to ensure that the information 
                                        contained herein is accurate and up to date, this is not always possible. 
                                        Please refer to actual policy for exact terms and conditions of the insurance product that 
                                        you are purchasing.
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>

                </>
            );
        }

        else if (props.insurer === 'RHBI') {
            return (
                <>
                   
                    <div className="row3 mb-3">
                        <div className="question">
                            <div className="row text-primary fw-bold">
                                <label className="col-2 col-lg-1 col-form-label text-center">1.</label>
                                <label className="col-10 col-lg-11 col-form-label text-primary">
                                    What is Travel Protector Plus Insurance?
                                </label>
                            </div>
                            <div className="row">
                                <div className="col-2 col-lg-1"></div>
                                <div className="col-10 col-lg-11 col-form-label">
                                    <p>
                                        This is a comprehensive Travel Insurance that provides compensation for Accidental Death, 
                                        Bodily Injury or Illness and Travel Inconveniences during your trip. 
                                        Please refer to the Table of Benefit below for the full product coverage. 
                                        This product is available for Domestic and Overseas travelling, and designed for Individual, 
                                        Individual & Spouse and Family plan.
                                    </p>   
                                </div>
                            </div>
                        </div>
                        <div className="question">
                            <div className="row text-primary fw-bold">
                                <label className="col-2 col-lg-1 col-form-label text-center">2.</label>
                                <label className="col-10 col-lg-11 col-form-label text-primary">
                                    Who is eligible?
                                </label>
                            </div>
                            <div className="row">
                                <div className="col-2 col-lg-1"></div>
                                <div className="col-10 col-lg-11 col-form-label">
                                    <p>
                                        All Malaysians, Malaysian Permanent Residents, and holders of valid working permits or dependent 
                                        passes in Malaysia
                                    </p>
                                    <p>
                                        Adult : 19 to 80 years old
                                    </p>
                                    <p>
                                        Children : 30 days up to 19 years old and is extended up to age of 23 if still studying, 
                                        unmarried and not gainfully employed
                                    </p>
                                    
                                </div>
                            </div>
                        </div>

                      

                        <div className="question">
                            <div className="row text-primary fw-bold">
                                <label className="col-2 col-lg-1 col-form-label text-center">3.</label>
                                <label className="col-10 col-lg-11 col-form-label text-primary">
                                What are the benefits provided?
                                </label>
                            </div>
                            <div className="row">
                                <div className="col-2 col-lg-1"></div>
                                <div className="col-10 col-lg-11 col-form-label">
                                    <p>
                                        Personal Accident Benefits
                                    </p>
                                    <p>
                                        Medical and Other Expenses (including COVID-19 Medical Expenses)
                                    </p>
                                    <p>
                                        Medical Evacuation & Repatriation
                                    </p>
                                    <p>
                                        Personal Luggage & Personal Effects
                                    </p>
                                    <p>
                                        Luggage Delay
                                    </p>
                                    <p>
                                        Personal Money & Travel Documents
                                    </p>
                                    <p>
                                        Trip Cancellation and Curtailment
                                    </p>
                                    <p>
                                        Travel Delay and Missed Departure
                                    </p>
                                    <p>
                                        Personal Liability
                                    </p>
                                    <p>
                                        Hijacking Inconvenience: Payment in case of hijacking
                                    </p>
                                    <p>
                                        Travel Overbooked and Postponement
                                    </p>
                                    <p>
                                        Loss of Deposit due to Abscondment or Insolvency of Travel Agency
                                    </p>
                                    <p>
                                        Travel Misconnection
                                    </p>
                                    <p>
                                        Credit Card Indemnity
                                    </p>
                                    <p>
                                        Home Care
                                    </p>
                                    <p>
                                        Emergency Medical Assistance Services
                                    </p>
                                    <p>
                                        Full Terrorism Cover
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="question">
                            <div className="row text-primary fw-bold">
                                <label className="col-2 col-lg-1 col-form-label text-center">4.</label>
                                <label className="col-10 col-lg-11 col-form-label text-primary">
                                    How much does the premium cost?
                                </label>
                            </div>
                            <div className="row">
                                <div className="col-2 col-lg-1"></div>
                                <div className="col-10 col-lg-11 col-form-label">
                                    
                                    <p>
                                    The premium varies based on the plan chosen and region of travel for individual, spouse, and family plans, and varies by the duration of travel.  Please refer to the Product Disclosure Sheet. 
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="question">
                            <div className="row text-primary fw-bold">
                                <label className="col-2 col-lg-1 col-form-label text-center">5.</label>
                                <label className="col-10 col-lg-11 col-form-label text-primary">
                                    How can I get emergency assistance while traveling?
                                </label>
                            </div>
                            <div className="row">
                                <div className="col-2 col-lg-1"></div>
                                <div className="col-10 col-lg-11 col-form-label">
                                    <p>
                                        You can get 24-hour assistance worldwide by calling 03-7965 3833.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="question">
                            <div className="row text-primary fw-bold">
                                <label className="col-2 col-lg-1 col-form-label text-center">6.</label>
                                <label className="col-10 col-lg-11 col-form-label text-primary">
                                    Does Travel Protector Plus cover medical expenses for COVID-19?
                                </label>
                            </div>
                            <div className="row">
                                <div className="col-2 col-lg-1"></div>
                                <div className="col-10 col-lg-11 col-form-label">
                                    <p>
                                    Yes. Provided you are hospitalized while travelling overseas.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="question">
                            <div className="row text-primary fw-bold">
                                <label className="col-2 col-lg-1 col-form-label text-center">7.</label>
                                <label className="col-10 col-lg-11 col-form-label text-primary">
                                    Are One-Way trips covered under Medical Expenses coverage due to COVID-19?
                                </label>
                            </div>
                            <div className="row">
                                <div className="col-2 col-lg-1"></div>
                                <div className="col-10 col-lg-11 col-form-label">
                                    <p>
                                        No. Only Return Trips are covered under Medical Expenses due to COVID-19.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="question">
                            <div className="row text-primary fw-bold">
                                <label className="col-2 col-lg-1 col-form-label text-center">8.</label>
                                <label className="col-10 col-lg-11 col-form-label text-primary">
                                    Does the medical expenses cover the cost of COVID-19 tests?
                                </label>
                            </div>
                            <div className="row">
                                <div className="col-2 col-lg-1"></div>
                                <div className="col-10 col-lg-11 col-form-label">
                                    <p>
                                    No, it does not cover the cost of your COVID-19 tests.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="question">
                            <div className="row text-primary fw-bold">
                                <label className="col-2 col-lg-1 col-form-label text-center">9.</label>
                                <label className="col-10 col-lg-11 col-form-label text-primary">
                                    Am I eligible to purchase if I am not vaccinated or partially vaccinated?
                                </label>
                            </div>
                            <div className="row">
                                <div className="col-2 col-lg-1"></div>
                                <div className="col-10 col-lg-11 col-form-label">
                                    <p>
                                        No.  You must be fully vaccinated.
                                       
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="question">
                            <div className="row text-primary fw-bold">
                                <label className="col-2 col-lg-1 col-form-label text-center">10.</label>
                                <label className="col-10 col-lg-11 col-form-label text-primary">
                                    Can I use Cashless Admission for treatment due to COVID-19?
                                </label>
                            </div>
                            <div className="row">
                                <div className="col-2 col-lg-1"></div>
                                <div className="col-10 col-lg-11 col-form-label">
                                    <p>
                                    No. The coverage is on reimbursement basis only.
                                    </p>
                                    
                                </div>
                            </div>
                        </div>

                        <div className="question">
                            <div className="row text-primary fw-bold">
                                <label className="col-2 col-lg-1 col-form-label text-center">11.</label>
                                <label className="col-10 col-lg-11 col-form-label text-primary">
                                    Can I cancel my policy?
                                </label>
                            </div>
                            <div className="row">
                                <div className="col-2 col-lg-1"></div>
                                <div className="col-10 col-lg-11 col-form-label">
                                    <p>
                                    This Policy may be cancelled by the Insured at any time by giving written notice to the Insurance Company to terminate cover. Such termination shall become effective on the date the notice is received by the Insurance Company or the date specified in the notice, whichever is earlier. No premium will be refunded upon cancellation of cover.
                                    </p>

                                    
                                </div>
                            </div>
                        </div>

                        <div className="question">
                            <div className="row text-primary fw-bold">
                                <label className="col-2 col-lg-1 col-form-label text-center">12.</label>
                                <label className="col-10 col-lg-11 col-form-label text-primary">
                                    How do I make a claim?
                                </label>
                            </div>
                            <div className="row">
                                <div className="col-2 col-lg-1"></div>
                                <div className="col-10 col-lg-11 col-form-label">
                                    <p>
                                    Please contact :
                                    </p>

                                    <div class="row">
                                        <div class="col-4"><strong>Customer Service Careline</strong></div>
                                        <div class="col-8"> 
                                            +60122606183 <br/>
                                            Monday to Friday<br/>
                                        </div>
                                    </div>

                                    {/* <p>
                                        <strong>Customer Service Careline </strong><br/>
                                        +60122606183 <br/>
                                        Monday to Friday<br/>
                                    </p> */}

                                    <div class="row">
                                        <div class="col-4"><strong>WhatsApp No.</strong></div>
                                        <div class="col-8"> 
                                            +60122606183<br/>
                                        </div>
                                    </div>

                                    {/* <p>
                                        <strong>WhatsApp No.</strong><br/>
                                        +60122606183<br/>
                                    </p> */}

                                    <div class="row">
                                        <div class="col-4"><strong>Email</strong></div>
                                        <div class="col-8"> 
                                            insta.admin@howdengroup.com<br/>
                                        </div>
                                    </div>
                                    
                                    {/* <p>
                                        <strong>Email</strong><br/>
                                        insta.admin@howdengroup.com<br/>
                                    </p> */}

                                </div>
                            </div>
                        </div>

                        <div className="question">
                            <div className="row text-primary fw-bold">
                                <label className="col-2 col-lg-1 col-form-label text-center">13.</label>
                                <label className="col-10 col-lg-11 col-form-label text-primary">
                                    What are the major exclusions under this policy?
                                </label>
                            </div>
                            <div className="row">
                                <div className="col-2 col-lg-1"></div>
                                <div className="col-10 col-lg-11 col-form-label">
                                    <p>
                                    This Insurance does not cover death, permanent disablement, bodily injury, any hospitalization caused indirectly or directly wholly or partly by any one of the following occurrences: -
                                    </p>

                                    <p>
                                        <ol class="k">
                                            <li>
                                                Suicide or attempted suicide, self-inflicted injuries, self-destruction or any attempt thereat while sane or insane.
                                            </li>
                                            <li>
                                                While participating in any professional sports;
                                            </li>
                                            <li>
                                                While committing or attempting to commit any unlawful act;
                                            </li>
                                            <li>
                                                Childbirth, miscarriage, pregnancy or any complications thereof;
                                            </li>
                                            <li>
                                                Acquired Immune Deficiency Syndrome (AIDS) or AIDS Related Complex (ARC) however this syndrome has been acquired or may be named.
                                            </li>
                                            <li>
                                                Travelling as aircraft crew.
                                            </li>
                                            <li>
                                                Medication, which at the time of departure is known to be required or to be continued outside the home territory.
                                            </li>
                                            <li>
                                                Treatment or services provided by a health spa, convalescent or nursing home or any rehabilitation center.
                                            </li>
                                            <li>
                                                You receiving in-patient treatment or are on a waiting list for in-patient treatment.
                                            </li>
                                            <li>
                                                You have received a terminal prognosis.
                                            </li>
                                            <li>
                                                Travelling against the advice of a medical practitioner, or in order to obtain medical advice or treatment abroad.
                                            </li>
                                            <li>
                                                You being under the influence of drugs or other substance abuse (other than those prescribed by a registered medical practitioner but not when.
                                                <ol class="k">
                                                    <li>
                                                        prescribed for the treatment of drug addiction.
                                                    </li>
                                                    <li>
                                                        You being under the influence of alcohol or intoxicating liquor.
                                                    </li>
                                                    <li>
                                                        Pre-existing condition.
                                                    </li>
                                                    <li>
                                                        Cosmetic surgery
                                                    </li>
                                                    <li>
                                                        Non-emergency medical check-ups.
                                                    </li>
                                                    <li>
                                                        Failure to obtain required vaccinations before departure.
                                                    </li>
                                                    <li>
                                                        Illness or disorders of a psychological nature, nervous depressions, any anxiety state and/or nervous depressions, mental illness.
                                                    </li>
                                                    <li>
                                                        Any loss resulting directly and indirectly from contagious disease that is declared as epidemic/pandemic issued by the World Health.
                                                    </li>
                                                    <li>
                                                        Organization (except for Covid-19 medical expenses incurred while travelling overseas but excluding the costs of isolation, quarantine and Covid-19 test.
                                                    </li>
                                                </ol>      
                                            </li>
                                        </ol>
                                    </p> 

                                    <p>
                                        Note: These exclusions are non-exhaustive. Please refer to Policy Wordings for full details.
                                    </p>
                                
                                </div>
                            </div>
                        </div>

                        <div className="question">
                            <div className="row text-primary fw-bold">
                                <label className="col-2 col-lg-1 col-form-label text-center">14.</label>
                                <label className="col-10 col-lg-11 col-form-label text-primary">
                                    Is there any after sales & claims services offered to customer after insurance purchase?
                                </label>
                            </div>
                            <div className="row">
                                <div className="col-2 col-lg-1"></div>
                                <div className="col-10 col-lg-11 col-form-label">
                                    <p>
                                    Yes, instaPol from Howden provides (1) Product Advisory, offering ongoing support to clients regarding insurance-related queries post-purchase (2) Assistance in changing / updating policy details (3) Claims assistance. Alternatively, you may also contact your chosen insurance company or takaful operator.
                                    </p>

                                    
                                </div>
                            </div>
                        </div>

                        <div className="question">
                            <div className="row text-primary fw-bold">
                                <label className="col-2 col-lg-1 col-form-label text-center">
                                    &nbsp;
                                </label>
                                <label className="col-10 col-lg-11 col-form-label text-primary">
                                 Disclaimer for FAQ
                                </label>
                                
                            </div>
                            <div className="row">
                                <div className="col-2 col-lg-1"></div>
                                <div className="col-10 col-lg-11 col-form-label">
                                    <p>
                                    The FAQs compiled herein are merely informational and not intended to be construed as a contract of insurance. While every effort has been made to ensure that the information contained herein is accurate and up to date, this is not always possible. Please refer to actual policy for exact terms and conditions of the insurance product that you are purchasing.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="question">
                            <div className="row text-primary fw-bold">
                                <label className="col-2 col-lg-1 col-form-label text-center">
                                    &nbsp;
                                </label>
                                <label className="col-10 col-lg-11 col-form-label text-primary">
                                IMPORTANT NOTE :
                                </label>
                                
                            </div>
                            <div className="row">
                                <div className="col-2 col-lg-1"></div>
                                <div className="col-10 col-lg-11 col-form-label">
                                    <p>
                                    YOU ARE ADVISED TO NOTE THE SCALES OF BENEFITS FOR DEATH AND DISABLEMENT IN YOUR INSURANCE POLICY. YOU MUST NOMINATE A NOMINEE AND ENSURE THAT YOUR NOMINEE IS AWARE OF THE PERSONAL ACCIDENT POLICY THAT YOU HAVE PURCHASED. YOU SHOULD READ AND UNDERSTAND THE INSURANCE POLICY AND DISCUSS WITH THE AGENT OR CONTACT THE INSURANCE COMPANY DIRECTLY FOR MORE INFORMATION.
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>

                </>
            );
        }

        return null;
    }

    return (
        ((!isEmpty(allPlans) && showAllPlans == true) || showManualPlans == true)  ?
            <Form onSubmit={(e) => onClickNext(e)}>
                <div className="mb-3 row justify-content-around">
                    {allPlans.map((plan, index) => (
                        <div className={ renewalPlan == plan.plan ? 'col-11 border shadow rounded mb-3 mb-0 m-md-3 bg-renewal' : 'col-11 border shadow rounded mb-3 mb-0 m-md-3'}>
                            <div className="row">
                                <div className="col-12">
                                    <div className="row p-3">
                                        
                                        <div className="col-12 col-sm-8 text-center align-self-center">
                                            <div className="row">
                                                <div className="col-12">
                                                    <p className="text-primary">{plan.product.toUpperCase() + ' - ' + plan.plan.toUpperCase()}</p>
                                                </div>
                                            </div>
                                            <div className="row mt-3 d-none d-md-flex align-items-center">
                                                <SumInsured plan={plan} />
                                            </div>
                                        </div>

                                        <div className="col-12 col-sm-4 text-center align-self-center">
                                            <div className="row">
                                                <div className="col-12">
                                                    <img src={"../images/" + plan.insurer.toLowerCase() + ".png"} alt={plan.insurer} className="img-fluid" width={120} />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-12 px-0">
                                                    <h4 className="fw-bold text-primary">
                                                      {(plan.insurer == insurer_msig || plan.insurer == insurer_rhbi || plan.insurer == insurer_tune) ? 'RM ' + parseFloat(plan.totalAmount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 'RM ' + parseFloat(plan.premium).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} 
                                                    </h4>
                                                    {(plan.insurer == insurer_msig || plan.insurer == insurer_rhbi  || plan.insurer == insurer_tune) ?
                                                         <span>
                                                            <small>including {process.env.MIX_SERVICE_CHARGE_RATE}% ST</small><br/>
                                                            <small>Stamp Duty RM {parseFloat(plan.stampDuty)}</small><br/>
                                                         </span>
                                                        : <small>including {process.env.MIX_SERVICE_CHARGE_RATE}% ST and Stamp Duty (if applicable)</small>
                                                    }

                                                    {(plan.insurer == insurer_msig || plan.insurer == insurer_rhbi  || plan.insurer == insurer_tune) &&  plan.discount > 0?
                                                        <small>Discount RM {parseFloat(plan.discount)}</small>
                                                        : ''
                                                    }
                                                    
                                                </div>
                                            </div>
                                            <div className="row mt-3">
                                                <div className="col-12 px-0">
                                                    <Button
                                                        variant={(planId && planId === plan.planId) ? ' btn-primary active' : ' border border-primary'}
                                                        className="px-2 px-sm-5"
                                                        value={JSON.stringify(plan)}
                                                        onClick={(e) => ChangeSelectedPlan(JSON.parse(e.currentTarget.value))}
                                                    >
                                                        Select
                                                    </Button>  
                                                </div>
                                                <div className="col-12 px-0">
                                                    <a href={"../storage/pdf/PDS_" + plan.insurer.toLowerCase() + ".pdf"} className="text-decoration-primary" target="_blank">
                                                        Product Disclosure Sheet
                                                    </a>
                                                </div>
                                                <div className="col-12 px-0">
                                                    {/*<a href={"../storage/pdf/" + plan.product.toLowerCase().replace(/\s/g, '') + "(" + plan.plan.toLowerCase() + ")" + ".pdf"} className="text-decoration-primary" target="_blank">
                                                        Schedule of Benefits
                                                </a> */}
                                                        
                                                 <a href={"../storage/pdf/POLICY_WORDING_" + plan.insurer.toLowerCase()+".pdf"} className="text-decoration-primary" target="_blank">
                                                        Policy Wording
                                                    </a>
                                                </div>

                                                 {/* Start: Keys Benefits for mobile phone*/}
                                                <div class="col-12 px-0 d-block d-md-none mt-2">
                                                    <div class="">
                                                        <div class="row">
                                                            <div class="col-12">
                                                                <label class="fw-bold">Key Benefits</label>
                                                                <ul class="list-group list-group-flush">
                                                                    <KeyBenefits plan={plan} />
                                                                   
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>


                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            {/* Start: More Benefits */}
                            {/* <div className='row rounded'>
                                <div className="col-12 rounded px-0 border">
                                    <Accordion className="rounded">
                                        <Card className="rounded">
                                            <div className="row">

                                                <div className="col-12 col-sm-12 pe-0">
                                                    <Accordion.Toggle
                                                        as={Card.Header}
                                                        eventKey={plan.product + index + ' bnf'}
                                                        className={
                                                            activeEventKey === plan.product + index + ' bnf' ?
                                                                "bg-primary text-center text-white h-100 clickable" :
                                                                "bg-transparent text-center text-dark h-100 clickable"
                                                        }
                                                        onClick={() => setActiveEventKey(activeEventKey === plan.product + index + ' bnf' ? '' : plan.product + index + ' bnf')}
                                                    >
                                                        <span className="clickable">More Benefits</span>
                                                    </Accordion.Toggle>
                                                </div>

                                            </div>
                                            <Accordion.Collapse eventKey={plan.product + index + ' bnf'}>
                                                <Card.Body>
                                                    <div className="row">
                                                        <div className="col-12">
                                                            <MoreBenefits insurer={plan.insurer} plan={plan} />
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Accordion.Collapse>
                                        </Card>
                                    </Accordion>
                                </div>
                            </div> */}
                            {/* End: More Benefits */}

                            <div className={plan.hideOverviewFaq !== true ? ' row rounded': ' d-none'}>
                                <div className="col-12 rounded px-0 border">
                                    <Accordion className="rounded">
                                        <Card className="rounded">
                                            <div className="row">

                                                <div className="col-12 col-sm-6 pe-0">
                                                    <Accordion.Toggle
                                                        as={Card.Header}
                                                        eventKey={plan.product + index + ' bnf'}
                                                        className={
                                                            activeEventKey === plan.product + index + ' bnf' ?
                                                                "bg-primary text-center text-white h-100 clickable" :
                                                                "bg-transparent text-center text-dark h-100 clickable"
                                                        }
                                                        onClick={() => setActiveEventKey(activeEventKey === plan.product + index + ' bnf' ? '' : plan.product + index + ' bnf')}
                                                    >
                                                        <span className="clickable">More Benefits</span>
                                                    </Accordion.Toggle>
                                                </div>

                                                {/* <div className="col-12 col-sm-3 px-0 border-start">
                                                    <Accordion.Toggle
                                                        as={Card.Header}
                                                        eventKey={plan.product + index + ' ovr'}
                                                        className={
                                                            activeEventKey === plan.product + index + ' ovr' ?
                                                                "bg-primary text-center text-white h-100 clickable" :
                                                                "bg-transparent text-center text-dark h-100 clickable"
                                                        }
                                                        onClick={() => setActiveEventKey(activeEventKey === plan.product + index + ' ovr' ? '' : plan.product + index + ' ovr')}
                                                    >
                                                        <span className="clickable">Overview</span>
                                                    </Accordion.Toggle>
                                                </div>

                                                <div className="col-12 col-sm-3 px-0 border-start">
                                                    <Accordion.Toggle
                                                        as={Card.Header}
                                                        eventKey={plan.product + index + ' pd'}
                                                        className={
                                                            activeEventKey === plan.product + index + ' pd' ?
                                                                "bg-primary text-center text-white h-100 clickable" :
                                                                "bg-transparent text-center text-dark h-100 clickable"
                                                        }
                                                        onClick={() => setActiveEventKey(activeEventKey === plan.product + index + ' pd' ? '' : plan.product + index + ' pd')}
                                                    >
                                                        <span className="clickable">Policy Details</span>
                                                    </Accordion.Toggle>
                                                </div> */}

                                               
                                                <div className="col-12 col-sm-6 ps-0 border-start">
                                                    <Accordion.Toggle
                                                        as={Card.Header}
                                                        eventKey={plan.product + index + ' faq'}
                                                        className={
                                                            activeEventKey === plan.product + index + ' faq' ?
                                                                "bg-primary text-center text-white h-100 clickable" :
                                                                "bg-transparent text-center text-dark h-100 clickable"
                                                        }
                                                        onClick={() => setActiveEventKey(activeEventKey === plan.product + index + ' faq' ? '' : plan.product + index + ' faq')}
                                                    >
                                                        <span className="clickable">FAQ</span>
                                                    </Accordion.Toggle>
                                                </div>

                                            </div>
                                            <Accordion.Collapse eventKey={plan.product + index + ' ovr'}>
                                                <Card.Body>
                                                    <div className="row">
                                                        <div className="col-12">
                                                            <Overview insurer={plan.insurer} plan={plan} />
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Accordion.Collapse>
                                            <Accordion.Collapse eventKey={plan.product + index + ' pd'}>
                                                <Card.Body>
                                                    <div className="row">
                                                        <div className="col-12">
                                                            <PolicyDetails insurer={plan.insurer} />
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Accordion.Collapse>
                                            <Accordion.Collapse eventKey={plan.product + index + ' sob'}>
                                                <Card.Body>
                                                    <div className="row">
                                                        <div className="col-12 d-md-none">
                                                            <p>Swipe left to see more <i class="fas fa-angle-double-right animate-left-right ml-1"></i></p>
                                                        </div>
                                                        <div className="col-12">
                                                            <Table responsive>
                                                                <thead>
                                                                    <tr>
                                                                        <th>Schedule of Benefits (applicable for Overseas Trip Only)</th>
                                                                        <th>Limit per Person / Event</th>
                                                                        <th className="col-3">Sum Insured (RM)</th>
                                                                    </tr>
                                                                </thead>

                                                                <tbody>
                                                                    <ScheduleOfBenefits plan={plan} />
                                                                </tbody>
                                                            </Table>
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Accordion.Collapse>
                                            <Accordion.Collapse eventKey={plan.product + index + ' faq'}>
                                                <Card.Body>
                                                    <div className="row">
                                                        <div className="col-12">
                                                            <FAQ insurer={plan.insurer} />
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Accordion.Collapse>
                                            <Accordion.Collapse eventKey={plan.product + index + ' bnf'}>
                                                <Card.Body>
                                                    <div className="row">
                                                        <div className="col-12">
                                                            <MoreBenefits insurer={plan.insurer} plan={plan} />
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Accordion.Collapse>
                                        </Card>
                                    </Accordion>
                                </div>
                            </div>

                        </div>
                    ))}

                    {/* Manual Plan Start */}
                    
                    {/* CHUBB */}
                    {props.travelInfo.allowManual == true || allowManualFromParam == true ?
                        <>
                        {manualInsurers.map((manualInsurer, index) => (
                            <div className={ renewalInsurer.toUpperCase() == manualInsurer.toUpperCase() ? 'col-11 border shadow rounded mb-3 mb-0 m-md-3 bg-renewal' : 'col-11 border shadow rounded mb-3 mb-0 m-md-3'}>
                                <div className="row">
                                    <div className="col-12">
                                        <div className="row p-3">
                                            
                                            <div className="col-12 col-sm-7 text-center align-self-center">
                                                <div className="row">
                                                    <div className="col-12">
                                                        <p className="text-primary">{getManualPlanName(manualInsurer)}</p>
                                                    </div>
                                                </div>
                                                
                                            </div>

                                            <div className="col-12 col-sm-5 text-center align-self-center">
                                                <div className="row">
                                                    <div className="col-12">
                                                        <img src={"../images/" + manualInsurer.toLowerCase() + ".png"} alt={manualInsurer.toUpperCase()} className="img-fluid" width={120} />
                                                    </div>
                                                </div>
                                                
                                                <div className="row mt-3">
                                                    <div className="col-12 px-0">
                                                        <Button
                                                            variant={(manualPlan && manualPlan == manualInsurer) ? ' btn-primary active' : ' border border-primary'}
                                                            className="px-2 px-sm-5 btn-manual-plans"
                                                            value={manualInsurer}
                                                            onClick={(e) => changeManualPlan(e.currentTarget.value)}
                                                        >
                                                            View More Plans
                                                        </Button>  
                                                    </div>
                                                    <div className="col-12 px-0">
                                                        <a href={"../storage/pdf/PDS_"+manualInsurer.toLowerCase()+".pdf"} className="text-decoration-primary" target="_blank">
                                                            Product Disclosure Sheet
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}

                        </>
                        :

                        null
                    }

                    {/* Manual Plan End */}

                   
                </div>
                <div class="d-flex justify-content-between mt-3">
                </div>
                <div className="mb-3 row">
                    <div className="col-sm-12" >
                        <button type="button" id="btn-back" class="btn btn-secondary" onClick={() => { onClickBack() }}>Back</button>
                    </div>
                </div>
                {/*<div className="mb-3 row ">
                <div className="col-sm-12 text-end">
                    <Button type="submit" variant="success" disabled={isEmpty(selectedPlan) ? 'disabled' : ''}>Continue</Button>
                </div>
            </div>*/}
            </Form>
            :
            <>
                <div className="row">
                    {((isEmpty(allPlans) &&  showAllPlans == true)  && showManualPlans == false) ?
                    <div className="col-12 text-center">
                        No Available Plans Found.
                    </div>
                    :
                    null
                    }
                </div>
                <div className="row">
                    <div className="col-12 text-end">
                        <Button type="button" variant="secondary" className="mr-3" onClick={() => { props.setActiveId('travel') }}>Back</Button>
                    </div>
                </div>
            </>
    );
}

function AddOn(props) {
    const [selectedAddOns, setSelectedAddOns] = useState([]);
    const [allAddOns, setAllAddOns] = useState([]);
    const swalAlert = withReactContent(Swal);

    useEffect(() => {
        if(props.activeId == 'add-on') {
            axios.post('/api/update-add-ons-info', {
                drop_off_point: dropOffAddOns,
                //travel info
                transaction_id: props.transactionId,
                tripType: props.travelInfo.tripType,
                destination: (props.travelInfo.productType == 'TAA' || props.travelInfo.productType == 'ONE') ? props.travelInfo.destinationList:  props.travelInfo.destination.label,
                departureDate: props.travelInfo.departureDate,
                returnDate: props.travelInfo.returnDate,
                dateOfBirth: props.travelInfo.dateOfBirth,
                planType: props.travelInfo.planType,
                //plan info
                product: props.selectedPlan.product,
                plan: props.selectedPlan.plan,
                insurer: props.selectedPlan.insurer,
                plan_type: props.selectedPlan.plan,
                referral: props.referral,   
                selected_add_ons: selectedAddOns,
                total_payable: props.totalPayable,

            }).then(function (response) {
                if(response.data.transactionId) {
                    props.setTransactionId(response.data.transactionId);
                }
            }).catch(function (error) {
                    console.log(error);
            })
        }
    }, [props.dropOffTrigger]);

    useEffect(() => {
        setSelectedAddOns([]);
        setAllAddOns([]);

      

        if (!isEmpty(props.selectedPlan)) {
            swalAlert.fire({
                title: 'Please Wait...',
                allowOutsideClick: false
            });
            swalAlert.showLoading();
            
           
            props.setGrossPremium(parseFloat(props.selectedPlan.premium));

            if(isNaN(props.selectedPlan.serviceTax)) {
                props.setServiceTax(0);
            } else {
                props.setServiceTax(parseFloat(props.selectedPlan.serviceTax));
            }

            if(isNaN(props.selectedPlan.stampDuty)) {
                props.setStampDuty(0);
            } else {
                props.setStampDuty(parseFloat(props.selectedPlan.stampDuty));
            }

           


            axios.post('/api/add-ons', {
                insurer: props.selectedPlan.insurer,
                plan_type: props.selectedPlan.plan,
                zone: props.selectedPlan.zone,
                departure_date: props.travelInfo.departureDate,
                return_date: props.travelInfo.returnDate,
                trip_type: props.travelInfo.tripType,
                product: props.selectedPlan.product
            }).then((response) => {
                setAllAddOns(response.data);
                swalAlert.close();
            }).catch((error) => {
                console.log(error);
            });
        }
    }, [props.selectedPlan]);

    useEffect(() => {
        props.setAddOnsTotal(0);

       

        props.setTotalPayable(parseFloat(props.grossPremium) + parseFloat(props.stampDuty) + parseFloat(props.serviceTax));

        if (!isEmpty(selectedAddOns)) {
            var total = 0;

            Array.from(selectedAddOns).forEach((add_ons) => {
                total += parseFloat(add_ons.premium);
            });

            props.setAddOnsTotal(parseFloat(total));
            props.setTotalPayable(parseFloat(total) + parseFloat(props.grossPremium) + parseFloat(props.stampDuty));
        }
    }, [selectedAddOns]);

    useEffect(() => {
        if (allAddOns.find(item => item.name === 'Pandemic Cover') !== undefined) {
            setSelectedAddOns([...selectedAddOns, allAddOns.filter(item => item.name === 'Pandemic Cover').pop()]);
        }
    }, [allAddOns]);

    function onCheckCheckbox(e) {
        if (e.target.checked) {
            setSelectedAddOns([...selectedAddOns, JSON.parse(e.target.value)]);
        } else {
            let selected = [...selectedAddOns];

            selected.splice(selected.findIndex(item => item.name === JSON.parse(e.target.value).name), 1);
            setSelectedAddOns(selected);
        }
    }

    function onClickNext(e) {
        e.preventDefault();

        props.setSelectedAddOns(selectedAddOns);
        props.setActiveId('insured');
    }

    function onClickBack() {
        props.setActiveId('plan');
    }

    function ProductBenefits(props) {
        if (!isEmpty(props.selectedPlan.benefits)) {

            if(props.selectedPlan.insurer == insurer_msig || props.selectedPlan.insurer == insurer_rhbi || props.selectedPlan.insurer == insurer_tune) {

                return (
                    <>
                     {props.selectedPlan.benefits.map((obj) => {
                        
                        if(props.selectedPlan.insurer == insurer_msig) {
                            
                        return (
                            <>
                           
                            <tr>
                                <td> {obj.coverageDescription}</td>
                                <td className="text-end">

                                    {(isNaN(obj.sumInsured.replace(',', '')) || isEmpty(obj.sumInsured.replace(',', '')) || obj.sumInsured.replace(',', '') <= 0) ?
                                        <span className="text-primary ml-3">Covered</span>

                                    :
                                        <span className="text-primary ml-3">
                                        
                                        RM {parseFloat(obj.sumInsured).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                                            
                                        </span>
                                    }

                                    {/* RM {parseFloat(obj.sumInsured).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })} */}
                                </td>
                            </tr>
                            
                            </>  
                            )
                     }  else if (props.selectedPlan.insurer == insurer_rhbi) {

                            return (
                                <>
                                <tr>
                                    <td> {obj.coverageDescription}</td>
                                </tr>
                                <tr>
                                    <td>
                                    <ul>
                                            {obj.items.map((objSum) => {
                                            return (
                                                <>
                                                <li>
                                                    {objSum.benefit} 
                                                    <span className="text-primary ml-3">
                                                        {props.selectedPlan.planId == 'ADVANCE'?   
                                                            <>
                                                                {objSum.sumInsured.ADVANCE == 'AVAILABLE' || objSum.sumInsured.ADVANCE == 'COVERED' ?
                                                                    <>
                                                                    {objSum.sumInsured.ADVANCE}
                                                                    </>

                                                                :
                                                                    <>
                                                                    RM {objSum.sumInsured.ADVANCE}
                                                                    </>

                                                                }
                                                               
                                                            </>
                                                    
                                                        :

                                                        <>
                                                            {objSum.sumInsured.SUPREME == 'AVAILABLE' || objSum.sumInsured.SUPREME == 'COVERED' ?
                                                                <>
                                                                {objSum.sumInsured.SUPREME}
                                                                </>
                                                                :
                                                                <>
                                                                RM {objSum.sumInsured.SUPREME}
                                                                </>
                                                            }
                                                        </>
                                                        }

                                                    {/* RM {parseFloat(objSum.sumInsured.ADVANCE.replace(',', '')).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })} */}
                                                    </span>    

                                                </li>
                                                
                                                </>
                                            );
                                            })}

                                        </ul>
                                
                                    </td>
                                </tr>
                                </>
                            );
                             
                        }  else if (props.selectedPlan.insurer == insurer_tune) {

                            return (
                                <>
                                    <tr>
                                        <td> {obj.coverageDescription}</td>
                                        <td className="text-end">
                                            <span className="text-primary ml-3">
                                                {obj.sumInsuredDescription}
                                            </span>
                                        </td>
                                    </tr>
                                </>
                            );
                        }
                           
                        

                     })
                    }
    
                    </>          
                    
                  );

            } else {    

                if (props.travelInfo.planType != 'Family' || props.selectedPlan.insurer == 'CHUBB') {
                    return (
                        <>
                            <tr>
                                <td>Medical Expenses up to</td>
                                <td>
                                    RM {props.selectedPlan.benefits.medical_expenses.adult_child.value}
                                </td>
                            </tr>
                            <tr>
                                <td>Accidental Death and Permanent Total Disablement up to</td>
                                <td>
                                    RM {props.selectedPlan.benefits.death_disablement.adult.value}
                                </td>
                            </tr>
                            <tr>
                                <td>Emergency Medical Evaluation</td>
                                <td>
                                    {props.selectedPlan.benefits.emergency_medical_evacuation.event.value}
                                </td>
                            </tr>
                            <tr>
                                <td>Reimbursement of Paid expenses on trip cancellation / postponement Up to</td>
                                <td>
                                    {isNaN(parseFloat(props.selectedPlan.benefits.cancellation.adult_child.value)) ?
                                        props.selectedPlan.benefits.cancellation.adult_child.value :
                                        'RM ' + props.selectedPlan.benefits.cancellation.adult_child.value
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td>Loss or Damage to Baggage and Personal Effects Up to</td>
                                <td>
                                    RM {props.selectedPlan.benefits.baggage_and_personal_effects.adult_child.value}
                                </td>
                            </tr>
                            <tr>
                                <td>Loss or Damage to Travel Documents Up to</td>
                                <td>
                                    RM {props.selectedPlan.benefits.travel_documents.adult_child.value}
                                </td>
                            </tr>
                            <tr>
                                <td>Baggage Delay Up to</td>
                                <td>
                                    RM {props.selectedPlan.benefits.baggage_delay.adult_child.value}
                                    <br />
                                    {<small>({props.selectedPlan.benefits.baggage_delay.adult_child.condition || ''})</small>}
                                </td>
                            </tr>
                        </>
                    );
                } else {
                    return (
                        <>
                            <tr>
                                <td>Medical Expenses up to</td>
                                <td>
                                    RM {props.selectedPlan.benefits.medical_expenses.family.value}
                                </td>
                            </tr>
                            <tr>
                                <td>Accidental Death and Permanent Total Disablement up to</td>
                                <td>
                                    RM {props.selectedPlan.benefits.death_disablement.family.value}
                                </td>
                            </tr>
                            <tr>
                                <td>Emergency Medical Evaluation</td>
                                <td>
                                    {props.selectedPlan.benefits.emergency_medical_evacuation.event.value}
                                </td>
                            </tr>
                            <tr>
                                <td>Reimbursement of Paid expenses on trip cancellation / postponement Up to</td>
                                <td>
                                    RM {props.selectedPlan.benefits.cancellation.family.value}
                                </td>
                            </tr>
                            <tr>
                                <td>Loss or Damage to Baggage and Personal Effects Up to</td>
                                <td>
                                    RM {props.selectedPlan.benefits.baggage_and_personal_effects.family.value}
                                </td>
                            </tr>
                            <tr>
                                <td>Loss or Damage to Travel Documents Up to</td>
                                <td>
                                    RM {props.selectedPlan.benefits.travel_documents.family.value}
                                </td>
                            </tr>
                            <tr>
                                <td>Baggage Delay Up to</td>
                                <td>
                                    RM {props.selectedPlan.benefits.baggage_delay.family.value}
                                    <br />
                                    {<small>({props.selectedPlan.benefits.baggage_delay.adult_child.condition || ''})</small>}
                                </td>
                            </tr>
                        </>
                    );
                }
            }
        }

        return null;
    }


    return (
        <Form onSubmit={(e) => onClickNext(e)}>
            <div className="mb-3 row">
                <div className="col-12 col-lg-6 pricing pb-3 pb-lg-0">
                    <Sticky boundaryElement=".pricing">
                        <Card className="rounded border-top">
                            <Card.Header>
                                <div className="mb-3 row mb-0">
                                    <div className="col-12 text-center">
                                        <h5>{getInsurerFullName(props.selectedPlan.insurer)}</h5>
                                        <p className="mb-0">{props.selectedPlan.product + ' - ' + props.selectedPlan.plan}</p>
                                    </div>
                                </div>
                            </Card.Header>
                            <Card.Body className="border-top-0">
                                <div className="mb-3 row">
                                    <div className="col-12">
                                        <div className="row justify-content-around">
                                            <label className="col-12 mb-sm-0">{props.travelInfo.tripType + " - " + props.selectedPlan.plan + " (" +props.travelInfo.planType + ")"} </label>
                                        </div>
                                        <div className="row justify-content-around">
                                            {props.travelInfo.tripType == 'Annual' ?
                                                <>
                                                 {props.travelInfo.isDomestic == true ?
                                                    <label className="col-12 mb-sm-0">{"Area " + props.travelInfo.destination?.label + " - Domestic"}</label>
                                                    :   
                                                    <label className="col-12 mb-sm-0">{"Area " + props.travelInfo.destination?.label + " - International"}</label>
                                                    }
                                                
                                                </>
                                               

                                            :
                                                <>
                                                    {props.travelInfo.isDomestic == true ?
                                                        <label className="col-12 mb-sm-0">{props.travelInfo.destinationList + " - Domestic"}</label>  
                                                        :
                                                    <label className="col-12 mb-sm-0">{props.travelInfo.destinationList + " - International"}</label>  
                                                    
                                                    }
                                                </>
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="mb-3 row">
                                    <label className="col-6 col-form-label">Premium</label>
                                    <label className="col-6 col-form-label text-end fw-bold">
                                       RM {parseFloat(props.grossPremium).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                    </label>
                                </div>
                                <div className="mb-3 row">
                                    <div className="col-8">
                                        <Accordion>
                                        
                                            <Accordion.Toggle as={Card.Header} eventKey={!isEmpty(allAddOns) ? 'add-ons' : '' } className={!isEmpty(allAddOns) ? 'ps-0 border-0 clickable' : 'ps-0 border-0'}>
                                              {!isEmpty(allAddOns) ? '+' : '' }
                                                Add On Benefits
                                            </Accordion.Toggle>
                                            <Accordion.Collapse eventKey='add-ons'>
                                                <Card.Body>
                                                    {selectedAddOns.map((add_ons) => (
                                                        <div className="row py-2 border-bottom">
                                                            <label className="col-6 pe-0">{add_ons.name}</label>
                                                            <label className="col-6 text-end">
                                                                RM {parseFloat(add_ons.premium).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                            </label>
                                                        </div>
                                                    ))}
                                                </Card.Body>
                                            </Accordion.Collapse>
                                        </Accordion>
                                    </div>
                                    <div className="col-4 text-end">
                                        <label className="col-form-label fw-bold align-self-center">
                                            RM {parseFloat(props.addOnsTotal).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                        </label>
                                    </div>
                                </div>
                                <div className="mb-3 row">
                                    <label className="col-6">Stamp Duty</label>
                                    <label className="col-6 text-end fw-bold">
                                        {parseFloat(props.stampDuty) == 0 ? 'Not Applicable' : 'RM ' + parseFloat(props.stampDuty).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                    </label>
                                </div>

                                <div className={( (props.selectedPlan.insurer === insurer_msig || props.selectedPlan.insurer === insurer_rhbi ||  props.selectedPlan.insurer === insurer_tune) ? "" : "d-none") + " mb-3 row"}>
                                    <label className="col-6">Service Tax</label>
                                    <label className="col-6 text-end fw-bold">
                                        {parseFloat(props.serviceTax) == 0 ? 'Not Applicable' : 'RM ' + parseFloat(props.serviceTax).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                    </label>
                                </div>

                            </Card.Body>
                            <Card.Footer>
                                <div className="mb-3 row mb-0">
                                    <label className="col-6">Total Payable</label>
                                    <label className="col-6 text-end fw-bold">
                                        RM {parseFloat(props.totalPayable).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                    </label>
                                </div>
                            </Card.Footer>
                        </Card>
                    </Sticky>
                </div>
                <div className="col-12 col-lg-6">
                    <div className="row mb-4">
                        <div className="col-12">
                            <Accordion>
                                <Card className="border-top rounded">
                                    <Accordion.Toggle as={Card.Header} eventKey="sob" className="border-0 clickable text-primary fw-bold">
                                        Product Benefits
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey="sob">
                                        <Card.Body>
                                            <Table className="mb-0">
                                                <tbody>
                                                    <ProductBenefits selectedPlan={props.selectedPlan} travelInfo={props.travelInfo} />
                                                </tbody>
                                            </Table>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card>
                            </Accordion>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <h5>Optional Rider Benefits</h5>
                            <p>with additional premium</p>
                            {!isEmpty(allAddOns) ?
                                <ol type="1">
                                    {allAddOns.map((add_ons, index) => (
                                        <li>
                                            <label className="col-12 col-form-label">
                                                <Form.Check
                                                    type="switch"
                                                    id={`add-ons-${index}`}
                                                    label={add_ons.name}
                                                    defaultChecked={parseFloat(add_ons.premium) === 0 || add_ons.name === 'Pandemic Cover' || selectedAddOns.includes(add_ons)}
                                                    value={JSON.stringify(add_ons)}
                                                    onChange={(e) => onCheckCheckbox(e)}
                                                    disabled={add_ons.name === 'Pandemic Cover'}
                                                />
                                            </label>
                                        </li>
                                    ))}
                                </ol>
                                :
                                <p>No Optional Rider Benefits available</p>
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex justify-content-between mt-3">


            </div>
            <div className="mb-3 row">
                <div className="col-sm-6" >
                    <button type="button" id="btn-back" class="btn btn-secondary" onClick={() => { onClickBack() }}>Back</button>
                </div>
                <div className="col-sm-6 text-end">
                    <Button type="submit" variant="success">Continue</Button>
                </div>
            </div>

        </Form>
    );
}

function Insured(props) {

    const [name, setName] = useState(props.basicName ?  props.basicName: "");
    const [idNumber, setIDNumber] = useState("");

    const [parentName, setParentName] = useState("");
    const [parentIdNumber, setParentIdNumber] = useState("");

    const [dateOfBirth, setDateOfBirth] = useState("");
    const [gender, setGender] = useState("");
    const [individualRelationship, setIndividualRelationship] = useState("C");
    const [groupType, setGroupType] = useState("A"); // A- Adult, C - Child
    const [stillStuding, setStillStuding] = useState("N");
    const [nationality, setNationality] = useState("");
    const [insuredNationality, setInsuredNationality] = useState({});
    const [insuredCountry, setInsuredCountry] = useState({});

    const [region, setRegion] = useState("");

    const [identityType, setIdentityType] = useState("");
    const [mobileNo, setMobileNo] = useState(props.basicContactNo? props.basicContactNo: "");
    const [displayMobileNo, setDisplayMobileNo] = useState(props.basicContactNo? props.basicContactNo: "");
    const [email, setEmail] = useState(props.basicEmailAdd? props.basicEmailAdd: "");

    const [address1, setAddress1] = useState("");
    const [address2, setAddress2] = useState("");
    const [address3, setAddress3] = useState("");
    const [address4, setAddress4] = useState("");
    const [postcode, setPostcode] = useState("");
    const [state, setState] = useState("");
    const [stateValue, setStateValue] = useState("");
    const [insuredRelationship, setInsuredRelationship] = useState("-- Select a Relationship --");
    const [nomineeName, setNomineeName] = useState("");
    const [nomineeID, setNomineeID] = useState("");
    const [nomineeRelationship, setNomineeRelationship] = useState("-- Select a Relationship --");
    const [insureds, setInsureds] = useState([]);
    const [index, setIndex] = useState(1);

    const [insuredMaritalStatusValue, setInsuredMaritalStatusValue] = useState("Single");
    const [insuredMaritalStatus, setInsuredMaritalStatus] = useState("S");

    const [maritalStatus, setMaritalStatus] = useState("S");

    const [maxInsured, setMaxInsured] = useState(1);
    const [allowNomination, setAllowNomination] = useState(false);
    const [allowContinue, setAllowContinue] = useState(false);
    const [totalAdult, setTotalAdult] = useState(0);
    const [totalChild, setTotalChild] = useState(0);
    const [editForm, setEditForm] = useState(false);
    const [isIdChange, setIsIdChange] = useState(false); 
    

    const [relationships] = useState([
        { value: "", label: "-- Select a Relationship --" },
        { value: 1, label: "Spouse" },
        { value: 2, label: "Father" },
        { value: 3, label: "Mother" },
        { value: 4, label: "Father-in-law" },
        { value: 5, label: "Mother-in-law" },
        { value: 6, label: "Child" },
        { value: 7, label: "Brother" },
        { value: 8, label: "Sister" },
        { value: 9, label: "Relative" },
        { value: 10, label: "Others" }
    ]);
    const [insuredRelationships, setInsuredRelationships] = useState([
        { value: "", label: "-- Select a Relationship --" },
        { value: 1, label: "Spouse" },
        { value: 2, label: "Child" }
    ]);

    const [allRegions] = useState([
        { value: '1', label: 'Muslim'},
        { value: '2', label: 'Buddhist'},
        { value: '3', label: 'Hindu'},
        { value: '4', label: 'Others'},
    ]);


    const [maritalStatusList] = useState([
        { value: "S", label: "Single" },
        { value: "M", label: "Married" },
        { value: "D", label: "Divorced/ Sepatared"},
        { value: "W", label: "Widowed" },
        { value: "E", label: "Society" },
        { value: "C", label: "Company" },
        { value: "O", label: "Others" },
    ]);

    const swalAlert = withReactContent(Swal);

    // e-Invoice details

    const [einvoiceIndicatorList] = useState([
        { value: "Y", label: "Yes" },
        { value: "N", label: "No" }
    ]);

    const [sstIndicatorList] = useState([
        { value: "Y", label: "Yes" },
        { value: "N", label: "No" }
    ]);

    const [einvoiceEnable, setEinvoiceEnable] = useState(false);
    const [einvoiceIndicator, setEinvoiceIndicator] = useState("");
    const [tinNo, setTinNo] = useState("");
    const [sstIndicator, setSstIndicator] = useState("");
    const [sstNo, setSstNo] = useState("");

    const formatChars = {
        '9': '[0-9]',
        'a': '[A-Za-z]',
        '*': '[A-Za-z0-9-]'
      };
   

    useEffect(() => {
        if(props.activeId == 'insured') {

            const insured_address = (insureds.length >= 1) ? insureds[0].address1+" "+insureds[0].address2+" "+insureds[0].address3+" "+insureds[0].address4 : address1+" "+address2+" "+address3+" "+address4;

            axios.post('/api/update-insured-info', {
                drop_off_point: dropOffInsured,
                transaction_id: props.transactionId,
                tripType: props.travelInfo.tripType,
                destination: (props.travelInfo.productType == 'TAA' || props.travelInfo.productType == 'ONE') ? props.travelInfo.destinationList:  props.travelInfo.destination.label,
                departureDate: props.travelInfo.departureDate,
                returnDate: props.travelInfo.returnDate,
                dateOfBirth: (insureds.length >= 1) ? Moment(insureds[0].dateOfBirth).format('DD/MM/YYYY') : Moment(dateOfBirth).format('DD/MM/YYYY'),
                planType: props.travelInfo.planType,
                product: props.selectedPlan.product,
                plan: props.selectedPlan.plan,
                insurer: props.selectedPlan.insurer,
                plan_type: props.selectedPlan.plan,
                referral: props.referral,   
                selected_add_ons: props.selectedAddOns,
                insured_name: (insureds.length >= 1) ? insureds[0].name : name ,
                insured_email: (insureds.length >= 1) ? insureds[0].email: email ,
                insured_mobile_number: (insureds.length >= 1) ? insureds[0].mobileNo : mobileNo ,
                insured_id_number: (insureds.length >= 1)?  insureds[0].idNumber: idNumber ,
                insured_gender: (insureds.length >= 1)? insureds[0].gender : gender,
                insured_address: insured_address,
                total_payable: props.totalPayable,
            }).then(function (response) {
                if(response.data.transactionId) {
                    props.setTransactionId(response.data.transactionId);
                }
            }).catch(function (error) {
                console.log(error);
            })
        }
    }, [props.dropOffTrigger]);


    useEffect(() => {
        if(!isEmpty(props.basicName)) {
            setName(props.basicName);
        }
       
        if(!isEmpty(props.basicContactNo)) {
            setMobileNo(props.basicContactNo);

            if(props.basicContactNo.charAt(0) == '0') {
                let resultMobileNo = '' + props.basicContactNo.slice(1);
                setDisplayMobileNo(resultMobileNo);
    
            } else {
                setDisplayMobileNo(e);
            }

        }
      
        if(!isEmpty(props.basicEmailAdd)) {
            setEmail(props.basicEmailAdd);
        }
       
    }, [props.basicName, props.basicContactNo, props.basicEmailAdd]);

    useEffect(() => {

        if(!isEmpty(props.renewalInfo) && !isEmpty(props.travelInfo)) {

            console.log('insured useEffect renewalInfo');

            checkDetails(props.renewalInfo.idNumber, 'id');
            if(!isEmpty(props.renewalInfo.insured_address1)) {
                setAddress1(props.renewalInfo.insured_address1);
            } 
            else {
                setAddress1(props.renewalInfo.insured_address)
            }

            setAddress2(props.renewalInfo.insured_address2);
            setAddress3(props.renewalInfo.insured_address3);
            setAddress4(props.renewalInfo.insured_address4);

            handlePostcodeChange(props.renewalInfo.insured_postcode);
            
        }
       
       
    }, [props.renewalInfo, props.travelInfo]);

    useEffect(() => {

      

        setIndex(insureds.length + 1);

        if (props.selectedPlan.insurer != insurer_msig && props.travelInfo.planType === 'Individual') {
            recalculatePremium();

            if (insureds.length === 9) {
                swalAlert.fire({
                    title: 'Oops...',
                    icon: 'error',
                    text: 'You have exceeded the maximum insured persons per policy. Kindly enroll additional insured person (if any) in a different transaction.'
                }).then((result) => {
                    if (result.isConfirmed) {
                        clearState(true);
                    }
                });
            }
        }

        // insureds.forEach((insured) => {
        //     if (insured.insuredRelationship === 'Spouse') {
        //         setInsuredRelationships(insuredRelationships.filter((relationship) => relationship.label !== "Spouse"));
        //     }
        // });
    }, [insureds]);


    useEffect(() => {


        if(!isEmpty(gender)) {

            if(props.travelInfo.planType == 'Individual') {
                setIndividualRelationship('C');
                // if(individualRelationship != 'C') {
                //     setIndividualRelationship(gender == 'Male' ? 'S' : 'D');
                // }   
            } else if(props.travelInfo.planType == 'InsuredSpouse') {

                setMaritalStatus('M');

                if(index === 1) {
                    setIndividualRelationship('C');
                   
                } else {
                    setIndividualRelationship(gender == 'Male' ? 'H' : 'W');
                   
                }

            } else if(props.travelInfo.planType == 'Family') {

                if(index === 1) {
                    setIndividualRelationship('C');
                   setMaritalStatus('M');
                } else if(insuredRelationship == 'Spouse') {
                  setMaritalStatus('M');
                    setIndividualRelationship(gender == 'Male' ? 'H' : 'W');
                } else {
                    setMaritalStatus('S');
                    setIndividualRelationship(gender == 'Male' ? 'S' : 'D');
                    //setStillStuding("Y");
                }

            } else if(props.travelInfo.planType == 'Child') {
                setIndividualRelationship(gender == 'Male' ? 'S' : 'D');
                //setStillStuding("Y");
            } else if(props.travelInfo.planType == 'Group') {

                    setIndividualRelationship('C');
               
            }

        }

        // if(props.travelInfo.planType != 'Individual') {

        //     setInsuredMaritalStatus('M');
        // }

    }, [gender, groupType, insuredRelationship]);


    useEffect(() => {

        if(props.selectedPlan.allowEinvoice) {

            setEinvoiceEnable(true);
        } else {
            setEinvoiceEnable(false);
        }

    }, [props.selectedPlan]);



    useEffect(() => {


        setInsuredCountry("");
        setNationality("");
        setInsuredNationality("");
        if(!isEmpty(props.travelInfo.nationality) && props.travelInfo.nationality == 'MAL') { //is malaysia
            setInsuredCountry(props.travelInfo.nationality);
            setInsuredNationality(props.travelInfo.nationality);
            setNationality('Malaysia');
        } 

        if(!isEmpty(props.travelInfo.nationality) && props.travelInfo.nationality == 'ALL') { // Non Malaysia

            updateNationality(props.travelInfo.nationalityCountryObj);

        }


    }, [props.travelInfo]);

    useEffect(() => {

        setIsIdChange(false);
        if(!isEmpty(props.travelInfo.dateOfBirth) && insureds.length > 0) {

            let dob =  Moment(props.travelInfo.dateOfBirth, 'DD/MM/YYYY').format('YYYY-MM-DD');

        
            handleEditInsured(0);
            setDateOfBirth(new Date(dob+" 00:00:00"));
            setIDNumber("");
            setIsIdChange(true);
            setAllowContinue(false);

        }

    }, [props.travelInfo.dateOfBirth]);   


    useEffect(() => {

        console.log('useEffect insureds');
    
        if(insureds.length == 0 && !isEmpty(props.travelInfo.dateOfBirth)) {
            let dob =  Moment(props.travelInfo.dateOfBirth, 'DD/MM/YYYY').format('YYYY-MM-DD');
            setDateOfBirth(new Date(dob+" 00:00:00"));

        }


       // setDateOfBirth(Moment(props.travelInfo.dateOfBirth, "DD/MM/YYYY"));

        if(props.selectedPlan.insurer == insurer_msig || props.selectedPlan.insurer == insurer_rhbi || props.selectedPlan.insurer == insurer_tune) {
             setInsuredAmount();

             updateInsuredRelationship('new');


            // if(props.travelInfo.buyFor == 'IS') {
    
            //     if(index > 1) {
            //         setInsuredRelationship('Spouse');
            //     }
               
            // }


           
        }


        if (props.selectedAddOns.length > 0 && insureds.length > 0) {
            let add_ons_total = props.selectedAddOns.map((add_on) => {
                return add_on.premium * insureds.length;
            }).reduce((current, prev) => {
                return current + prev;
            });

            props.setAddOnsTotal(add_ons_total);

            props.setTotalPayable(props.grossPremium + add_ons_total + props.stampDuty + props.serviceTax);
        }
    }, [props.selectedAddOns, insureds]);

    useEffect(() => {

        if(dateOfBirth) {


          let insuredAge = Moment(props.travelInfo.departureDate, 'DD/MM/YYYY').diff(Moment(dateOfBirth), 'years',false);

          if(props.selectedPlan.insurer == insurer_rhbi) {
            insuredAge = Moment().diff(Moment(dateOfBirth), 'years',false) + 1;
          }

         

        if((insureds.length === 0 || index === 1) || insuredRelationship === 'Spouse' || props.travelInfo.buyFor == 'GP') {

            if(props.selectedPlan.insurer == insurer_msig) {
                if ( insuredAge > 69 || insuredAge < 18) {

                    let message = (index === 1 || props.travelInfo.buyFor == 'GP') ? 'Sorry, Age of Insured must be between 18 to 69 years old.' : 'Sorry, Age of spouse must be between 18 to 69 years old.';
    
                    swalAlert.fire({
                        title: 'Oops...',
                        icon: 'error',
                        text: message
                    }).then((result) => {
                        if (result.isConfirmed) {
                            setDateOfBirth("");
                            setIDNumber("");
                        }
                    });
        
                    
                } 

            } else if(props.selectedPlan.insurer == insurer_rhbi && (props.travelInfo.buyFor != 'IC' && groupType != 'C' && insuredRelationship != 'Child')) {

                if(props.selectedPlan.planId == 'SUPREME' && insuredAge > 60) {

                    let message = 'Sorry, Age of Insured must between 19 to 60 years old.';
    
                    swalAlert.fire({
                        title: 'Oops...',
                        icon: 'error',
                        text: message
                    }).then((result) => {
                        if (result.isConfirmed) {
                            setDateOfBirth("");
                            setIDNumber("");
                        }
                    });


                } else if( insuredAge > 80 || insuredAge < 19) {

                    let message = 'Sorry, Age of Insured must between 19 to 80 years old.';
    
                    swalAlert.fire({
                        title: 'Oops...',
                        icon: 'error',
                        text: message
                    }).then((result) => {
                        if (result.isConfirmed) {
                            setDateOfBirth("");
                            setIDNumber("");
                        }
                    });

                }
         

            }

        }

        if(props.selectedPlan.insurer == insurer_msig) {
            if (insuredRelationship === 'Child' && 
                ((parseInt(Moment(props.travelInfo.departureDate, 'DD/MM/YYYY').diff(Moment(dateOfBirth), 'days')) < 30 ) || insuredAge > 17)) 
            {
    
                    swalAlert.fire({
                        title: 'Oops...',
                        icon: 'error',
                        text: 'Sorry, Age of Child must be between 30 days to 17 years old.'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            setDateOfBirth("");
                            setIDNumber("");
                        }
                    });
        
                   
    
            }

        } else if(props.selectedPlan.insurer == insurer_rhbi) {

            let maxChildAge = stillStuding == 'N' ? 19 : 23;

            if ((insuredRelationship === 'Child' || groupType == 'C' || props.travelInfo.buyFor == 'IC') && 
                ((parseInt(Moment(props.travelInfo.departureDate, 'DD/MM/YYYY').diff(Moment(dateOfBirth), 'days')) < 15 ) || insuredAge > maxChildAge)) 
            {
    
                    swalAlert.fire({
                        title: 'Oops...',
                        icon: 'error',
                        text: "Sorry, Age of Child must be between 15 days to " + maxChildAge+ " years old."
                    }).then((result) => {
                        if (result.isConfirmed) {
                            setDateOfBirth("");
                            setIDNumber("");
                        }
                    });
        
    
            }


        } else if(props.selectedPlan.insurer == insurer_tune) {

            if (insuredRelationship === 'Child' && 
                ((parseInt(Moment(props.travelInfo.departureDate, 'DD/MM/YYYY').diff(Moment(dateOfBirth), 'days')) < 30 ) || insuredAge > 21)) 
            {
    
                    swalAlert.fire({
                        title: 'Oops...',
                        icon: 'error',
                        text: 'Sorry, Age of Child must be between 30 days to 21 years old.'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            setDateOfBirth("");
                            setIDNumber("");
                        }
                    });
        
    
            }

        }

        if(props.selectedPlan.insurer == insurer_tune && insuredRelationship !== 'Child') {

            if(props.travelInfo.isDomestic == true) {

                if((insuredAge > 80) || (insuredAge < 18)) {
                    swalAlert.fire({
                        title: 'Oops...',
                        icon: 'error',
                        text: 'Sorry, Age of Insured must be between 18 years old to 80 years old.'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            setDateOfBirth("");
                            setIDNumber("");
                        }
                    });
                
                }


            } else {

                 //60 and below
                if(props.travelInfo.tuneCheckAge == false) {

                    if((insuredAge > 60) || (insuredAge < 18)) {
                    //if(diffYear < 18 || diffYear > 60) {
                        swalAlert.fire({
                            title: 'Oops...',
                            icon: 'error',
                            text: 'Sorry, Age of Insured must be between 18 years old to 60 years old.'
                        }).then((result) => {
                            if (result.isConfirmed) {
                                setDateOfBirth("");
                                setIDNumber("");
                            }
                        });
                    
                    }

                } else {

                    if((insuredAge > 80) || (insuredAge < 61)) {
                        swalAlert.fire({
                            title: 'Oops...',
                            icon: 'error',
                            text: 'Sorry, Age of Insured must be between 61 years old to 80 years old.'
                        }).then((result) => {
                            if (result.isConfirmed) {
                                setDateOfBirth("");
                                setIDNumber("");
                            }
                        });
                    
                    }

                }

            }


           
            
        }

    }
    

    },[dateOfBirth]);   

    function updateEinvoice(value) {
        setEinvoiceIndicator(value);
        if(value == 'N') {
            setTinNo("");
            setSstIndicator("");
            setSstNo("");
        }

    }


    function handlePostcodeChange(e) {

        if(!isEmpty(e)) {

            let postcode = e;
            setPostcode(e);

            console.log('handlePostcodeChange');
            console.log(e);

            if (e.length == 5) {
            axios.get('/api/check-postcode/' + postcode)
                .then((response) => {
                    setState(response.data.state);
                    setStateValue(response.data.state_value);
                    
                }
            );
        }

    }


    }

    function handleCardNumberChange(e) {

        let originalMobile = e;

        if(originalMobile.charAt(0) == '0') {
            let result = '' + originalMobile.slice(1);
            setDisplayMobileNo(result);
            setMobileNo(e);

        } else {
            setDisplayMobileNo(e);

            let formatMobile = '0' + e;
            setMobileNo(formatMobile);
        }

       

    }

    function updateInsuredRelationship(mode = null) {


        console.log('updateInsuredRelationship mode ='+ mode);

    
        if(props.travelInfo.buyFor == 'IS') {

           
            setInsuredRelationships(insuredRelationships.filter((relationship) => relationship.label === "Spouse"));

            setInsuredRelationship('Spouse');

            if(index > 1) {
                setInsuredRelationship('Spouse');
            }

           
        }


        if(props.travelInfo.buyFor == 'FC' && props.travelInfo.noOfAdults == 1) {

           
            setInsuredRelationships(insuredRelationships.filter((relationship) => relationship.label === "Child"));

            if(index > 1) {
                setInsuredRelationship('Child');
            }

        }

        if(props.travelInfo.buyFor == 'FC' && props.travelInfo.noOfAdults == 2) {  //family with spouse and childs
            

            setInsuredRelationships([{ value: 1, label: "Spouse" }, { value: 2, label: "Child" }]);

            if(insureds.length > 0)
            {
                let hasSpouse = false;
                insureds.forEach((insured) => {
                   
                    if (insured.insuredRelationship == 'Spouse') {
                        
                        hasSpouse = true;
                    }
                });

                if(mode == 'new') {

                    if(hasSpouse) {

                        setInsuredRelationships([{ value: 2, label: "Child" }]);
                      
                        $("#relationshipId").find(".css-1uccc91-singleValue").html("Child");
                        setInsuredRelationship('Child');
                    } else {
                       
                        $("#relationshipId").find(".css-1uccc91-singleValue").html("Spouse");
                        setInsuredRelationship('Spouse');
    
                    }

                } else if(mode = 'delete') {

                    setInsuredRelationships([
                        { value: "", label: "-- Select a relationship --" },
                        { value: 1, label: "Spouse" },
                        { value: 2, label: "Child" }
                    ]);
            
                    insureds.forEach((insured) => {
                        if (insured.insuredRelationship == 'Spouse') {
                            console.log('got spouse');
                            console.log(insuredRelationships);
            
                            setInsuredRelationships([
                                { value: 2, label: "Child" }
                            ]);
            
                            // setInsuredRelationships(insuredRelationships.filter((relationship) => relationship.label != "Spouse"));
                            setInsuredRelationship('Child');
                            
                        }
                    });


                }
                 else { //edit mode

                    if(insuredRelationship == 'Child') 
                    {
                        setInsuredRelationships([{ value: 2, label: "Child" }]);
                        $("#relationshipId").find(".css-1uccc91-singleValue").html("Child");
                        setInsuredRelationship('Child');

                    }

                    if(insuredRelationship == 'Spouse') {

                        setInsuredRelationships([{ value: 1, label: "Spouse" }]);
                        $("#relationshipId").find(".css-1uccc91-singleValue").html("Spouse");
                        setInsuredRelationship('Spouse');

                    }



                }
              

            }
            
        }

    
    }

    function setInsuredAmount() {

        switch(props.travelInfo.planType) {
            case 'Individual':
                    setMaxInsured(1);
                break;
            case 'InsuredSpouse':
                setMaxInsured(2);
            break;  
            case 'Family':
                    let total = parseInt(props.travelInfo.noOfAdults) + parseInt(props.travelInfo.noOfChildren);
                    setMaxInsured(total);
                break;
            case 'Child':
                setMaxInsured(1);
                break;  
            case 'Group':
                setMaxInsured(props.travelInfo.noOfPersons);
                break;  
            default:
                
        }

    }

    function checkInsured() {

      

        let allowed = true;

        if(index === 1 && (!name || !idNumber || !gender || !nationality || !mobileNo || !email || !address || !nomineeName || !nomineeID || nomineeRelationship === "-- Select a Relationship --")) 
        {
            allowed = false;
        }
        if((index > 1 && ((props.travelInfo.planType === 'Family' && insuredRelationship === "-- Select a Relationship --") || !name || !idNumber || !gender || !nationality)))
        {
            allowed = false;
        }

        if(props.selectedPlan.insurer == insurer_msig) {

            if(index > maxInsured) {
                allowed = false;
            }

        } else {

            if((props.travelInfo.planType === 'Family' && insureds.length === 11) || (props.travelInfo.planType === 'Individual' && insureds.length === 9)) 
            {
                allowed = false;
            }

        }


      
        setAllowSaveInsured(allowed);
    }

    function recalculatePremium() {
        return new Promise((resolve) => {
            swalAlert.fire({
                title: 'Please Wait...',
                text: 'Recalculating Premium...',
                allowOutsideClick: false
            });
            swalAlert.showLoading();

            if (props.travelInfo.planType === 'Individual' && insureds.length > 1) {
                let gross_premium = parseFloat(props.selectedPlan.premium) * insureds.length;

                props.setGrossPremium(gross_premium);
                props.setTotalPayable(gross_premium + props.addOnsTotal + props.stampDuty + props.serviceTax);
            } else if (props.travelInfo.planType === 'Family' && props.selectedPlan.insurer === 'CHUBB' && insureds.length === 2 && insureds[1]?.insuredRelationship === 'Spouse') {
                axios.post('/api/plans', {
                    trip_type: props.travelInfo.tripType,
                    departure_date: props.travelInfo.departureDate,
                    return_date: props.travelInfo.returnDate,
                    destination: props.travelInfo.destination,
                    plan_type: 'Individual',
                    dob: props.travelInfo.dateOfBirth,
                    insurer: props.selectedPlan.insurer,
                    plan_name: props.selectedPlan.product,
                    switch_plan: true
                }).then((response) => {
                    props.setSelectedPlan(response.data[0]);

                    let gross_premium = response.data[0].premium * insureds.length;

                    props.setGrossPremium(gross_premium);
                    props.setTotalPayable(gross_premium + props.addOnsTotal + props.stampDuty + props.serviceTax);

                    swalAlert.close();
                }).catch((error) => {
                    console.log(error);
                });
            }

            swalAlert.close();

            resolve();
        });
    }

   

    function checkDetails(e, idType) {

       
         if(!isEmpty(props.travelInfo.nationality) && props.travelInfo.nationality == 'MAL') { //is malaysia 

             populateRhbiDetails(e, idType);

         } else if(props.selectedPlan.insurer == insurer_msig || props.selectedPlan.insurer === insurer_tune) {

            if(!isEmpty(props.travelInfo.nationality) && props.travelInfo.nationality == 'MAL') { //is malaysia 
                populateRhbiDetails(e, idType);
            } else {
                populateDetails(e);
            }
        } else if(props.selectedPlan.insurer == insurer_rhbi) {
            populateRhbiDetails(e, idType);
        }


    }

    function populateRhbiDetails(e,idType) {

       var ic = e.replaceAll('-', '');

       if(idType == 'parentId') {
        setParentIdNumber(ic);
       } else {
        setIDNumber(ic);
        //default to Malaysia country

        setNationality("Malaysia");
        setInsuredNationality(props.malNationality.countrycode);
        setInsuredCountry(props.malNationality.countrycode);
        setIdentityType("NRIC");
       }
       

        if (ic.match(/^(\d{2})([0][1-9]|[1][0-2])([0][1-9]|[1-2][0-9]|[3][0-1])\d{2}\d{4}$/m)) {
            var [, year, month, day] = ic.match(/^(\d{2})([0][1-9]|[1][0-2])([0][1-9]|[1-2][0-9]|[3][0-1])\d{2}\d{4}$/m);
            var now = new Date().getFullYear().toString();

            if (now.substring(2) >= year) {
                year = parseInt(now.substring(0, 2).concat(year.toString()));
            } else {
                year = parseInt(parseInt(now.substring(0, 2) - 1).toString().concat(year.toString()));
            }

            if(idType == 'id') {

                setDateOfBirth(new Date(year, (month - 1), day));

                // setNationality("Malaysia");
            
                // setInsuredNationality(props.malNationality.countrycode);
                // setInsuredCountry(props.malNationality.countrycode);
                setGender(parseInt(ic.substr(ic.lastIndexOf('-'))) % 2 == 0 ? 'Female' : 'Male');
                //setIdentityType("NRIC");


            }

            //setIndividualRelationship(parseInt(ic.substr(ic.lastIndexOf('-'))) % 2 == 0 ? 'D' : 'S');

        } else {

            setNationality("Malaysia");
            setInsuredNationality(props.malNationality.countrycode);
            setInsuredCountry(props.malNationality.countrycode);

        }
    }

    function populateDetails(e) {
        var ic = e;
        setIDNumber(ic);

        setIdentityType("Passport");
        setInsuredCountry(props.malNationality.msig_countrycode);


        if(insureds.length > 0) {
            console.log('Yes set insuredNationality '+insureds[0].insuredNationality);
            setNationality(insureds[0].nationality);
            setInsuredNationality(insureds[0].insuredNationality);
            }

        // if (ic.match(/^(\d{2})([0][1-9]|[1][0-2])([0][1-9]|[1-2][0-9]|[3][0-1])\d{2}\d{4}$/m)) {
        //     var [, year, month, day] = ic.match(/^(\d{2})([0][1-9]|[1][0-2])([0][1-9]|[1-2][0-9]|[3][0-1])\d{2}\d{4}$/m);
        //     var now = new Date().getFullYear().toString();

        //     if (now.substring(2) >= year) {
        //         year = parseInt(now.substring(0, 2).concat(year.toString()));
        //     } else {
        //         year = parseInt(parseInt(now.substring(0, 2) - 1).toString().concat(year.toString()));
        //     }

           
        //     setDateOfBirth(new Date(year, (month - 1), day));

        //     setNationality("Malaysia");
         
        //     setInsuredNationality(props.malNationality.msig_countrycode);
        //     setInsuredCountry(props.malNationality.msig_countrycode);
        //     setGender(parseInt(ic.substr(ic.lastIndexOf('-'))) % 2 == 0 ? 'Female' : 'Male');
        //     setIdentityType("NRIC");

        //     //setIndividualRelationship(parseInt(ic.substr(ic.lastIndexOf('-'))) % 2 == 0 ? 'D' : 'S');

        // } else {
        //    // setDateOfBirth("");
        //    // setNationality("");
        //     //setInsuredNationality("");
        //     //setInsuredCountry(props.malNationality.msig_countrycode); //default to Malaysia
        //    // setGender("");
        //     setIdentityType("Passport");

        // }

        


    }


    function changeInsuredRelationship(e) {

        setInsuredRelationship(e.label);

    }

    function changeMaritalStatus(e) {

       
        setInsuredMaritalStatus(e.value);
        setInsuredMaritalStatusValue(e.value);

    }

    function updateNomineeRelationship(e) {

        setNomineeRelationship(e.label);
    }

    function updateNationality(e) {

        setNationality(e.label);
        setInsuredNationality(e.countrycode);

        switch(props.selectedPlan.insurer) {
            case insurer_msig:
                setInsuredNationality(e.msig_countrycode);
            break;
            case insurer_tune:
                setInsuredNationality(e.tune_countrycode);
            break;
        }

    }

    function updateCountry(e) {

        setInsuredCountry(e.countrycode);

        switch(props.selectedPlan.insurer) {
            case insurer_msig:
                setInsuredCountry(e.msig_countrycode);
            break;
            case insurer_tune:
                setInsuredCountry(e.tune_countrycode);
            break;
        }
    }

    function onAddInsured() {
    
       

        setAllowContinue(false);

        if (email && !email.match(/^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/)) {

            swalAlert.fire({
                title: 'Oops...',
                icon: 'error',
                text: 'Invalid email address. Please re-enter. '
            }).then((result) => {
                if (result.isConfirmed) {
                    clearState(false, 'Email')
                }
            });
            return false;
        
        }   

        if (identityType == 'NRIC' && !idNumber.match(/^((\d{2})([0][1-9]|[1][0-2])([0][1-9]|[1-2][0-9]|[3][0-1])\d{2}\d{4})|([a-zA-Z]{1}[0-9]{7,8})$/m)) {
            swalAlert.fire({
                title: 'Oops...',
                icon: 'error',
                text: 'Invalid NRIC format. Please re-enter. '
            }).then((result) => {
                if (result.isConfirmed) {
                    clearState(false, 'IDNumber')
                }
            });

            return false;
        } else if (identityType == 'NRIC' && nomineeID != "" && !nomineeID.match(/^((\d{2})([0][1-9]|[1][0-2])([0][1-9]|[1-2][0-9]|[3][0-1])\d{2}\d{4})|([a-zA-Z]{1}[0-9]{7,8})$/m)) {
            swalAlert.fire({
                title: 'Oops...',
                icon: 'error',
                text: 'Invalid NRIC format. Please re-enter for Nominee.'
            }).then((result) => {
                if (result.isConfirmed) {
                    clearState(false, 'NomineeIDNumber')
                }
            });

            return false;
        } else if(identityType == 'Passport' && (idNumber.length < 8 || idNumber.length > 12)) {

            swalAlert.fire({
                title: 'Oops...',
                icon: 'error',
                text: 'Passport No. must be between 8 and 12 characters. Please re-enter.'
            }).then((result) => {
                if (result.isConfirmed) {
                    clearState(false, 'Passport')
                }
            });

            return false;

        }

        switch(props.selectedPlan.insurer) {
            case insurer_msig:
            case insurer_rhbi: 
            case insurer_tune:   
               msigRhbInsuredRules();
                break;
        }
          
    }

    function msigRhbInsuredRules() {

        //let dateCurr = new Date();
        let currYear = Moment(props.travelInfo.departureDate, "DD/MM/YYYY").format('YYYY');
        let dobYear = Moment(dateOfBirth).format('YYYY');

        let diffYear = (parseInt(currYear) - parseInt(dobYear));

        let insuredAge = Moment(props.travelInfo.departureDate, 'DD/MM/YYYY').diff(dateOfBirth, 'years',false);

        if(props.selectedPlan.insurer == insurer_rhbi) {
            insuredAge = Moment().diff(Moment(dateOfBirth), 'years',false) + 1;
        }

        if((insureds.length === 0 || index === 1) || insuredRelationship === 'Spouse' || props.travelInfo.buyFor == 'GP') {

            if(props.selectedPlan.insurer == insurer_msig) {
                if ( insuredAge > 69 || insuredAge < 18) {

                    let message = (index === 1 || props.travelInfo.buyFor == 'GP') ? 'Sorry, Age of Insured must between 18 to 69 years old.' : 'Sorry, Age of spouse must between 18 to 69 years old.';
    
                    swalAlert.fire({
                        title: 'Oops...',
                        icon: 'error',
                        text: message
                    }).then((result) => {
                        if (result.isConfirmed) {
                            setDateOfBirth("");
                            setIDNumber("");
                        }
                    });
        
                    return false;
                } 

            } else if(props.selectedPlan.insurer == insurer_rhbi && (props.travelInfo.buyFor != 'IC' && groupType != 'C' && insuredRelationship != 'Child')) {


                if(props.selectedPlan.planId == 'SUPREME' && insuredAge > 60) {

                    let message = 'Sorry, Age of Insured must between 19 to 60 years old.';
    
                    swalAlert.fire({
                        title: 'Oops...',
                        icon: 'error',
                        text: message
                    }).then((result) => {
                        if (result.isConfirmed) {
                            setDateOfBirth("");
                            setIDNumber("");
                        }
                    });

                    return false;


                } else if( insuredAge > 80 || insuredAge < 19) {

                    let message = 'Sorry, Age of Insured must between 19 to 80 years old.';
    
                    swalAlert.fire({
                        title: 'Oops...',
                        icon: 'error',
                        text: message
                    }).then((result) => {
                        if (result.isConfirmed) {
                            setDateOfBirth("");
                            setIDNumber("");
                        }
                    });

                    return false;
                }
        
            } 
            // else if(props.selectedPlan.insurer == insurer_tune) {

            //     if ( diffYear > 55 || diffYear < 18) {

            //         let message = (index === 1) ? 'Sorry, Age of Insured must between 18 to 55 years old.' : 'Sorry, Age of spouse must between 18 to 55 years old.';
    
            //         swalAlert.fire({
            //             title: 'Oops...',
            //             icon: 'error',
            //             text: message
            //         }).then((result) => {
            //             // if (result.isConfirmed) {
            //             //     props.setActiveId('travel');
            //             // }
            //         });
        
            //         return false;
            //     } 


            // }
            

        }

        if(props.selectedPlan.insurer == insurer_msig) {
            if (insuredRelationship === 'Child' && 
                ((parseInt(Moment(props.travelInfo.departureDate, 'DD/MM/YYYY').diff(Moment(dateOfBirth), 'days')) < 30 ) || insuredAge > 17)) 
            {
    
                    swalAlert.fire({
                        title: 'Oops...',
                        icon: 'error',
                        text: 'Sorry, Age of Child must between 30 days to 17 years old.'
                    }).then((result) => {
                        // if (result.isConfirmed) {
                        //     props.setActiveId('travel');
                        // }
                    });
        
                    return false;
    
            }

        } else if(props.selectedPlan.insurer == insurer_rhbi) {

            let maxChildAge = stillStuding == 'N' ? 19 : 23;

            if ((insuredRelationship === 'Child' || groupType == 'C' || props.travelInfo.buyFor == 'IC') && 
                ((parseInt(Moment(props.travelInfo.departureDate, 'DD/MM/YYYY').diff(Moment(dateOfBirth), 'days')) < 15 ) || insuredAge > maxChildAge)) 
            {
    
                    swalAlert.fire({
                        title: 'Oops...',
                        icon: 'error',
                        text: "Sorry, Age of Child must between 15 days to " + maxChildAge+ " years old."
                    }).then((result) => {
                        // if (result.isConfirmed) {
                        //     props.setActiveId('travel');
                        // }
                    });
        
                    return false;
    
            }


        } else if(props.selectedPlan.insurer == insurer_tune) {

            if (insuredRelationship === 'Child' && 
                ((parseInt(Moment(props.travelInfo.departureDate, 'DD/MM/YYYY').diff(Moment(dateOfBirth), 'days')) < 30 ) || insuredAge > 21)) 
            {
    
                    swalAlert.fire({
                        title: 'Oops...',
                        icon: 'error',
                        text: 'Sorry, Age of Child must between 30 days to 21 years old.'
                    }).then((result) => {
                        // if (result.isConfirmed) {
                        //     props.setActiveId('travel');
                        // }
                    });
        
                    return false;
    
            }

        }

        if(props.selectedPlan.insurer == insurer_tune && insuredRelationship !== 'Child') {

            if(props.travelInfo.isDomestic == true) {

                if((insuredAge > 80) || (insuredAge < 18)) {
                    swalAlert.fire({
                        title: 'Oops...',
                        icon: 'error',
                        text: 'Sorry, Age of Insured must be between 18 years old to 80 years old.'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            setDateOfBirth("");
                            setIDNumber("");
                        }
                    });
                
                }


            } else {

                //60 and below
                if(props.travelInfo.tuneCheckAge == false) {

                    if((insuredAge > 60) || (insuredAge < 18)) {
                    //if(diffYear < 18 || diffYear > 60) {
                        swalAlert.fire({
                            title: 'Oops...',
                            icon: 'error',
                            text: 'Sorry, Age of Insured must between 18 years old to 60 years old.'
                        }).then((result) => {
                            if (result.isConfirmed) {
                                setDateOfBirth("");
                                setIDNumber("");
                            }
                        });
                        return false;
                    }

                } else {

                    if((insuredAge > 80) || (insuredAge < 61)) {
                        swalAlert.fire({
                            title: 'Oops...',
                            icon: 'error',
                            text: 'Sorry, Age of Insured must between 61 years old to 80 years old.'
                        }).then((result) => {
                            // if (result.isConfirmed) {
                            //     props.setActiveId('travel');
                            // }
                        });
                        return false;
                    }

                }

            }

            
        }
        
       

        if (insureds.find(insured => insured.idNumber == idNumber) === undefined || index != insureds.length + 1) {

        } else {

            swalAlert.fire({
                title: 'Oops...',
                icon: 'error',
                text: 'Double entry of Insured Person.'
            }).then((result) => {
                if (result.isConfirmed) {
                    clearState(true);
                }
            });

            return false;
        }

        if (idNumber == nomineeID) 
        {
            swalAlert.fire({
                title: 'Oops...',
                icon: 'error',
                text: 'You cannot be the nominee for your own policy. Please insert the details of your next of kin.'
            }).then((result) => {
                if (result.isConfirmed) {
                    setNomineeName("");
                    setNomineeID("");
                }
            })

            return false;
        }

        ////////////////////////////////////////////////////
        // (index === 1 && props.selectedPlan.insurer == insurer_msig &&
        //     (!name || !idNumber || !gender || !nationality || !mobileNo || !email || !address1 || !postcode))
        //     || ((props.travelInfo.planType === 'Individual') && props.selectedPlan.insurer == insurer_msig && (!name || !idNumber || !gender || !nationality ||
        //         !mobileNo || !email || !address1 || !postcode))
        //     || (index === 1 && props.selectedPlan.insurer == insurer_rhbi &&
        //         (!name || !idNumber || !gender || !nationality || !mobileNo || !email))
        //     || ((props.travelInfo.planType === 'Individual' || props.travelInfo.planType === 'Group') && props.selectedPlan.insurer == insurer_rhbi && (!name || !idNumber || !gender || !nationality ||
        //         !mobileNo || !email))          
        //     || (index > 1 && ((props.travelInfo.planType === 'Family' && insuredRelationship === "-- Select a relationship --") || !name || !idNumber || !gender || !nationality))

        let mandatory_missing = false;

        if(index === 1 && props.selectedPlan.insurer == insurer_msig && (!name || !idNumber ||  !dateOfBirth || !gender || !insuredNationality || !mobileNo || !email || !address1 || !postcode || !insuredCountry || (allowNomination && !nomineeName) || (allowNomination && !nomineeID) || (allowNomination && nomineeRelationship === "-- Select a Relationship --"))) {
            mandatory_missing = true;
        } 

        if(index === 1 && props.selectedPlan.insurer == insurer_rhbi && (!name || !idNumber ||  !dateOfBirth || !gender || !insuredNationality || !mobileNo || !email  || !address1 || !postcode)) {
            mandatory_missing = true;
        }

        if(index === 1 && props.selectedPlan.insurer == insurer_tune && (!name || !idNumber ||  !dateOfBirth || !gender || !insuredNationality || !mobileNo || !email || !address1 || !postcode || !insuredCountry)) {
            mandatory_missing = true;
        } 


        if((props.travelInfo.planType === 'Individual' || props.travelInfo.planType === 'Group') && (props.selectedPlan.insurer == insurer_rhbi || props.selectedPlan.insurer == insurer_tune) && (!name || !idNumber || !gender || !nationality ||
            !mobileNo || !email  || !address1 || !postcode)) 
        {
            mandatory_missing = true;
            
        }

        if((index > 1 && props.selectedPlan.insurer == insurer_msig) && (!name || !idNumber || !dateOfBirth ||  !insuredNationality )) {
            mandatory_missing = true;
        }

        if((index > 1 && props.selectedPlan.insurer == insurer_tune) && (!name || !idNumber || !dateOfBirth ||  !insuredNationality )) {
            mandatory_missing = true;
        }

        // check for e-invoice fields
        if(einvoiceEnable && ((index == 1 && props.travelInfo.buyFor == 'FC') || props.travelInfo.buyFor != 'FC')) {
        //if(einvoiceEnable && index === 1) {
            if(!einvoiceIndicator || (einvoiceIndicator == 'Y' && (!sstIndicator)) || (sstIndicator == 'Y' && !sstNo))
            {
                swalAlert.fire({
                    title: 'Oops...',
                    icon: 'error',
                    text: 'Please enter or select required e-Invoice details to proceed.'
                });
    
                return false;
                
            }
           

            if(!isEmpty(tinNo) && tinNo.length < 10) {

                swalAlert.fire({
                    title: 'Oops...',
                    icon: 'error',
                     text: 'TIN must be between 10 and 14 characters. Please re-enter.'
                });
    
                return false;

            } 

        }


        if(mandatory_missing == true) {
            swalAlert.fire({
                title: 'Oops...',
                icon: 'error',
                text: 'Please enter the required insured details to proceed.'
            });

            return false;
        }

        // if(props.travelInfo.buyFor == 'FC') {

        //     if(insuredRelationship == 'Spouse') {

        //         setInsuredRelationships(insuredRelationships.filter((relationship) => relationship.label === "Child"));

        //         $("#relationshipId").find(".css-1uccc91-singleValue").html("");
        //         setInsuredRelationship('Child');

        //     }           
        // }
        /////////////////////////////////////////////////////

       

        let insuredType = 1;

        if(index ===1 || insuredRelationship === 'Spouse') {
            insuredType = 1;
        } else {
            insuredType = 2;
        }

        if(editForm === false) {
            countIdentityType();
        }

        let newInsured = {
            insuredRelationship: insuredRelationship,
            name: name,
            idNumber: idNumber,
            groupType: 'A', //fixed to Adult
            parentName: parentName,
            parentIdNumber: parentIdNumber,
            identityType:identityType,
            dateOfBirth: Moment(dateOfBirth).format('YYYY-MM-DD'),
            gender: gender,
            nationality: nationality,
            insuredNationality: (props.selectedPlan.insurer == insurer_rhbi || props.travelInfo.nationality == 'MAL') ? props.travelInfo.nationality : insuredNationality,
            mobileNo: mobileNo,
            displayMobileNo: displayMobileNo,
            email: email,
            address1: address1,
            address2: address2,
            address3: address3,
            address4: address4,
            postcode: postcode,
            state: state,
            stateValue: stateValue,
            insuredCountry: insuredCountry,
            insuredType : insuredType, // 1 - adult, 2 - child
            planId: props.selectedPlan.planId,
            planName: props.selectedPlan.product,
            totalAmount: props.selectedPlan.totalAmount,
            quotationID: props.selectedPlan.quotationID,
            //travelCountryCode:  props.travelInfo.destination.msig_countrycode,
            travelCountryCode: (props.travelInfo.productType == 'TDA') ? '' : props.travelInfo.destination.msig_countrycode,
            travelDestination: props.travelInfo.destination,
            noOfAdults: props.travelInfo.noOfAdults,
            noOfChildren:  props.travelInfo.noOfChildren,
            productType: props.travelInfo.productType,
            travelTo: props.travelInfo.travelTo,
            travelStartDate: Moment(props.travelInfo.departureDate, "DD/MM/YYYY").format('YYYY-MM-DD'),
            travelEndDate: Moment(props.travelInfo.returnDate, "DD/MM/YYYY").format('YYYY-MM-DD'),
            buyFor: props.travelInfo.buyFor,
            token: props.token,
            tuneToken: props.tuneToken,
            individualRelationship: individualRelationship,
            //maritalStatus: insuredMaritalStatus,
            maritalStatus: maritalStatus,
            stillStuding: stillStuding,
            region: region,
            nominee: {
                name: nomineeName,
                idNumber: nomineeID,
                 relationship: nomineeRelationship.label? nomineeRelationship.label : nomineeRelationship
               // relationship: nomineeRelationship
            },
            einvoiceEnable: einvoiceEnable,
            einvoiceIndicator: einvoiceIndicator,
            tinNo: tinNo,
            sstIndicator: sstIndicator,
            sstNo: sstNo
        };

        if (index !== insureds.length + 1) {
            let _insureds = insureds;
            _insureds.splice(index - 1, 1, newInsured);
            setInsureds(_insureds);

            setIndex(insureds.length + 1);

        } else {
            setInsureds([...insureds, newInsured]);
        }

        setAllowContinue(true);

        setEditForm(false);

        clearState(true);

        console.log('newInsured');
        console.log(newInsured);
                        

    }

    function countIdentityType () {
        if(index ===1 || insuredRelationship === 'Spouse') {
            setTotalAdult(totalAdult + 1);
          
        } else {
            setTotalChild(totalChild + 1);
        }

    }

    function removeCountIdentityType (insuredIdentityType) {
        if(insuredIdentityType == 1) {
            setTotalAdult(totalAdult - 1);
        } else {
            setTotalChild(totalChild - 1);
        }

    }

    function updateRegion(e) {
        setRegion(e.value);
        setMaritalStatus(e.value);
        setInsuredMaritalStatusValue(e.label);
        // if(e.value == 1) {
        //     setAllowNomination(false);
        // } else {
        //     setAllowNomination(true);
        // }
    }

    

    function onClickNext(e) {
        e.preventDefault();  

        let TotalInsured = parseInt(totalAdult) + parseInt(totalChild);

       
       

        if(props.selectedPlan.insurer == insurer_msig) {

            if(props.travelInfo.noOfAdults != totalAdult) {
                swalAlert.fire({
                    title: 'Oops...',
                    icon: 'error',
                    text: 'Sorry, number of adults shoud be '+props.travelInfo.noOfAdults,
                });
    
                return false;

            }

            if(props.travelInfo.noOfChildren != totalChild) {
                swalAlert.fire({
                    title: 'Oops...',
                    icon: 'error',
                    text: 'Sorry, number of children shoud be '+props.travelInfo.noOfChildren,
                });
    
                return false;

            }

            if(totalAdult < 0) {
                swalAlert.fire({
                    title: 'Oops...',
                    icon: 'error',
                    text: 'Sorry, Minimum number of adults in Family Plan is 1.',
                });
    
                return false;
            }
    
            if(totalAdult > 2) {
                swalAlert.fire({
                    title: 'Oops...',
                    icon: 'error',
                    text: 'Sorry, Number of adults in Family Plan is up to maximum 2.',
                });
    
                return false;
            }
    
            if(TotalInsured > 6) {
                swalAlert.fire({
                    title: 'Oops...',
                    icon: 'error',
                    text: 'Sorry, Total number of people in Family Plan is up to maximum 6.',
                });
    
                 return false;
    
            }

            //msigValidationCustomer();
          
        }
        else if(props.selectedPlan.insurer == insurer_rhbi) {

        } else if(props.selectedPlan.insurer == insurer_tune) {

            if(props.travelInfo.planType === 'Family')
            {   

                if(props.travelInfo.noOfAdults != totalAdult) {
                    swalAlert.fire({
                        title: 'Oops...',
                        icon: 'error',
                        text: 'Sorry, number of adults shoud be '+props.travelInfo.noOfAdults,
                    });
        
                    return false;

                }

                if(props.travelInfo.noOfChildren != totalChild) {
                    swalAlert.fire({
                        title: 'Oops...',
                        icon: 'error',
                        text: 'Sorry, number of children shoud be '+props.travelInfo.noOfChildren,
                    });
        
                    return false;

                }

                if(totalAdult < 0) {
                    swalAlert.fire({
                        title: 'Oops...',
                        icon: 'error',
                        text: 'Sorry, Minimum number of adults in Family Plan is 1.',
                    });
        
                    return false;
                }
        
                if(totalAdult > 2) {
                    swalAlert.fire({
                        title: 'Oops...',
                        icon: 'error',
                        text: 'Sorry, Number of adults in Family Plan is up to maximum 2.',
                    });
        
                    return false;
                }

                if(totalChild > 10) {
                    swalAlert.fire({
                        title: 'Oops...',
                        icon: 'error',
                        text: 'Sorry, Number of children in Family Plan is up to maximum 10.',
                    });
        
                    return false;

                }

        
                if(TotalInsured > 12) {
                    swalAlert.fire({
                        title: 'Oops...',
                        icon: 'error',
                        text: 'Sorry, Total number of people in Family Plan is up to maximum 12.',
                    });
        
                    return false;
        
                }

            }

        } 
        else {

            if (props.travelInfo.planType === 'Family' && insureds.length < 2) {

                swalAlert.fire({
                    title: 'Hmm...',
                    icon: 'warning',
                    text: 'You need to insert minimum 2 travellers for family plan (one adult one child).'
                });
    
            } 
            else if (insureds.length > 0) {
                recalculatePremium().then(() => {
                    props.setInsuredInfo(insureds);
                    props.setActiveId('payment');
                });
            } else {
                swalAlert.fire({
                    title: 'Oops...',
                    icon: 'error',
                    text: 'Please enter the required insured and nominee details to proceed.'
                });
            }

        }

        insurerValidationCustomer();

        
    }

    function onClickBack() {
        props.setActiveId('add-on');
    }

    function clearState(all = false, part = '') {
        if (all) {
            setInsuredRelationship("-- Select a Relationship --");
            setName("");
            setIDNumber("");
            setParentIdNumber("");
            setParentName("");
            setGroupType("");
            setIdentityType("");
            setDateOfBirth("");
            setGender("");
            setNationality("");
            setMobileNo("");
            setDisplayMobileNo("");
            setEmail("");
            setAddress1("");
            setAddress2("");
            setAddress3("");
            setAddress4("");
            setPostcode("");
            setInsuredNationality("");
            setInsuredCountry("");
            setNomineeName("");
            setNomineeID("");
            setNomineeRelationship("-- Select a Relationship --");
            setIndividualRelationship("");
            setInsuredMaritalStatus("S");
            setStillStuding("")

            //updateEinvoice();
            
            setEinvoiceIndicator(einvoiceIndicator);
            setTinNo("");
            setSstIndicator("");
            setSstNo("");
            

        } else {
            if (identityType == 'NRIC'  && part == 'IDNumber') {
                setIDNumber("");
                setDateOfBirth("");
                setGender("");
                setNationality("");
                setIdentityType("");
            }
            else if (part == 'Passport') {
                setIDNumber("");
            }      
            else if (part == 'NomineeIDNumber') {
                setNomineeID("");
            }  else if (part == 'Email') {
                setEmail("");
            }
        }
    }

    function handleEditInsured(index) {

        $('.insured-form').prop("disabled", false);
       
        let insured = insureds[index];

      

        // if(props.travelInfo.buyFor == 'FC') {

        //     setInsuredRelationships([{ value: 1, label: "Spouse" }, { value: 2, label: "Child" }]);

        //     // if(insured.insuredRelationship == 'Spouse') {

        //     //     setInsuredRelationships([{ value: 1, label: "Spouse" }]);
 
        //     // }
            
        //     // if(insured.insuredRelationship == 'Child') {

        //     //     setInsuredRelationships([{ value: 1, label: "Child" }]);
 
        //     // }    
        // }

        console.log(insured);

        if(insured.insuredRelationship == 'Spouse') {
            setInsuredRelationships([
                { value: 1, label: "Spouse" },
            ]);
        }

        if(insured.insuredRelationship == 'Child') {
            setInsuredRelationships([
                { value: 2, label: "Child" }
            ]);
        }


        setInsuredRelationship(insured.insuredRelationship || "");
        setName(insured.name);
        setIDNumber(insured.idNumber);
        setParentIdNumber(insured.parentIdNumber);
        setParentName(insured.parentName);
        setGroupType(insured.groupType);
        setIdentityType(insured.identityType);
        setDateOfBirth(new Date(Moment(insured.dateOfBirth).format('YYYY-MM-DD')+" 00:00:00"));
        setGender(insured.gender);
        setNationality(insured.nationality);
        setMobileNo(insured.mobileNo);
        setDisplayMobileNo(insured.displayMobileNo);
        setEmail(insured.email);
        setAddress1(insured.address1);
        setAddress2(insured.address2);
        setAddress3(insured.address3);
        setAddress4(insured.address4);
        setPostcode(insured.postcode);
        setInsuredNationality(insured.insuredNationality);
        setInsuredCountry(insured.insuredCountry);
        setNomineeName(insured.nominee.name);
        setNomineeID(insured.nominee.idNumber);
        setNomineeRelationship(insured.nominee.relationship);
        setIndividualRelationship(insured.individualRelationship);
        setInsuredMaritalStatus(insured.insuredMaritalStatus);
        setStillStuding(insured.stillStuding);

        setMaritalStatus(insured.maritalStatus);

        //updateInsuredRelationship();
        
        setEinvoiceIndicator(insured.einvoiceIndicator);
        setTinNo(insured.tinNo);
        setSstIndicator(insured.sstIndicator);
        setSstNo(insured.sstNo);
        

        setEditForm(true);

      

        setIndex(index + 1);

        document.getElementById('add-insured-btn').classList.remove('d-none');
    }

    function handleDeleteInsured(row) {

       
        if (insureds.length !== 0) {
           
            removeCountIdentityType(insureds[row].insuredType);
            insureds.splice(row , 1);
           
            setInsureds(insureds);

            setIndex(insureds.length + 1);

            updateInsuredRelationship('delete');

            $('.insured-form').prop("disabled", false);
        }

    }

    function insurerValidationCustomer() {

        swalAlert.fire({
            title: 'Please Wait...',
            allowOutsideClick: false
        });
        swalAlert.showLoading();

        axios.post('/api/update-validate-customer', {
            insurer: props.selectedPlan.insurer,
            token: props.token,
            tuneToken: props.tuneToken,
            insureds: insureds,
            travelInfo: {
                travelCountryCode: (props.travelInfo.productType == 'TDA') ? '' : props.travelInfo.destination.msig_countrycode,
                travelDestination: props.travelInfo.destination,
                noOfAdults: props.travelInfo.noOfAdults,
                noOfChildren:  props.travelInfo.noOfChildren,
                productType: props.travelInfo.productType,
                travelTo: props.travelInfo.travelTo,
                travelStartDate: Moment(props.travelInfo.departureDate, "DD/MM/YYYY").format('YYYY-MM-DD'),
                travelEndDate: Moment(props.travelInfo.returnDate, "DD/MM/YYYY").format('YYYY-MM-DD'),
                buyFor: props.travelInfo.buyFor,
            },
            planInfo: {
                planId: props.selectedPlan.planId,
                planName: props.selectedPlan.product,
                totalAmount: props.selectedPlan.totalAmount,
                quotationID: props.selectedPlan.quotationID,
            },
            transactionNo: props.transactionNo
        }).then((response) => {
          

            swalAlert.close()

    
            //var responseData = JSON.parse(response.data.data);
        
            if(response.status == 200) {

                if(response.data.status == 200) {
                    props.setInsuredInfo(insureds);
                    props.setActiveId('payment');
                } else {

                    swalAlert.fire({
                        title: 'Oops...',
                        icon: 'error',
                        text: response.data.message,
                    });
        
                    return false;

                }
               
            }

           
        }).catch((error) => {
            swalAlert.close()
            console.log(error);
        });

    }

    function msigValidationCustomer() {

        // props.setInsuredInfo(insureds);
        // props.setActiveId('payment');

        swalAlert.fire({
            title: 'Please Wait...',
            allowOutsideClick: false
        });
        swalAlert.showLoading();

        axios.post('/api/validate-customer', {
            insurer: insurer_msig,
            token: props.token,
            tuneToken: props.tuneToken,
            insureds: insureds,
        }).then((response) => {
          

            swalAlert.close()

    
            //var responseData = JSON.parse(response.data.data);
        
            if(response.status == 200) {

                if(response.data.status == 200) {
                    props.setInsuredInfo(insureds);
                    props.setActiveId('payment');
                } else {

                    swalAlert.fire({
                        title: 'Oops...',
                        icon: 'error',
                        text: response.data.message,
                    });
        
                    return false;

                }
               
            }

           
        }).catch((error) => {
            swalAlert.close()
            console.log(error);
        });

    }

    return (
        <Form onSubmit={(e) => onClickNext(e)}>
            <div className="mb-3 row justify-content-between">
                <div className="col-12 col-lg-5 pricing pb-3 pb-lg-0">
                    <Sticky boundaryElement=".pricing">
                        <Card className="rounded border-top">
                            <Card.Header>
                                <div className="mb-3 row mb-0">
                                    <div className="col-12 text-center">
                                        <h5>{getInsurerFullName(props.selectedPlan.insurer)}</h5>
                                        <p>{props.selectedPlan.product}</p>
                                    </div>
                                </div>
                            </Card.Header>
                            <Card.Body className="border-top-0">
                                <div className="mb-3 row">
                                    <div className="col-12">
                                        <div className="row justify-content-around">
                                            <label className="col-12 mb-sm-0">{props.travelInfo.tripType + " - " + props.selectedPlan.plan + " (" +props.travelInfo.planType + ")"}</label>
                                        </div>
                                        <div className="row justify-content-around">
                                            {props.travelInfo.tripType == 'Annual' ?
                                                <>
                                                {props.travelInfo.isDomestic == true ?
                                                    <label className="col-12 mb-sm-0">{"Area " + props.travelInfo.destination?.label +  " - Domestic"}</label>   
                                                 :   

                                                    <label className="col-12 mb-sm-0">{"Area " + props.travelInfo.destination?.label +  " - International"}</label>

                                                }
                                                
                                                </>
                                                

                                            :
                                                <>
                                                {props.travelInfo.isDomestic == true ?

                                                    <label className="col-12 mb-sm-0">{props.travelInfo.destinationList + " - Domestic"}</label>   

                                                :

                                                    <label className="col-12 mb-sm-0">{props.travelInfo.destinationList + " - International"}</label>   
                                                }
                                                </>
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="mb-3 row">
                                    <label className="col-6 col-form-label">Premium</label>
                                    <label className="col-6 col-form-label text-end fw-bold">
                                        RM {parseFloat(props.grossPremium).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                    </label>
                                </div>
                                <div className="mb-3 row">
                                    <div className="col-8">
                                        <Accordion>
                                            <Accordion.Toggle as={Card.Header} eventKey={!isEmpty(props.selectedAddOns) ? 'add-ons' : '' } className={!isEmpty(props.selectedAddOns) ? 'ps-0 border-0 clickable' : 'ps-0 border-0'}>
                                            {!isEmpty(props.selectedAddOns) ? '+' : '' }
                                                Add On Benefits
                                            </Accordion.Toggle>
                                            <Accordion.Collapse eventKey='add-ons'>
                                                <Card.Body>
                                                    {props.selectedAddOns?.map((add_ons) => (
                                                        <div className="row py-2 border-bottom">
                                                            <label className="col-6 pe-0">{add_ons.name}</label>
                                                            <label className="col-6 text-end">
                                                                RM {parseFloat(add_ons.premium).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                            </label>
                                                        </div>
                                                    ))}
                                                </Card.Body>
                                            </Accordion.Collapse>
                                        </Accordion>
                                    </div>
                                    <div className="col-4 text-end">
                                        <label className="col-form-label fw-bold align-self-center">
                                            RM {parseFloat(props.addOnsTotal).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                        </label>
                                    </div>
                                </div>
                                <div className="mb-3 row">
                                    <label className="col-6">Stamp Duty</label>
                                    <label className="col-6 text-end fw-bold">
                                        {parseFloat(props.stampDuty) == 0 ? 'Not Applicable' : 'RM ' + parseFloat(props.stampDuty).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                    </label>
                                </div>

                                <div className={((props.selectedPlan.insurer === insurer_msig || props.selectedPlan.insurer === insurer_rhbi || props.selectedPlan.insurer === insurer_tune) ? "" : "d-none") + " mb-3 row"}>
                                    <label className="col-6">Service Tax</label>
                                    <label className="col-6 text-end fw-bold">
                                        {parseFloat(props.serviceTax) == 0 ? 'Not Applicable' : 'RM ' + parseFloat(props.serviceTax).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                    </label>
                                </div>
                            </Card.Body>
                            <Card.Footer>
                                <div className="mb-3 row mb-0">
                                    <label className="col-6">Total Payable</label>
                                    <label className="col-6 text-end fw-bold">
                                        RM {parseFloat(props.totalPayable).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                    </label>
                                </div>
                            </Card.Footer>
                        </Card>
                    </Sticky>
                </div>

                <div className="col-12 col-lg-7">
                    <div className={((props.selectedPlan.insurer == insurer_msig || props.selectedPlan.insurer == insurer_rhbi || props.selectedPlan.insurer == insurer_tune) && (index > maxInsured)) ? 'd-none' : 'border rounded px-3'}>
                        
                        <div className="mb-3 row">
                            <label className="col-12 col-sm-12 col-form-label">
                                <small>Fields marked with an asterisk(<span className="text-danger">*</span>) are required.</small>
                            </label>
                        </div>


                        <div className={(index > 1 && (props.travelInfo.planType != 'Individual' && props.travelInfo.planType != 'Group') ? "" : "d-none ") + "mb-3 row"}>
                            <label className="col-12 col-sm-4">Relationship with Insured # <span className="text-danger">*</span></label>
                            <div className="col-12 col-sm-8">
                                <Select
                                    id="relationshipId"
                                    className="insured-form"
                                    styles={{
                                        control: provided => ({ ...provided, borderRadius: "2rem" })
                                    }}
                                    options={insuredRelationships}
                                    onChange={(e) => changeInsuredRelationship(e)}
                                    value={insuredRelationships.find(relationship => relationship.label == insuredRelationship)}
                                    placeholder="Select a Relationship"
                                    required
                                    disabled={((props.selectedPlan.insurer == insurer_msig || props.selectedPlan.insurer == insurer_rhbi || props.selectedPlan.insurer === insurer_tune) && (index > maxInsured))
                                        ? 
                                        'disabled'  : ''}
    
                                />
                            </div>
                        </div>

                        {props.travelInfo.planType == 'Child' || groupType == 'C' ?
                            <h5 className="fw-bold my-4">A. Child Details</h5> 
                             :
                            <h5 className="fw-bold my-4">{"A. Insured Persons #" + index}</h5> 
                        }

                        <div className="mb-3 row">
                            <label className="col-12 col-sm-4">Full Name <span className="text-danger">*</span><br /><small>(as per NRIC)</small></label>
                            <div className="col-12 col-sm-8">
                                <input type="text" className="form-control insured-form" value={name} maxLength={50} onChange={(e) => setName(e.target.value)} 
                                 disabled={((props.selectedPlan.insurer == insurer_msig || props.selectedPlan.insurer == insurer_rhbi || props.selectedPlan.insurer === insurer_tune) && (index > maxInsured))
                                    ? 
                                    'disabled'  : ''}
                                />
                            </div>
                        </div>
                        <div className="mb-3 row">
                            {props.selectedPlan.insurer == insurer_rhbi || (!isEmpty(props.travelInfo.nationality) && props.travelInfo.nationality != 'ALL') ?
                                <>
                                    <label className="col-12 col-sm-4">
                                        {insuredRelationship == 'Child' ?
                                            <>
                                            NRIC/ MYKID
                                            </>

                                            :
                                            <>
                                            NRIC
                                            </>
                                        }
                                       
                                        <span className="text-danger">*</span>
                                    </label>

                                    <div className="col-12 col-sm-8">

                                        <InputMask
                                            mask="999999-99-9999"
                                            maskChar=""
                                            type="text"
                                            className="form-control"
                                            required
                                            value={idNumber}
                                            placeholder="e.g 891011021234"
                                            onChange={(e) => checkDetails(e.target.value, 'id')}
                                            disabled={((props.selectedPlan.insurer == insurer_msig || props.selectedPlan.insurer == insurer_rhbi || props.selectedPlan.insurer == insurer_tune) && (index > maxInsured))
                                                ? 
                                                'disabled'  : ''}
                                        />


                                    </div>

                                    {isIdChange?            
                                        <label class="col-12">
                                            <small class="text-danger">Please key in NRIC as Date of Birth changed.</small>
                                        </label>
                                    :
                                        null
                                    }
                                </>

                            :
                                <>
                                    <label className="col-12 col-sm-4">Passport No. <span className="text-danger">*</span></label>
                                    <div className="col-12 col-sm-8">

                                        <InputMask
                                            mask="************"
                                            maskChar=""
                                            type="text"
                                            className="form-control"
                                            required
                                            value={idNumber}
                                            placeholder="e.g A18556788"
                                            onChange={(e) => checkDetails(e.target.value, 'id')}
                                            disabled={((props.selectedPlan.insurer == insurer_msig || props.selectedPlan.insurer == insurer_rhbi || props.selectedPlan.insurer === insurer_tune) && (index > maxInsured))
                                                ? 
                                                'disabled'  : ''}
                                        />

                                        {/* <input
                                            type="text"
                                            placeholder="eg. 891011021234"
                                            className="form-control insured-form"
                                            value={idNumber} onChange={(e) => checkDetails(e, 'id')}
                                            disabled={((props.selectedPlan.insurer == insurer_msig || props.selectedPlan.insurer == insurer_rhbi) && (index > maxInsured))
                                                ? 
                                                'disabled'  : ''}
            
                                        /> */}
                                    </div>

                                    {isIdChange?            
                                        <label class="col-12">
                                            <small class="text-danger">Please key in NRIC/ MYKID/ Passport No. as Date of Birth changed.</small>
                                        </label>
                                    :
                                        null
                                    }    
                                </>        
                            }
                            
                        </div>
                        <div className="mb-3 row">
                            <label className="col-12 col-sm-4">Date of Birth <span className="text-danger">*</span></label>
                            <div className="col-12 col-sm-8">

                            {(props.selectedPlan.insurer == insurer_rhbi || (!isEmpty(props.travelInfo.nationality) && props.travelInfo.nationality != 'ALL')) ?
                                   
                                    <DatePicker
                                        id="insured-dob"
                                        className="form-control"
                                        dateFormat="dd/MM/yyyy"
                                        selected={dateOfBirth || ""}
                                        onChange={(date) => { setDateOfBirth(date) }}
                                        autoComplete="off" 
                                        disabled
                                        showYearDropdown
                                        showMonthDropdown
                                        scrollableYearDropdown
                                        dropdownMode="select"    
                                        
                                    />

                                :
                                
                                    <DatePicker
                                        id="insured-dob"
                                        className="form-control insured-form"
                                        dateFormat="dd/MM/yyyy"
                                        selected={dateOfBirth || ""}
                                        onChange={(date) => { setDateOfBirth(date) }}
                                        autoComplete="off" 
                                        showYearDropdown
                                        showMonthDropdown
                                        scrollableYearDropdown
                                        dropdownMode="select"    
                                        
                                    />

                                }

                            </div>
                        </div>
                        <div className="mb-3 row">
                            <label className="col-12 col-sm-4">Gender <span className="text-danger">*</span></label>

                            

                             
                            <div className="col-12 col-sm-8 btn-group" role="group" aria-label="Basic radio toggle button group">

                                <input type="radio" className="insured-form btn-check" id="gender1" name="gender" checked={gender === "Male" ? 'checked' : ''} value="Male" onClick={(e) => setGender(e.target.value)} selected={gender === 'Male'} 
                                                                     disabled={(((props.selectedPlan.insurer == insurer_msig || props.selectedPlan.insurer == insurer_rhbi) || props.selectedPlan.insurer == insurer_rhbi) && (index > maxInsured))
                                                                        ? 
                                                                        'disabled'  : ''}
                                    />   
                                <label for="gender1" className={gender === "Male" ? 'btn btn-primary active' : ((props.selectedPlan.insurer == insurer_msig || props.selectedPlan.insurer == insurer_rhbi || props.selectedPlan.insurer == insurer_tune) && (index > maxInsured)) ? 'btn btn-outline-primary disabled' :'btn btn-outline-primary'}>
                                    Male
                                </label>

                                <input type="radio" className="insured-form btn-check"  id="gender2" name="gender" value="Female" checked={gender === "Female" ? 'checked' : ''} onClick={(e) => setGender(e.target.value)} selected={gender === 'Female'} 
                                                                     disabled={((props.selectedPlan.insurer == insurer_msig || props.selectedPlan.insurer == insurer_rhbi) && (index > maxInsured))
                                                                        ? 
                                                                        'disabled'  : ''}
                                    />
                                <label for="gender2" className={gender === "Female" ? 'btn btn-primary active' : ((props.selectedPlan.insurer == insurer_msig || props.selectedPlan.insurer == insurer_rhbi || props.selectedPlan.insurer === insurer_tune) && (index > maxInsured)) ? 'btn btn-outline-primary disabled' : 'btn btn-outline-primary'}>
                                    Female
                                </label>
                            </div>
                        </div>

                        <div className="mb-3 row">
                            <label className="col-12 col-sm-4">Nationality <span className="text-danger">*</span></label>
                            <div className="col-12 col-sm-8">
                                {props.selectedPlan.insurer == insurer_rhbi || props.travelInfo.nationality == 'MAL'?

                                        <input
                                        type="text"
                                        className="form-control"
                                        id="nationality" name="nationality"
                                        value={'Malaysia'} 
                                        disabled
                                        />

                                    :
                                   
                                    <Select
                                        id="nationality"
                                        styles={{
                                            control: provided => ({ ...provided, borderRadius: "2rem" }),
                                            menu: provided => ({ ...provided, zIndex: 2 })
                                        }}
                                        placeholder="Select a Nationality"
                                        options={props.allNationalities}
                                        value={props.allNationalities.find(dest => dest.countrycode === insuredNationality)}
                                        onChange={(e) => { updateNationality(e) }}
                                    />
                                  

                                    }
                            </div>
                        </div>

                        {props.travelInfo.planType == 'Child' || groupType == 'C'  ?
                        <>
                            <h5 className="fw-bold my-4">B. Parent Details</h5> 

                            <div className="mb-3 row">
                                <label className="col-12 col-sm-4">Full Name <span className="text-danger">*</span><br /><small>(as per NRIC)</small></label>
                                <div className="col-12 col-sm-8">
                                    <input type="text" className="form-control insured-form" value={parentName} maxLength={50} onChange={(e) => setParentName(e.target.value)} 
                                    disabled={((props.selectedPlan.insurer == insurer_msig || props.selectedPlan.insurer == insurer_rhbi || props.selectedPlan.insurer === insurer_tune) && (index > maxInsured))
                                        ? 
                                        'disabled'  : ''}
                                    />
                                </div>

                            </div>
                            <div className="mb-3 row">
                                <label className="col-12 col-sm-4">NRIC<span className="text-danger">*</span></label>
                                <div className="col-12 col-sm-8">
                                    <InputMask
                                        mask="************"
                                        maskChar=""
                                        type="text"
                                        className="form-control"
                                        required
                                        value={parentIdNumber}
                                        placeholder="e.g 891011021234"
                                        onChange={(e) => checkDetails(e.target.value, 'parentId')}
                                        disabled={((props.selectedPlan.insurer == insurer_msig || props.selectedPlan.insurer == insurer_rhbi || props.selectedPlan.insurer === insurer_tune) && (index > maxInsured))
                                            ? 
                                            'disabled'  : ''}
        
                                    />

                                    {/* <input
                                        type="text"
                                        placeholder="eg. 190908057698"
                                        className="form-control insured-form"
                                        value={parentIdNumber} onChange={(e) => checkDetails(e, 'parentId')}
                                        disabled={((props.selectedPlan.insurer == insurer_msig || props.selectedPlan.insurer == insurer_rhbi) && (index > maxInsured))
                                            ? 
                                            'disabled'  : ''}
        
                                    /> */}
                                </div>
                            </div>
                        </>
                             :
                            null
                        }



                        <div className="mb-3 row">
                            <label className="col-12 col-sm-4">Malaysia Mobile No. 
                                {(index > 1 && props.travelInfo.planType == 'Family') ? <><br /> <small>(Optional)</small></> : <> <span className="text-danger">*</span> </>}
                            </label>
                            <div className="col-12 col-sm-8">

                                <div class="input-group mb-2">
                                <span class="input-group-text" disabled  style={{borderRadius: '4rem 0 0 4rem'}}>
                                    +60
                                </span>

                                <InputMask mask="9999999999" maskChar="" 
                                class="form-control insured-form" placeholder="e.g 122349990"  style={{borderRadius: '0 4rem 4rem 0'}} value={displayMobileNo}
                                minLength={10} onChange={(e) => handleCardNumberChange(e.target.value)}
                                disabled={(props.selectedPlan.insurer == insurer_msig && (index > maxInsured))
                                    ? 
                                    'disabled'  : ''}
                                />

                                {/* <input type="text" class="form-control insured-form" placeholder="e.g 122349990"  style={{borderRadius: '0 4rem 4rem 0'}} value={mobileNo} onChange={(e) => setMobileNo(e.target.value)}  
                                minLength={10} maxLength={11} disabled={(props.selectedPlan.insurer == insurer_msig && (index > maxInsured))
                                    ? 
                                    'disabled'  : ''}
                                /> */}

                                </div>

                                {/* <input type="text" className="form-control insured-form" value={mobileNo} onChange={(e) => setMobileNo(e.target.value)} minLength={10} maxLength={11} disabled={(props.selectedPlan.insurer == insurer_msig && (index > maxInsured))
                                    ? 
                                    'disabled'  : ''}
                                    /> */}
                            </div>
                        </div>
                        <div className="mb-3 row">
                            <label className="col-12 col-sm-4">Email Address 
                                {(index > 1 && (props.travelInfo.planType == 'Family' || props.travelInfo.planType == 'InsuredSpouse')) ? <><br /> <small>(Optional)</small></> : <> <span className="text-danger">*</span> </>}
                            </label>
                            <div className="col-12 col-sm-8">
                                <input type="email" className="form-control insured-form" maxLength={50} value={email} onChange={(e) => setEmail(e.target.value)}                                  disabled={(props.selectedPlan.insurer == insurer_msig && (index > maxInsured))
                                    ? 
                                    'disabled'  : ''}
                                />
                                
                                

                               
                                
                            </div>
                        </div>
                        <div className="mb-3 row">
                            <label className="col-12 col-sm-4">Address 1 
                                {(index == 1 || props.travelInfo.planType == 'Group') ? <> <span className="text-danger">*</span> </> : <><br />  <small>(Optional)</small></>}
                            </label>
                            <div className="col-12 col-sm-8">
                                <input type="text" className="form-control insured-form" maxLength={35} value={address1} onChange={(e) => setAddress1(e.target.value)} 
                                                                 disabled={((props.selectedPlan.insurer == insurer_msig || props.selectedPlan.insurer == insurer_rhbi || props.selectedPlan.insurer === insurer_tune) && (index > maxInsured))
                                                                    ? 
                                                                    'disabled'  : ''}
                                
                                />
                            </div>
                        </div>
                        <div className="mb-3 row">
                            <label className="col-12 col-sm-4">Address 2 <br /> <small>(Optional)</small></label>
                            <div className="col-12 col-sm-8">
                                <input type="text" className="form-control insured-form" maxLength={35} value={address2} onChange={(e) => setAddress2(e.target.value)} 
                                                                 disabled={((props.selectedPlan.insurer == insurer_msig || props.selectedPlan.insurer == insurer_rhbi || props.selectedPlan.insurer === insurer_tune) && (index > maxInsured))
                                                                    ? 
                                                                    'disabled'  : ''}
                                
                                />
                            </div>
                        </div>
                        <div className="mb-3 row">
                            <label className="col-12 col-sm-4">Address 3 <br /> <small>(Optional)</small></label>
                            <div className="col-12 col-sm-8">
                                <input type="text" className="form-control insured-form" maxLength={35} value={address3} onChange={(e) => setAddress3(e.target.value)} 
                                                                 disabled={((props.selectedPlan.insurer == insurer_msig || props.selectedPlan.insurer == insurer_rhbi || props.selectedPlan.insurer === insurer_tune) && (index > maxInsured))
                                                                    ? 
                                                                    'disabled'  : ''}
                                
                                />
                            </div>
                        </div>
                        <div className="mb-3 row">
                            <label className="col-12 col-sm-4">Address 4 <br /> <small>(Optional)</small></label>
                            <div className="col-12 col-sm-8">
                                <input type="text" className="form-control insured-form" maxLength={35} value={address4} onChange={(e) => setAddress4(e.target.value)} 
                                                                 disabled={((props.selectedPlan.insurer == insurer_msig || props.selectedPlan.insurer == insurer_rhbi || props.selectedPlan.insurer === insurer_tune) && (index > maxInsured))
                                                                    ? 
                                                                    'disabled'  : ''}
                                
                                />
                            </div>
                        </div>
                        <div className="mb-3 row">
                            <label className="col-12 col-sm-4">Postcode 
                                {(index == 1 || props.travelInfo.planType == 'Group' ) ? <><span className="text-danger"> *</span> </> : <> <br /> <small>(Optional)</small> </>}
                            </label>
                            <div className="col-12 col-sm-8">
                                <input type="text" className="form-control insured-form" value={postcode} onChange={(e) => handlePostcodeChange(e.target.value)}  maxLength={5}
                                                                 disabled={((props.selectedPlan.insurer == insurer_msig || props.selectedPlan.insurer == insurer_rhbi || props.selectedPlan.insurer === insurer_tune) && (index > maxInsured))
                                                                    ? 
                                                                    'disabled'  : ''}
                                
                                />
                            </div>
                        </div>

                        <div className="mb-3 row">
                            <label className="col-12 col-sm-4">State <small>(Optional)</small>
                            </label>
                            <div className="col-12 col-sm-8">
                                <input type="text" className="form-control" value={state} disabled/>
                            </div>
                        </div>

                        <div className="mb-3 row">
                            <label className="col-12 col-sm-4">Country 
                                {(index == 1 && (props.selectedPlan.insurer == insurer_msig || props.selectedPlan.insurer === insurer_tune) ) ? <> <span className="text-danger">*</span> </> : <> <br /> <small>(Optional)</small>  </>}
                            </label>
                            <div className="col-12 col-sm-8">
                                <Select
                                        id="country"
                                        styles={{
                                            control: provided => ({ ...provided, borderRadius: "2rem" }),
                                            menu: provided => ({ ...provided, zIndex: 2 })
                                        }}
                                        placeholder="Select a country"
                                        options={props.allNationalities}
                                        value={props.allNationalities.find(dest => dest.countrycode === insuredCountry)}
                                        onChange={(e) => { updateCountry(e) }}
                                        required
                                    />
                                
                            </div>
                        </div>

                        {props.selectedPlan.insurer == insurer_rhbi && ((index == 1 && individualRelationship != 'C') || (insuredRelationship == 'Child' || props.travelInfo.planType == 'Child' || groupType == 'C'))  ?                            
                            <div className="mb-3 row">
                                <label className="col-12 col-sm-4">Still Study</label>
                                <div className="col-12 col-sm-8 btn-group btn-group-toggle" role="group">
                                    <label className={stillStuding === "N" ? 'btn btn-primary active' : (props.selectedPlan.insurer == insurer_msig && (index > maxInsured)) ? 'btn btn-outline-primary disabled' :'btn btn-outline-primary'}>
                                        <input type="radio" className="insured-form" name="still_study" value="N" onClick={(e) => setStillStuding(e.target.value)} selected={stillStuding === 'N'} 
                                                                        disabled={(((props.selectedPlan.insurer == insurer_msig || props.selectedPlan.insurer == insurer_rhbi) || props.selectedPlan.insurer == insurer_rhbi) && (index > maxInsured))
                                                                            ? 
                                                                            'disabled'  : ''}
                                        />No
                                    </label>
                                    <label className={stillStuding === "Y" ? 'btn btn-primary active' : ((props.selectedPlan.insurer == insurer_msig || props.selectedPlan.insurer == insurer_rhbi) && (index > maxInsured)) ? 'btn btn-outline-primary disabled' : 'btn btn-outline-primary'}>
                                        <input type="radio" className="insured-form" name="still_study" value="Y" onClick={(e) => setStillStuding(e.target.value)} selected={stillStuding === 'Y'} 
                                                                        disabled={((props.selectedPlan.insurer == insurer_msig || props.selectedPlan.insurer == insurer_rhbi) && (index > maxInsured))
                                                                            ? 
                                                                            'disabled'  : ''}
                                        />Yes
                                    </label>
                                </div>
                            </div>
                            :
                            null
                        }

                        {/* {props.selectedPlan.insurer == insurer_rhbi &&  props.travelInfo.planType == 'Individual' ?  

                            <div className="mb-3 row">
                                <label className="col-12 col-sm-4">Marital Status</label>
                                <div className="col-12 col-sm-8">
                                    <Select
                                        id="maritalStatus"
                                        className="insured-form"
                                        styles={{
                                            control: provided => ({ ...provided, borderRadius: "2rem" })
                                        }}
                                        options={maritalStatusList}
                                        onChange={(e) => changeMaritalStatus(e)}
                                        value={maritalStatusList.find(maritalStatus => maritalStatus.label == insuredMaritalStatusValue)}
                                        placeholder="Select Marital Status"
                                        required
                                        disabled={((props.selectedPlan.insurer == insurer_msig || props.selectedPlan.insurer == insurer_rhbi) && (index > maxInsured))
                                            ? 
                                            'disabled'  : ''}

                                    />
                                </div>
                            </div>
                        
                            :
                            null
                        } */}

                        {props.selectedPlan.insurer == insurer_rhbi &&  props.travelInfo.planType == 'Individual' ?     
                        <div className="mb-3 row">
                            <label htmlFor="region" className="col-12 col-sm-4">Marital Status</label>
                            <div className="col-12 col-sm-8">
                                <Select
                                    id="region"
                                    styles={{
                                        control: provided => ({ ...provided, borderRadius: "2rem" }),
                                        menu: provided => ({ ...provided, zIndex: 2 })
                                    }}
                                    placeholder="Select Marital Status"
                                    options={maritalStatusList}
                                    value={maritalStatusList.find(dest => dest.label === insuredMaritalStatusValue)}
                                    onChange={(e) => updateRegion(e)} 
                                    required
                                />
                            </div>
                        </div>
                         :
                         null
                        }

                         {/* einvoice details */}
                        {einvoiceEnable && ((index == 1 && props.travelInfo.buyFor == 'FC') || props.travelInfo.buyFor != 'FC') ?
                            <>
                                <h5 className="fw-bold my-4">{"B. e-Invoice Details #" + index}</h5>

                                <div className="mb-3 row">
                                    <label className="col-12 col-sm-4">Require e-Invoice? <span className="text-danger">*</span></label>
                                    <div className="col-12 col-sm-8">
                                        <Select
                                            styles={{
                                                control: provided => ({ ...provided, borderRadius: "2rem" })
                                            }}
                                            placeholder="Select e-Invoice Indicator"
                                            value={einvoiceIndicatorList.find(obj => obj.value === einvoiceIndicator)}
                                            options={einvoiceIndicatorList}
                                            onChange={(e) => { updateEinvoice(e.value); }}
                                        />
                                    </div>
                                </div> 

                                {einvoiceIndicator && einvoiceIndicator == 'Y' ?
                                    <>
                                        <div className="mb-3 row">
                                            <label className="col-12 col-sm-4">TIN <br /><small>(Optional)</small></label>
                                            <div className="col-12 col-sm-8">
                                                <InputMask mask="**************" maskChar="" class="form-control" placeholder="e.g EIRTE45354310" value={tinNo} onChange={(e) => setTinNo(e.target.value)}/>
                                            </div>
                                        </div>

                                        <div className="mb-3 row">
                                            <label className="col-12 col-sm-4">SST Registrant?
                                            { einvoiceIndicator == 'Y' ? <> <span className="text-danger">*</span> </> : <> <br /> <small>(Optional)</small> </>}
                                            </label>
                                            <div className="col-12 col-sm-8">
                                                <Select
                                                    styles={{
                                                        control: provided => ({ ...provided, borderRadius: "2rem" })
                                                    }}
                                                    placeholder="Select SST Registrant Indicator"
                                                    value={sstIndicatorList.find(obj => obj.value === sstIndicator)}
                                                    options={sstIndicatorList}
                                                    onChange={(e) => { setSstIndicator(e.value); }}
                                                />
                                            </div>
                                        </div> 

                                        <div className="mb-3 row">
                                            <label className="col-12 col-sm-4">SST Registration No.
                                            { sstIndicator == 'Y' ? <> <span className="text-danger">*</span> </> : <> <br /> <small>(Optional)</small>  </>}
                                            </label>
                                            <div className="col-12 col-sm-8">
                                                <InputMask mask="*****************"  formatChars={formatChars} maskChar="" class="form-control" placeholder="e.g ER-1234575222" value={sstNo} onChange={(e) => setSstNo(e.target.value)} />
                                            </div>
                                        </div>
                                    </>
                                    :
                                    ""
                                }
                           

                            </>
                            :
                            ""
                        }

                    </div>


                    <div className={((props.selectedPlan.insurer == insurer_msig || props.selectedPlan.insurer == insurer_rhbi || props.selectedPlan.insurer === insurer_tune) && (index > maxInsured)) ? 'd-none' : 'mb-3 row px-3 my-3'}>
                        <div className="col-12 text-end">
                             {/* 
                                Rules:
                                - first insured with one nomination
                                - 2nd insured onward and select relationship
                                - family 
                            */}

                            {/* <Button variant="success" id="add-insured-btn" onClick={() => onAddInsured()} 
                            disabled={ 
                                (index === 1 && (!name || !idNumber || !gender || !insuredNationality || !mobileNo || !email || !address1 || !postcode || !insuredCountry || (allowNomination && !nomineeName) || (allowNomination && !nomineeID) || (allowNomination && nomineeRelationship === "-- Select a Relationship --")))
                                || (index > 1 && ((props.travelInfo.planType === 'Family' && insuredRelationship === "-- Select a Relationship --") || !name || !idNumber || !gender || !nationality))
                                || (props.selectedPlan.insurer != insurer_msig && props.travelInfo.planType === 'Family' && insureds.length === 11)
                                || (props.selectedPlan.insurer != insurer_msig && props.travelInfo.planType === 'Individual' && insureds.length === 9) 
                                || (props.selectedPlan.insurer == insurer_msig && (index > maxInsured))
                                ? 
                                'disabled'  : ''}
                            >
                            
                                Save Insured
                            </Button> */}

                            <Button variant="success" id="add-insured-btn" onClick={() => onAddInsured()} disabled={
                                    (index === 1 && (props.selectedPlan.insurer == insurer_msig || props.selectedPlan.insurer === insurer_tune) &&
                                    (!name || !idNumber || !dateOfBirth || !gender || !insuredNationality || !mobileNo || !email || !address1 || !postcode))
                                    || ((props.travelInfo.planType === 'Individual') && (props.selectedPlan.insurer == insurer_msig || props.selectedPlan.insurer === insurer_tune) && (!name || !idNumber || !gender || !insuredNationality ||
                                        !mobileNo || !email || !address1 || !postcode))
                                    || (index === 1 && props.selectedPlan.insurer == insurer_rhbi &&
                                        (!name || !idNumber || !gender || !insuredNationality || !mobileNo || !email ||  !address1 || !postcode))
                                    || ((props.travelInfo.planType === 'Individual' || props.travelInfo.planType === 'Group') && props.selectedPlan.insurer == insurer_rhbi && (!name || !idNumber || !gender || !insuredNationality ||
                                        !mobileNo || !email || !address1 || !postcode))          
                                    || (index > 1 && ((props.travelInfo.planType === 'Family' && insuredRelationship === "-- Select a Relationship --") || !name || !idNumber || !gender || !insuredNationality))
                                    // || (props.selectedPlan.insurer != insurer_msig && props.travelInfo.planType === 'Family' && insureds.length === 11)
                                    // ||(props.selectedPlan.insurer != insurer_msig && props.travelInfo.planType === 'Individual' && insureds.length === 9) 
                                    // || (props.selectedPlan.insurer == insurer_msig && (index > maxInsured))
                                    ? 'disabled' : ''}
                                >
                                    Save Insured
                            </Button>
                        </div>
                    </div>

                    <div className="mb-3 row">
                        <div className="col-12">
                            <Table responsive striped hover id="insured-listing" className="rounded">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>Insured Persons</th>
                                        <th>NRIC / Passport No.</th>
                                        <th>Date of Birth</th>
                                        <th>Nationality</th>
                                        {(props.travelInfo.planType != 'Individual') ?
                                             <th>Relationship with Insured #1</th>

                                             :
                                            ""
                                        }
                                       
                                        
                                        {/* <th>Nominee</th> */}
                                       
                                    </tr>
                                </thead>
                                <tbody>
                                    {insureds.map((insured, index) => (
                                        <tr key={index}>
                                            <td>
                                                <div className="row">
                                                    <div className="col-12">
                                                        <Button variant="warning" onClick={() => handleEditInsured(index)}><i className="fas fa-pen"></i></Button>
                                                        <Button variant="danger" onClick={() => handleDeleteInsured(index)}><i className="fas fa-trash"></i></Button>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>{insured.name}</td>
                                            <td>{insured.idNumber}</td>
                                            <td>{Moment(insured.dateOfBirth).format('DD/MM/YYYY')}</td>
                                            <td>{insured.nationality}</td>
                                            {(props.travelInfo.planType != 'Individual') ?
                                                <td>{ index == 0 ? " "  : insured.insuredRelationship }</td>
                                                : ""
                                            }
                                            {/* <td>{insured.nominee.name}</td> */}
                                            
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    </div>

                    <div class="d-flex justify-content-between mt-3">

                    </div>
                    <div className="mb-3 row">
                        {/* <div className="col-sm-6">
                            <button type="button" id="btn-back" class="btn btn-secondary" onClick={() => { onClickBack() }}>Back</button>
                        </div> */}
                        <div className="col-sm-12 text-end">
                            <Button type="submit" variant="success" disabled=
                            {
                                (insureds.length === 0 
                                || (props.travelInfo.planType === 'Family' && insureds.length < 2) 
                                || allowContinue === false
                                || ( (props.selectedPlan.insurer == insurer_msig || props.selectedPlan.insurer == insurer_rhbi || props.selectedPlan.insurer === insurer_tune) && (insureds.length < maxInsured))
                                ) ? 'disabled' : ''
                            }
                            >
                                Continue
                            </Button>
                        </div>
                    </div>


                    {allowNomination ?    
                        <div className={(props.selectedPlan.insurer == insurer_msig && (index > maxInsured)) ? 'd-none' : 'border rounded px-3 mt-3'}>
                            <h5 className="fw-bold my-3">{"C. Nomination for Insured #" + index} (Optional)</h5>
                            <div className="mb-3 row">
                                <label className="col-12 col-sm-4">Nominee Name <span className="text-danger">*</span><br /><small>(as per NRIC)</small> {index > 1 ? <><br /> <small>(Optional)</small></> : ''}</label>
                                <div className="col-12 col-sm-8">
                                    <input type="text" className="form-control" value={nomineeName} onChange={(e) => setNomineeName(e.target.value)} 
                                                                    disabled={(props.selectedPlan.insurer == insurer_msig && (index > maxInsured))
                                                                        ? 
                                                                        'disabled'  : ''}
                                    
                                    />
                                </div>
                            </div>
                            <div className="mb-3 row">
                                <label className="col-12 col-sm-4">NRIC / Passport No. <span className="text-danger">*</span> {index > 1 ? <><br /> <small>(Optional)</small></> : ''}</label>
                                <div className="col-12 col-sm-8">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="eg. 891011021234"
                                        value={nomineeID} onChange={(e) => setNomineeID(e.target.value)}
                                        disabled={(props.selectedPlan.insurer == insurer_msig && (index > maxInsured))
                                            ? 
                                            'disabled'  : ''}
        
                                    />
                                </div>
                            </div>
                            <div className="mb-3 row">
                                <label className="col-12 col-sm-4">Relationship <span className="text-danger">*</span> {index > 1 ? <><br /> <small>(Optional)</small></> : ''}</label>
                                <div className="col-12 col-sm-8">
                                    <Select
                                        styles={{
                                            control: provided => ({ ...provided, borderRadius: "2rem" })
                                        }}
                                        options={relationships}
                                        onChange={(e) => updateNomineeRelationship(e)}
                                        value={relationships.find(relationship => relationship.label == nomineeRelationship)}
                                        placeholder="Select Nominee Relationship"
                                        disabled={(props.selectedPlan.insurer == insurer_msig && (index > maxInsured))
                                            ? 
                                            'disabled'  : ''}
        
                                    />
                                </div>
                            </div>
                        </div>

                    :
                                      
                        <div className="border rounded px-3 mt-3">
                            <h5 className="fw-bold my-3">
                                <>
                                {(index > maxInsured) ?
                                    <>
                                    C. Nomination for Insured (Optional)
                                    </>
                                :
                                    <>
                                    C. Nomination for Insured #{index} (Optional)
                                    </>
                                }
                                </>
                            </h5>
                            <div class="row justify-content-around">
                                <label class="col-12 mb-sm-0">
                                    <a href={"../storage/pdf/"+String(props.selectedPlan.insurer).toLowerCase()+"-nomination-form.pdf"} target="_blank" className="text-decoration-none fw-bold">Click here</a> for the nomination form.
                                </label>
                            </div>
                            <div class="row justify-content-around">
                                <label class="col-12 mb-sm-2">
                                Once completed, kindly email the form to <a href={"mailto:"+process.env.MIX_CONFIRMATION_EMAIL_INSTA_ADMIN} className="text-decoration-none fw-bold">{process.env.MIX_CONFIRMATION_EMAIL_INSTA_ADMIN}</a>, and return the physical copy to the following address: -
                                </label>
                            </div>
                            <div class="row justify-content-around">
                                <label class="col-12 mb-sm-0 fw-bold">
                                    <em>
                                    Howden Insurance Brokers Sdn Bhd  
                                    </em>
                                </label>
                            </div>
                            <div class="row justify-content-around">
                                <label class="col-12 mb-sm-0">
                                    <em>
                                    Attn: InstaAdmin
                                    </em>
                                </label>
                            </div>
                            <div class="row justify-content-around">
                                <label class="col-12 mb-sm-0">
                                    <em>
                                    Level 27, Menara Etiqa, No. 3 Jalan Bangsar Utama 1,
                                    </em>
                                </label>
                            </div>
                            <div class="row justify-content-around">
                                <label class="col-12 mb-sm-0">
                                    <em>
                                    59000 Kuala Lumpur, Malaysia
                                    </em>
                                </label>
                            </div>
                        </div>

                    }
                </div>

            </div>
            <div class="d-flex justify-content-between mt-3">

            </div>
            <div className="mb-3 row">
                <div className="col-sm-6">
                    <button type="button" id="btn-back" class="btn btn-secondary" onClick={() => { onClickBack() }}>Back</button>
                </div>
                {/* <div className="col-sm-6 text-end">
                    <Button type="submit" variant="success" disabled=
                    {
                        (insureds.length === 0 
                        || (props.travelInfo.planType === 'Family' && insureds.length < 2) 
                        || allowContinue === false
                        || (props.selectedPlan.insurer == insurer_msig && (insureds.length < maxInsured))
                        ) ? 'disabled' : ''
                    }
                    >
                        Continue
                    </Button>
                </div> */}
            </div>

            
        </Form>
    );

}

function Payment(props) {
    let query = new URLSearchParams(useLocation().search);
    const [transactionData, setTransactionData] = useState({});
    const [onSave, setOnSave] = useState(false);
    //const [transactionNo] = useState(Math.floor(new Date().getTime() / 1000));
    const [isGetSummary, setIsGetSummary] = useState(false);
    const [showDeclarationModal, setShowDeclarationModal] = useState(false);
    const [agreed, setAgreed] = useState("");
    const swalAlert = withReactContent(Swal);
    const [proceedPayment, setProceedPayment] =  useState(false);

    let serviceID = process.env.MIX_PAYMENT_GATEWAY_SERVICE_ID;
    let password = process.env.MIX_PAYMENT_GATEWAY_PASSWORD;
    let merchantReturnURL = process.env.MIX_APP_URL + "/api/store";
    let currencyCode = "MYR";
    let ip = process.env.MIX_APP_URL;
    let timeout = "600";
    let HashValue = SHA256(password + serviceID + props.transactionNo + merchantReturnURL + Number(transactionData.total_payable).toFixed(2) + currencyCode + ip + timeout);
    let zone = "";
    let commissionAmount = parseFloat(props.grossPremium) * parseFloat(process.env.MIX_COMMISION_RATE / 100);

    const commissionStyle = {
        color: "#899499",
        fontSize: "0.688em",
      };

    const currentDate = Moment().format('YYYY-MM-DD');  

    useEffect(() => {
        if( !isEmpty(props.travelInfo) && props.activeId == 'payment' && proceedPayment === false) {

            const insured_address = (!isEmpty(props.insuredInfo[0])) ? props.insuredInfo[0].address1+" "+props.insuredInfo[0].address2+" "+props.insuredInfo[0].address3+" "+props.insuredInfo[0].address4 : '';

            axios.post('/api/update-payment-info', {
                drop_off_point: dropOffPaymentSummary,
                transaction_id: props.transactionId,
                tripType: props.travelInfo.tripType,
                destination: (props.travelInfo.productType == 'TAA' || props.travelInfo.productType == 'ONE') ? props.travelInfo.destinationList:  props.travelInfo.destination.label,
                departureDate: props.travelInfo.departureDate,
                returnDate: props.travelInfo.returnDate,
                dateOfBirth: Moment(props.insuredInfo[0].dateOfBirth).format('DD/MM/YYYY'),
                planType: props.travelInfo.planType,
                product: props.selectedPlan.product,
                plan: props.selectedPlan.plan,
                insurer: props.selectedPlan.insurer,
                plan_type: props.selectedPlan.plan,
                referral: props.referral,   
                selected_add_ons: props.selectedAddOns,
                insured_name: props.insuredInfo[0].name,
                insured_email: props.insuredInfo[0].email,
                insured_mobile_number: props.insuredInfo[0].mobileNo,
                insured_id_number: props.insuredInfo[0].idNumber,
                insured_gender: props.insuredInfo[0].gender,
                insured_address: insured_address,
                total_payable: props.totalPayable,
            }).then(function (response) {
                if(response.data.transactionId) {
                    props.setTransactionId(response.data.transactionId);
                }
            }).catch(function (error) {
                console.log(error);
            })
        }
    }, [props.dropOffTrigger]);  



    useEffect(() => {

        if (props.selectedPlan.insurer === 'AXA') {
            zone = props.travelInfo.destination?.axa_zone;
        }
        else if (props.selectedPlan.insurer === 'CHUBB') {
            zone = props.travelInfo.destination?.chubb_zone;
        }
        else if (props.selectedPlan.insurer === 'MSIG') {
            if(props.travelInfo.productType == 'TAA') {
                zone = props.travelInfo.destination?.msig_zone;
            } else {
                zone = props.travelInfo.destination?.msig_zone;
            }
            
        }
        else if (props.selectedPlan.insurer === 'ZurichTakaful') {
            zone = props.travelInfo.destination?.zurichTakaful_zone;
        }
        else if (props.selectedPlan.insurer === 'TUNEPROTECT') {
            zone = props.travelInfo.destination?.tune_zone;
        }


        if (!isEmpty(props.travelInfo) && !isEmpty(props.selectedPlan) && !isEmpty(props.insuredInfo) && query.get('paymentID') === null) {
           
            setTransactionData({
                name: props.insuredInfo[0].name,
                mobileNo: props.insuredInfo[0].mobileNo,
                displayMobileNo: props.insuredInfo[0].displayMobileNo,
                email: props.insuredInfo[0].email,
                insured: props.insuredInfo,
                travelInfo: {
                    dateOfBirth: Moment(props.travelInfo.dateOfBirth).format('YYYY-MM-DD'),
                    travelCountryCode: (props.travelInfo.productType == 'TDA') ? '' : props.travelInfo.destination.msig_countrycode,
                    travelDestination: props.travelInfo.destination,
                    noOfAdults: props.travelInfo.noOfAdults,
                    noOfChildren:  props.travelInfo.noOfChildren,
                    noOfPersons: props.travelInfo.noOfPersons,
                    productType: props.travelInfo.productType,
                    travelTo: props.travelInfo.travelTo,
                    travelStartDate: Moment(props.travelInfo.departureDate, "DD/MM/YYYY").format('YYYY-MM-DD'),
                    travelEndDate: Moment(props.travelInfo.returnDate, "DD/MM/YYYY").format('YYYY-MM-DD'),
                    buyFor: props.travelInfo.buyFor,
                },
                planInfo: {
                    planId: props.selectedPlan.planId,
                    planName: props.selectedPlan.product,
                    totalAmount: props.selectedPlan.totalAmount,
                    quotationID: props.selectedPlan.quotationID,
                },
                product: props.selectedPlan.product,
                plan: props.selectedPlan.plan,
                insurer: props.selectedPlan.insurer,
                trip_type: props.travelInfo.tripType,
                plan_type: props.travelInfo.planType,
                coverage_from: props.travelInfo.departureDate,
                coverage_to: props.travelInfo.returnDate,
                destination: props.travelInfo.destination.label,
                destinationList: props.travelInfo.destinationList,
                destination_zone: zone,
                gross_premium: props.grossPremium,
                add_ons_total: props.addOnsTotal,
                total_payable: props.totalPayable,
                service_tax: props.serviceTax,
                stamp_duty: props.stampDuty,
                referral: props.referral,
                transaction_number: props.transactionNo,
                token: props.token,
                tuneToken: props.tuneToken
            });
        } else if (query.get('paymentID') !== null) {

          

            axios.get('/api/order/' + query.get('paymentID'))
                .then((response) => {
                    let trans = response.data[0]['transaction_data'];

                   

                     setTransactionData({
                        name: trans.name,
                        mobileNo: trans.mobileNo,
                        displayMobileNo: '+6'+trans.mobileNo,
                        email: trans.email,
                        insured: trans.insured,
                        travelInfo: trans.travelInfo,
                        planInfo: trans.planInfo,
                        product: trans.product,
                        plan: trans.plan,
                        insurer:  trans.insurer,
                        trip_type: trans.trip_type,
                        plan_type:  trans.plan_type,
                        coverage_from: Moment(trans.coverage_from).format('YYYY-MM-DD'),
                        coverage_to:  Moment(trans.coverage_to).format('YYYY-MM-DD'),
                        inception_date: Moment(trans.coverage_from).format('DD/MM/YYYY'),
                        expiry_date:  Moment(trans.coverage_to).format('DD/MM/YYYY'),
                        destination: trans.destination,
                        destinationList: trans.destination,
                        destination_zone: trans.destination_zone,
                        gross_premium: trans.gross_premium,
                        add_ons_total: trans.add_ons_total,
                        total_payable: trans.total_payable,
                        service_tax: trans.service_tax,
                        stamp_duty: trans.stamp_duty,
                        referral: trans.referral,
                        //transaction_number: trans.transaction_number,
                        transaction_number: props.transactionNo,
                        payment_status: trans.payment_status,
                        txn_message: trans.txn_message,
                        add_ons: response.data[0]['add_ons'],
                        token: trans.token,
                        tuneToken: trans.tuneToken
                    });

                    setIsGetSummary(true);
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    }, [
        props.travelInfo, props.selectedPlan, props.selectedAddOns, props.insuredInfo,
        props.grossPremium, props.addOnsTotal, props.totalPayable, props.serviceTax, props.stampDuty
    ]);



    useEffect(() => {
        if (agreed === 'Agree') {
            if (onSave && !isEmpty(transactionData)) {
                setShowDeclarationModal(false);
                setProceedPayment(true);

                swalAlert.fire({
                    title: 'Please Wait...',
                    allowOutsideClick: false
                });
                swalAlert.showLoading();

                axios.post('/api/insert-payment', {
                    transaction_type: 'SALE',
                    payment_method: 'CC',
                    service_id: serviceID,
                    payment_id: props.transactionNo,
                    order_number: props.transactionNo,
                    payment_description: "Travel Insurance - " + transactionData.name,
                    amount: transactionData.total_payable,
                    currency_code: currencyCode,
                    hash: HashValue.toString()
                }).then(() => {

                    axios.post('/api/insert-transaction', {
                        transaction_data: transactionData,
                        selected_add_ons: props.selectedAddOns,
                        add_ons: transactionData.add_ons,
                        transaction_id: props.transactionId,
                    })
                    .then(function (response) {

                        console.log(response.data);

                        if (response.data.status) {
                          
                            document.getElementById('payment-form').submit();
                        }

                        swalAlert.close();

                    })
                    .catch(function (error) {
                        swalAlert.close();
                        console.log(error);
                    })
                });
            }
        }
    }, [onSave]);

    function Message() {
        if (transactionData.payment_status == 'Pending') {
            return <PaymentPending />;
        } else if (transactionData.payment_status == 'Payment Accepted') {
            return <PaymentSuccess />;
        } else if (transactionData.payment_status == 'Payment Failure')
            return <PaymentFail />
        else return <></>
    }

    function PaymentSuccess() {
        return (<div className="alert alert-success" role="alert">
            {transactionData.txn_message}
        </div>);
    }

    function PaymentFail() {
        return (<div className="alert alert-danger" role="alert">
            {transactionData.txn_message}. Please click 'Proceed to Pay' button to proceed with the payment.
        </div>);
    }

    function PaymentPending() {
        return (<div className="alert alert-warning" role="alert">
            Your Payment is still Pending.
        </div>);
    }


    function DeclarationModal(props) {
        const [agree, setAgree] = useState("");
        const [error, setError] = useState(false);

        useEffect(() => {
            if (agree === 'Disagree') {
                setError(true);

                setTimeout(() => {
                    setError(false);
                }, 3000);
            } else {
                setError(false);
            }
        }, [agree]);

        return (
            <Modal show={props.showDeclarationModal} onHide={() => { props.setShowDeclarationModal(false); }} centered>
                <Modal.Header>
                    <Modal.Title>
                        <p className="mb-0">Confirmation</p>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>I, {props.insuredName}, confirm that:</p>
                    <p className="mt-3">
                        - I understand that it is my duty to take reasonable care not to make a misrepresentation in answering
                        the questions in this Application Form and I hereby declare that I have fully and accurately answered
                        the questions above.
                    </p>
                     <p className="mt-3">
                     - By clicking the 'Pay Now' button below, you hereby expressly consent to share your Personal Data subject to the following 
                     <a href={process.env.MIX_INSTAPOL_TREMS} className="text-blue text-decoration-none" target="_blank">
                     Terms and Conditions
                     </a>,   
                       {transactionData.insurer == insurer_tune ?
                        <> 
                           <span> accept </span><a href={process.env.MIX_INSTAPOL_PRIVACY} className="text-blue text-decoration-none" target="_blank">
                          Howden's Privacy Policy </a> & <a href={"../storage/pdf/privacy_policy_"+String(transactionData.insurer).toLowerCase()+".pdf"} className="text-blue text-decoration-none" target="_blank">
                            Tune Protect's Privacy Policy
                         </a>
                        </>
                       :
                        <>
                             <span> accept the </span><a href={process.env.MIX_INSTAPOL_PRIVACY} className="text-blue text-decoration-none" target="_blank">
                            Privacy Policy </a> 
                        </>
                      
                        }
                       
                      <span> and read and understood the </span><a href={"../storage/pdf/PDS_" + String(transactionData.insurer).toLowerCase() + ".pdf"} target="_blank" className="text-decoration-none">
                      Product Disclosure Sheet 
                      </a> by the Insurer.
                    </p>

                    { currentDate >= process.env.MIX_CAMPAING_START_DATE && currentDate <= process.env.MIX_CAMPAING_END_DATA ?
                        <p className="mt-3">
                            - I have read, understood and accepted the <a href="../storage/pdf/Travel Insurance Campaign T&C 2026_RAYA TRIPS TNG TREATS_FINAL.pdf" className="text-blue text-decoration-none" target="_blank">Terms & Conditions</a> of the "Raya Trips, TnG Treats" Travel Insurance Campaign.
                        </p>
                        :
                        ""
                    }
                    <div className="mb-3 row">
                        <div className="col-sm-6 d-grid">
                            <Button
                                block
                                type="radio"
                                variant={agree == "Agree" ? "info" : "border border-primary"}
                                className="mb-3 mb-sm-0"
                                onClick={() => { setAgree("Agree"); }}
                            >
                                Agree
                            </Button>
                        </div>
                        <div className="col-sm-6 d-grid">
                            <Button
                                block
                                type="radio"
                                variant={agree == "Disagree" ? "info" : "border border-primary"}
                                className="mb-3 mb-sm-0"
                                onClick={() => { setAgree("Disagree"); }}
                            >
                                Disagree
                            </Button>
                        </div>

                        {error ?
                            <p className="text-danger text-center fw-bold px-3 mt-2">
                                You have to agree to our terms in order to complete the transaction.
                            </p>
                            :
                            null
                        }
                    </div>
                    <p className="mt-3 fw-bold">
                        Please make sure you review the order and personal details before payment page
                    </p>
                    <p>Once you click 'Pay Now' you cannot change these details</p>
                    <p className="mt-3">
                        In the event that your proposal does not meet the requirement of Anti Money Laundering
                        and Sanction screening, this confirmation will be void <span className="font-italic">ab initio</span> and your premium will be
                        refunded accordingly by Howden Insurance Brokers Sdn Bhd.
                    </p>

                     
                    <p className="mt-3">
                        The benefit(s) payable under eligible product is protected by PIDM up to limits. Please refer to <a href={"../storage/pdf/PIDM_Brochure.pdf"} className="text-decoration-primary" target="_blank">PIDM's TIPS Brochure</a> or contact {getInsurerFullName(transactionData.insurer)} or PIDM (visit <a href="https://www.pidm.gov.my/" className="text-decoration-primary" target="_blank">www.pidm.gov.my</a>).
                    </p>
                 

                </Modal.Body>
                <Modal.Footer>
                    <div className="row">

                       
                        {
                            (transactionData.insurer == insurer_msig) ?

                            <div className="col-8 text-justify" style={commissionStyle}>
                                You are visiting the online site of instalPol. When you purchase a policy through this site, we will provide you with insurance advice and claims assistance/services,
                                for which an insurance fee is inclusive in the premium. Alternatively, you may choose to visit the MSIG website.
                            </div>

                            :
                            <>
                                {(transactionData.insurer == insurer_tune) ?


                                    <div className="col-8 text-justify" style={commissionStyle}>
                                    Consumers have an option to purchase similar product with a rebate on commission or is commission-free if purchased directly from TIMB’s own website or physical branches.
                                   </div>
                                   :
                                   null

                                }
                                
                            </>
                            }

                        <div className={(transactionData.insurer == insurer_msig || transactionData.insurer == insurer_tune) ? 'col-4 text-end' : 'col-12 text-end'}>
                            {/* <Button variant="secondary" className="border-0 bg-transparent">Cancel</Button> */}
                            <Button variant="success" id="btn-paynow" onClick={() => { props.setOnSave(agree === 'Agree'); props.setAgreed(agree) }}>Pay Now</Button>
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>
        );
    }

    return (
        <Form action={process.env.MIX_PAYMENT_GATEWAY_URL} method="POST" id="payment-form">
            <input type="hidden" name="TransactionType" value="SALE" />
            <input type="hidden" name="PymtMethod" value="ANY" />
            <input type="hidden" name="ServiceID" value={serviceID} />
            <input type="hidden" name="PaymentID" value={props.transactionNo} />
            <input type="hidden" name="OrderNumber" value={props.transactionNo} />
            <input type="hidden" name="PaymentDesc" value={process.env.MIX_APP_NAME + ' - ' + transactionData.name + '(' + transactionData.transaction_number + ')'} />
            <input type="hidden" name="MerchantReturnURL" value={merchantReturnURL} />
            <input type="hidden" name="Amount" value={Number(transactionData.total_payable).toFixed(2)} />
            <input type="hidden" name="CurrencyCode" value={currencyCode} />
            <input type="hidden" name="CustName" value={transactionData.name} />
            <input type="hidden" name="CustPhone" value={transactionData.mobileNo} />
            <input type="hidden" name="CustEmail" value={transactionData.email} />
            <input type="hidden" name="CustIP" value={ip} />
            <input type="hidden" name="PageTimeout" value={timeout} />
            <input type="hidden" name="LanguageCode" value="en" />
            <input type="hidden" name="HashValue" value={HashValue} />
            <div className="mb-3 row mb-0">
                <div className="col-12">
                    <div className="my-2">
                        {isGetSummary ? <Message /> : null}
                    </div>
                    <Card className="border rounded">
                        <Card.Header>
                            <label className="fw-bold text-primary mb-0">Summary of Payment</label>
                        </Card.Header>
                        <Card.Body>
                            <div className="row">
                                <div className="col-12">
                                    <label>{[transactionData.trip_type, transactionData.plan_type].join(' - ')}</label>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    {transactionData.trip_type == 'Annual' ?
                                        <>
                                        {props.travelInfo.isDomestic == true ?

                                                      
                                            <label>{'(' + transactionData.travelInfo.travelDestination?.label + ') - Domestic'}</label>

                                            :
                                            <label>{'(Area ' + transactionData.travelInfo.travelDestination?.label + ') - International'}</label>
                                            }
                                        
                                        </>
                                       
                                    :
                                    <>
                                        {props.travelInfo.isDomestic == true ?
                                            <label>{'(' + transactionData.destinationList + ') - Domestic'}</label>

                                        :
                                            <label>{'(' + transactionData.destinationList + ') - International'}</label>
                                        }
                                    
                                    </>

                                       
                                    }
                                </div>
                            </div>
                            <div className="row mt-4">
                                <div className="col-12">
                                    <div className="row align-items-center">
                                        <label className="col-6">Product</label>
                                        <label className="col-6 text-end fw-bold">{transactionData.product}</label>
                                    </div>
                                    <div className="row align-items-center">
                                        <label className="col-6">Plan</label>
                                        <label className="col-6 text-end fw-bold">{transactionData.plan}</label>
                                    </div>
                                    <div className="row align-items-center">
                                        <label className="col-6">Insurer</label>
                                        <label className="col-6 text-end fw-bold">{getInsurerFullName(transactionData.insurer)}</label>
                                    </div>
                                    <div className="row align-items-center">
                                        <label className="col-6">Period of Insurance</label>
                                        <label className="col-6 text-end fw-bold">
                                            {transactionData.coverage_from + " to " + transactionData.coverage_to}
                                        </label>
                                    </div>
                                    <div className="row align-items-center border-top mt-3 pt-2">
                                        <label className="col-6">Premium (including 8% Service Tax)</label>
                                        <label className="col-6 text-end fw-bold align-self-center">
                                            RM {parseFloat(transactionData.gross_premium).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                        </label>
                                    </div>
                                    <div className="row align-items-center">
                                        <label className="col-7">Add On Benefits</label>
                                        <label className="col-5 text-end fw-bold align-self-center">
                                            RM {parseFloat(transactionData.add_ons_total).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                        </label>
                                    </div>
                                    <div className="row align-items-center ps-sm-4">
                                        <div className="col-10 col-sm-7">
                                            <ol type="1">
                                                {props.selectedAddOns.map(add_on => (
                                                    <li>{add_on.name}</li>
                                                ))}
                                            </ol>
                                        </div>
                                    </div>
                                    <div className="row align-items-center">
                                        <label className="col-6">Stamp Duty</label>
                                        <label className="col-6 text-end fw-bold align-self-center">
                                            RM {parseFloat(transactionData.stamp_duty).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                        </label>
                                    </div>
                                    <div className="row align-items-center">
                                        <label className="col-6"> Service Tax</label>
                                        <label className="col-6 text-end fw-bold align-self-center">
                                            RM {parseFloat(transactionData.service_tax).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </Card.Body>
                        <Card.Footer>
                            <div className="row">
                                <div className="col-6">Total Payable</div>
                                <div className="col-6 text-end fw-bold align-self-center">
                                    RM {parseFloat(transactionData.total_payable).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <div style={commissionStyle}>{process.env.MIX_COMMISION_RATE}% of commission amounting to RM {parseFloat(commissionAmount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} is payable to intermediary.</div>
                                </div>
                            </div>
                        </Card.Footer>
                    </Card>
                    <Card className="border rounded mt-3">
                        <Card.Header>
                            <label className="fw-bold text-primary mb-0">Summary of Insured Details</label>
                        </Card.Header>
                        <Card.Body>
                            {!isEmpty(transactionData.insured) ? transactionData.insured.map((data, index) => (
                                <>
                                <div className="insured-group border-bottom">
                                    <p className="lead fw-bold text-blue mt-3">{['Insured', '#', index + 1].join(' ')}</p>
                                    <div className="mb-3 row">
                                        <div className="col-12 col-sm-6">
                                            <div className="row align-items-center">
                                                <label className="col-5">Name</label>
                                                <label className="col-7 text-end fw-bold">{data.name}</label>
                                            </div>
                                            <div className="row align-items-center">
                                                <label className="col-5">NRIC / Passport No.</label>
                                                <label className="col-7 text-end fw-bold">{data.idNumber}</label>
                                            </div>
                                            <div className="row align-items-center">
                                                <label className="col-5">Date of Birth</label>
                                                <label className="col-7 text-end fw-bold">{Moment(data.dateOfBirth).format("DD/MM/YYYY")}</label>
                                            </div>
                                            <div className="row align-items-center">
                                                <label className="col-5">Gender</label>
                                                <label className="col-7 text-end fw-bold">{data.gender}</label>
                                            </div>
                                        </div>
                                        <div className="col-12 col-sm-6">
                                            <div className="row align-items-center">
                                                <label className="col-5">Nationality</label>
                                                <label className="col-7 text-end fw-bold">{data.nationality}</label>
                                            </div>
                                            <div className="row align-items-center">
                                                <label className="col-5">Mobile No.</label>
                                                <label className="col-7 text-end fw-bold">
                                                {
                                                    !isEmpty(data.displayMobileNo) ?
                                                    <>
                                                    +60{data.displayMobileNo}
                                                    </>
                                                    :
                                                    ""   
                                                }
                                               
                                                </label>
                                            </div>
                                            <div className="row align-items-center">
                                                <label className="col-4">Email Address</label>
                                                <label className="col-8 text-end fw-bold">{data.email}</label>
                                            </div>
                                            <div className="row align-items-center">
                                                <label className="col-4">Address</label>
                                                <label className="col-8 text-end fw-bold">
                                                    {data.address1} {data.address2} {data.address3} {data.address4} <br/>
                                                    {data.postcode} {data.state}
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    {data.nominee.name ?
                                        <div className="mb-3 row">
                                            <div className="col-12 col-sm-6">
                                                <label className="text-blue fw-bold">Nominee Details</label>
                                                <div className="row align-items-center">
                                                    <label className="col-5">Name</label>
                                                    <label className="col-7 text-end fw-bold">{data.nominee.name}</label>
                                                </div>
                                                <div className="row align-items-center">
                                                    <label className="col-5">NRIC / Passport No.</label>
                                                    <label className="col-7 text-end fw-bold">{data.nominee.idNumber}</label>
                                                </div>
                                                <div className="row align-items-center">
                                                    <label className="col-5">Relationship</label>
                                                    <label className="col-7 text-end fw-bold">{data.nominee.relationship}</label>
                                                </div>
                                            </div>
                                        </div>
                                        : null
                                    }
                                </div>

                                  {data.einvoiceEnable && (((index + 1) == 1 && props.travelInfo.buyFor == 'FC') || props.travelInfo.buyFor != 'FC') ?    
                                
                                    <div className="insured-group border-bottom">
                                        <p className="fw-bold mt-3">{"e-Invoice Details #" + (index + 1)}</p>
                                        <div className="mb-3 row">
                                            <div className="col-12 col-sm-6">
                                                <div className="row align-items-center">
                                                    <label className="col-6">Require e-Invoice?</label>
                                                    <label className="col-6 text-end fw-bold">
                                                        {data.einvoiceIndicator == 'Y' ? 'Yes':
                                                            <>
                                                        
                                                                {
                                                                    data.einvoiceIndicator == 'N' ? 
                                                                    'No' 
                                                                    : ""
                                                                }
                                                            </>
                                                        
                                                        }
                                                        </label>
                                                </div>
                                                
                                                <div className="row align-items-center">
                                                    <label className="col-6">SST Registrant?</label>
                                                    <label className="col-6 text-end fw-bold">
                                                        {data.sstIndicator == 'Y' ? 'Yes' : 
                                                        
                                                              <>
                                                        
                                                                {
                                                                    data.sstIndicator == 'N' ? 
                                                                    'No' 
                                                                    : ""
                                                                }
                                                              </>
                                                        }
                                                        
                                                        </label>
                                                </div>
                                                
                                            </div>

                                            <div className="col-12 col-sm-6">
                                                <div className="row align-items-center">
                                                    <label className="col-6">TIN</label>
                                                    <label className="col-6 text-end fw-bold">{data.tinNo}</label>
                                                </div>
                                                <div className="row align-items-center">
                                                    <label className="col-6">SST Registration No.</label>
                                                    <label className="col-6 text-end fw-bold">{data.sstNo}</label>
                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                :

                                    ""
                                }

                                </>

                            )) : null}
                        </Card.Body>
                    </Card>

                    <div className="mb-3 row mt-3">
                        <div className="col-6">
                            {(query.get('paymentID') == null) ?
                                <Button type="button" variant="secondary" onClick={() => { props.setActiveId('insured') }}>Back</Button>
                            :
                                null
                            }
                        </div>
                        <div className="col-6 text-end">
                            <Button type="button" variant="success" onClick={() => setShowDeclarationModal(true)} disabled={transactionData.total_payable == 0 ? 'disabled' : ""}>
                                Proceed to Pay RM {parseFloat(transactionData.total_payable).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </Button>
                            <DeclarationModal
                                showDeclarationModal={showDeclarationModal} setShowDeclarationModal={setShowDeclarationModal} setAgreed={setAgreed}
                                insuredName={transactionData.name} setOnSave={setOnSave} insurer={transactionData.insurer}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Form>
    );
}

function getInsurerFullName(short_name) {
    let full_name = '';

    if (short_name === 'MSIG') {
        full_name = 'MSIG Insurance (Malaysia) Bhd';
    } else if (short_name === 'RHBI') {
        full_name = 'RHB Insurance Berhad';
    } else if (short_name === 'CHUBB') {
        full_name = 'Chubb Insurance Malaysia Berhad';
    } else if (short_name === 'AXA') {
        full_name = 'AXA Affin General Insurance Berhad';
    } else if (short_name === 'ZurichTakaful') {
        full_name = 'Zurich General Takaful Malaysia Berhad';
    } else if (short_name === 'TuneProtect' || short_name === 'TUNEPROTECT') {
        full_name = 'Tune Insurance Malaysia Berhad';
    }

    return full_name;
}

function getBenefitName(benefit) {
    if (benefit === 'medical_expenses') {
        return 'Medical, Hospital and Treatment Expenses';
    } else if (benefit === 'alternative_medicine') {
        return 'Alternative Medicine *';
    } else if (benefit === 'child_care') {
        return 'Child Care *';
    } else if (benefit === 'medical_treatment_malaysia') {
        return 'Medical Treatment in Malaysia *';
    } else if (benefit === 'delay_overbooked') {
        return 'Travel Delay, Overbooked, Misconnection or Reroute';
    } else if (benefit === 'delay') {
        return 'Travel Delay';
    } else if (benefit === 'overbooked') {
        return 'Travel Overbooked';
    } else if (benefit === 'reroute') {
        return 'Travel Re-route';
    } else if (benefit === 'misconnection') {
        return 'Travel Misconnection';
    } else if (benefit === 'cancellation') {
        return 'Cancellation or Postponement';
    } else if (benefit === 'entertainment_ticket') {
        return 'Loss of Use of Entertainment Tickets';
    } else if (benefit === 'credit_card') {
        return 'Loss of Credit Card';
    } else if (benefit === 'ransom_payment') {
        return 'Ransom Payment as a result of Kidnapping & Hostage';
    } else if (benefit === 'sports_equipment') {
        return 'Sports Equipment / Musical Instruments';
    } else if (benefit === 'flight_cancellation') {
        return 'Flight Cancellation or Rescheduling';
    } else if (benefit === 'death_disablement_top_up') {
        return 'Accidental Death & Permanent Disablement Top Up';
    } else if (benefit === 'covid19_cover') {
        return 'COVID19 Cover';
    } else {
        return benefit.split('_').map((text) => {
            return text.charAt(0).toUpperCase() + text.slice(1);
        }).join(' ');
    }
}

function getManualPlanName(short_name) {
    let plan_name = '';

    if (short_name === 'chubb') {
        plan_name = 'Chubb travel insurance';
    } else if (short_name === 'aig') {
        plan_name = 'aig travelguard';
    } else if (short_name === 'tuneprotect') {
        plan_name = 'tune travel travel comprehensive';
    }

    return plan_name.toUpperCase();
}

